/* FrogMatch v2 · motore feature-based + 3 controller (Quiz · Wrapped · Per Te)
   ───────────────────────────────────────────────────────────────────────────
   Profili basati su meccaniche, categorie, tipologie BGG (non più 5 assi astratti).
   Match: overlap tipologie + Jaccard meccaniche + Jaccard categorie + vicinanza stats.
   Persistenza in localStorage. window.FrogMatch è l'API pubblica.
*/

(function () {
  'use strict';

  const STORAGE_KEY = 'frogmatch_profile_v2';
  const SWIPES_KEY = 'frogmatch_swipes_v2';
  const MOOD_KEY = 'frogmatch_mood_v2';

  const EURO_MECH = [
    'Worker Placement', 'Engine Building', 'Tile Placement', 'Drafting',
    'Open Drafting', 'Closed Drafting', 'Resource Management', 'Resource To Move',
    'Variable Set-up', 'Set Collection', 'Tableau Building', 'Auction',
    'Auction/Bidding', 'Action Points', 'Network and Route Building',
    'Pick-up and Deliver', 'Income', 'Loans', 'Contracts', 'Map Addition',
    'Action Drafting', 'Worker Placement, Different Worker Types',
    // AGGIUNTE 2026-06: meccaniche euro-firma che mancavano (Scythe & co. finivano "american").
    // NB: 'Area Majority / Influence' lasciato NEUTRO apposta — sta sia su euro (El Grande)
    // sia su american (Root): metterlo euro faceva diventare Root "eurogame" (sbagliato).
    'End Game Bonuses', 'Tech Trees / Tech Tracks', 'Victory Points as a Resource'
  ];

  const AMERICAN_MECH = [
    // RIMOSSI 2026-06: 'Variable Player Powers' (sta su mille euro: Wingspan/Cascadia/Scythe),
    // 'Solo / Solitaire Game' (avere l'Automa NON è american), 'Area Movement' (neutro/euro).
    // Erano segnali-rumore che spingevano euro-ibridi verso "american".
    'Dice Rolling', 'Storytelling', 'Player Elimination',
    'Take That', 'Hidden Movement', 'Adventure', 'Combat', 'Variable Phase Order',
    'Critical Hits and Failures', 'Role Playing', 'Campaign / Battle Card Driven',
    'Modular Board', 'Movement Points'
  ];

  // Meccaniche UBIQUE/rumorose: compaiono su moltissimi giochi diversi → NON sono
  // segnale di "somiglianza" a un gioco specifico. Usate per scremare il bonus-preferiti
  // (fix 2026-06): Viscounts condivideva con Scythe solo questi tag generici → +20 finto.
  const GENERIC_MECH = [
    'Hand Management', 'Set Collection', 'Dice Rolling', 'Open Drafting', 'Drafting',
    'Closed Drafting', 'Variable Player Powers', 'Modular Board', 'Area Majority / Influence',
    'Variable Set-up', 'Solo / Solitaire Game', 'End Game Bonuses', 'Multi-Use Cards'
  ];

  const PARTY_MECH = [
    'Push Your Luck', 'Memory', 'Singing', 'Acting', 'Voting', 'Real-Time'
  ];

  // ============================================================
  // INTERAZIONE & ALEA — derivati automaticamente dalle meccaniche
  // Livelli 0-3 per ogni asse, usati in computeMatch e nel profile
  // ============================================================

  // Interazione: 0 = solitaria, 1 = indiretta amichevole, 2 = indiretta forte, 3 = diretta/conflitto
  const INTERACTION_DIRECT = [
    'Combat', 'Take That', 'Player Elimination', 'Negotiation', 'Bluffing',
    'Trading', 'Bribery', 'Stock Holding', 'Hidden Movement', 'Voting'
  ];
  const INTERACTION_STRONG_INDIRECT = [
    'Worker Placement', 'Worker Placement, Different Worker Types',
    'Area Majority / Influence', 'Auction', 'Auction/Bidding', 'Predictive Bid',
    'Open Drafting', 'Closed Drafting', 'Drafting', 'Card Drafting', 'Action Drafting'
  ];
  const INTERACTION_INDIRECT = [
    'Engine Building', 'Tableau Building', 'Tile Placement', 'Set Collection',
    'Pattern Building', 'Pattern Recognition', 'Network and Route Building',
    'Hand Management', 'Resource Management', 'Income'
  ];
  const INTERACTION_NONE = [
    'Solo / Solitaire Game', 'Solo / Solitaire', 'Multi-Use Cards', 'Paper-and-Pencil'
  ];

  // Alea: 0 = puro skill, 1 = bassa, 2 = media, 3 = alta
  const ALEA_HIGH = [
    'Dice Rolling', 'Push Your Luck', 'Random Production', 'Bag Building',
    'Dice Drafting', 'Die Icon Resolution', 'Critical Hits and Failures'
  ];
  const ALEA_MEDIUM = [
    'Hand Management', 'Card Drafting', 'Open Drafting', 'Set Collection',
    'Deck, Bag, and Pool Building', 'Deck Construction'
  ];
  const ALEA_LOW = [
    'Closed Drafting', 'Action Points', 'Action Drafting', 'Worker Placement',
    'Tile Placement', 'Network and Route Building', 'Engine Building'
  ];

  function deriveInteraction(product) {
    const m = product.mch || [];
    const f = product.f || {};
    if (m.length === 0) return null;
    if (f.solo && m.length < 3) return 0;
    let direct = 0, strong = 0, indirect = 0, none = 0;
    for (const x of m) {
      if (INTERACTION_DIRECT.indexOf(x) >= 0) direct++;
      if (INTERACTION_STRONG_INDIRECT.indexOf(x) >= 0) strong++;
      if (INTERACTION_INDIRECT.indexOf(x) >= 0) indirect++;
      if (INTERACTION_NONE.indexOf(x) >= 0) none++;
    }
    if (direct >= 2) return 3;
    if (direct >= 1 && strong === 0) return 3;
    if (strong >= 2) return 2;
    if (strong >= 1) return 2;
    if (indirect >= 2) return 1;
    if (none >= 1 && direct === 0 && strong === 0) return 0;
    return 1; // default amichevole se non classificabile altrimenti
  }

  function deriveAlea(product) {
    const m = product.mch || [];
    if (m.length === 0) return null;
    let high = 0, medium = 0, low = 0;
    for (const x of m) {
      if (ALEA_HIGH.indexOf(x) >= 0) high++;
      if (ALEA_MEDIUM.indexOf(x) >= 0) medium++;
      if (ALEA_LOW.indexOf(x) >= 0) low++;
    }
    if (high >= 2) return 3;
    if (high >= 1 && low < 2) return 3;
    if (medium >= 2 && low < 2) return 2;
    if (medium >= 1) return 2;
    if (low >= 2) return 1;
    return 1; // default basso se astratto/non classificabile
  }

  const INTERACTION_LABELS = {
    0: 'Solitaria',
    1: 'Indiretta amichevole',
    2: 'Indiretta forte',
    3: 'Diretta / conflittuale'
  };
  const INTERACTION_ICONS = { 0: '🧘', 1: '🤝', 2: '🏗️', 3: '⚔️' };

  const ALEA_LABELS = {
    0: 'Puro skill',
    1: 'Bassa',
    2: 'Media',
    3: 'Alta'
  };
  const ALEA_ICONS = { 0: '◇', 1: '🎯', 2: '🃏', 3: '🎲' };

  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

  function jaccardSim(a, b) {
    if (!a || !b || a.length === 0 || b.length === 0) return 0;
    const setA = new Set(a);
    const setB = new Set(b);
    let inter = 0;
    for (const x of setA) if (setB.has(x)) inter++;
    const union = setA.size + setB.size - inter;
    return union === 0 ? 0 : inter / union;
  }

  function overlapSim(a, b) {
    if (!a || !b || a.length === 0 || b.length === 0) return 0;
    const setB = new Set(b);
    let inter = 0;
    for (const x of a) if (setB.has(x)) inter++;
    return inter / Math.min(a.length, b.length);
  }

  function deriveTypologies(p) {
    const types = [];
    const m = p.mch || [];
    const c = p.cat || [];
    const f = p.f || {};
    const w = p.w;
    const tmax = p.tmax || p.tmin || 0;
    const rt = p.rt || 0;

    if (f.coop) types.push('coop');
    if (f.party) types.push('party');
    // NB: 'solo' NON è più derivato qui automaticamente.
    // f.solo significa "il gioco SUPPORTA il solo", non "ti piace giocare in solo".
    // Vero tag 'solo' viene aggiunto in buildProfile/syncBggData via score combinato
    // (vedi computeSoloGamerScore: plays solo reali + giochi puri solo + ratio collezione).

    const isAbstract = c.some(x => /abstract/i.test(x));
    const isWargameCat = c.some(x => /wargame|miniature/i.test(x));
    if (isAbstract) types.push('astratto');
    if (isWargameCat) types.push('wargame');

    const isFiller = w != null && w > 0 && w < 1.8 && tmax > 0 && tmax <= 30;
    if (isFiller) types.push('filler');

    const isFamilyCat = c.some(x => /family|children/i.test(x));
    const isFamily = (w != null && w > 0 && w <= 2.0) || isFamilyCat;
    if (isFamily && !isFiller && !types.includes('coop') && !types.includes('party')) types.push('family');

    if (m.some(x => /Paper-and-Pencil/i.test(x))) types.push('rollwrite');
    if (m.some(x => /Legacy Game|Campaign\s*\/\s*Battle Card Driven|Legacy/i.test(x))) types.push('legacy');
    if (m.some(x => /Storytelling|Narrative Choice/i.test(x))) types.push('narrativo');
    if (m.some(x => /Deck,?\s*Bag,?\s*and Pool Building|Deck Construction|Deck Building/i.test(x))) types.push('deckbuilder');
    if (m.some(x => /Trick-?taking|Trick Taking/i.test(x))) types.push('tricktaking');
    if (c.some(x => /Action\s*\/\s*Dexterity/i.test(x))) types.push('dexterity');

    const hasAdventure = c.some(x => /Adventure|Fighting/i.test(x));
    const hasMiniatures = c.some(x => /Miniatures/i.test(x));
    const hasFantasyOrSci = c.some(x => /Fantasy|Science Fiction/i.test(x));
    if ((hasAdventure && hasFantasyOrSci) || (hasMiniatures && hasAdventure)) {
      types.push('dungeon');
    }

    // Asimmetrico VERO: Variable Player Powers + segnali sostanziali.
    // BGG mette "VPP" su giochi family/eurogame con poteri lievemente diversi (Wingspan, Saltfjord,
    // Harmonies, Cascadia). Non sono asimmetrici tipo Root/Spirit Island/Vast/Inis.
    // Serve: VPP + (conflitto diretto) OR (cooperative pesante 3.5+) OR (peso molto pesante 3.8+).
    if (m.some(x => /Variable Player Powers/i.test(x)) && !types.includes('party')) {
      const hasConflict = m.some(x => /Combat|Take That|Hidden Roles|Player Elimination|Hidden Movement/i.test(x));
      const isCoopHeavy = (f.coop || m.some(x => /Cooperative Game/i.test(x))) && w != null && w >= 3.5;
      const isVeryHeavy = w != null && w >= 3.8;
      if (hasConflict || isCoopHeavy || isVeryHeavy) {
        types.push('asimmetrico');
      }
    }

    if (c.some(x => /Puzzle/i.test(x)) && f.coop) types.push('escape');

    // Gateway: gioco INTRODUTTIVO ai boardgame moderni. Peso stretto 1.8-2.2 + rating alto BGG.
    // Era troppo permissivo (1.8-2.5): catturava Wingspan/Catan/7 Wonders/Carcassonne come gateway.
    // Veri gateway: Azul, Splendor, Ticket to Ride, Sushi Go.
    if (w != null && w >= 1.8 && w <= 2.2 && rt >= 7.3 && !types.includes('filler') && !types.includes('family')) {
      types.push('gateway');
    }

    const euroScore = m.filter(x => EURO_MECH.includes(x)).length;
    let amerScore = m.filter(x => AMERICAN_MECH.includes(x)).length;

    // VPP è AMBIGUO: euro su Wingspan/Cascadia, american-asimmetrico su Root/Vast/Scythe.
    // Regola contestuale (2026-06): conta american (+2) SOLO se c'è anche conflitto diretto.
    // Senza conflitto resta neutro → Wingspan non diventa american. Con conflitto Root torna american.
    if (m.some(x => /Variable Player Powers/i.test(x)) &&
        m.some(x => /Combat|Take That|Player Elimination|Hidden Movement|Critical Hits/i.test(x))) {
      amerScore += 2;
    }

    // Ibrido VERO: entrambi i lati forti (≥3) e bilanciati (diff ≤2). Es. Architects of West Kingdom.
    // Altrimenti vince chi ha più segnali. Saltfjord (5 euro / 2 american) → eurogame, non ibrido.
    if (euroScore >= 3 && amerScore >= 3 && Math.abs(euroScore - amerScore) <= 2) {
      types.push('ibrido');
    } else if (euroScore >= 2 && euroScore > amerScore) {
      types.push('eurogame');
    } else if (amerScore >= 2 && amerScore > euroScore) {
      types.push('american');
    } else if (euroScore >= 2) {
      types.push('eurogame');
    } else if (amerScore >= 2) {
      types.push('american');
    }

    return types;
  }

  const MECHANIC_LABELS = {
    'Hand Management': 'Gestione mano',
    'Set Collection': 'Collezionismo',
    'Worker Placement': 'Piazzamento lavoratori',
    'Worker Placement, Different Worker Types': 'Piazzamento lavoratori asimmetrico',
    'Open Drafting': 'Drafting aperto',
    'Closed Drafting': 'Drafting chiuso',
    'Drafting': 'Drafting',
    'Action Drafting': 'Drafting di azioni',
    'Area Majority / Influence': 'Controllo area',
    'Area Movement': 'Movimento per aree',
    'Area-Impulse': 'Area-Impulse',
    'End Game Bonuses': 'Bonus fine partita',
    'Multi-Use Cards': 'Carte multifunzione',
    'Physical Removal': 'Rimozione fisica',
    'Ladder Climbing': 'Scala (carte)',
    'Solo / Solitaire Game': 'Modalità solo',
    'Race': 'Corsa',
    'Race Game': 'Gara',
    'Events': 'Eventi',
    'Action / Event': 'Azione / Evento',
    'Bribery': 'Corruzione',
    'Deduction': 'Deduzione',
    'Hidden Roles': 'Ruoli nascosti',
    'Hidden Movement': 'Movimento nascosto',
    'Voting': 'Votazione',
    'Simultaneous Action Selection': 'Azione simultanea',
    'Team-Based Game': 'A squadre',
    'Tech Trees / Tech Tracks': 'Albero tecnologico',
    'Variable Player Powers': 'Poteri asimmetrici',
    'Variable Phase Order': 'Ordine fasi variabile',
    'Variable Set-up': 'Setup variabile',
    'Die Icon Resolution': 'Dadi a icone',
    'Dice Rolling': 'Lancio dadi',
    'Paper-and-Pencil': 'Carta e matita',
    'Predictive Bid': 'Bid previsionale',
    'Trick-taking': 'Prese',
    'Trick Taking': 'Prese',
    'Engine Building': 'Costruzione motore',
    'Tile Placement': 'Piazzamento tessere',
    'Resource Management': 'Gestione risorse',
    'Resource To Move': 'Risorse per muovere',
    'Tableau Building': 'Costruzione tableau',
    'Auction': 'Asta',
    'Auction/Bidding': 'Asta',
    'Action Points': 'Punti azione',
    'Network and Route Building': 'Reti e rotte',
    'Pick-up and Deliver': 'Raccogli e consegna',
    'Income': 'Reddito',
    'Loans': 'Prestiti',
    'Contracts': 'Contratti',
    'Map Addition': 'Modifica mappa',
    'Modular Board': 'Plancia modulare',
    'Storytelling': 'Narrazione',
    'Player Elimination': 'Eliminazione giocatore',
    'Take That': 'Take That',
    'Adventure': 'Avventura',
    'Combat': 'Combattimento',
    'Critical Hits and Failures': 'Critici e fallimenti',
    'Role Playing': 'Ruolo (RPG)',
    'Campaign / Battle Card Driven': 'Campagna a carte',
    'Movement Points': 'Punti movimento',
    'Push Your Luck': 'Tira la sorte',
    'Memory': 'Memoria',
    'Real-Time': 'Tempo reale',
    'Cooperative Game': 'Cooperativo',
    'Catch the Leader': 'Aggancia il leader',
    'Movement Programming': 'Movimento programmato',
    'Roll / Spin and Move': 'Lancia e muovi',
    'Bluffing': 'Bluff',
    'Negotiation': 'Negoziazione',
    'Acting': 'Recitazione',
    'Singing': 'Canto',
    'Pattern Recognition': 'Riconoscimento pattern',
    'Pattern Building': 'Costruzione pattern',
    'Hexagon Grid': 'Griglia esagonale',
    'Square Grid': 'Griglia quadrata',
    'Grid Movement': 'Movimento su griglia',
    'Grid Coverage': 'Copertura griglia',
    'Card Drafting': 'Drafting di carte',
    'Deck Construction': 'Costruzione mazzo',
    'Deck, Bag, and Pool Building': 'Deck/bag building',
    'Hand Management': 'Gestione mano',
    'Roles with Asymmetric Information': 'Ruoli con info asimmetrica',
    'Track Movement': 'Movimento su traccia',
    'Mancala': 'Mancala',
    'Tug of War': 'Tira e molla',
    'Stock Holding': 'Azioni in borsa',
    'Hidden Victory Points': 'Punti vittoria nascosti',
    'Solo / Solitaire Game': 'Solo'
  };

  const CATEGORY_LABELS = {
    'Adventure': 'Avventura',
    'Ancient': 'Antichità',
    'Animals': 'Animali',
    'Arabian': 'Arabia',
    'City Building': 'Città',
    'Civilization': 'Civiltà',
    'Comic Book / Strip': 'Fumetti',
    'Economic': 'Economico',
    'Environmental': 'Ambiente',
    'Exploration': 'Esplorazione',
    'Fantasy': 'Fantasy',
    'Farming': 'Fattoria',
    'Fighting': 'Combattimento',
    'Horror': 'Horror',
    'Industry / Manufacturing': 'Industria',
    'Mafia': 'Mafia',
    'Medical': 'Medico',
    'Medieval': 'Medievale',
    'Modern Warfare': 'Guerra moderna',
    'Movies / TV / Radio theme': 'Cinema / TV',
    'Murder/Mystery': 'Mistero',
    'Mythology': 'Mitologia',
    'Napoleonic': 'Napoleonico',
    'Nautical': 'Marinaresco',
    'Pirates': 'Pirati',
    'Political': 'Politico',
    'Post-Napoleonic': 'Post-Napoleonico',
    'Prehistoric': 'Preistorico',
    'Religious': 'Religione',
    'Renaissance': 'Rinascimento',
    'Science Fiction': 'Fantascienza',
    'Space Exploration': 'Spazio',
    'Spies/Secret Agents': 'Spionaggio',
    'Sports': 'Sport',
    'Territory Building': 'Territorio',
    'Trains': 'Treni',
    'Transportation': 'Trasporti',
    'Travel': 'Viaggio',
    'Video Game Theme': 'Videogiochi',
    'Western': 'Western',
    'World War I': 'Prima guerra mondiale',
    'World War II': 'Seconda guerra mondiale',
    'Zombies': 'Zombie',
    'Pike and Shot': 'Picca e moschetto',
    'American Civil War': 'Guerra civile americana',
    'American Revolutionary War': 'Rivoluzione americana',
    'Vietnam War': 'Vietnam',
    'Korean War': 'Corea',
    'Christmas': 'Natale',
    'Aviation / Flight': 'Aviazione',
    'Mature / Adult': null,
    'Adult': null,
    'Educational': null,
    'Children\'s Game': null,
    'Card Game': null,
    'Dice': null,
    'Number': null,
    'Party Game': null,
    'Trivia': null,
    'Word Game': null,
    'Memory': null,
    'Real-time': null,
    'Expansion for Base-game': null,
    'Action / Dexterity': null,
    'Print & Play': null,
    'Bluffing': null,
    'Negotiation': null,
    'Deduction': null,
    'Humor': null,
    'Maze': null,
    'Puzzle': null,
    'Math': null,
    'Abstract Strategy': null,
    'Wargame': null,
    'Collectible Components': null,
    'Miniatures': null,
    'Book': null,
    'Game System': null,
    'Fan Expansion': null,
    'Music': null
  };

  function tMech(en) {
    return MECHANIC_LABELS[en] || en;
  }

  function tCat(en) {
    if (!en) return '';
    if (!(en in CATEGORY_LABELS)) return en;
    // Se la label mappata è null (= categoria meta da nascondere come
    // "Strategy Games", "Expansion for Base-game") ritorna stringa vuota
    // invece di null, così .filter(Boolean) o escapeHtml non producono "null".
    return CATEGORY_LABELS[en] || '';
  }

  function isThemeCategory(en) {
    if (en in CATEGORY_LABELS) return CATEGORY_LABELS[en] !== null;
    return true;
  }

  const COMMON_MECHANICS = [
    { id: 'Engine Building', examples: ['Wingspan', 'Terraforming Mars'] },
    { id: 'Tableau Building', examples: ['Race for the Galaxy', 'Splendor'] },
    { id: 'Resource Management', examples: ['Stone Age', 'Catan'] },
    { id: 'Resource To Move', examples: ['Brass: Birmingham', 'Imperial'] },
    { id: 'Income', examples: ['Brass: Birmingham', 'Power Grid'] },
    { id: 'Loans', examples: ['Brass: Birmingham', 'Container'] },
    { id: 'Stock Holding', examples: ['Acquire', 'Stockpile'] },
    { id: 'Investment', examples: ['Acquire', 'Container'] },
    { id: 'Tech Trees / Tech Tracks', examples: ['Through the Ages', 'Eclipse'] },
    { id: 'Network and Route Building', examples: ['Ticket to Ride', 'Brass: Birmingham'] },
    { id: 'Map Addition', examples: ['Carcassonne', 'Heroes of Land Air & Sea'] },
    { id: 'Variable Set-up', examples: ['Catan', 'Pandemic'] },
    { id: 'Modular Board', examples: ['Catan', 'Mage Knight'] },

    { id: 'Hand Management', examples: ['Race for the Galaxy', 'San Juan'] },
    { id: 'Open Drafting', examples: ['7 Wonders', 'Sushi Go'] },
    { id: 'Closed Drafting', examples: ['Magic: The Gathering', 'Through the Ages'] },
    { id: 'Card Drafting', examples: ['7 Wonders', 'Among the Stars'] },
    { id: 'Set Collection', examples: ['Ticket to Ride', 'Splendor'] },
    { id: 'Multi-Use Cards', examples: ['Race for the Galaxy', 'Innovation'] },
    { id: 'Trick-taking', examples: ['The Crew', 'Skull King'] },
    { id: 'Deck, Bag, and Pool Building', examples: ['Dominion', 'Star Realms'] },
    { id: 'Deck Construction', examples: ['Magic: The Gathering', 'Marvel Champions'] },

    { id: 'Worker Placement', examples: ['Agricola', 'Caverna'] },
    { id: 'Worker Placement, Different Worker Types', examples: ['Caverna', 'A Feast for Odin'] },
    { id: 'Action Points', examples: ['Pandemic', 'Tikal'] },
    { id: 'Action Drafting', examples: ['Puerto Rico', 'Lords of Waterdeep'] },
    { id: 'Simultaneous Action Selection', examples: ['Race for the Galaxy', 'RoboRally'] },
    { id: 'Variable Phase Order', examples: ['Puerto Rico', 'Race for the Galaxy'] },

    { id: 'Area Majority / Influence', examples: ['El Grande', 'Inis'] },
    { id: 'Area Movement', examples: ['Risk', 'Diplomacy'] },
    { id: 'Tile Placement', examples: ['Carcassonne', 'Azul'] },
    { id: 'Hidden Movement', examples: ['Fury of Dracula', 'Letters from Whitechapel'] },
    { id: 'Pick-up and Deliver', examples: ['Ticket to Ride', 'Container'] },
    { id: 'Movement Programming', examples: ['RoboRally', 'Captain Sonar'] },
    { id: 'Movement Points', examples: ['Carcassonne', 'Talisman'] },
    { id: 'Hexagon Grid', examples: ['Twilight Struggle', 'Terra Mystica'] },
    { id: 'Race Game', examples: ['Camel Up', 'Ave Caesar'] },
    { id: 'Race', examples: ['Long Shot', 'Camel Up'] },

    { id: 'Variable Player Powers', examples: ['Root', 'Spirit Island'] },
    { id: 'Combat', examples: ['Risk', 'War of the Ring'] },
    { id: 'Critical Hits and Failures', examples: ['Talisman', 'Descent'] },
    { id: 'Take That', examples: ['Munchkin', 'Smash Up'] },
    { id: 'Player Elimination', examples: ['Risk', 'Bang!'] },
    { id: 'Hidden Roles', examples: ['Resistance', 'Werewolf'] },
    { id: 'Voting', examples: ['Resistance', 'Battlestar Galactica'] },
    { id: 'Bluffing', examples: ['Skull', 'Coup'] },
    { id: 'Bribery', examples: ['Diplomacy', 'Republic of Rome'] },

    { id: 'Cooperative Game', examples: ['Pandemic', 'Forbidden Island'] },
    { id: 'Storytelling', examples: ['Tales of the Arabian Nights', 'Above and Below'] },
    { id: 'Adventure', examples: ['Gloomhaven', 'Mage Knight'] },
    { id: 'Role Playing', examples: ['Gloomhaven', 'Descent'] },
    { id: 'Campaign / Battle Card Driven', examples: ['Gloomhaven', 'Pandemic Legacy'] },
    { id: 'Legacy Game', examples: ['Pandemic Legacy', 'Charterstone'] },
    { id: 'Events', examples: ['Robinson Crusoe', 'Twilight Struggle'] },
    { id: 'Action / Event', examples: ['Twilight Struggle', '1960: The Making of the President'] },

    { id: 'Dice Rolling', examples: ['Catan', 'Yahtzee'] },
    { id: 'Die Icon Resolution', examples: ['7 Wonders Dice', 'Castles of Burgundy'] },
    { id: 'Dice Drafting', examples: ['Sagrada', 'Bunny Kingdom'] },
    { id: 'Push Your Luck', examples: ['Quacks of Quedlinburg', "Can't Stop"] },

    { id: 'Auction', examples: ['Power Grid', 'Modern Art'] },
    { id: 'Auction/Bidding', examples: ['Modern Art', 'Vegas Showdown'] },
    { id: 'Predictive Bid', examples: ['The Crew', 'Skull King'] },
    { id: 'Negotiation', examples: ['Chinatown', 'Sidereal Confluence'] },
    { id: 'Real-Time', examples: ['Captain Sonar', 'Magic Maze'] },
    { id: 'Deduction', examples: ['Clue', 'Mysterium'] },
    { id: 'Memory', examples: ['Memory', 'Sherlock Holmes'] },
    { id: 'Pattern Building', examples: ['Azul', 'Sagrada'] },
    { id: 'Pattern Recognition', examples: ['Cascadia', 'Azul'] },
    { id: 'Acting', examples: ["Time's Up", 'Charades'] },
    { id: 'Singing', examples: ['SongPop', 'Spontuneous'] },
    { id: 'Solo / Solitaire Game', examples: ['Mage Knight', 'Friday'] },
    { id: 'Team-Based Game', examples: ['Codenames', 'Time\'s Up'] },
    { id: 'Action / Dexterity', examples: ['Junk Art', 'Klask'] },
    { id: 'Paper-and-Pencil', examples: ['Welcome To', 'Cartographers'] },
    { id: 'End Game Bonuses', examples: ['Wingspan', 'Concordia'] }
  ];

  const COMMON_CATEGORIES = [
    'Fantasy', 'Science Fiction', 'Civilization', 'Economic', 'Industry / Manufacturing',
    'Adventure', 'Exploration', 'Mythology', 'Ancient', 'Medieval', 'Renaissance',
    'World War II', 'Modern Warfare', 'Animals', 'Farming', 'Nautical', 'Pirates',
    'Space Exploration', 'Political', 'Spies/Secret Agents', 'Horror', 'Murder/Mystery',
    'City Building', 'Trains', 'Transportation', 'Sports', 'Western', 'Zombies',
    'Religious', 'Travel', 'Environmental', 'Prehistoric', 'Territory Building'
  ];

  const TYPOLOGY_LABELS = {
    eurogame: 'Eurogame',
    american: 'American',
    ibrido: 'Ibrido',
    coop: 'Cooperativo',
    party: 'Party',
    filler: 'Filler',
    family: 'Family',
    astratto: 'Astratto',
    wargame: 'Wargame',
    solo: 'Solo',
    rollwrite: 'Roll & Write',
    dungeon: 'Dungeon Crawler',
    legacy: 'Legacy',
    narrativo: 'Narrativo',
    asimmetrico: 'Asimmetrico',
    deckbuilder: 'Deck Builder',
    dexterity: 'Dexterity',
    gateway: 'Gateway',
    escape: 'Escape Room',
    tricktaking: 'Trick-Taking'
  };

  const TYPOLOGY_ICONS = {
    eurogame: '🎯',
    american: '⚔️',
    ibrido: '🌀',
    coop: '🤝',
    party: '🎉',
    filler: '⚡',
    family: '👨‍👩‍👧',
    astratto: '◇',
    wargame: '🛡️',
    solo: '🧘',
    rollwrite: '✏️',
    dungeon: '🗡️',
    legacy: '📜',
    narrativo: '📖',
    asimmetrico: '⚖️',
    deckbuilder: '🃏',
    dexterity: '👋',
    gateway: '🚪',
    escape: '🔓',
    tricktaking: '🎴'
  };

  function topN(items, n) {
    const counts = {};
    for (const it of items) counts[it] = (counts[it] || 0) + 1;
    return Object.keys(counts)
      .sort((a, b) => counts[b] - counts[a])
      .slice(0, n);
  }

  /**
   * Weight di un singolo swipe per la derivazione dell'archetipo.
   * Combina ownership/rating con ORE AL TAVOLO loggate da BGG plays.
   *
   * Filosofia: 8h a Twilight Imperium pesa più di 5h a Trio nel decidere
   * "che tipo di Frogger sei", anche se entrambi sono rated/owned.
   * I giochi posseduti ma mai giocati hanno boost ridotto (collezione "passiva")
   * se l'utente è abbastanza attivo da avere ore loggate.
   *
   *  - Base 1
   *  - Ownership: ×1.5 se giocato/recente · ×0.6 se "scaffale" (0h e profilo attivo)
   *  - Rating ≥9 ×2 · ≥8 ×1.7 · ≥7 ×1.3
   *  - Ore al tavolo (BGG plays): ≥50h ×4 · ≥20h ×3 · ≥10h ×2.5 · ≥5h ×2 · ≥1h ×1.3
   *
   * @param totalPlaysContext - num plays totali del profilo. Se ≥20, attiva il decay
   *                            ownership per giochi non giocati. Se assente o basso,
   *                            ownership pieno (1.5x) per non penalizzare nuovi import.
   */
  function _swipeWeightForArchetype(s, totalPlaysContext) {
    if (!s) return 1;
    let w = 1;
    // Distingue owned attuale (forte segnale) da prevowned (segnale debole/ambiguo).
    // Un prevowned arrivato qui è entrato come 'love' SOLO se rating ≥7
    // (deriveReaction filtra il resto come 'pass'). Quindi è un segnale moderato.
    const ownedNow = !!(s.product && s.product.owned);
    const prevowned = !!(s.product && s.product.prevowned && !s.product.owned);
    const hours = (s.minutesPlayed || 0) / 60;
    const playsCount = s.playsCount || 0;
    // Profilo attivo: ha almeno 20 partite loggate complessivamente
    const isActiveProfile = (totalPlaysContext || 0) >= 20;

    if (ownedNow) {
      if (isActiveProfile && hours < 0.5 && playsCount === 0) {
        // Owned ma "sullo scaffale": collezione passiva, peso ridotto
        w *= 0.6;
      } else {
        w *= 1.5;
      }
    } else if (prevowned) {
      // Prevowned: l'avevi e l'hai venduto. Anche con rating alto, non rappresenta
      // più i tuoi gusti attuali quanto un owned. Boost moderato 1.1x.
      w *= 1.1;
    }

    const r = s.userRating || 0;
    if (r >= 9) w *= 2;
    else if (r >= 8) w *= 1.7;
    else if (r >= 7) w *= 1.3;

    // ENGAGEMENT = il MEGLIO tra "ore al tavolo" e "numero di partite" (fix 2026-06).
    // I minuti BGG sono spesso assenti (es. Faraway: 160 partite ma 0 min loggati) → da soli
    // seppellivano i giochi più giocati. Le partite coprono il buco; le ore restano (giochi
    // lunghi loggati col tempo). Si prende il massimo → nessuno dei due segnali sotterra l'altro.
    let hoursBoost = 1;
    if (hours >= 50) hoursBoost = 4;
    else if (hours >= 20) hoursBoost = 3;
    else if (hours >= 10) hoursBoost = 2.5;
    else if (hours >= 5) hoursBoost = 2;
    else if (hours >= 1) hoursBoost = 1.3;
    // RECENCY (fix 2026-06): le partite recenti (ultimi 365gg) valgono piene, le vecchie
    // al 30% → un gioco macinato 5 anni fa e oggi fermo SFUMA (non sei più tu di oggi).
    const recentPlays = (s.recentPlaysCount != null) ? s.recentPlaysCount : playsCount;
    const effPlays = recentPlays + Math.max(0, playsCount - recentPlays) * 0.3;
    let playsBoost = 1;
    if (effPlays >= 50) playsBoost = 4;
    else if (effPlays >= 25) playsBoost = 3;
    else if (effPlays >= 15) playsBoost = 2.5;
    else if (effPlays >= 8) playsBoost = 2;
    else if (effPlays >= 3) playsBoost = 1.3;
    w *= Math.max(hoursBoost, playsBoost);
    // TETTO DOMINANZA: nessun singolo gioco (preferito o iper-giocato) può monopolizzare il
    // profilo. Senza, un solo titolo riempiva i top-5 da solo. Cap morbido → declass relativo.
    if (w > 8) w = 8;
    return w;
  }

  function _evalFeature(featureName, getFeatures, loved, passed, totalLoved, totalPassed, totalPlaysContext) {
    // Sia conteggio "raw" (per backward compatibility) che pesato per ore/owned/rating
    let lovedHits = 0;
    let lovedSuperHits = 0;
    let lovedWeightedSum = 0;
    let totalLovedWeight = 0;
    for (const s of loved) {
      const swipeW = _swipeWeightForArchetype(s, totalPlaysContext);
      totalLovedWeight += swipeW;
      if (!s.product) continue;
      const features = getFeatures(s.product);
      if (!Array.isArray(features) || features.indexOf(featureName) === -1) continue;
      lovedHits++;
      lovedWeightedSum += swipeW;
      // Super hit = solo owned attuale o rating ≥9.
      // Prevowned non conta come super hit (anche se è entrato come love con rating ≥7),
      // perché l'utente ha scelto di liberarsene → segnale moderato non eccezionale.
      const ownedNow = !!s.product.owned;
      const r = s.userRating || 0;
      if (ownedNow || r >= 9) lovedSuperHits++;
    }
    let passedHits = 0;
    for (const s of passed) {
      if (!s.product) continue;
      const features = getFeatures(s.product);
      if (Array.isArray(features) && features.indexOf(featureName) >= 0) passedHits++;
    }
    if (lovedHits + passedHits === 0) return null;

    // Share PESATO per ore al tavolo (1h TI > 10x Trio 30min): chi gioca poche
    // sessioni lunghe di una tipologia conta come chi gioca tante sessioni brevi.
    const loveShareRaw = totalLoved > 0 ? lovedHits / totalLoved : 0;
    const loveShare = totalLovedWeight > 0 ? lovedWeightedSum / totalLovedWeight : loveShareRaw;
    const passShare = totalPassed > 0 ? passedHits / totalPassed : 0;
    const loveRatio = (lovedHits + passedHits) > 0 ? lovedHits / (lovedHits + passedHits) : 0;

    let verdict, score;
    if (loveShare >= 0.15) {
      verdict = 'top';
      score = loveShare * 100 + lovedSuperHits * 5;
    } else if (lovedSuperHits >= 2) {
      verdict = 'top';
      score = lovedSuperHits * 8 + loveShare * 50;
    } else if (lovedSuperHits >= 1) {
      verdict = 'safe';
      score = lovedSuperHits * 4 + loveShare * 30;
    } else if (lovedHits === 0 && passedHits >= Math.max(2, totalPassed * 0.10)) {
      verdict = 'avoided';
      score = -passShare * 100;
    } else if (loveRatio < 0.3 && passedHits >= Math.max(3, totalPassed * 0.15)) {
      verdict = 'avoided';
      score = -passShare * 100;
    } else {
      verdict = 'neutral';
      score = (loveShare - passShare * 0.5) * 50;
    }

    return { feature: featureName, verdict, score, lovedHits, passedHits, lovedSuperHits, loveShare, loveShareRaw, passShare, loveRatio };
  }

  function deriveProfileFromSwipes(swipes) {
    const loved = swipes.filter(s => s.reaction === 'love');
    const passed = swipes.filter(s => s.reaction === 'pass');
    const totalLoved = loved.length;
    const totalPassed = passed.length;

    const profile = {
      topMechanics: [],
      topCategories: [],
      topTypologies: [],
      topDesigners: [],
      avoidedMechanics: [],
      avoidedTypologies: [],
      weightTarget: null,
      weightRange: null,
      playtimeTarget: null,
      playerCountIdeal: null,
      experience: null,
      sample: { loved: totalLoved, passed: totalPassed }
    };

    if (totalLoved === 0 && totalPassed === 0) return profile;

    if (totalLoved === 0) {
      const passedC = [0, 0, 0, 0, 0];
      profile.topMechanics = [];
      profile.topCategories = [];
      profile.topTypologies = [];
      const passedMechBag = [];
      for (const s of passed) {
        if (s.product && Array.isArray(s.product.mch)) passedMechBag.push(...s.product.mch);
      }
      profile.avoidedMechanics = topN(passedMechBag, 3);
      return profile;
    }

    const allMech = new Set();
    const allCat = new Set();
    const allTyp = new Set();
    const allDes = new Set();
    for (const s of loved.concat(passed)) {
      if (!s.product) continue;
      if (Array.isArray(s.product.mch)) for (const m of s.product.mch) allMech.add(m);
      if (Array.isArray(s.product.cat)) {
        for (const c of s.product.cat) {
          if (isThemeCategory(c)) allCat.add(c);
        }
      }
      for (const t of deriveTypologies(s.product)) allTyp.add(t);
      if (Array.isArray(s.product.des)) for (const d of s.product.des) allDes.add(d);
    }

    const getMech = (p) => p.mch;
    const getCat = (p) => Array.isArray(p.cat) ? p.cat.filter(isThemeCategory) : [];
    const getTyp = (p) => deriveTypologies(p);
    const getDes = (p) => p.des;

    // Total plays loggate del profilo (per attivare ownership decay sui giochi-scaffale)
    const totalPlaysContext = swipes.reduce((sum, s) => sum + (s.playsCount || 0), 0);

    const mechResults = [];
    allMech.forEach(m => {
      const r = _evalFeature(m, getMech, loved, passed, totalLoved, totalPassed, totalPlaysContext);
      if (r) mechResults.push(r);
    });
    const catResults = [];
    allCat.forEach(c => {
      const r = _evalFeature(c, getCat, loved, passed, totalLoved, totalPassed, totalPlaysContext);
      if (r) catResults.push(r);
    });
    const typResults = [];
    allTyp.forEach(t => {
      const r = _evalFeature(t, getTyp, loved, passed, totalLoved, totalPassed, totalPlaysContext);
      if (r) typResults.push(r);
    });
    const desResults = [];
    allDes.forEach(d => {
      const r = _evalFeature(d, getDes, loved, passed, totalLoved, totalPassed, totalPlaysContext);
      if (r) desResults.push(r);
    });

    profile.topMechanics = mechResults.filter(r => r.verdict === 'top').sort((a, b) => b.score - a.score).slice(0, 5).map(r => r.feature);
    if (profile.topMechanics.length < 3) {
      const fallback = mechResults
        .filter(r => r.verdict === 'safe' || (r.verdict === 'neutral' && r.score > 0))
        .filter(r => profile.topMechanics.indexOf(r.feature) === -1)
        .sort((a, b) => b.score - a.score)
        .slice(0, 5 - profile.topMechanics.length);
      profile.topMechanics = profile.topMechanics.concat(fallback.map(r => r.feature));
    }

    profile.topCategories = catResults.filter(r => r.verdict === 'top').sort((a, b) => b.score - a.score).slice(0, 3).map(r => r.feature);
    if (profile.topCategories.length < 2) {
      const fallback = catResults
        .filter(r => r.verdict === 'safe' || (r.verdict === 'neutral' && r.score > 0))
        .filter(r => profile.topCategories.indexOf(r.feature) === -1)
        .sort((a, b) => b.score - a.score)
        .slice(0, 3 - profile.topCategories.length);
      profile.topCategories = profile.topCategories.concat(fallback.map(r => r.feature));
    }

    profile.topTypologies = typResults.filter(r => r.verdict === 'top').sort((a, b) => b.score - a.score).slice(0, 3).map(r => r.feature);
    if (profile.topTypologies.length < 2) {
      const fallback = typResults
        .filter(r => r.verdict === 'safe' || (r.verdict === 'neutral' && r.score > 0))
        .filter(r => profile.topTypologies.indexOf(r.feature) === -1)
        .sort((a, b) => b.score - a.score)
        .slice(0, 3 - profile.topTypologies.length);
      profile.topTypologies = profile.topTypologies.concat(fallback.map(r => r.feature));
    }

    profile.avoidedMechanics = mechResults
      .filter(r => r.verdict === 'avoided')
      .sort((a, b) => a.score - b.score)
      .slice(0, 3)
      .map(r => r.feature);

    profile.topDesigners = desResults
      .filter(r => r.verdict === 'top')
      .sort((a, b) => b.score - a.score)
      .slice(0, 5)
      .map(r => r.feature);
    if (profile.topDesigners.length < 3) {
      const fallback = desResults
        .filter(r => r.verdict === 'safe' && profile.topDesigners.indexOf(r.feature) === -1)
        .sort((a, b) => b.score - a.score)
        .slice(0, 5 - profile.topDesigners.length);
      profile.topDesigners = profile.topDesigners.concat(fallback.map(r => r.feature));
    }

    // ════════════════════════════════════════════════════════════════════
    // weightTarget: media pesata del peso BGG dei giochi.
    //
    // Filosofia: 1 partita di 8h a Twilight Imperium dovrebbe pesare di più
    // di 10 partite da 30 min a Trio. Il sistema premia ORE al tavolo, non
    // numero di partite (e neppure il semplice "love score").
    //
    // Componenti del peso (importance) per ogni gioco:
    //  - Base: 1
    //  - Owned/prevowned: 2x
    //  - Rating ≥9: 3x · ≥8: 2.5x · ≥7: 1.5x
    //  - Ore al tavolo loggate (da BGG plays):
    //      ≥50h: ×4 · ≥20h: ×3 · ≥10h: ×2.5 · ≥5h: ×2 · ≥1h: ×1.3
    //  Le ore moltiplicano la base, così TI con 1 partita di 8h ottiene
    //  importance = (1 owned × 2) × (≥5h × 2) = 4. Trio con 10 partite × 30 min = 5h
    //  ottiene importance = 1 × 2 = 2 (se non rated).
    //  → TI pesa il doppio di Trio nel calcolo dell'archetipo.
    // ════════════════════════════════════════════════════════════════════
    const lovedWeights = [];
    for (const s of loved) {
      if (!s.product || !s.product.w || s.product.w <= 0) continue;
      const r = s.userRating || 0;
      const ownedNow = !!s.product.owned;
      const prevowned = !!(s.product.prevowned && !s.product.owned);
      let importance = 1;
      // Owned attuale: full boost. Prevowned (rivenduto): boost ridotto 1.3x
      // perché non rappresenta i gusti attuali quanto un owned vivo.
      if (ownedNow) importance = 2;
      else if (prevowned) importance = 1.3;
      if (r >= 9) importance = Math.max(importance, 3);
      else if (r >= 8) importance = Math.max(importance, 2.5);
      else if (r >= 7) importance = Math.max(importance, 1.5);
      // ENGAGEMENT = meglio tra ore al tavolo e numero di partite (fix 2026-06).
      // Idem topMechanics: i minuti BGG sono spesso assenti → da soli sotterrano i più
      // giocati (Faraway). Le partite coprono il buco; si prende il massimo.
      const hours = (s.minutesPlayed || 0) / 60;
      const playsCount = s.playsCount || 0;
      let hoursBoost = 1;
      if (hours >= 50) hoursBoost = 4;
      else if (hours >= 20) hoursBoost = 3;
      else if (hours >= 10) hoursBoost = 2.5;
      else if (hours >= 5) hoursBoost = 2;
      else if (hours >= 1) hoursBoost = 1.3;
      // recency: recenti piene, vecchie al 30% (idem _swipeWeightForArchetype)
      const recentPlays = (s.recentPlaysCount != null) ? s.recentPlaysCount : playsCount;
      const effPlays = recentPlays + Math.max(0, playsCount - recentPlays) * 0.3;
      let playsBoost = 1;
      if (effPlays >= 50) playsBoost = 4;
      else if (effPlays >= 25) playsBoost = 3;
      else if (effPlays >= 15) playsBoost = 2.5;
      else if (effPlays >= 8) playsBoost = 2;
      else if (effPlays >= 3) playsBoost = 1.3;
      importance *= Math.max(hoursBoost, playsBoost);
      if (importance > 8) importance = 8; // tetto dominanza anche sul peso ideale
      lovedWeights.push({ value: s.product.w, weight: importance });
    }
    if (lovedWeights.length > 0) {
      const totalW = lovedWeights.reduce((sum, x) => sum + x.weight, 0);
      const weightedAvg = lovedWeights.reduce((sum, x) => sum + x.value * x.weight, 0) / totalW;
      profile.weightTarget = +weightedAvg.toFixed(2);
      profile.weightRange = [
        +(Math.max(1, profile.weightTarget - 0.8)).toFixed(1),
        +(Math.min(5, profile.weightTarget + 0.8)).toFixed(1)
      ];
    }

    const tmins = [];
    const tmaxs = [];
    for (const s of loved) {
      if (s.product && s.product.tmin > 0) tmins.push(s.product.tmin);
      if (s.product && s.product.tmax > 0) tmaxs.push(s.product.tmax);
    }
    if (tmins.length > 0 && tmaxs.length > 0) {
      const tminAvg = tmins.reduce((a, b) => a + b, 0) / tmins.length;
      const tmaxAvg = tmaxs.reduce((a, b) => a + b, 0) / tmaxs.length;
      profile.playtimeTarget = [Math.round(tminAvg / 5) * 5, Math.round(tmaxAvg / 5) * 5];
    }

    const bests = [];
    for (const s of loved) {
      if (!s.product) continue;
      if (s.product.pbest > 0) bests.push(s.product.pbest);
      else if (s.product.pmin > 0 && s.product.pmax > 0) bests.push(Math.round((s.product.pmin + s.product.pmax) / 2));
    }
    if (bests.length > 0) {
      const counts = {};
      for (const b of bests) counts[b] = (counts[b] || 0) + 1;
      const sorted = Object.keys(counts).sort((a, b) => counts[b] - counts[a]);
      profile.playerCountIdeal = parseInt(sorted[0], 10);
    }

    // Interazione & Alea: derivati come MEDIA pesata sui giochi amati
    const interactionVals = [];
    const aleaVals = [];
    for (const s of loved) {
      if (!s.product) continue;
      const r = s.userRating || 0;
      const owned = !!(s.product.owned || s.product.prevowned);
      let w = 1;
      if (owned) w = 2;
      if (r >= 9) w = 3;
      else if (r >= 8) w = 2.5;
      else if (r >= 7) w = 1.5;
      const inter = deriveInteraction(s.product);
      const alea = deriveAlea(s.product);
      if (inter != null) interactionVals.push({ value: inter, weight: w });
      if (alea != null) aleaVals.push({ value: alea, weight: w });
    }
    if (interactionVals.length >= 3) {
      const totalW = interactionVals.reduce((s, x) => s + x.weight, 0);
      const avg = interactionVals.reduce((s, x) => s + x.value * x.weight, 0) / totalW;
      profile.interactionPreference = Math.round(avg);
      profile.interactionAvg = +avg.toFixed(2);
    }
    if (aleaVals.length >= 3) {
      const totalW = aleaVals.reduce((s, x) => s + x.weight, 0);
      const avg = aleaVals.reduce((s, x) => s + x.value * x.weight, 0) / totalW;
      profile.aleaPreference = Math.round(avg);
      profile.aleaAvg = +avg.toFixed(2);
    }

    return profile;
  }

  function archetypeLabel(profile) {
    const t = profile.topTypologies[0];
    const w = profile.weightTarget;
    let weightLabel = '';
    if (w != null) {
      if (w < 2) weightLabel = 'Leggero';
      else if (w < 2.7) weightLabel = 'Medio-Leggero';
      else if (w < 3.5) weightLabel = 'Mediopesante';
      else if (w < 4.2) weightLabel = 'Pesante';
      else weightLabel = 'Cinghiale';
    }
    if (!t && !weightLabel) return 'Frogger';
    if (!t) return 'Frogger ' + weightLabel;
    const tLabel = TYPOLOGY_LABELS[t] || t;
    if (!weightLabel) return tLabel + ' Frogger';
    const noWeightModifier = ['filler', 'party', 'gateway', 'escape', 'rollwrite', 'tricktaking', 'dexterity'];
    if (noWeightModifier.indexOf(t) >= 0) return tLabel + ' Frogger';
    return tLabel + ' ' + weightLabel;
  }

  function archetypeTagline(profile) {
    const t = profile.topTypologies[0];
    const taglines = {
      eurogame: 'Costruisci motori, ottimizza azioni',
      american: 'Tema, scontri, narrazione',
      ibrido: 'Strategia tematica',
      coop: 'Vincere insieme è il punto',
      party: 'Risate, gruppo grande, caos buono',
      filler: 'Decisioni rapide, profondità in 30 minuti',
      family: 'Tutti dentro, regole accessibili',
      astratto: 'Skill pura, zero rumore',
      wargame: 'Tattica, posizione, controllo',
      solo: 'Tu contro il sistema',
      rollwrite: 'Carta, matita, scelte rapide',
      dungeon: 'Esplora, combatti, conquista',
      legacy: 'Una storia che si scrive',
      narrativo: 'Lascia che il gioco ti racconti',
      asimmetrico: 'Ogni giocatore, un gioco diverso',
      deckbuilder: 'Costruisci il tuo motore di carte',
      dexterity: 'Mani ferme, mira precisa',
      gateway: 'Il primo passo nel mondo dei giochi',
      escape: 'Risolvi il puzzle insieme',
      tricktaking: 'Bid, prese, controllo'
    };
    return taglines[t] || 'Profilo unico';
  }

  function buildProfile(swipes, products, extras) {
    const swipesWithProduct = swipes.map(s => {
      const product = products.find(p => p.id === s.productId);
      return Object.assign({}, s, { product });
    }).filter(s => s.product);

    const derived = deriveProfileFromSwipes(swipesWithProduct);
    const profile = Object.assign({
      version: 2,
      createdAt: Date.now(),
      updatedAt: Date.now(),
      source: (extras && extras.source) || 'swipe',
      archetypeName: archetypeLabel(derived),
      archetypeTagline: archetypeTagline(derived),
      experience: (extras && extras.experience) || null,
      age: (extras && extras.age) || null,
      motto: (extras && extras.motto) || null
    }, derived);
    // Applica score combinato per tag 'solo' (eventualmente già con dati BGG su extras)
    if (extras && extras.playsActivity) profile.playsActivity = extras.playsActivity;
    if (extras && extras.bggCollection) profile.bggCollection = extras.bggCollection;
    applySoloGamerTag(profile, products);
    return profile;
  }

  /**
   * Score combinato "Solo Gamer" — somma segnali multipli, soglia >= 4 per tag affidabile.
   * Risolve il bug "f.solo significa supporta solo, non ti piace solo".
   * Ritorna { score, breakdown, isSoloGamer }
   */
  function computeSoloGamerScore(profile, products) {
    const breakdown = {};
    let score = 0;

    // 1. Plays-in-solo reali (BGG players empty per quel play)
    const act = profile.playsActivity || {};
    const ratio = act.soloPlaysRatio || 0;
    const count = act.soloPlays || 0;
    if (ratio >= 0.25) { score += 3; breakdown.playsRatio = '+3 (≥25% solo)'; }
    else if (ratio >= 0.10) { score += 1; breakdown.playsRatio = '+1 (10-25% solo)'; }
    if (count >= 5) { score += 2; breakdown.playsCount = '+2 (5+ partite solo)'; }

    // 2. Possiede giochi PURI solo (pmin == 1 && pmax == 1)
    const owned = (profile.bggCollection && Array.isArray(profile.bggCollection.owned))
      ? profile.bggCollection.owned : [];
    const ownedProducts = owned.map(item => {
      const id = (typeof item === 'object') ? item.id : item;
      return (products || []).find(prod => prod.bgg === id);
    }).filter(Boolean);

    // FIX 2026-05-10: escludere giochi COOPERATIVI dai segnali solo.
    // Bug originale: escape room/coop con pmin=1 venivano contati come "solo"
    // anche se l'utente le gioca sempre col gruppo. Il flag f.coop o la mech
    // "Cooperative Game" sono il discriminante: chi ha coop pmin=1 le gioca
    // in gruppo, NON da solo. Eccezione: i giochi con f.solo esplicito (es.
    // Spirit Island, marcato sia coop sia solo) restano segnale valido per #3.
    const isCoopGame = (p) => {
      if (p.f && p.f.coop) return true;
      if (Array.isArray(p.mch) && p.mch.some(m => /Cooperative Game/i.test(m))) return true;
      return false;
    };

    // 2. Possiede giochi PURI solo (pmin == 1 && pmax == 1) — non coop, non escape
    const pureSolo = ownedProducts.filter(p => p.pmin === 1 && p.pmax === 1 && !isCoopGame(p)).length;
    if (pureSolo >= 3) { score += 2; breakdown.pureSolo = '+2 (' + pureSolo + ' giochi puri solo)'; }
    else if (pureSolo >= 1) { score += 1; breakdown.pureSolo = '+1 (' + pureSolo + ' giochi puri solo)'; }

    // 3. Almeno 10 giochi solo-friendly posseduti.
    // Manteniamo f.solo qui perché è un flag esplicito BGG ("solo-friendly")
    // che già esclude la maggior parte degli escape room (segnati solo coop).
    const soloFriendly = ownedProducts.filter(p => p.f && p.f.solo).length;
    if (soloFriendly >= 10) { score += 1; breakdown.soloFriendly = '+1 (' + soloFriendly + ' solo-friendly)'; }

    // 4. >50% giochi posseduti hanno pmin == 1 E NON sono coop (collezione skewed verso solo).
    // Escludendo i coop, le escape room e simili non contano più: chi le possiede
    // le gioca col gruppo, non da solo.
    if (ownedProducts.length >= 5) {
      const pmin1NotCoop = ownedProducts.filter(p => p.pmin === 1 && !isCoopGame(p)).length;
      const pmin1Ratio = pmin1NotCoop / ownedProducts.length;
      if (pmin1Ratio >= 0.5) { score += 2; breakdown.pmin1Ratio = '+2 (>50% pmin=1 non-coop)'; }
      else if (pmin1Ratio >= 0.3) { score += 1; breakdown.pmin1Ratio = '+1 (30-50% pmin=1 non-coop)'; }
    }

    return { score, breakdown, isSoloGamer: score >= 4 };
  }

  /**
   * Genera snapshot trimestrali del profilo.
   * Per chi ha BGG plays storiche, ricostruisce retroattivamente l'evoluzione.
   * Pattern Spotify Wrapped year cards: ogni snapshot è una card scrollabile.
   * Limite tecnico: usa lastPlayed di topPlayed (no per-play dates), quindi è
   * una "fotografia di cosa stavi giocando" in quella finestra (lastPlayed entro 6 mesi prima).
   */
  function generateRetroSnapshots(profile, products) {
    const out = [];
    const act = profile.playsActivity || {};
    const topPlayed = act.topPlayed || [];
    const createdAt = profile.createdAt || Date.now();

    // Genesi: il più vecchio fra createdAt Frogames e prima play BGG
    let genesisTs = createdAt;
    if (act.fromDate) {
      const firstPlayTs = new Date(act.fromDate).getTime();
      if (firstPlayTs > 0 && firstPlayTs < genesisTs) genesisTs = firstPlayTs;
    }
    const now = Date.now();
    const Q_MS = 90 * 86400000;
    const SIX_MO_MS = 180 * 86400000;

    // Genesi sempre presente (anche se non ha plays). Card "punto zero".
    // GENESI: punto zero del viaggio. Cerchiamo il "primo gioco" giocato (firstPlayed più vecchio).
    let firstGame = null;
    if (topPlayed.length > 0) {
      const candidates = topPlayed.filter(g => g.firstPlayed || g.lastPlayed).slice();
      if (candidates.length > 0) {
        candidates.sort((a, b) => {
          const aTs = new Date(a.firstPlayed || a.lastPlayed).getTime();
          const bTs = new Date(b.firstPlayed || b.lastPlayed).getTime();
          return aTs - bTs;
        });
        firstGame = { name: candidates[0].name, img: candidates[0].img };
      }
    }

    out.push({
      ts: genesisTs,
      label: '🌱 Genesi',
      season: 'genesi',
      isGenesis: true,
      typology: null,
      archetype: 'Girino',
      weightAvg: null,
      uniqueGames: 0,
      totalPlays: 0,
      topGame: firstGame,
      topDesigner: null
    });

    // ── SNAPSHOT TRIMESTRALI VERI con playsByQuarter ──
    // Per ogni gioco abbiamo plays distribuiti per quarter key (es. "2024-Q3").
    // Per ogni trimestre da Genesi a oggi, calcoliamo lo stato cumulative usando dati reali.
    const hasQuarterData = topPlayed.some(g => g.playsByQuarter && Object.keys(g.playsByQuarter).length > 0);
    if (!hasQuarterData) {
      // Nessun dato per quarter (worker vecchio o sync vecchio): aggiungi solo persistiti
      const persisted = (profile.snapshots || []).filter(s => s && s.ts);
      persisted.forEach(s => out.push(s));
      return out;
    }

    const seasonNamesQ = ['🌷 Primavera', '☀️ Estate', '🍂 Autunno', '❄️ Inverno'];
    const seasonKeysQ = ['primavera', 'estate', 'autunno', 'inverno'];

    // Genera lista trimestri da Genesi a oggi
    const startD = new Date(genesisTs);
    const startQ = { year: startD.getFullYear(), q: Math.floor(startD.getMonth() / 3) + 1 };
    const todayD = new Date(now);
    const todayQ = { year: todayD.getFullYear(), q: Math.floor(todayD.getMonth() / 3) + 1 };

    let curY = startQ.year;
    let curQ = startQ.q + 1; // primo snapshot al trimestre dopo la genesi
    if (curQ > 4) { curQ = 1; curY += 1; }

    while (curY < todayQ.year || (curY === todayQ.year && curQ < todayQ.q)) {
      // NB: < (not <=) per non generare snapshot futuri (Q corrente lo gestisce "Oggi")
      const qKey = curY + '-Q' + curQ;
      // Cumulative: tutti i giochi con almeno 1 play in qualche quarter <= cursor
      const cumulative = topPlayed.filter(g => {
        if (!g.playsByQuarter) return false;
        return Object.keys(g.playsByQuarter).some(k => {
          const [y, qStr] = k.split('-Q');
          const yy = parseInt(y, 10), qq = parseInt(qStr, 10);
          return yy < curY || (yy === curY && qq <= curQ);
        });
      });

      if (cumulative.length === 0) {
        // Avanza trimestre
        curQ++; if (curQ > 4) { curQ = 1; curY++; }
        continue;
      }

      // Plays di questo trimestre (per top game del periodo)
      const inThisQuarter = topPlayed.map(g => {
        const c = (g.playsByQuarter && g.playsByQuarter[qKey]) || 0;
        return c > 0 ? Object.assign({}, g, { _qPlays: c }) : null;
      }).filter(Boolean);

      // Peso medio cumulative pesato sui plays cumulativi (fino a curY-curQ)
      let weightSum = 0, weightW = 0;
      const designers = {};
      const typologyVotes = {};
      cumulative.forEach(g => {
        const product = (products || []).find(p => p.bgg === g.bggId);
        if (!product) return;
        // Plays cumulative fino a quel quarter
        const cumPlays = Object.entries(g.playsByQuarter || {}).reduce((s, [k, v]) => {
          const [y, qStr] = k.split('-Q');
          const yy = parseInt(y, 10), qq = parseInt(qStr, 10);
          if (yy < curY || (yy === curY && qq <= curQ)) return s + v;
          return s;
        }, 0);
        if (cumPlays === 0) return;
        if (product.w && product.w > 0) {
          weightSum += product.w * cumPlays;
          weightW += cumPlays;
        }
        if (Array.isArray(product.des)) {
          product.des.forEach(d => { designers[d] = (designers[d] || 0) + cumPlays; });
        }
        const typs = (window.FrogMatch && window.FrogMatch.deriveTypologies)
          ? window.FrogMatch.deriveTypologies(product) : [];
        typs.forEach(t => { typologyVotes[t] = (typologyVotes[t] || 0) + cumPlays; });
      });

      const weightAvg = weightW > 0 ? +(weightSum / weightW).toFixed(2) : null;
      const topDesigner = Object.entries(designers).sort((a, b) => b[1] - a[1])[0];
      const topTyp = Object.entries(typologyVotes).sort((a, b) => b[1] - a[1])[0];
      const topGameInQuarter = inThisQuarter.slice().sort((a, b) => b._qPlays - a._qPlays)[0];

      const fakeProfile = {
        topTypologies: topTyp ? [topTyp[0]] : [],
        weightTarget: weightAvg
      };
      const archetype = (window.FrogMatch && window.FrogMatch.archetypeLabel)
        ? window.FrogMatch.archetypeLabel(fakeProfile) : 'Frogger';

      // Total plays cumulativi
      const totalPlays = cumulative.reduce((s, g) => {
        return s + Object.entries(g.playsByQuarter || {}).reduce((ss, [k, v]) => {
          const [y, qStr] = k.split('-Q');
          const yy = parseInt(y, 10), qq = parseInt(qStr, 10);
          if (yy < curY || (yy === curY && qq <= curQ)) return ss + v;
          return ss;
        }, 0);
      }, 0);

      // Calcola timestamp medio del trimestre (mese centrale)
      const tsMonth = (curQ - 1) * 3 + 1; // mese centrale del trimestre (feb, mag, ago, nov)
      const ts = new Date(curY, tsMonth, 15).getTime();

      out.push({
        ts,
        label: seasonNamesQ[curQ - 1],
        season: seasonKeysQ[curQ - 1],
        isGenesis: false,
        typology: topTyp ? topTyp[0] : null,
        archetype,
        weightAvg,
        uniqueGames: cumulative.length,
        totalPlays,
        topGame: topGameInQuarter ? { name: topGameInQuarter.name, img: topGameInQuarter.img, plays: topGameInQuarter._qPlays } : null,
        topDesigner: topDesigner ? topDesigner[0] : null,
        quarterKey: qKey
      });

      // Avanza trimestre
      curQ++; if (curQ > 4) { curQ = 1; curY++; }
    }

    // Aggiungi anche snapshot persistiti (tutti dopo gli ultimi calcolati per data)
    const persisted = (profile.snapshots || []).filter(s => s && s.ts);
    persisted.forEach(s => out.push(s));

    // Ordina per timestamp e dedupe per quarterKey
    out.sort((a, b) => a.ts - b.ts);
    return out;
  }

  /**
   * Auto-snapshot trimestrale: salva snapshot live in profile.snapshots[]
   * se è passato un trimestre dall'ultimo. Persistente cross-device via metafield.
   */
  function maybeSaveQuarterlySnapshot(profile) {
    if (!profile) return false;
    const Q_MS = 90 * 86400000;
    const now = Date.now();
    const list = profile.snapshots || [];
    const last = list.length > 0 ? list[list.length - 1] : null;
    const lastTs = last ? last.ts : (profile.createdAt || 0);
    if (now - lastTs < Q_MS) return false; // troppo presto

    const act = profile.playsActivity || {};
    const top = (profile.topTypologies || [])[0] || null;
    const monthNames = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];
    const d = new Date(now);
    const seasonIdx = Math.floor(d.getMonth() / 3) % 4;
    const seasonNames = ['🌷 Primavera', '☀️ Estate', '🍂 Autunno', '❄️ Inverno'];
    const seasonKey = ['primavera', 'estate', 'autunno', 'inverno'][seasonIdx];
    const topGame = (act.topPlayed || [])[0];

    profile.snapshots = list.concat([{
      ts: now,
      label: seasonNames[seasonIdx],
      season: seasonKey,
      isGenesis: false,
      typology: top,
      archetype: profile.archetypeName || 'Frogger',
      weightAvg: profile.weightTarget || null,
      uniqueGames: act.uniqueGames || 0,
      totalPlays: act.totalPlays || 0,
      topGame: topGame ? { name: topGame.name, img: topGame.img, plays: topGame.plays } : null,
      topDesigner: (profile.topDesigners || [])[0] || null
    }]);
    return true;
  }

  /**
   * Post-process: applica score "solo" al profilo dopo derive automatico.
   * Va chiamato dopo deriveProfileFromSwipes / dopo sync BGG.
   * Aggiunge 'solo' a topTypologies SOLO se score >= 4.
   * Ricalcola anche archetypeName/Tagline.
   */
  function applySoloGamerTag(profile, products) {
    if (!profile) return profile;
    // Pulisce eventuale 'solo' residuo da vecchi profili (legacy)
    ['topTypologies', 'topTypologiesPrimary', 'topTypologiesSecondary'].forEach(key => {
      if (Array.isArray(profile[key])) {
        profile[key] = profile[key].filter(t => t !== 'solo');
      }
    });

    // Pulisce 'asimmetrico' errato: bug vecchio taggava qualsiasi gioco con Variable Player Powers
    // (anche family/light tipo Wingspan/Harmonies). Ora richiede peso >= 2.5.
    // Verifica se l'utente ha davvero almeno 1 gioco asimmetrico reale tra owned/played.
    if (products && Array.isArray(products)) {
      const act = profile.playsActivity || {};
      const ownedIds = new Set();
      if (profile.bggCollection && Array.isArray(profile.bggCollection.owned)) {
        profile.bggCollection.owned.forEach(item => {
          const id = (typeof item === 'object') ? item.id : item;
          if (id) ownedIds.add(id);
        });
      }
      const playedIds = new Set();
      if (act.topPlayed) act.topPlayed.forEach(g => { if (g.bggId) playedIds.add(g.bggId); });
      const hasAsimmetricoReal = products.some(p => {
        if (!p.bgg || (!ownedIds.has(p.bgg) && !playedIds.has(p.bgg))) return false;
        if (!Array.isArray(p.mch) || !p.mch.some(m => /Variable Player Powers/i.test(m))) return false;
        const conflict = p.mch.some(m => /Combat|Take That|Hidden Roles|Player Elimination|Hidden Movement/i.test(m));
        const coopHeavy = (p.f && p.f.coop || p.mch.some(m => /Cooperative Game/i.test(m))) && p.w != null && p.w >= 3.5;
        const veryHeavy = p.w != null && p.w >= 3.8;
        return conflict || coopHeavy || veryHeavy;
      });
      if (!hasAsimmetricoReal) {
        ['topTypologies', 'topTypologiesPrimary', 'topTypologiesSecondary'].forEach(key => {
          if (Array.isArray(profile[key])) {
            profile[key] = profile[key].filter(t => t !== 'asimmetrico');
          }
        });
      }

      // Stessa logica per 'ibrido': verifica se almeno 1 gioco posseduto/giocato è ibrido VERO
      // (euro≥3 AND amer≥3 AND diff≤2). Altrimenti rimuovi tag legacy.
      const hasIbridoReal = products.some(p => {
        if (!p.bgg || (!ownedIds.has(p.bgg) && !playedIds.has(p.bgg))) return false;
        if (!Array.isArray(p.mch)) return false;
        const euroScore = p.mch.filter(x => EURO_MECH.includes(x)).length;
        const amerScore = p.mch.filter(x => AMERICAN_MECH.includes(x)).length;
        return euroScore >= 3 && amerScore >= 3 && Math.abs(euroScore - amerScore) <= 2;
      });
      if (!hasIbridoReal) {
        ['topTypologies', 'topTypologiesPrimary', 'topTypologiesSecondary'].forEach(key => {
          if (Array.isArray(profile[key])) {
            profile[key] = profile[key].filter(t => t !== 'ibrido');
          }
        });
      }

      // Stessa logica per 'gateway': peso stretto 1.8-2.2 + rating ≥7.3.
      // Verifica se almeno 1 gioco posseduto/giocato è gateway VERO con la nuova soglia.
      const hasGatewayReal = products.some(p => {
        if (!p.bgg || (!ownedIds.has(p.bgg) && !playedIds.has(p.bgg))) return false;
        return p.w != null && p.w >= 1.8 && p.w <= 2.2 && p.rt >= 7.3;
      });
      if (!hasGatewayReal) {
        ['topTypologies', 'topTypologiesPrimary', 'topTypologiesSecondary'].forEach(key => {
          if (Array.isArray(profile[key])) {
            profile[key] = profile[key].filter(t => t !== 'gateway');
          }
        });
      }
    }

    const result = computeSoloGamerScore(profile, products);
    profile.soloGamerScore = result.score;
    profile.soloGamerBreakdown = result.breakdown;

    if (result.isSoloGamer) {
      // Inserisce 'solo' come prima typology
      profile.topTypologies = ['solo', ...(profile.topTypologies || [])].slice(0, 3);
    }

    // Ricalcola weightTarget pesato per ore (1h TI vale più di 10x Trio da 30 min)
    try { recomputeWeightTargetWithHours(profile, products); } catch (e) { /* silenzioso */ }

    // Ricalcola archetype con la lista aggiornata
    profile.archetypeName = archetypeLabel(profile);
    profile.archetypeTagline = archetypeTagline(profile);
    return profile;
  }

  /**
   * Ricalcola weightTarget pesando per ORE al tavolo + ownership/rating.
   * Filosofia: 1 partita di 8h a Twilight Imperium pesa di più di 10 partite a Trio
   * di 30 minuti, perché 8h > 5h totali.
   *
   * Sorgenti:
   *  - profile.bggCollection.owned (per ownership boost) → peso 2x base
   *  - profile.playsActivity.topPlayed (per ore al tavolo) → boost 1.3x → 4x
   *  - rating dei topPlayed (se BGG plays espone) → boost simile a "love"
   *
   * Aggiorna profile.weightTarget e profile.weightRange in place.
   */
  function recomputeWeightTargetWithHours(profile, products) {
    if (!profile || !products || !Array.isArray(products)) return;
    const act = profile.playsActivity || {};
    const ownedIds = new Set();
    if (profile.bggCollection && Array.isArray(profile.bggCollection.owned)) {
      for (const item of profile.bggCollection.owned) {
        const id = (typeof item === 'object') ? item.id : item;
        if (id) ownedIds.add(id);
      }
    }
    const minutesByBgg = {};
    if (Array.isArray(act.topPlayed)) {
      for (const g of act.topPlayed) {
        if (g.bggId) minutesByBgg[g.bggId] = g.minutes || 0;
      }
    }

    // Considera tutti i giochi conosciuti dell'utente (catalogo Frogames + topPlayed BGG)
    const candidates = [];
    // 1. Catalogo Frogames per i giochi posseduti / giocati
    for (const p of products) {
      if (!p.bgg || !p.w) continue;
      if (!ownedIds.has(p.bgg) && !minutesByBgg[p.bgg]) continue;
      candidates.push({ w: p.w, bgg: p.bgg });
    }
    // 2. Giochi BGG-only GIOCATI (con metadata enriched nel log partite)
    for (const g of (act.topPlayed || [])) {
      if (!g.bggId || !g.w) continue;
      if (candidates.some(c => c.bgg === g.bggId)) continue;
      candidates.push({ w: g.w, bgg: g.bggId });
    }
    // 3. Giochi POSSEDUTI su BGG fuori catalogo, col peso arricchito dal worker
    //    (enrichOwnedWithThingMeta). Senza questa fonte il peso ideale collassava
    //    sui pochi titoli leggeri a catalogo (≈1.7) ignorando la collezione vera:
    //    chi possiede giochi pesanti NON venduti da Frogames vedeva sempre ~1.7.
    if (profile.bggCollection && Array.isArray(profile.bggCollection.owned)) {
      for (const item of profile.bggCollection.owned) {
        if (!item || typeof item !== 'object') continue;
        const bgg = item.id;
        const w = (typeof item.w === 'number') ? item.w : null;
        if (!bgg || !w || w <= 0) continue;
        if (candidates.some(c => c.bgg === bgg)) continue;
        candidates.push({ w: w, bgg: bgg });
      }
    }
    if (candidates.length === 0) return;

    // Profilo attivo (≥20 plays totali)? → applica decay ownership su giochi-scaffale
    const totalPlaysCtx = (act.totalPlays || 0);
    const isActiveProfile = totalPlaysCtx >= 20;

    const lovedWeights = [];
    for (const c of candidates) {
      const owned = ownedIds.has(c.bgg);
      const hours = (minutesByBgg[c.bgg] || 0) / 60;
      let importance = 1;
      // Ownership: boost ridotto se "scaffale" (0h e profilo attivo) → 0.6x invece di 2x
      if (owned) {
        importance *= (isActiveProfile && hours < 0.5) ? 0.6 : 2;
      }
      // Boost per ore al tavolo
      let hoursBoost = 1;
      if (hours >= 50) hoursBoost = 4;
      else if (hours >= 20) hoursBoost = 3;
      else if (hours >= 10) hoursBoost = 2.5;
      else if (hours >= 5) hoursBoost = 2;
      else if (hours >= 1) hoursBoost = 1.3;
      importance *= hoursBoost;
      lovedWeights.push({ value: c.w, weight: importance });
    }
    if (lovedWeights.length === 0) return;

    const totalW = lovedWeights.reduce((sum, x) => sum + x.weight, 0);
    const weightedAvg = lovedWeights.reduce((sum, x) => sum + x.value * x.weight, 0) / totalW;
    profile.weightTarget = +weightedAvg.toFixed(2);
    profile.weightRange = [
      +(Math.max(1, profile.weightTarget - 0.8)).toFixed(1),
      +(Math.min(5, profile.weightTarget + 0.8)).toFixed(1)
    ];
  }

  /**
   * Ri-deriva le feature di GUSTO (meccaniche, categorie, tipologie, durata, interazione,
   * alea) dalla collezione BGG ARRICCHITA (bggCollection.owned con w/tmin/tmax/cat/mch).
   *
   * BUG che risolve: dopo import/refresh veniva ricalcolato SOLO il peso
   * (recomputeWeightTargetWithHours), lasciando mecc./cat./tipologia/durata congelate
   * alla PRIMA derivazione (spesso fatta su pochissimi giochi → profilo "di un gioco solo").
   *
   * Riusa la stessa deriveProfileFromSwipes dell'import, ma alimentata dalla collezione
   * COMPLETA. Merge selettivo: NON tocca i campi che la collezione non può fornire
   * (designers, player count) per non sovrascriverli con vuoto, e lascia il PESO alla sua
   * fonte ufficiale (recomputeWeightTargetWithHours via applySoloGamerTag).
   */
  function recomputeProfileFromCollection(profile, products) {
    if (!profile || !profile.bggCollection) return profile;
    const bc = profile.bggCollection;
    const owned = Array.isArray(bc.owned) ? bc.owned : [];
    const wish = Array.isArray(bc.wishlist) ? bc.wishlist : [];

    // Minuti/partite per gioco (per pesare l'archetipo: ore al tavolo > numero partite)
    const act = profile.playsActivity || {};
    const minutesByBgg = {}, playsByBgg = {}, recentByBgg = {};
    if (Array.isArray(act.topPlayed)) {
      for (const g of act.topPlayed) {
        if (!g.bggId) continue;
        minutesByBgg[g.bggId] = g.minutes || 0;
        playsByBgg[g.bggId] = g.plays || 0;
        recentByBgg[g.bggId] = (g.plays365d != null) ? g.plays365d : (g.recentPlays || 0);
      }
    }

    const toProduct = (item, isOwned) => {
      if (!item || typeof item !== 'object') return null;
      const mch = Array.isArray(item.mch) ? item.mch : [];
      const cat = Array.isArray(item.cat) ? item.cat : [];
      const hasW = (typeof item.w === 'number' && item.w > 0);
      if (mch.length === 0 && cat.length === 0 && !hasW) return null; // niente metadati → inutile
      const catLow = cat.map(c => String(c).toLowerCase());
      const mchLow = mch.map(m => String(m).toLowerCase());
      const bid = (typeof item.id === 'number' && item.id > 0) ? item.id : null;
      return {
        id: item.id, bgg: bid, t: item.name,
        w: hasW ? item.w : null,
        tmin: item.tmin || 0, tmax: item.tmax || 0,
        mch: mch, cat: cat, des: [], rt: 0,
        owned: !!isOwned,
        // f derivato da cat/mch come nell'import (gli owned salvati non conservano f)
        f: {
          coop: catLow.some(c => /cooperative/.test(c)) || mchLow.some(m => /cooperative game/.test(m)),
          party: catLow.some(c => /party/.test(c)),
          solo: mchLow.some(m => /solo|solitaire/.test(m)),
          t2p: false,
          team: catLow.some(c => /team/.test(c)) || mchLow.some(m => /team-based/.test(m))
        }
      };
    };

    const swipes = [];
    const pushSwipe = (item, isOwned) => {
      const prod = toProduct(item, isOwned);
      if (!prod) return;
      const bid = prod.bgg;
      swipes.push({
        productId: prod.id, reaction: 'love', product: prod, userRating: null,
        minutesPlayed: bid ? (minutesByBgg[bid] || 0) : 0,
        playsCount: bid ? (playsByBgg[bid] || 0) : 0,
        recentPlaysCount: bid ? (recentByBgg[bid] || 0) : 0
      });
    };
    for (const it of owned) pushSwipe(it, true);
    for (const it of wish) pushSwipe(it, false);

    // Guardia qualità: serve un minimo di giochi con meccaniche/categorie, altrimenti
    // NON degradare il profilo esistente (es. collezione non ancora arricchita).
    const withMeta = swipes.filter(s => s.product.mch.length > 0 || s.product.cat.length > 0);
    if (withMeta.length < 3) return profile;

    const d = deriveProfileFromSwipes(swipes);

    // Merge SELETTIVO: solo ciò che la collezione fornisce in modo affidabile.
    if (d.topMechanics && d.topMechanics.length) profile.topMechanics = d.topMechanics;
    if (d.topCategories && d.topCategories.length) profile.topCategories = d.topCategories;
    if (d.topTypologies && d.topTypologies.length) profile.topTypologies = d.topTypologies;
    // avoidedMechanics: la collezione è tutta "love" → niente segnale di rifiuto.
    // Sovrascrivo solo se la derivazione ne produce, per non azzerare dati esistenti.
    if (d.avoidedMechanics && d.avoidedMechanics.length) profile.avoidedMechanics = d.avoidedMechanics;
    if (Array.isArray(d.playtimeTarget) && d.playtimeTarget.length === 2) profile.playtimeTarget = d.playtimeTarget;
    if (d.interactionPreference != null) { profile.interactionPreference = d.interactionPreference; profile.interactionAvg = d.interactionAvg; }
    if (d.aleaPreference != null) { profile.aleaPreference = d.aleaPreference; profile.aleaAvg = d.aleaAvg; }
    // Peso: NON toccato qui — lo possiede recomputeWeightTargetWithHours (via applySoloGamerTag).

    return profile;
  }

  // ══════════════════════════════════════════════════════════════════════════
  // computeMatch v3 (2026-05-12) — refactor "math fatto bene e sempre onesto"
  // ──────────────────────────────────────────────────────────────────────────
  // Cosa cambia rispetto a v2:
  //  1. Meccaniche/categorie ora usano position-weighted log shrinkage:
  //     ogni shared aggiunge un contributo che DECRESCE con la posizione
  //     nel ranking utente. Niente più "divido per topMechanics.length"
  //     (che penalizzava la varietà — più mech avevi, meno scoravi).
  //     Pilgrims con 3 mech in comune ora scora ~20pt su 25, non 7.5/25.
  //  2. "Unknown ≠ negative". Se l'utente non conosce una meccanica/cat
  //     non scoriamo zero — la mettiamo in `unknowns[]` per dirla in Fase 2
  //     come "🌱 da scoprire". Il punteggio negativo arriva SOLO da segnali
  //     espliciti (avoidedMechanics, peso lontano, interazione/alea opposta).
  //  3. Display rescaling Netflix-style: lo score interno (0-100) viene
  //     rimappato per il display in modo che un match "decente" (35+ interno)
  //     parta da 60% in vista — coerente con come gli utenti leggono i %.
  //     Sotto 25 internal: niente numero, solo badge "Esplorazione".
  //  4. Confidence gate: se totalSignal < 10 (pochi swipe + plays + posseduti),
  //     niente numero, solo badge "Da scoprire" — il sistema è onesto sul fatto
  //     che non sa abbastanza per dare un numero affidabile.
  //  5. Recency pesa: weightedPlays già viene usato per topPlayed/heavilyPlayed,
  //     mantenuto identico (30d×3, 90d×2, 180d×1, 365d×0.5, older×0.25).
  //  6. Espone parts + positives[]/negatives[]/unknowns[] per la breakdown
  //     "✅ Attrae / ⚖️ Attenua / 🌱 Da scoprire" di Fase 2.
  //
  // Output:
  //   pct: number (0-100, display rescalato — può essere 0 se hideNumber)
  //   internalScore: number (0-100, raw — usato da rankProducts per sort)
  //   tier: 'top'|'strong'|'good'|'discover'|'distant'|'explore'
  //   hideNumber: bool (true se confidence troppo bassa o score < soglia)
  //   parts: { typologyPrimary, mechanics, categories, weight, duration,
  //            players, interactionMatch, aleaMatch, rating, penalty,
  //            fourFavBoost, communityBoost, ownershipBoost, playedBoost,
  //            realFit, ownedFrogames, ownedBgg }
  //   positives[], negatives[], unknowns[]: arrays di { kind, ... } per UI Fase 2
  // ══════════════════════════════════════════════════════════════════════════
  function computeMatch(profile, product) {
    if (!product) return null;
    let score = 0;
    const parts = {};
    const positives = [];
    const negatives = [];
    const unknowns = [];

    // ─── ENRICHMENT FALLBACK (2026-05-12) ────────────────────────────────
    // Se il prodotto Shopify ha metafield BGG vuoti (mch/cat/tmin/etc), ma
    // l'utente ha già loggato partite di questo gioco (con dati BGG enriched
    // dal worker), uso QUELLI come fallback. Senza, prodotti senza metafield
    // BGG (es. nuovi arrivi non ancora syncati) mostrano sempre 0 match.
    //
    // FALLBACK PER NOME: se né product.bgg né product.id matchano una topPlayed,
    // proviamo a matchare per nome normalizzato. Caso d'uso: Tax the Rich con
    // bgg_id metafield vuoto + play loggata da BGG search (bggId reale, productId null).
    const _normalizeName = (s) => (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '') // togli accenti
      .replace(/[^a-z0-9]+/g, ' ') // tutto non-alfanum → spazio
      .trim();
    const productEnrichedFromPlay = (function () {
      if (!profile.playsActivity || !Array.isArray(profile.playsActivity.topPlayed)) return null;
      const topPlayed = profile.playsActivity.topPlayed;
      let tp = topPlayed.find(g =>
        (product.bgg && g.bggId === product.bgg) ||
        (product.id && String(g.productId) === String(product.id))
      );
      // Fallback per nome se bggId/productId non hanno matchato
      if (!tp && product.t) {
        const pName = _normalizeName(product.t);
        if (pName.length >= 3) {
          tp = topPlayed.find(g => g.name && _normalizeName(g.name) === pName);
        }
      }
      if (!tp) return null;
      const hasMech = product.mch && product.mch.length > 0;
      const hasCat = product.cat && product.cat.length > 0;
      const hasW = product.w != null && product.w > 0;
      // Se i dati ci sono già, non sovrascriviamo
      if (hasMech && hasCat && hasW) return null;
      return {
        mch: hasMech ? product.mch : (Array.isArray(tp.mch) ? tp.mch : []),
        cat: hasCat ? product.cat : (Array.isArray(tp.cat) ? tp.cat : []),
        w: hasW ? product.w : (typeof tp.weight === 'number' ? tp.weight : null),
        bgg: product.bgg || tp.bggId || null,
        tmin: product.tmin || tp.playingTime || tp.tmin || null,
        tmax: product.tmax || tp.playingTime || tp.tmax || null,
        rt: product.rt || tp.rating || null
      };
    })();
    if (productEnrichedFromPlay) {
      // Merge non-destrutivo: usato SOLO localmente in computeMatch, non muta product
      product = Object.assign({}, product, {
        mch: productEnrichedFromPlay.mch,
        cat: productEnrichedFromPlay.cat,
        w: productEnrichedFromPlay.w != null ? productEnrichedFromPlay.w : product.w,
        bgg: productEnrichedFromPlay.bgg,
        tmin: productEnrichedFromPlay.tmin || product.tmin,
        tmax: productEnrichedFromPlay.tmax || product.tmax,
        rt: productEnrichedFromPlay.rt || product.rt
      });
      parts.enrichedFromPlay = true;
    }

    // ─── A) TIPOLOGIA — cap 25 (segnale identità più forte) ─────────────
    const productTyps = deriveTypologies(product);
    // COERENZA label↔match (fix 2026-06): la label archetipo usa SOLO topTypologies[0].
    // Prima qui invece TUTTE le topTypologies (fino a 3) erano "primarie" a peso pieno →
    // un profilo "Deck Builder" premiava american/eurogame uguale. Ora: profili swipe/BGG
    // (che non popolano *Primary) usano la 1ª come primaria, le altre come secondarie.
    let primaryTyps, secondaryTyps;
    if (profile.topTypologiesPrimary && profile.topTypologiesPrimary.length) {
      primaryTyps = profile.topTypologiesPrimary;
      secondaryTyps = profile.topTypologiesSecondary || [];
    } else {
      const _tt = profile.topTypologies || [];
      primaryTyps = _tt.slice(0, 1);
      secondaryTyps = (profile.topTypologiesSecondary && profile.topTypologiesSecondary.length)
        ? profile.topTypologiesSecondary
        : _tt.slice(1);
    }
    const tSharedPrimary = primaryTyps.filter(t => productTyps.includes(t));
    const tSharedSecondary = secondaryTyps.filter(t => productTyps.includes(t));
    const tShared = tSharedPrimary.concat(tSharedSecondary);
    if (tSharedPrimary.length > 0) {
      // 1 primario shared = 18, 2 = 25 (cap). Position-aware non serve: max 2 primary.
      parts.typologyPrimary = Math.min(25, 18 + (tSharedPrimary.length - 1) * 7);
      score += parts.typologyPrimary;
      positives.push({ kind: 'typology', strength: 'high', match: tSharedPrimary });
    } else if (tSharedSecondary.length > 0) {
      parts.typologySecondary = Math.min(8, tSharedSecondary.length * 8);
      score += parts.typologySecondary;
      positives.push({ kind: 'typology', strength: 'mid', match: tSharedSecondary });
    } else if (primaryTyps.length > 0 && productTyps.length > 0) {
      // Tipologia diversa — la diciamo come "diversa" non come "negativa".
      // Niente penalità: l'utente potrebbe voler esplorare.
      unknowns.push({ kind: 'typology', userPrefers: primaryTyps[0], productIs: productTyps[0] });
    }

    // ─── B) MECCANICHE — cap 25, position-weighted ────────────────────────
    // Ogni shared contribuisce 8 / (1 + pos×0.2):
    //  pos 0 → 8.0   pos 5 → 4.0
    //  pos 1 → 6.67  pos 6 → 3.64
    //  pos 2 → 5.71  pos 7 → 3.33
    //  pos 3 → 5.0   pos 8 → 3.08
    //  pos 4 → 4.44  pos 9 → 2.86
    // Cap 25 saturato con 4-5 match nel top del profilo.
    // Razionale: condividere 3 meccaniche è già un segnale forte.
    // Dividere per topMechanics.length come prima penalizzava la varietà.
    const topMechs = profile.topMechanics || [];
    const productMechs = product.mch || [];
    const mShared = topMechs.filter(m => productMechs.includes(m));
    if (topMechs.length > 0 && mShared.length > 0) {
      let mScore = 0;
      mShared.forEach(m => {
        const pos = topMechs.indexOf(m);
        mScore += 8 / (1 + pos * 0.2);
      });
      parts.mechanics = Math.min(25, mScore);
      score += parts.mechanics;
      positives.push({ kind: 'mechanics', shared: mShared.slice(0, 4), count: mShared.length });
    }
    // Meccaniche del prodotto che l'utente non conosce (non avoided, non in topMechs)
    // → "🌱 da scoprire" in Fase 2. NON sottraiamo punti per queste.
    const avoidedSet = new Set(profile.avoidedMechanics || []);
    const topMechsSet = new Set(topMechs);
    const mUnknown = productMechs.filter(m => !topMechsSet.has(m) && !avoidedSet.has(m));
    if (mUnknown.length > 0 && topMechs.length > 0) {
      unknowns.push({ kind: 'mechanics', list: mUnknown.slice(0, 5) });
    }

    // ─── C) CATEGORIE — cap 15, position-weighted ────────────────────────
    const topCats = profile.topCategories || [];
    const productCats = product.cat || [];
    const cShared = topCats.filter(c => productCats.includes(c));
    if (topCats.length > 0 && cShared.length > 0) {
      let cScore = 0;
      cShared.forEach(c => {
        const pos = topCats.indexOf(c);
        cScore += 5 / (1 + pos * 0.2);
      });
      parts.categories = Math.min(15, cScore);
      score += parts.categories;
      positives.push({ kind: 'categories', shared: cShared.slice(0, 3), count: cShared.length });
    }

    // ─── D) PESO — cap 8 ────────────────────────────────────────────────
    if (product.w != null && product.w > 0 && profile.weightTarget != null) {
      const diffPrimary = Math.abs(product.w - profile.weightTarget);
      let weightScore = 8 * Math.max(0, 1 - diffPrimary / 2.5);
      if (profile.weightSecondary != null) {
        const diffSecondary = Math.abs(product.w - profile.weightSecondary);
        const secondaryScore = 4 * Math.max(0, 1 - diffSecondary / 2.5);
        weightScore = Math.max(weightScore, secondaryScore);
      }
      parts.weight = weightScore;
      score += parts.weight;
      if (parts.weight >= 5) {
        positives.push({ kind: 'weight', productW: product.w, userW: profile.weightTarget });
      } else if (diffPrimary >= 1.5) {
        // Solo peso davvero lontano (>= 1.5 diff su scala 1-5) è "attenua".
        // 1.0 di differenza = -2 pt soft, 1.5+ = -4 pt fermo.
        const penalty = diffPrimary >= 2 ? -4 : -2;
        parts.weightPenalty = penalty;
        score += penalty;
        negatives.push({ kind: 'weight', productW: product.w, userW: profile.weightTarget, diff: diffPrimary });
      }
    }
    // Peso sconosciuto: nessuna penalità, nessun bonus.

    // ─── E) DURATA — cap 7 ──────────────────────────────────────────────
    // FIX 2026-06: serve ANCHE tmin valido. Prima con tmin mancante (undefined+tmax)/2 = NaN
    // → durationScore NaN → internalScore NaN → ranking corrotto (confronti con NaN sempre falsi).
    if (product.tmin > 0 && product.tmax > 0 && profile.playtimeTarget) {
      const targetMid = (profile.playtimeTarget[0] + profile.playtimeTarget[1]) / 2;
      const productMid = (product.tmin + product.tmax) / 2;
      const diffPrimary = Math.abs(targetMid - productMid);
      let durationScore = 7 * Math.max(0, 1 - diffPrimary / 90);
      if (profile.playtimeAcceptable && profile.playtimeAcceptable !== profile.playtimeTarget) {
        const accMid = (profile.playtimeAcceptable[0] + profile.playtimeAcceptable[1]) / 2;
        const diffAcc = Math.abs(accMid - productMid);
        const accScore = 4 * Math.max(0, 1 - diffAcc / 90);
        durationScore = Math.max(durationScore, accScore);
      }
      parts.duration = durationScore;
      score += parts.duration;
      if (parts.duration >= 5) {
        positives.push({ kind: 'duration', tmin: product.tmin, tmax: product.tmax });
      }
    }

    // ─── F) GIOCATORI — cap 5, no penalità se mismatch ──────────────────
    if (product.pmin > 0 && product.pmax > 0) {
      const PLAYER_RANGES = { '1': [1, 1], '2': [2, 2], '3': [3, 4], '5': [5, 99] };
      let userRanges = [];
      if (profile.playerCounts && profile.playerCounts.length > 0) {
        userRanges = profile.playerCounts.map(p => PLAYER_RANGES[p] || [parseInt(p, 10), parseInt(p, 10)]);
      } else if (profile.playerCountIdeal) {
        userRanges = [[profile.playerCountIdeal, profile.playerCountIdeal]];
      }
      if (userRanges.length > 0) {
        const matches = userRanges.some(r => product.pmax >= r[0] && product.pmin <= r[1]);
        parts.players = matches ? 5 : 0;
        if (matches) {
          score += parts.players;
          positives.push({ kind: 'players', pmin: product.pmin, pmax: product.pmax });
        }
        // Niente penalità per mismatch: chi gioca in 4 può anche giocare in 2.
      }
    }

    // ─── G) INTERAZIONE — cap 6, può essere lievemente negativo ─────────
    if (profile.interactionPreference != null) {
      const productInter = deriveInteraction(product);
      if (productInter != null) {
        const distance = Math.abs(productInter - profile.interactionPreference);
        if (distance === 0) parts.interactionMatch = 6;
        else if (distance === 1) parts.interactionMatch = 3;
        else if (distance === 2) parts.interactionMatch = 0;
        else parts.interactionMatch = -3; // distanza 3 = mismatch totale, ma soft
        score += parts.interactionMatch;
        if (parts.interactionMatch >= 6) {
          positives.push({ kind: 'interaction', user: profile.interactionPreference, product: productInter });
        } else if (parts.interactionMatch < 0) {
          negatives.push({ kind: 'interaction', user: profile.interactionPreference, product: productInter });
        }
      }
    }

    // ─── H) ALEA — stesso schema ────────────────────────────────────────
    if (profile.aleaPreference != null) {
      const productAlea = deriveAlea(product);
      if (productAlea != null) {
        const distance = Math.abs(productAlea - profile.aleaPreference);
        if (distance === 0) parts.aleaMatch = 6;
        else if (distance === 1) parts.aleaMatch = 3;
        else if (distance === 2) parts.aleaMatch = 0;
        else parts.aleaMatch = -3;
        score += parts.aleaMatch;
        if (parts.aleaMatch >= 6) {
          positives.push({ kind: 'alea', user: profile.aleaPreference, product: productAlea });
        } else if (parts.aleaMatch < 0) {
          negatives.push({ kind: 'alea', user: profile.aleaPreference, product: productAlea });
        }
      }
    }

    // ─── I) RATING BGG — cap 5 ──────────────────────────────────────────
    if (product.rt > 7.5) {
      parts.rating = product.rt > 8 ? 5 : 3;
      score += parts.rating;
      positives.push({ kind: 'rating', value: product.rt });
    }

    // ─── J) MECCANICHE EVITATE — cap -12 ────────────────────────────────
    const avoidedHits = (profile.avoidedMechanics || []).filter(a => productMechs.includes(a));
    if (avoidedHits.length > 0) {
      parts.penalty = -Math.min(12, avoidedHits.length * 6);
      score += parts.penalty;
      negatives.push({ kind: 'avoided', list: avoidedHits });
    }

    // ─── K) FOUR FAVORITES — cap 10 (fix 2026-06: era 20) ───────────────
    // Per ogni "Gioco del cuore" che condivide ≥3 meccaniche DISTINTIVE col prodotto → +5pt.
    // FIX: prima bastavano 3 meccaniche QUALSIASI → Viscounts (3 tag generici come Scythe)
    // prendeva +20 finto. Ora i tag ubiqui (VPP, Area Majority, Hand Management…) NON contano:
    // serve vera somiglianza su meccaniche distintive. Cap dimezzato 20→10.
    if (window.FrogMatch && window.FrogMatch._fourFavoritesMechs && productMechs.length > 0) {
      const favMechsArray = window.FrogMatch._fourFavoritesMechs;
      let boost = 0;
      let matchedFavorites = 0;
      for (const favMechs of favMechsArray) {
        if (!favMechs || favMechs.size === 0) continue;
        let shared = 0;
        for (const m of productMechs) {
          if (favMechs.has(m) && GENERIC_MECH.indexOf(m) === -1) shared++; // solo meccaniche DISTINTIVE
        }
        if (shared >= 3) {
          boost += 5;
          matchedFavorites++;
        }
      }
      if (boost > 0) {
        parts.fourFavBoost = Math.min(10, boost);
        parts.fourFavMatched = matchedFavorites;
        score += parts.fourFavBoost;
        positives.push({ kind: 'favorites', matched: matchedFavorites });
      }
    }

    // ─── L) COMMUNITY SIGNAL ────────────────────────────────────────────
    if (window.FrogMatch && window.FrogMatch._communityData && product.bgg) {
      const c = window.FrogMatch._communityData[product.bgg];
      if (c && c.uniqueFroggers >= 10) {
        let boost;
        if (c.uniqueFroggers >= 60) boost = 6;
        else if (c.uniqueFroggers >= 30) boost = 4;
        else boost = 2;
        if (c.avgPlaysPerFrogger30d >= 5) boost = boost * 1.5;
        else if (c.avgPlaysPerFrogger30d >= 3) boost = boost * 1.2;
        parts.communityBoost = +boost.toFixed(1);
        score += parts.communityBoost;
        positives.push({ kind: 'community', froggers: c.uniqueFroggers });
      }
    }

    // ─── M) OWNERSHIP (+6) ──────────────────────────────────────────────
    // Fix 2026-05-12: aggiunto check su profile.manualOwned (giochi aggiunti
    // manualmente alla ludoteca dall'utente, senza acquisto Frogames né BGG sync).
    // Prima la "ludoteca manuale" non veniva considerata → match% non riconosceva
    // i giochi posseduti dall'utente se aggiunti via "Aggiungi al tuo scaffale".
    let isOwnedFrogames = false, isOwnedBgg = false, isOwnedManual = false;
    if (profile.purchasedProducts && profile.purchasedProducts.length > 0 && product.id) {
      const purchasedIds = new Set(profile.purchasedProducts.map(p => String(p.productId)));
      if (purchasedIds.has(String(product.id))) isOwnedFrogames = true;
    }
    if (profile.bggCollection && profile.bggCollection.owned && product.bgg) {
      isOwnedBgg = profile.bggCollection.owned.some(item => {
        const id = (typeof item === 'object') ? item.id : item;
        return id === product.bgg;
      });
    }
    if (Array.isArray(profile.manualOwned) && profile.manualOwned.length > 0) {
      const pName = product.t ? _normalizeName(product.t) : '';
      isOwnedManual = profile.manualOwned.some(m => {
        if (product.bgg && m.bggId === product.bgg) return true;
        if (product.id && String(m.productId) === String(product.id)) return true;
        if (pName.length >= 3 && m.title && _normalizeName(m.title) === pName) return true;
        return false;
      });
    }
    if (isOwnedFrogames || isOwnedBgg || isOwnedManual) {
      parts.ownershipBoost = 6;
      parts.ownedFrogames = isOwnedFrogames;
      parts.ownedBgg = isOwnedBgg;
      parts.ownedManual = isOwnedManual;
      score += parts.ownershipBoost;
      positives.push({ kind: 'ownership', frogames: isOwnedFrogames, bgg: isOwnedBgg, manual: isOwnedManual });
    }

    // ─── N) PLAYED BOOST (time-decayed via weightedPlays) ───────────────
    // FIX 2026-05-12 (3 livelli di lookup):
    //   1. topPlayed (curated/enriched dal worker BGG)
    //   2. manualPlays a root level (partite loggate a mano, possono non essere
    //      ancora state mergiate in topPlayed se il BGG sync ha sovrascritto)
    //   3. Match per bggId, productId, nome normalizzato — in ordine di affidabilità
    const topPlayedArr = (profile.playsActivity && Array.isArray(profile.playsActivity.topPlayed))
      ? profile.playsActivity.topPlayed : [];
    const manualPlaysArr = Array.isArray(profile.manualPlays) ? profile.manualPlays : [];
    const hasAnyPlayData = topPlayedArr.length > 0 || manualPlaysArr.length > 0;

    if (hasAnyPlayData) {
      const heavilyPlayed = topPlayedArr.filter(g => (g.weightedPlays || g.plays) >= 1.5);
      const totalWeighted = heavilyPlayed.length > 0
        ? heavilyPlayed.reduce((s, g) => s + (g.weightedPlays || g.plays), 0)
        : 1;

      // ── 1) Cerca in topPlayed (entry curate, hanno weightedPlays) ─────
      let alreadyPlayed =
        (product.bgg && topPlayedArr.find(g => g.bggId === product.bgg)) ||
        (product.id && topPlayedArr.find(g => String(g.productId) === String(product.id)));
      if (!alreadyPlayed && product.t) {
        const pName = _normalizeName(product.t);
        if (pName.length >= 3) {
          alreadyPlayed = topPlayedArr.find(g => g.name && _normalizeName(g.name) === pName);
        }
      }

      // ── 2) Fallback: cerca in manualPlays (root). Conta le occorrenze. ──
      // manualPlays è array di { bggId, productId, title, date, minutes, ... }
      // dove ogni elemento è UNA partita. Aggreghiamo per gioco e produciamo
      // una entry stile topPlayed (plays, weightedPlays, name).
      if (!alreadyPlayed && manualPlaysArr.length > 0) {
        const pName = product.t ? _normalizeName(product.t) : '';
        const matchingPlays = manualPlaysArr.filter(p => {
          if (product.bgg && p.bggId === product.bgg) return true;
          if (product.id && String(p.productId) === String(product.id)) return true;
          if (pName.length >= 3 && p.title && _normalizeName(p.title) === pName) return true;
          return false;
        });
        if (matchingPlays.length > 0) {
          // Calcola weightedPlays grezzo: stessa scala 30d×3, 90d×2, 180d×1, 365d×0.5, older×0.25
          const now = Date.now();
          let weighted = 0;
          matchingPlays.forEach(p => {
            const t = new Date(p.date || p.timestamp || now).getTime();
            const ageDays = (now - t) / 86400000;
            if (ageDays <= 30) weighted += 3;
            else if (ageDays <= 90) weighted += 2;
            else if (ageDays <= 180) weighted += 1;
            else if (ageDays <= 365) weighted += 0.5;
            else weighted += 0.25;
          });
          alreadyPlayed = {
            plays: matchingPlays.length,
            weightedPlays: weighted,
            name: matchingPlays[0].title,
            bggId: matchingPlays[0].bggId,
            productId: matchingPlays[0].productId,
            _fromManualPlays: true // diagnostica
          };
        }
      }

      if (alreadyPlayed) {
        const w = alreadyPlayed.weightedPlays || alreadyPlayed.plays || 0;
        const plays = alreadyPlayed.plays || 1;
        // playedBoost rivisto 2026-05-12: aver GIOCATO un gioco è un segnale
        // di conoscenza/scelta volontaria fortissimo, indipendente dalle features.
        //   1 partita → +6, 2-4 → +10, 5+ o weightedPlays ≥ 3 → +14
        let playedBoost;
        if (plays >= 5 || w >= 3) playedBoost = 14;
        else if (plays >= 2 || w >= 2) playedBoost = 10;
        else playedBoost = 6;
        const share = totalWeighted > 0 ? w / totalWeighted : 0;
        const shareScore = Math.min(14, share * 100);
        parts.playedBoost = Math.max(playedBoost, shareScore);
        score += parts.playedBoost;
        positives.push({
          kind: 'played',
          weightedPlays: +(w || 0).toFixed(1),
          plays: plays,
          fromManual: !!alreadyPlayed._fromManualPlays
        });
      }

      if (heavilyPlayed.length > 0 && window.FrogMatch._heavilyPlayedMechCache && productMechs.length > 0) {
        const playedMechSet = window.FrogMatch._heavilyPlayedMechCache;
        const sharedReal = productMechs.filter(m => playedMechSet.has(m));
        if (sharedReal.length >= 2) {
          parts.realFit = Math.min(6, sharedReal.length * 1.5);
          score += parts.realFit;
          positives.push({ kind: 'realFit', shared: sharedReal.slice(0, 4) });
        }
      }
    }

    // ─── CONFIDENCE GATE ─────────────────────────────────────────────────
    // Quanti segnali ha l'utente in TOTALE? Sotto 10 = poco profilo, non sappiamo
    // ancora abbastanza per dare un numero su NIENTE. Sopra 10 = sappiamo a sufficienza
    // del gusto generale. NB: questo è confidenza SUL PROFILO, non sul gioco specifico.
    const totalSignal =
      ((profile.sample && profile.sample.loved) || 0) +
      (profile.bggLovedCount || 0) +
      ((profile.playsActivity && profile.playsActivity.totalPlays) || 0) +
      (profile.bggOwnedCount || 0) +
      ((profile.purchasedProducts && profile.purchasedProducts.length) || 0) +
      ((profile.fourFavorites && profile.fourFavorites.length) || 0) * 3;
    const hasConfidence = totalSignal >= 10;

    // Segnale specifico su QUESTO gioco: l'utente l'ha già giocato/posseduto?
    // Se sì, dargli "non ho abbastanza info" è insultante: lui sa il gioco,
    // vuole un numero (anche basso) onesto.
    const hasGameSpecificSignal = !!(parts.playedBoost || parts.ownershipBoost);

    // Bypass alternativo: anche senza game-specific signal, se ci sono ≥2
    // positivi onesti (peso vicino + giocatori OK, per esempio), il sistema
    // ha abbastanza per dare un numero anche basso. "Sentiero diverso senza %"
    // si applica solo a giochi davvero a 0 segnali positivi.
    const hasEnoughPositives = positives.length >= 2;

    // Rete di sicurezza: mai propagare NaN/Infinity al ranking (corromperebbe l'ordinamento)
    if (!isFinite(score)) score = 0;
    const internalScore = clamp(Math.round(score), 0, 100);

    // ─── HIDE-NUMBER POLICY ──────────────────────────────────────────────
    // Due ragioni distinte per nascondere il numero:
    //   1. low_confidence: profilo troppo magro per qualsiasi numero affidabile.
    //   2. low_score: pochi segnali su QUESTO gioco (no positivi, no played,
    //      score molto basso < 10). Se ci sono ≥2 positivi o l'utente ha giocato/
    //      posseduto, mostriamo il numero (onesto vs reticente).
    let hideNumber, hideReason;
    if (!hasConfidence) {
      hideNumber = true;
      hideReason = 'low_confidence';
    } else if (internalScore < 10 && !hasGameSpecificSignal && !hasEnoughPositives) {
      hideNumber = true;
      hideReason = 'low_score';
    } else {
      hideNumber = false;
      hideReason = null;
    }

    // ─── DISPLAY RESCALING ──────────────────────────────────────────────
    // Lo score interno è la verità (usato per ranking). Per il display rimappiamo
    // perché 30-65 interno = "match decente" → 55-90 in vista (Netflix-style).
    let displayPct;
    if (internalScore < 18) {
      // Fascia bassa "sentiero diverso" — mostriamo numero (35-45%) se hasGameSpecificSignal,
      // altrimenti 0 (hideNumber). 0→35, 17→45 lineare quando si mostra.
      displayPct = Math.round(35 + (internalScore / 17) * 10);
    } else if (internalScore < 30) {
      // 18→48, 29→58 — fascia "discover"
      displayPct = Math.round(48 + (internalScore - 18) * 0.9);
    } else if (internalScore < 60) {
      // 30→60, 45→78, 60→90 — fascia "buono → forte"
      displayPct = Math.round(60 + ((internalScore - 30) / 30) * 30);
    } else {
      // 60→90, 100→100
      displayPct = Math.round(90 + ((internalScore - 60) / 40) * 10);
    }
    displayPct = Math.min(100, Math.max(0, displayPct));

    // ─── TIER (badge a 6 livelli) ───────────────────────────────────────
    let tier;
    if (!hasConfidence) tier = 'discover';
    else if (internalScore >= 60) tier = 'top';
    else if (internalScore >= 45) tier = 'strong';
    else if (internalScore >= 30) tier = 'good';
    else if (internalScore >= 18) tier = 'discover';
    else if (internalScore >= 8) tier = 'distant';
    else tier = 'explore';

    return {
      pct: displayPct,
      internalScore,
      tier,
      hideNumber,
      hideReason, // 'low_confidence' | 'low_score' | null
      hasConfidence,
      hasGameSpecificSignal,
      totalSignal,
      parts,
      positives,
      negatives,
      unknowns,
      sharedMech: mShared,
      sharedCat: cShared,
      sharedTyp: tShared
    };
  }

  function rankProducts(profile, products, mood) {
    if (!profile) return [];
    const effectiveProfile = applyMood(profile, mood);

    // Pre-compute "heavily played mechanics" cache: usa weightedPlays per privilegiare attività recente
    window.FrogMatch._heavilyPlayedMechCache = null;
    if (profile.playsActivity && profile.playsActivity.topPlayed) {
      const heavy = profile.playsActivity.topPlayed.filter(g => (g.weightedPlays || g.plays) >= 1.5);
      if (heavy.length > 0) {
        const heavyBggIds = new Set(heavy.map(g => g.bggId));
        const mechSet = new Set();
        for (const p of products) {
          if (p.bgg && heavyBggIds.has(p.bgg) && p.mch) {
            for (const m of p.mch) mechSet.add(m);
          }
        }
        if (mechSet.size > 0) window.FrogMatch._heavilyPlayedMechCache = mechSet;
      }
    }

    // Pre-compute "Four Favorites mechanics" cache: PER-FAVORITO (Proposta B 2026-05-10).
    //
    // Struttura: array di Set, una entry per ogni favorito che ha meccaniche disponibili.
    // Esempio Arwen67 con 4 favoriti wargame:
    //   [Set(Twilight Struggle: HM, AreaInfluence, VPO, ...),
    //    Set(Through the Ages: HM, ResourceManagement, ...),
    //    Set(Brass: NetworkBuilding, RouteBuilding, ...),
    //    Set(Caverna: WorkerPlacement, AnimalHusbandry, ...)]
    //
    // Permette al match% di calcolare il boost PER FAVORITO (non aggregato),
    // così 4 favoriti coerenti danno +20pt vs 1 favorito che dà +5pt.
    //
    // Sources di meccaniche per ogni favorito:
    //   1. Catalogo Frogames (se il favorito è venduto da noi)
    //   2. BGG-enriched topPlayed (se l'utente ha giocato il favorito → meccaniche enriched)
    if (window.FrogMatch) window.FrogMatch._fourFavoritesMechs = null;
    if (profile.fourFavorites && profile.fourFavorites.length > 0) {
      const act = profile.playsActivity || {};
      const topPlayedByBgg = {};
      if (Array.isArray(act.topPlayed)) {
        for (const tp of act.topPlayed) {
          if (tp.bggId) topPlayedByBgg[tp.bggId] = tp;
        }
      }
      const favMechsArray = [];
      for (const fav of profile.fourFavorites) {
        if (!fav || !fav.bggId) continue;
        const mechs = new Set();
        // Source 1: catalogo Frogames
        const catProduct = products.find(p => p.bgg === fav.bggId);
        if (catProduct && Array.isArray(catProduct.mch)) {
          for (const m of catProduct.mch) mechs.add(m);
        }
        // Source 2: BGG-enriched topPlayed
        const tp = topPlayedByBgg[fav.bggId];
        if (tp && Array.isArray(tp.mch)) {
          for (const m of tp.mch) mechs.add(m);
        }
        // Solo favoriti con almeno qualche meccanica conosciuta entrano nel pool
        if (mechs.size > 0) favMechsArray.push(mechs);
      }
      if (favMechsArray.length > 0 && window.FrogMatch) {
        window.FrogMatch._fourFavoritesMechs = favMechsArray;
      }
    }

    return products
      .map(p => {
        const m = computeMatch(effectiveProfile, p);
        if (!m) return null;
        // matchPercent = display pct (può essere 0 se hideNumber).
        // matchInternal = score raw 0-100 usato per ordinare il ranking
        // (più stabile e non distorto dal rescaling Netflix-style).
        return Object.assign({}, p, {
          matchPercent: m.pct,
          matchInternal: m.internalScore,
          matchTier: m.tier,
          matchHideNumber: m.hideNumber,
          matchDetail: m
        });
      })
      .filter(p => p != null)
      .sort((a, b) => (b.matchInternal || 0) - (a.matchInternal || 0));
  }

  function applyMood(profile, mood) {
    if (!mood) return profile;
    const out = Object.assign({}, profile);
    if (mood.weightTarget != null) out.weightTarget = mood.weightTarget;
    if (mood.playtimeTarget) out.playtimeTarget = mood.playtimeTarget;
    if (mood.boostTypologies && mood.boostTypologies.length > 0) {
      out.topTypologies = [...mood.boostTypologies, ...(profile.topTypologies || [])].slice(0, 3);
      out.topTypologiesPrimary = [...mood.boostTypologies, ...(profile.topTypologiesPrimary || [])].slice(0, 2);
    }
    return out;
  }

  function migrateGermanToEurogame(p) {
    if (!p) return p;
    const replace = (arr) => {
      if (!Array.isArray(arr)) return arr;
      const out = arr.map(t => t === 'german' ? 'eurogame' : t);
      return [...new Set(out)];
    };
    if (p.topTypologies) p.topTypologies = replace(p.topTypologies);
    if (p.topTypologiesPrimary) p.topTypologiesPrimary = replace(p.topTypologiesPrimary);
    if (p.topTypologiesSecondary) p.topTypologiesSecondary = replace(p.topTypologiesSecondary);
    if (p.avoidedTypologies) p.avoidedTypologies = replace(p.avoidedTypologies);
    return p;
  }

  function loadProfile() {
    // FIX 2026-05-11: sync multi-device.
    // Prima: localStorage vinceva sempre → modifiche fatte su PC non apparivano su mobile
    // (e viceversa) perché ogni device aveva la sua copia locale "stale".
    // Ora: confronto updatedAt di local vs remote e uso il più recente. Last-write-wins
    // tra device. Conflitti rari (utente non modifica contemporaneamente da 2 device).
    let local = null;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const p = JSON.parse(raw);
        if (p.version === 2) local = migrateGermanToEurogame(p);
      }
    } catch (e) {}

    const customer = readCustomerDataFromDOM();
    let remote = null;
    if (customer && customer.remoteProfile && customer.remoteProfile.version === 2) {
      remote = migrateGermanToEurogame(customer.remoteProfile);
    }

    // Solo locale (nessun remote) → ritorna local
    if (!remote) return local;

    // Solo remote (nessun local: device nuovo) → salva remote in localStorage e usa
    if (!local) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(remote)); } catch (e) {}
      return remote;
    }

    // Entrambi esistono: usa il più recente
    const localTime = local.updatedAt || local.createdAt || 0;
    const remoteTime = remote.updatedAt || remote.createdAt || 0;
    if (remoteTime > localTime) {
      // Remote è più recente (sync da altro device) → sovrascrive local
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(remote)); } catch (e) {}
      return remote;
    }
    return local;
  }

  function saveProfile(profile) {
    // Assicura updatedAt aggiornato a ogni save: serve al last-write-wins
    // del sync multi-device in loadProfile (vince il più recente).
    if (profile) profile.updatedAt = Date.now();
    // ── ENGAGEMENT TRACKING (2026-05-12) ──────────────────────────────
    // saveProfile è chiamato SOLO lato client (da azioni utente: log play,
    // swipe, favoriti, mood, ecc.). La cron BGG notturna scrive direttamente
    // KV/Shopify senza passare da qui. Quindi lastUserActionAt è proxy fedele
    // dell'ultima volta che l'utente ha fatto qualcosa NEL prodotto FrogMatch
    // (non semplicemente "sync BGG ha sovrascritto qualcosa").
    if (profile) profile.lastUserActionAt = Date.now();
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(profile)); } catch (e) {}
    syncProfileToServer(profile);
    // Notifica al match-display (badge card + breakdown) di re-renderizzare
    // con il profilo aggiornato. Fix 2026-05-12: log play / edit / delete plays
    // non aggiornavano la card "match%" sulla pagina prodotto fino a refresh.
    try {
      window.dispatchEvent(new CustomEvent('frogmatch:profile-updated', { detail: { reason: 'save' } }));
    } catch (e) { /* CustomEvent non supportato — silenzioso */ }
  }

  function loadSwipes() {
    try {
      const raw = localStorage.getItem(SWIPES_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function saveSwipes(swipes) {
    try { localStorage.setItem(SWIPES_KEY, JSON.stringify(swipes)); } catch (e) {}
  }

  function loadMood() {
    try {
      const raw = localStorage.getItem(MOOD_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function saveMood(mood) {
    try {
      if (mood) localStorage.setItem(MOOD_KEY, JSON.stringify(mood));
      else localStorage.removeItem(MOOD_KEY);
    } catch (e) {}
  }

  function clearAll() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(SWIPES_KEY);
      localStorage.removeItem(MOOD_KEY);
      localStorage.removeItem('frogmatch_profile_v1');
      localStorage.removeItem('frogmatch_swipes_v1');
      localStorage.removeItem('frogmatch_mood_v1');
    } catch (e) {}
    syncProfileToServer({ cleared: true, version: 0, clearedAt: Date.now() });
  }

  function normalizeListField(v) {
    if (Array.isArray(v)) return v;
    if (typeof v === 'string') {
      try {
        const parsed = JSON.parse(v);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {}
      return v.split(/[,;]/).map(s => s.trim()).filter(Boolean);
    }
    return [];
  }

  function normalizeProduct(p) {
    const out = Object.assign({}, p);
    out.mch = normalizeListField(out.mch);
    out.cat = normalizeListField(out.cat);
    if (!out.f || typeof out.f !== 'object') out.f = {};
    return out;
  }

  function readProductDataFromDOM() {
    const node = document.getElementById('frogmatch-products-data');
    if (!node) return [];
    try {
      const arr = JSON.parse(node.textContent);
      return Array.isArray(arr) ? arr.map(normalizeProduct) : [];
    } catch (e) { return []; }
  }

  // ── Catalogo completo dal worker (2026-11-01) ─────────────────────────────
  // Le sezioni Liquid passano al massimo 250 prodotti (paginate; il profilo 150):
  // sono i PRIMI in ordine alfabetico, quindi "Per te" consigliava solo giochi con
  // la A o un numero. Il worker froghunt tiene in KV tutto il catalogo con i dati BGG
  // (stesso formato dello snippet frogmatch-data-bootstrap, rinfrescato ogni notte):
  // lo scarichiamo una volta e lo teniamo in Cache Storage per 6 ore.
  // Per i prodotti presenti anche nella pagina vincono i dati LIVE del Liquid
  // (disponibilità, prezzo, copertina, titolo tradotto, link con la lingua).
  // Se il worker non risponde si resta sui prodotti della pagina, come prima.
  const FULL_CATALOG_CACHE = 'fm-catalog-v1';
  const FULL_CATALOG_TTL_MS = 6 * 60 * 60 * 1000;
  let _fullCatalog = null;
  let _fullCatalogPromise = null;

  function catalogWorkerUrl() {
    let base = '';
    try { const c = readCustomerDataFromDOM(); base = (c && c.workerUrl) || ''; } catch (e) {}
    return (base || 'https://froghunt.info-frogames.workers.dev').replace(/\/$/, '') + '/api/frogmatch/catalog';
  }

  async function fetchCatalogJson(url) {
    let cache = null;
    try { if (window.caches) cache = await caches.open(FULL_CATALOG_CACHE); } catch (e) { cache = null; }
    if (cache) {
      try {
        const hit = await cache.match(url);
        const savedAt = hit ? parseInt(hit.headers.get('x-fm-saved') || '0', 10) : 0;
        if (hit && Date.now() - savedAt < FULL_CATALOG_TTL_MS) return await hit.json();
      } catch (e) {}
    }
    const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), 20000) : null;
    try {
      const res = await fetch(url, ctrl ? { signal: ctrl.signal } : undefined);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const text = await res.text();
      const json = JSON.parse(text);
      if (cache && json && Array.isArray(json.products) && json.products.length) {
        try {
          await cache.put(url, new Response(text, { headers: { 'content-type': 'application/json', 'x-fm-saved': String(Date.now()) } }));
        } catch (e) {}
      }
      return json;
    } finally {
      if (timer) clearTimeout(timer);
    }
  }

  // Link del worker = assoluto e senza lingua → relativo con la radice della lingua corrente.
  function localizeProductUrl(u, handle) {
    let path = String(u || '');
    if (/^https?:\/\//.test(path)) {
      try { path = new URL(path).pathname; } catch (e) { path = '/products/' + handle; }
    }
    if (!path) path = '/products/' + handle;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root !== '/' && path.indexOf(root) !== 0) path = root.replace(/\/$/, '') + path;
    return path;
  }

  function loadFullCatalog() {
    if (_fullCatalog) return Promise.resolve(_fullCatalog);
    if (_fullCatalogPromise) return _fullCatalogPromise;
    _fullCatalogPromise = fetchCatalogJson(catalogWorkerUrl()).then(json => {
      const remote = (json && Array.isArray(json.products)) ? json.products : [];
      const dom = readProductDataFromDOM();
      if (remote.length <= dom.length) return null;
      const domById = new Map(dom.map(p => [String(p.id), p]));
      const out = [];
      for (const raw of remote) {
        // Senza link del negozio online = non pubblicato sul sito: niente link rotti.
        if (!raw || !/^https?:\/\//.test(String(raw.u || ''))) continue;
        const p = normalizeProduct(raw);
        const live = domById.get(String(p.id));
        if (live) {
          domById.delete(String(p.id));
          out.push(Object.assign(p, { t: live.t || p.t, av: live.av, price: live.price, img: live.img || p.img, u: live.u || p.u, wl: live.wl }));
        } else {
          p.u = localizeProductUrl(p.u, p.h);
          out.push(p);
        }
      }
      domById.forEach(p => out.push(p)); // nuovi prodotti non ancora nell'indice notturno
      _fullCatalog = out;
      try { document.dispatchEvent(new CustomEvent('frogmatch:catalog', { detail: { count: out.length } })); } catch (e) {}
      return out;
    }).catch(e => {
      console.warn('[FrogMatch] catalogo completo non disponibile, uso i prodotti della pagina:', e && e.message);
      _fullCatalogPromise = null;
      return null;
    });
    return _fullCatalogPromise;
  }

  // I prodotti migliori disponibili ADESSO: catalogo completo se è già arrivato,
  // altrimenti quelli della pagina. Sincrona: non aspetta il worker.
  function getCatalogProducts() {
    return _fullCatalog || readProductDataFromDOM();
  }

  function readCustomerDataFromDOM() {
    const node = document.getElementById('frogmatch-customer-data');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  /**
   * Backfill acquisti pregressi del customer dal customer.orders Liquid.
   * Funziona uguale per BGG sync e onboarding manuale: legge
   * customerData.purchaseHistory (popolato server-side da Liquid) e
   * deduplica contro la lista esistente. Filtra solo prodotti con metadata
   * BGG validi (mch valorizzato) per garantire che contribuiscano davvero
   * all'archetipo.
   *
   * @param existingPurchases array attuale da non duplicare (default [])
   * @returns array unito {productId, title, bggId, mch, cat, w, purchasedAt}
   */
  function backfillPurchasesFromHistory(existingPurchases) {
    const customer = readCustomerDataFromDOM();
    if (!customer || !customer.loggedIn) return existingPurchases || [];
    const history = Array.isArray(customer.purchaseHistory) ? customer.purchaseHistory : [];
    if (history.length === 0) return existingPurchases || [];

    // FIX 2026-05-12: arricchisci entry ESISTENTI con img/url/bggId/mch/cat se mancano.
    // Bug noto: entry create prima dell'aggiunta dei campi img/url al backfill
    // (es. 5 aprile per Formosa Tea, Emerald Echoes) hanno solo {productId, title,
    // bggId, purchasedAt} senza img → ludoteca mostra fallback iniziale invece di cover.
    // Lookup per productId nel current customer.orders → copia campi mancanti.
    const historyByProductId = {};
    for (const h of history) {
      if (h.productId) historyByProductId[String(h.productId)] = h;
    }

    const seen = new Set();
    const out = [];
    // Mantieni esistenti, MA arricchisci con img/url da history se mancano
    for (const p of (existingPurchases || [])) {
      const key = String(p.productId || '');
      if (key) seen.add(key);
      const fresh = historyByProductId[key];
      if (fresh) {
        // Backfill arricchimento: solo campi MANCANTI vengono completati
        if (!p.img && fresh.img) p.img = fresh.img;
        if (!p.url && fresh.url) p.url = fresh.url;
        if (!p.bggId && fresh.bggId) p.bggId = fresh.bggId;
        if ((!p.mch || p.mch.length === 0) && Array.isArray(fresh.mch) && fresh.mch.length > 0) p.mch = fresh.mch;
        if ((!p.cat || p.cat.length === 0) && Array.isArray(fresh.cat) && fresh.cat.length > 0) p.cat = fresh.cat;
      }
      out.push(p);
    }
    // Aggiungi history dedup
    for (const h of history) {
      const key = String(h.productId || '');
      if (!key || seen.has(key)) continue;
      // Filtro qualità: deve avere bggId O mch popolato per essere "vero gioco"
      // (esclude accessori/sleeves/promo che non contribuiscono all'archetipo).
      const hasMch = Array.isArray(h.mch) && h.mch.length > 0;
      const hasBggId = h.bggId && h.bggId > 0;
      if (!hasMch && !hasBggId) continue;
      seen.add(key);
      out.push({
        productId: key,
        title: h.title || '',
        bggId: h.bggId || null,
        // Salva anche img + url così la ludoteca può renderizzare anche se il
        // prodotto NON è nel this.products della pagina corrente (es. sold out,
        // collection diversa, prodotto rimosso dal catalogo).
        img: h.img || null,
        url: h.url || null,
        purchasedAt: h.purchasedAt || Date.now()
      });
    }
    return out;
  }

  async function syncProfileToServer(profile) {
    const customer = readCustomerDataFromDOM();
    if (!customer || !customer.loggedIn || !customer.workerUrl) return false;
    if (!customer.customerId) return false;

    const cleanId = String(customer.customerId).replace(/\D/g, '');
    if (!cleanId) return false;

    try {
      const res = await fetch(customer.workerUrl.replace(/\/$/, '') + '/api/frogmatch/profile', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: cleanId, profile })
      });
      // Log diagnostico per investigare race condition sync multi-device.
      // Se il worker rifiuta con 409 (stale), il client ha provato a salvare dati
      // più vecchi di quello che il server ha già. Senza log questo era silenzioso.
      if (!res.ok) {
        const errBody = await res.text().catch(() => '');
        console.warn('[FrogMatch] Sync rejected:', res.status, errBody);
      } else {
        console.log('[FrogMatch] Sync OK at', new Date().toISOString(), '| updatedAt:', profile && profile.updatedAt ? new Date(profile.updatedAt).toISOString() : 'N/A');
      }
      return res.ok;
    } catch (e) {
      console.warn('[FrogMatch] Profile sync failed (network):', e);
      return false;
    }
  }

  function _testNameMatch(bggName, products) {
    const norm = (n) => {
      if (!n) return '';
      return String(n).toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/\s*\([^)]*\)\s*/g, '')
        .replace(/[–—:]/g, ' ')
        .replace(/\b(the|il|lo|la|i|gli|le|un|una|uno|a|an|di|del|della|dei|degli|delle)\b/g, '')
        .replace(/[^a-z0-9]+/g, '');
    };
    const target = norm(bggName);
    const matches = products.filter(p => norm(p.t) === target);
    const partial = products.filter(p => norm(p.t).indexOf(target) >= 0 || target.indexOf(norm(p.t)) >= 0).slice(0, 5);
    return { bggName, normalized: target, exactMatches: matches.map(p => p.t), partialMatches: partial.map(p => p.t) };
  }

  // ============================================================
  // MANUAL PLAYS — registrazione partite manuale (per chi non usa BGG)
  // Le partite vengono aggiunte come entry in profile.manualPlays e merged
  // dentro playsActivity.topPlayed così l'algoritmo le tratta identiche a quelle BGG
  // ============================================================

  function logManualPlay(opts) {
    // opts: { productId, bggId, title, date, minutes, rating, players, playersList, context, addToCollection, img }
    const profile = loadProfile();
    if (!profile) return { ok: false, error: 'Profilo non trovato' };

    if (!profile.manualPlays) profile.manualPlays = [];

    const play = {
      id: 'mp_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8),
      productId: opts.productId || null,
      bggId: opts.bggId || null,
      title: opts.title || '',
      date: opts.date || new Date().toISOString().slice(0, 10),
      minutes: opts.minutes ? parseInt(opts.minutes, 10) : 0,
      rating: opts.rating ? parseInt(opts.rating, 10) : null,
      players: opts.players ? parseInt(opts.players, 10) : null,
      // outcome: 'win' | 'loss' | 'coop_win' | 'coop_loss' | null.
      outcome: typeof opts.outcome === 'string' ? opts.outcome : null,
      // context: dove si è giocato — 'tavolo' (dal vivo, default) | 'bga' | 'online'.
      // Solo 'tavolo' qualificherà i compagni come compagni veri nelle medaglie social.
      context: (opts.context === 'bga' || opts.context === 'online') ? opts.context : 'tavolo',
      // playersList: array opzionale di sfidanti con vincitore/punti/bot.
      playersList: Array.isArray(opts.playersList) ? opts.playersList : null,
      // myScore: i TUOI punti (l'utente non sta in playersList). firstPlayer: chi ha iniziato.
      myScore: (typeof opts.myScore === 'number' && isFinite(opts.myScore)) ? opts.myScore : null,
      firstPlayer: opts.firstPlayer ? String(opts.firstPlayer).slice(0, 30) : null,
      // Durata stimata (tua media o media BGG): tenuta a parte da `minutes`, così non altera le ore giocate.
      minutesEstimate: (typeof opts.minutesEstimate === 'number' && opts.minutesEstimate > 0) ? opts.minutesEstimate : null,
      durationSource: opts.durationSource || null,
      // Da solo: 'game' (contro il gioco) | 'automa' | 'score' (batti il tuo punteggio) | null.
      soloMode: opts.soloMode || null,
      // tableId: tavolo di Scopri da cui arriva, per non importarla due volte.
      tableId: opts.tableId || null,
      // Il modo di vittoria e le voci dei punti, solo se scritti: voci = [{ l: nome, v: [io, altri...] }].
      ...(opts.winWay ? { winWay: String(opts.winWay).slice(0, 40) } : {}),
      ...(Array.isArray(opts.voci) && opts.voci.length ? { voci: opts.voci.slice(0, 24).map(x => ({ l: String(x.l || '').slice(0, 40), v: (x.v || []).slice(0, 12).map(n => (typeof n === 'number' && isFinite(n)) ? n : null) })) } : {}),
      // extras: array di espansioni / set compatibili usati nella partita.
      // Shape: [{ bggId, name, type }] dove type = 'expansion' | 'standalone'.
      // - expansion = espansione vera (richiede gioco base, es. Wicked to the Core)
      // - standalone = set compatibile mescolato (Marvel Villainous con Disney Villainous)
      // Metadata, NON contate come plays separate. Solo gioco base riceve +1.
      extras: Array.isArray(opts.extras)
        ? opts.extras.filter(e => e && e.bggId).map(e => ({
            bggId: parseInt(e.bggId, 10),
            name: String(e.name || '').slice(0, 100),
            type: (e.type === 'standalone') ? 'standalone' : 'expansion'
          }))
        : [],
      loggedAt: Date.now()
    };
    profile.manualPlays.push(play);

    // Merge in playsActivity.topPlayed per usare lo stesso algoritmo dei BGG plays
    if (!profile.playsActivity) {
      profile.playsActivity = {
        fetchedAt: Date.now(),
        totalPlays: 0,
        totalMinutes: 0,
        last30DaysPlays: 0,
        last30DaysMinutes: 0,
        last90DaysMinutes: 0,
        uniqueGames: 0,
        topPlayed: [],
        activityStatus: 'active',
        source: 'manual'
      };
    }
    mergeManualPlayIntoActivity(profile.playsActivity, play);

    // Se richiesto, aggiungi anche alla ludoteca manuale (per chi non ha BGG sync)
    if (opts.addToCollection) {
      addManualOwnedInternal(profile, {
        productId: opts.productId || null,
        bggId: opts.bggId || null,
        title: opts.title || '',
        img: opts.img || null
      });
    }

    profile.updatedAt = Date.now();
    saveProfile(profile);
    return { ok: true, play, profile };
  }

  // ============================================================
  // MANUAL OWNED — ludoteca manuale per chi NON ha BGG sync
  // I giochi vivono in profile.manualOwned[] con shape: {id, productId, bggId, name, img, addedAt}
  // collectCollection() li unisce a bggCollection.owned + purchasedProducts
  // ============================================================

  function addManualOwnedInternal(profile, opts) {
    if (!profile.manualOwned) profile.manualOwned = [];
    // Dedup: se già presente per bggId o productId, skip
    const existing = profile.manualOwned.find(g =>
      (opts.bggId && g.bggId === opts.bggId) ||
      (opts.productId && g.productId === opts.productId) ||
      (!opts.bggId && !opts.productId && (g.title || '').toLowerCase() === (opts.title || '').toLowerCase())
    );
    if (existing) return existing;
    // Skip se già in bggCollection.owned (no doppione con BGG sync)
    if (opts.bggId && profile.bggCollection && Array.isArray(profile.bggCollection.owned)) {
      const inBgg = profile.bggCollection.owned.some(item => {
        const id = (typeof item === 'object') ? item.id : item;
        return id === opts.bggId;
      });
      if (inBgg) return null;
    }
    const entry = {
      id: 'mo_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6),
      productId: opts.productId || null,
      bggId: opts.bggId || null,
      title: opts.title || '',
      img: opts.img || null,
      addedAt: Date.now()
    };
    profile.manualOwned.push(entry);
    return entry;
  }

  function addManualOwned(opts) {
    const profile = loadProfile();
    if (!profile) return { ok: false, error: 'Profilo non trovato' };
    const entry = addManualOwnedInternal(profile, opts);
    if (!entry) return { ok: false, error: 'Già nella tua ludoteca' };
    profile.updatedAt = Date.now();
    saveProfile(profile);
    return { ok: true, entry, profile };
  }

  function removeManualOwned(entryId) {
    const profile = loadProfile();
    if (!profile || !profile.manualOwned) return { ok: false };
    const idx = profile.manualOwned.findIndex(g => g.id === entryId);
    if (idx < 0) return { ok: false, error: 'Gioco non trovato' };
    profile.manualOwned.splice(idx, 1);
    profile.updatedAt = Date.now();
    saveProfile(profile);
    return { ok: true, profile };
  }

  // Import di molte partite: un salvataggio solo, non uno a partita. Solo i campi che servono, il profilo ha un limite di spazio.
  function importManualPlays(list) {
    const profile = loadProfile();
    if (!profile || !Array.isArray(list) || !list.length) return { ok: false };
    if (!profile.manualPlays) profile.manualPlays = [];
    if (!profile.playsActivity) {
      profile.playsActivity = { fetchedAt: Date.now(), totalPlays: 0, totalMinutes: 0, last30DaysPlays: 0, last30DaysMinutes: 0, last90DaysMinutes: 0, uniqueGames: 0, topPlayed: [], activityStatus: 'active', source: 'manual' };
    }
    const now = Date.now();
    list.forEach((x, i) => {
      const play = Object.assign({ id: 'mp_' + now + '_' + i + '_' + Math.random().toString(36).slice(2, 6), minutes: 0, rating: null, context: 'bga', extras: [], loggedAt: now }, x);
      profile.manualPlays.push(play);
      mergeManualPlayIntoActivity(profile.playsActivity, play);
    });
    saveProfile(profile);
    return { ok: true, profile, added: list.length };
  }

  // Completa partite già registrate con i dati arrivati dopo: un salvataggio solo.
  // Le espansioni di un gioco, dalla più probabile: quelle già usate, poi le tue, poi quelle che vendiamo.
  // BGG ne elenca anche decine di promo: senza un motivo restano dietro "Altre".
  function rankExpansions(list, ctx) {
    const c = ctx || {}, used = c.used || {}, owned = c.owned || {}, titles = c.titles || {}, base = String(c.baseTitle || '').trim().toLowerCase();
    const short = (t) => {
      const s = String(t || '').trim();
      let r = s;
      if (base && s.toLowerCase().indexOf(base) === 0) r = s.slice(base.length).replace(/^[\s:–—-]+/, '');
      else { const m = s.match(/^.{2,}?(?::| [–—-] )\s*(.+)$/); if (m) r = m[1]; }
      r = r.replace(/[\s–—-]*\b(espansione|expansion)$/i, '').trim();
      return r || s;
    };
    const seen = {}, out = [];
    (list || []).concat(c.extra || []).forEach(e => {
      if (!e || !e.bggId || seen[e.bggId]) return;
      seen[e.bggId] = 1;
      const id = e.bggId, u = used[id] || 0;
      out.push({ bggId: id, name: e.name, label: short(titles[id] || e.name), why: u ? 'used' : owned[id] ? 'owned' : titles[id] ? 'shop' : '', used: u });
    });
    const w = { used: 0, owned: 1, shop: 2, '': 3 };
    return out.map((x, i) => ({ x, i })).sort((a, b) => w[a.x.why] - w[b.x.why] || b.x.used - a.x.used || a.i - b.i).map(o => o.x);
  }

  function patchManualPlays(patches) {
    const profile = loadProfile();
    if (!profile || !profile.manualPlays || !patches || !patches.length) return { ok: false };
    let n = 0;
    patches.forEach((x) => {
      const play = profile.manualPlays.find((m) => m && m.id === x.id);
      if (play) { Object.assign(play, x.fields); n++; }
    });
    if (n) saveProfile(profile);
    return { ok: !!n, profile, patched: n };
  }

  function mergeManualPlayIntoActivity(activity, play) {
    const lookup = play.bggId || ('shop:' + play.productId);
    let game = activity.topPlayed.find(g =>
      (play.bggId && g.bggId === play.bggId) ||
      (play.productId && g.productId === play.productId) ||
      (g.lookupKey === lookup)
    );

    const now = Date.now();
    const playDate = new Date(play.date).getTime();
    const isLast30 = (now - playDate) <= 30 * 86400000;
    const isLast90 = (now - playDate) <= 90 * 86400000;
    const isLast180 = (now - playDate) <= 180 * 86400000;
    const isLast365 = (now - playDate) <= 365 * 86400000;

    if (!game) {
      game = {
        bggId: play.bggId || null,
        productId: play.productId || null,
        lookupKey: lookup,
        name: play.title || '',
        // FIX 2026-05-11: propaga img da play → topPlayed entry. Senza, l'entry creata
        // da una manualPlay non aveva img → primo favorito (basato su topPlayed) vuoto.
        img: play.img || null,
        plays: 0,
        plays30d: 0,
        plays90d: 0,
        plays180d: 0,
        plays365d: 0,
        minutes: 0,
        weightedPlays: 0,
        lastPlayed: null,
        freshness: 'active',
        source: 'manual'
      };
      activity.topPlayed.push(game);
      activity.uniqueGames = (activity.uniqueGames || 0) + 1;
    } else if (!game.img && play.img) {
      // Game esistente senza img + nuova play con img → arricchisci
      game.img = play.img;
    }

    game.plays += 1;
    if (isLast30) game.plays30d += 1;
    if (isLast90) game.plays90d += 1;
    if (isLast180) game.plays180d += 1;
    if (isLast365) game.plays365d += 1;
    game.minutes += play.minutes || 0;
    if (!game.lastPlayed || play.date > game.lastPlayed) game.lastPlayed = play.date;

    // Ricalcola weightedPlays e freshness
    const p030 = game.plays30d;
    const p3090 = Math.max(0, game.plays90d - game.plays30d);
    const p90180 = Math.max(0, game.plays180d - game.plays90d);
    const p180365 = Math.max(0, game.plays365d - game.plays180d);
    const pOlder = Math.max(0, game.plays - game.plays365d);
    game.weightedPlays = +(p030 * 3 + p3090 * 2 + p90180 * 1 + p180365 * 0.5 + pOlder * 0.25).toFixed(2);

    if (game.plays30d > 0) game.freshness = 'active';
    else if (game.plays90d > 0) game.freshness = 'recent';
    else if (game.plays180d > 0) game.freshness = 'casual';
    else game.freshness = 'paused';

    // Aggiorna i totali activity-wide
    activity.totalPlays = (activity.totalPlays || 0) + 1;
    activity.totalMinutes = (activity.totalMinutes || 0) + (play.minutes || 0);
    if (isLast30) {
      activity.last30DaysPlays = (activity.last30DaysPlays || 0) + 1;
      activity.last30DaysMinutes = (activity.last30DaysMinutes || 0) + (play.minutes || 0);
    }
    if (isLast90) activity.last90DaysMinutes = (activity.last90DaysMinutes || 0) + (play.minutes || 0);
    if (!activity.mostRecentPlay || play.date > activity.mostRecentPlay) activity.mostRecentPlay = play.date;
    if (!activity.fromDate || play.date < activity.fromDate) activity.fromDate = play.date;
    activity.toDate = activity.mostRecentPlay;
    // NB: NON tocchiamo activity.playsByDate qui — quella struttura è popolata
    // solo dalla sync BGG. Le partite manuali vengono lette separatamente da
    // profile.manualPlays in collectPlaysByDate() (calendario) e in
    // computeMomentCards() (Wrapped). Aggiungerle anche a playsByDate causerebbe
    // doppio conteggio nel calendario.

    // Riordina topPlayed per weightedPlays
    activity.topPlayed.sort((a, b) => (b.weightedPlays || 0) - (a.weightedPlays || 0));
    activity.topPlayed = activity.topPlayed.slice(0, 30);

    // Riaggiorna activityStatus complessivo
    const a30 = activity.last30DaysPlays || 0;
    if (a30 >= 3) activity.activityStatus = 'active';
    else if (a30 >= 1) activity.activityStatus = 'recent';
    else if ((activity.last90DaysMinutes || 0) > 0) activity.activityStatus = 'casual';
    else activity.activityStatus = 'paused';
  }

  function deleteManualPlay(playId) {
    const profile = loadProfile();
    if (!profile || !profile.manualPlays) return { ok: false };
    const idx = profile.manualPlays.findIndex(p => p.id === playId);
    if (idx < 0) return { ok: false, error: 'Play non trovato' };
    profile.manualPlays.splice(idx, 1);
    // Per semplicità: ricompila playsActivity da zero rebuilding from manual + (originale BGG sparito ormai)
    // In v1 lasciamo: la rimozione non sottrae dalle stats aggregate finché non si fa un re-import BGG
    saveProfile(profile);
    return { ok: true };
  }

  /**
   * Modifica una partita manuale esistente.
   * opts: { date, minutes, rating, players, title? } — solo i campi da aggiornare.
   * Restituisce { ok, play, profile } o { ok: false, error }.
   * Nota: per ora NON aggiorna in modo perfetto le stats aggregate (playsActivity)
   * — il re-merge completo richiederebbe ricalcolo. Per i casi tipici (correzione
   * durata/voto/giocatori dopo errore), basta aggiornare l'entry direttamente.
   */
  function editManualPlay(playId, opts) {
    const profile = loadProfile();
    if (!profile || !profile.manualPlays) return { ok: false, error: 'Nessuna partita registrata' };
    const idx = profile.manualPlays.findIndex(p => p.id === playId);
    if (idx < 0) return { ok: false, error: 'Partita non trovata' };
    const play = profile.manualPlays[idx];

    if (opts.date != null) play.date = opts.date;
    if (opts.minutes != null) {
      play.minutes = parseInt(opts.minutes, 10) || 0;
      if (play.minutes > 0) { play.minutesEstimate = null; play.durationSource = 'hand'; }
    }
    if (opts.rating !== undefined) play.rating = opts.rating ? parseInt(opts.rating, 10) : null;
    if (opts.players !== undefined) play.players = opts.players ? parseInt(opts.players, 10) : null;
    if (opts.context !== undefined) play.context = (opts.context === 'bga' || opts.context === 'online') ? opts.context : 'tavolo';
    if (opts.title != null && opts.title.trim()) play.title = opts.title.trim();
    if (opts.myScore !== undefined) play.myScore = (typeof opts.myScore === 'number' && isFinite(opts.myScore)) ? opts.myScore : null;
    if (opts.outcome !== undefined) play.outcome = typeof opts.outcome === 'string' ? opts.outcome : null;
    if (opts.playersList !== undefined) play.playersList = Array.isArray(opts.playersList) && opts.playersList.length ? opts.playersList : null;
    if (opts.firstPlayer !== undefined) play.firstPlayer = opts.firstPlayer ? String(opts.firstPlayer).slice(0, 30) : null;
    if (opts.soloMode !== undefined) play.soloMode = opts.soloMode || null;
    if (opts.winWay !== undefined) { if (opts.winWay) play.winWay = String(opts.winWay).slice(0, 40); else delete play.winWay; }
    if (opts.voci !== undefined) {
      if (Array.isArray(opts.voci) && opts.voci.length) play.voci = opts.voci.slice(0, 24).map(x => ({ l: String(x.l || '').slice(0, 40), v: (x.v || []).slice(0, 12).map(n => (typeof n === 'number' && isFinite(n)) ? n : null) }));
      else delete play.voci;
    }
    if (opts.extras !== undefined) {
      play.extras = Array.isArray(opts.extras)
        ? opts.extras.filter(e => e && e.bggId).map(e => ({
            bggId: parseInt(e.bggId, 10),
            name: String(e.name || '').slice(0, 100),
            type: (e.type === 'standalone') ? 'standalone' : 'expansion'
          }))
        : [];
    }
    play.editedAt = Date.now();

    saveProfile(profile);
    return { ok: true, play, profile };
  }

  // Carica dati community più giocati (anonimo, aggregato giornaliero)
  // Risultato indicizzato per bggId, usato in computeMatch per communityBoost
  let _communityLoadPromise = null;
  function loadCommunityData(workerUrl, days) {
    if (!workerUrl) return Promise.resolve(null);
    if (_communityLoadPromise) return _communityLoadPromise;
    const url = workerUrl.replace(/\/$/, '') + '/api/community/most-played?days=' + (days || 30) + '&limit=50';
    _communityLoadPromise = fetch(url)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data || !data.games) return null;
        const byBggId = {};
        for (const g of data.games) byBggId[g.bggId] = g;
        window.FrogMatch._communityData = byBggId;
        window.FrogMatch._communityMeta = { rebuiltAt: data.rebuiltAt, totalFroggers: data.totalFroggers, days: data.days };
        return byBggId;
      })
      .catch(() => null);
    return _communityLoadPromise;
  }

  // ============================================================
  // VOLUME DEL MESE — Wrapped statico mensile
  // Dato un monthKey 'YYYY-MM', calcola tutti i dati necessari a
  // renderizzare il "Volume" del mese: partite, durata, top games,
  // nuovi giochi, delta vs media storica, annotazioni Frogger.
  //
  // Riusa la logica dedup BGG+manual già rodata in computeMomentCards.
  // Output: { monthLabel, volNumber, partite, giochi, nuovi, ore,
  //           deltaMedia, topGames[], annotations[], hasData }
  // ============================================================
  function computeVolumeData(monthKey) {
    if (!/^\d{4}-\d{2}$/.test(monthKey || '')) {
      throw new Error('computeVolumeData: monthKey deve essere YYYY-MM');
    }
    const profile = loadProfile();
    const products = getCatalogProducts();
    const productByBgg = {};
    for (const p of products) {
      if (p && p.bgg) productByBgg[p.bgg] = p;
    }

    const act = (profile && profile.playsActivity) || {};
    const playsByDate = act.playsByDate || {};
    const manualPlays = Array.isArray(profile && profile.manualPlays) ? profile.manualPlays : [];

    // ── COVER LOOKUP MULTI-FONTE con HD priority ──────────────
    // Manteniamo 2 set di mappe: imgFull (HD, image BGG ~600-1500px) e
    // img (thumbnail BGG ~200px). resolveCover preferisce HD per qualità
    // export PNG. Display normale usa anche HD se disponibile (no overhead
    // perché object-fit: contain/cover scala bene).
    const imgFullByBgg = {};
    const imgFullByName = {};
    const imgByBgg = {};
    const imgByName = {};
    const normLow = (s) => (s || '').toLowerCase().trim();
    const rememberImg = (bggId, name, thumb, full) => {
      if (bggId) {
        if (thumb && !imgByBgg[bggId]) imgByBgg[bggId] = thumb;
        if (full && !imgFullByBgg[bggId]) imgFullByBgg[bggId] = full;
      }
      if (name) {
        const k = normLow(name);
        if (k) {
          if (thumb && !imgByName[k]) imgByName[k] = thumb;
          if (full && !imgFullByName[k]) imgFullByName[k] = full;
        }
      }
    };
    // 1) Prodotti Shopify (priorità massima — usa product.img come HD)
    for (const pr of products) {
      if (pr && pr.bgg && pr.img) rememberImg(pr.bgg, pr.t, pr.img, pr.img);
    }
    // 2) act.topPlayed (sync BGG) — img è thumbnail, imgFull se enriched
    if (Array.isArray(act.topPlayed)) {
      for (const g of act.topPlayed) {
        if (g) rememberImg(g.bggId, g.name, g.img, g.imgFull);
      }
    }
    // 3) manualPlays
    for (const mp of manualPlays) {
      if (mp) rememberImg(mp.bggId, mp.title, mp.img, mp.imgFull);
    }
    // 4) bggCollection.owned (thumbnail + image HD se persistita)
    const owned = (profile && profile.bggCollection && Array.isArray(profile.bggCollection.owned))
      ? profile.bggCollection.owned : [];
    for (const item of owned) {
      if (!item || typeof item !== 'object') continue;
      rememberImg(item.id, item.name, item.thumbnail || item.img, item.image);
    }
    // 5) manualOwned
    const manualOwned = (profile && Array.isArray(profile.manualOwned)) ? profile.manualOwned : [];
    for (const mo of manualOwned) {
      if (mo) rememberImg(mo.bggId, mo.title || mo.name, mo.img, mo.imgFull);
    }
    // 6) purchasedProducts
    if (Array.isArray(profile.purchasedProducts)) {
      for (const pp of profile.purchasedProducts) {
        if (pp) rememberImg(pp.bggId, pp.title || pp.name, pp.img, pp.imgFull);
      }
    }
    // 7) playsByDate.games — fallback estremo
    for (const info of Object.values(playsByDate)) {
      if (!info || !Array.isArray(info.games)) continue;
      for (const g of info.games) {
        if (g) rememberImg(g.bggId, g.name, g.img, g.imgFull);
      }
    }

    // resolveCover preferisce HD (imgFull) per qualità export PNG.
    const resolveCover = (bggId, name) => {
      if (bggId && imgFullByBgg[bggId]) return imgFullByBgg[bggId];
      const k = normLow(name);
      if (k && imgFullByName[k]) return imgFullByName[k];
      if (bggId && imgByBgg[bggId]) return imgByBgg[bggId];
      if (k && imgByName[k]) return imgByName[k];
      return null;
    };

    // Parsing label mese
    const [yearStr, monthStr] = monthKey.split('-');
    const monthIdx = parseInt(monthStr, 10) - 1;
    const monthNames = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];
    const monthLabel = (monthNames[monthIdx] || monthStr) + ' ' + yearStr;

    const norm = (s) => (s || '').toLowerCase().trim();

    // Helper: conta partite di un mese (dedup BGG/manual)
    function countMonth(mk) {
      let p = 0;
      for (const [date, info] of Object.entries(playsByDate)) {
        if (!date.startsWith(mk) || !info) continue;
        p += info.plays || 0;
      }
      for (const mp of manualPlays) {
        if (!mp.date || !mp.date.startsWith(mk)) continue;
        const bggDay = playsByDate[mp.date];
        if (bggDay && Array.isArray(bggDay.games)) {
          const dup = bggDay.games.some(g =>
            (mp.bggId && g.bggId && g.bggId === mp.bggId) ||
            (g.name && norm(g.name) === norm(mp.title))
          );
          if (dup) continue;
        }
        p += 1;
      }
      return p;
    }

    // ── AGGREGAZIONE MESE TARGET ──
    let partite = 0, minuti = 0;
    const gameCounts = {};
    const gameBgg = {};

    for (const [date, info] of Object.entries(playsByDate)) {
      if (!date.startsWith(monthKey) || !info) continue;
      partite += info.plays || 0;
      minuti += info.minutes || 0;
      for (const g of (info.games || [])) {
        if (!g.name) continue;
        gameCounts[g.name] = (gameCounts[g.name] || 0) + (g.plays || 0);
        if (g.bggId && !gameBgg[g.name]) gameBgg[g.name] = g.bggId;
      }
    }
    for (const mp of manualPlays) {
      if (!mp.date || !mp.date.startsWith(monthKey)) continue;
      const bggDay = playsByDate[mp.date];
      if (bggDay && Array.isArray(bggDay.games)) {
        const dup = bggDay.games.some(g =>
          (mp.bggId && g.bggId && g.bggId === mp.bggId) ||
          (g.name && norm(g.name) === norm(mp.title))
        );
        if (dup) continue;
      }
      partite += 1;
      minuti += mp.minutes || 0;
      const name = mp.title || 'Sconosciuto';
      gameCounts[name] = (gameCounts[name] || 0) + 1;
      if (mp.bggId && !gameBgg[name]) gameBgg[name] = mp.bggId;
    }

    // ── TOP GAMES con cover (multi-fonte) ──
    const topGames = Object.entries(gameCounts)
      .sort((a, b) => b[1] - a[1])
      .map(([name, plays]) => {
        const bggId = gameBgg[name] || null;
        const product = bggId ? productByBgg[bggId] : null;
        return {
          name,
          plays,
          bggId,
          cover: resolveCover(bggId, name),
          url: (product && product.url) || null
        };
      });

    const giochi = topGames.length;

    // ── NUOVI GIOCHI (mai giocati prima del monthKey) ──
    const seenBefore = new Set();
    for (const [date, info] of Object.entries(playsByDate)) {
      if (date.slice(0, 7) >= monthKey || !info) continue;
      for (const g of (info.games || [])) {
        if (g.name) seenBefore.add(norm(g.name));
      }
    }
    for (const mp of manualPlays) {
      if (!mp.date) continue;
      if (mp.date.slice(0, 7) >= monthKey) continue;
      seenBefore.add(norm(mp.title));
    }
    const nuovi = topGames.filter(g => !seenBefore.has(norm(g.name))).length;

    // ── VOLUME NUMBER (N-esimo mese con almeno 1 partita) ──
    const monthsWithPlays = new Set();
    for (const date of Object.keys(playsByDate)) {
      const mk = date.slice(0, 7);
      if (/^\d{4}-\d{2}$/.test(mk)) monthsWithPlays.add(mk);
    }
    for (const mp of manualPlays) {
      if (mp.date) {
        const mk = mp.date.slice(0, 7);
        if (/^\d{4}-\d{2}$/.test(mk)) monthsWithPlays.add(mk);
      }
    }
    const sortedMonths = Array.from(monthsWithPlays).sort();
    const volNumber = sortedMonths.indexOf(monthKey) + 1; // 0 se non trovato

    // ── DELTA VS MEDIA STORICA (sui mesi precedenti) ──
    const previousMonths = sortedMonths.filter(m => m < monthKey);
    let mediaPartite = 0;
    if (previousMonths.length > 0) {
      let totPrec = 0;
      for (const m of previousMonths) totPrec += countMonth(m);
      mediaPartite = totPrec / previousMonths.length;
    }
    const deltaMedia = mediaPartite > 0
      ? Math.round(((partite - mediaPartite) / mediaPartite) * 100)
      : null;

    const ore = Math.round((minuti / 60) * 10) / 10;

    // topShare = quota di partite sul gioco più giocato (serve sotto e al motore titolo)
    const topShare = (topGames.length > 0 && partite > 0) ? topGames[0].plays / partite : null;

    // ══ TITOLO DEL MESE ══════════════════════════════════════════════════════
    // Un SOLO headline forte, scelto per notabilità: si calcolano più candidati,
    // ognuno con un punteggio (= quanto è notevole QUESTO mese), vince il più alto.
    // Sostituisce la lista di annotazioni sul Volume (che diventava un mappazzone
    // e ripeteva ogni mese le stesse frasi banali).
    const _weekdays = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
    const _numWords = ['', 'uno', 'due', 'tre', 'quattro', 'cinque', 'sei', 'sette', 'otto', 'nove', 'dieci'];
    const _cap = (s) => s ? s.charAt(0).toUpperCase() + s.slice(1) : s;

    // picco giornaliero (serata più intensa)
    const dayTotals = {};
    for (const [date, info] of Object.entries(playsByDate)) {
      if (!date.startsWith(monthKey) || !info) continue;
      dayTotals[date] = (dayTotals[date] || 0) + (info.plays || 0);
    }
    for (const mp of manualPlays) {
      if (!mp.date || !mp.date.startsWith(monthKey)) continue;
      dayTotals[mp.date] = (dayTotals[mp.date] || 0) + 1;
    }
    let peakDate = null, peakCount = 0;
    for (const d in dayTotals) { if (dayTotals[d] > peakCount) { peakCount = dayTotals[d]; peakDate = d; } }

    // record: partite del mese vs massimo dei mesi precedenti (serve un minimo di storia)
    let maxPrev = 0;
    for (const m of previousMonths) { const c = countMonth(m); if (c > maxPrev) maxPrev = c; }
    const isRecord = previousMonths.length >= 2 && partite > maxPrev && partite >= 8;

    const _titleCandidates = [];
    if (isRecord) {
      _titleCandidates.push({ score: 100, headline: 'Il tuo mese più intenso', sub: `${partite} partite — il tuo record personale` });
    }
    if (deltaMedia !== null && deltaMedia >= 40) {
      _titleCandidates.push({ score: 45 + Math.min(deltaMedia, 200) * 0.25, headline: 'Sopra il tuo passo', sub: `+${deltaMedia}% sulla tua media mensile` });
    }
    if (nuovi >= 3) {
      const word = nuovi <= 10 ? _numWords[nuovi] : String(nuovi);
      _titleCandidates.push({ score: 34 + nuovi * 6, headline: `${_cap(word)} mondi nuovi`, sub: `${nuovi} giochi mai provati${giochi ? ' su ' + giochi : ''} — un mese da esploratore` });
    }
    if (peakCount >= 4 && peakDate) {
      const dt = new Date(peakDate + 'T12:00:00');
      _titleCandidates.push({ score: 28 + peakCount * 9, headline: `${_cap(_weekdays[dt.getDay()] || '')} ${dt.getDate()}: ${peakCount} partite`, sub: 'la tua serata più intensa del mese' });
    }
    if (ore >= 30) {
      _titleCandidates.push({ score: 22 + Math.min(ore, 100) * 0.5, headline: `${ore.toString().replace('.', ',')} ore al tavolo`, sub: 'un mese da maratoneta' });
    }

    let title = null;
    if (_titleCandidates.length) {
      _titleCandidates.sort((a, b) => b.score - a.score);
      title = { headline: _titleCandidates[0].headline, sub: _titleCandidates[0].sub };
    } else if (partite > 0) {
      // Fallback quieto: mai vuoto, ma senza fingere un "insight" che non c'è.
      title = { headline: `${partite} ${partite === 1 ? 'partita' : 'partite'} a ${monthNames[monthIdx] || monthLabel}`, sub: 'il tuo mese al tavolo' };
    }

    // ── ANNOTAZIONI FROGGER (legacy: non più mostrate sul Volume, sostituite dal titolo) ──
    const annotations = [];
    // (Rimossa l'annotazione "fedele al X%": ridondante con l'eroe — che già mostra il
    //  gioco più giocato come "chiodo fisso" — e banale, scattava ogni mese uguale.
    //  Un eventuale segnale di "focus" andrà fatto raro e senza ripetere il gioco dell'eroe.)
    if (nuovi >= 3) {
      annotations.push(`Hai aperto ${nuovi} nuovi mondi mai esplorati`);
    } else if (nuovi === 2) {
      annotations.push(`Due nuovi mondi mai esplorati prima`);
    } else if (nuovi === 1) {
      annotations.push(`Una nuova scoperta è entrata nel tuo stagno`);
    }
    if (deltaMedia !== null && deltaMedia >= 20) {
      annotations.push(`Hai superato del ${deltaMedia}% la tua media mensile`);
    } else if (deltaMedia !== null && deltaMedia <= -30) {
      annotations.push(`Mese tranquillo: meno tavoli del solito, ma scelti bene`);
    }
    if (giochi >= 8 && topShare !== null && topShare < 0.3) {
      annotations.push(`Esploratore: ${giochi} giochi diversi senza fermarti`);
    }
    if (ore >= 30) {
      annotations.push(`${ore.toString().replace('.', ',')} ore al tavolo: un mese da maratoneta`);
    }
    if (annotations.length === 0 && partite > 0) {
      annotations.push(`${partite} ${partite === 1 ? 'partita' : 'partite'} in ${monthNames[monthIdx] || monthLabel}, ogni una conta`);
    }
    // Cap a 3 annotazioni (estetica Volume)
    while (annotations.length > 3) annotations.pop();

    return {
      monthKey,
      monthLabel,
      volNumber,
      partite,
      giochi,
      nuovi,
      minuti,
      ore,
      deltaMedia,
      topGames,
      title,
      annotations,
      hasData: partite > 0
    };
  }

  // ============================================================
  // ENRICH COVER BGG MANCANTI — fix ludoteca con thumbnail null
  // ────────────────────────────────────────────────────────────
  // Causa: BGG XML collection a volte non ritorna <thumbnail> per
  // giochi nuovi/indie. Risultato: bggCollection.owned[].thumbnail
  // vuoto → ludoteca con placeholder lettera.
  //
  // Soluzione: per ogni entry senza img/thumbnail, chiama il worker
  // /api/bgg-thumb-by-name che fa bridge nome→bggId→thumbnail RAW.
  // Salva in profile + persist localStorage. Throttled per evitare
  // rate limit BGG.
  //
  // Input:  workerUrl, opts = {maxFetch, throttleMs, onStart, onProgress, onCoverFound}
  // Output: Promise<{processed, found, totalCandidates}>
  // ============================================================
  async function enrichProfileCoversFromBgg(workerUrl, opts) {
    opts = opts || {};
    const maxFetch = opts.maxFetch != null ? opts.maxFetch : 30;
    const throttleMs = opts.throttleMs != null ? opts.throttleMs : 300;
    if (!workerUrl) return { processed: 0, found: 0, error: 'no workerUrl' };

    const base = workerUrl.replace(/\/$/, '');
    const profile = loadProfile();
    if (!profile) return { processed: 0, found: 0, error: 'no profile' };

    const norm = (s) => (s || '').toLowerCase().trim();
    const seen = new Set();
    const targets = []; // {name, bggId}

    // Scansiona TUTTE le fonti del profile.
    // CRITICO: skip solo se ha HD (imgFull/image), NON se ha solo thumbnail.
    // Bug Andrea: aveva 18 cover sgranate perché enrich skippava entries
    // con thumbnail BGG e non upgradava mai a HD.
    if (profile.bggCollection && Array.isArray(profile.bggCollection.owned)) {
      for (const item of profile.bggCollection.owned) {
        if (!item || typeof item !== 'object') continue;
        if (item.image || !item.name) continue; // skip solo se ha HD image
        const k = norm(item.name);
        if (!k || seen.has(k)) continue;
        seen.add(k);
        targets.push({ name: item.name, bggId: item.id || null });
      }
    }
    if (Array.isArray(profile.manualOwned)) {
      for (const mo of profile.manualOwned) {
        if (!mo || mo.imgFull) continue; // skip solo se ha HD
        const moName = mo.title || mo.name;
        if (!moName) continue;
        const k = norm(moName);
        if (!k || seen.has(k)) continue;
        seen.add(k);
        targets.push({ name: moName, bggId: mo.bggId || null });
      }
    }
    if (Array.isArray(profile.manualPlays)) {
      for (const mp of profile.manualPlays) {
        if (!mp || mp.imgFull || !mp.title) continue; // skip solo se ha HD
        const k = norm(mp.title);
        if (!k || seen.has(k)) continue;
        seen.add(k);
        targets.push({ name: mp.title, bggId: mp.bggId || null });
      }
    }
    if (Array.isArray(profile.purchasedProducts)) {
      for (const pp of profile.purchasedProducts) {
        if (!pp || pp.imgFull) continue; // skip solo se ha HD
        const ppName = pp.title || pp.name;
        if (!ppName) continue;
        const k = norm(ppName);
        if (!k || seen.has(k)) continue;
        seen.add(k);
        targets.push({ name: ppName, bggId: pp.bggId || null });
      }
    }
    if (profile.playsActivity && Array.isArray(profile.playsActivity.topPlayed)) {
      for (const tp of profile.playsActivity.topPlayed) {
        if (!tp || tp.imgFull || !tp.name) continue; // skip solo se ha HD
        const k = norm(tp.name);
        if (!k || seen.has(k)) continue;
        seen.add(k);
        targets.push({ name: tp.name, bggId: tp.bggId || null });
      }
    }
    // fourFavorites: scansiona anche le 4 card "Giochi del cuore"
    if (Array.isArray(profile.fourFavorites)) {
      for (const fav of profile.fourFavorites) {
        if (!fav || fav.imgFull) continue; // skip se ha già HD
        if (!fav.name) continue;
        const k = norm(fav.name);
        if (!k || seen.has(k)) continue;
        seen.add(k);
        targets.push({ name: fav.name, bggId: fav.bggId || null });
      }
    }

    const totalCandidates = targets.length;
    if (opts.onStart) opts.onStart(Math.min(totalCandidates, maxFetch));

    if (totalCandidates === 0) return { processed: 0, found: 0, totalCandidates: 0 };

    const sample = targets.slice(0, maxFetch);
    let processed = 0, found = 0;

    // FIX 2026-11-01: le copertine trovate si applicano a `target`, che a fine giro è il
    // profilo RILETTO da localStorage. Prima si salvava la copia letta all'inizio: il giro
    // dura da secondi a minuti e una partita registrata nel frattempo veniva cancellata.
    let target = profile;
    const foundCovers = [];
    function applyThumbToProfile(targetName, targetBggId, thumb, foundBggId, thumbFull) {
      const bggId = foundBggId || targetBggId;
      const nameKey = norm(targetName);
      // thumb = thumbnail BGG (~200px). thumbFull = image HD (~600-1500px).
      // Salviamo entrambi: thumbnail/img per liste compatte, image/imgFull per
      // viste grandi (es. card ludoteca su retina dove il thumb si vede sfumato).
      if (target.bggCollection && Array.isArray(target.bggCollection.owned)) {
        for (const item of target.bggCollection.owned) {
          if (!item || typeof item !== 'object') continue;
          const idMatch = bggId && item.id === bggId;
          const nameMatch = nameKey && norm(item.name) === nameKey;
          if (idMatch || nameMatch) {
            if (!item.thumbnail && thumb) item.thumbnail = thumb;
            if (!item.image && thumbFull) item.image = thumbFull;
          }
        }
      }
      if (Array.isArray(target.manualOwned)) {
        for (const mo of target.manualOwned) {
          if (!mo) continue;
          const idMatch = bggId && mo.bggId === bggId;
          const moName = mo.title || mo.name;
          const nameMatch = nameKey && norm(moName) === nameKey;
          if (idMatch || nameMatch) {
            if (!mo.img && thumb) mo.img = thumb;
            if (!mo.imgFull && thumbFull) mo.imgFull = thumbFull;
          }
        }
      }
      if (Array.isArray(target.manualPlays)) {
        for (const mp of target.manualPlays) {
          if (!mp) continue;
          const idMatch = bggId && mp.bggId === bggId;
          const nameMatch = nameKey && norm(mp.title) === nameKey;
          if (idMatch || nameMatch) {
            if (!mp.img && thumb) mp.img = thumb;
            if (!mp.imgFull && thumbFull) mp.imgFull = thumbFull;
          }
        }
      }
      if (Array.isArray(target.purchasedProducts)) {
        for (const pp of target.purchasedProducts) {
          if (!pp) continue;
          const idMatch = bggId && pp.bggId === bggId;
          const ppName = pp.title || pp.name;
          const nameMatch = nameKey && norm(ppName) === nameKey;
          if (idMatch || nameMatch) {
            if (!pp.img && thumb) pp.img = thumb;
            if (!pp.imgFull && thumbFull) pp.imgFull = thumbFull;
          }
        }
      }
      if (target.playsActivity && Array.isArray(target.playsActivity.topPlayed)) {
        for (const tp of target.playsActivity.topPlayed) {
          if (!tp) continue;
          const idMatch = bggId && tp.bggId === bggId;
          const nameMatch = nameKey && norm(tp.name) === nameKey;
          if (idMatch || nameMatch) {
            if (!tp.img && thumb) tp.img = thumb;
            if (!tp.imgFull && thumbFull) tp.imgFull = thumbFull;
          }
        }
      }
      // fourFavorites: salva img + imgFull per "Giochi del cuore"
      if (Array.isArray(target.fourFavorites)) {
        for (const fav of target.fourFavorites) {
          if (!fav) continue;
          const idMatch = bggId && fav.bggId === bggId;
          const nameMatch = nameKey && norm(fav.name) === nameKey;
          if (idMatch || nameMatch) {
            if (!fav.img && thumb) fav.img = thumb;
            if (!fav.imgFull && thumbFull) fav.imgFull = thumbFull;
          }
        }
      }
    }

    for (const t of sample) {
      processed++;
      if (opts.onProgress) opts.onProgress(processed, sample.length, t.name);
      let foundImg = null, foundImgFull = null, foundBggId = t.bggId || null;
      try {
        // STRADA 1 (preferita): /api/bgg-thumb-by-id se ho bggId.
        if (t.bggId) {
          const res = await fetch(base + '/api/bgg-thumb-by-id?id=' + t.bggId);
          if (res.ok) {
            const json = await res.json();
            if (json && json.img) {
              foundImg = json.img;
              foundImgFull = json.imgFull || null;
              foundBggId = json.bggId || t.bggId;
            }
          }
        }
        // STRADA 2 (fallback): /api/bgg-thumb-by-name.
        if (!foundImg && t.name) {
          const res = await fetch(base + '/api/bgg-thumb-by-name?q=' + encodeURIComponent(t.name));
          if (res.ok) {
            const json = await res.json();
            if (json && json.img) {
              foundImg = json.img;
              foundImgFull = json.imgFull || null;
              foundBggId = json.bggId || foundBggId;
            }
          }
        }
        if (foundImg) {
          foundCovers.push([t.name, t.bggId, foundImg, foundBggId, foundImgFull]);
          found++;
          if (opts.onCoverFound) opts.onCoverFound(t.name, foundImg, foundImgFull);
        }
      } catch (e) { /* continue */ }
      if (throttleMs > 0 && processed < sample.length) {
        await new Promise(r => setTimeout(r, throttleMs));
      }
    }

    if (found > 0) {
      // Rilegge il profilo ADESSO (può contenere partite salvate durante il giro) e ci
      // applica le copertine trovate: niente sovrascritture con una copia vecchia.
      target = loadProfile() || profile;
      for (const c of foundCovers) applyThumbToProfile(c[0], c[1], c[2], c[3], c[4]);
      try { saveProfile(target); } catch (e) { /* localStorage quota */ }
    }

    return { processed, found, totalCandidates };
  }

  // Scopri si apre anche senza Carta Frogger: è la porta d'ingresso di chi arriva da un link.
  // Chi passa da accesso o quiz torna dove stava (fma_dest), anche se per strada si perde il #.
  function scopriAperto() {
    try {
      const dest = sessionStorage.getItem('fma_dest');
      if (dest) {
        sessionStorage.removeItem('fma_dest');
        if (/^#giochi/.test(dest)) window.location.hash = dest;
      }
    } catch (e) {}
    return /^#giochi/.test(window.location.hash);
  }

  window.FrogMatch = {
    scopriAperto,
    deriveTypologies,
    deriveProfileFromSwipes,
    archetypeLabel,
    archetypeTagline,
    buildProfile,
    computeSoloGamerScore,
    applySoloGamerTag,
    recomputeWeightTargetWithHours,
    recomputeProfileFromCollection,
    generateRetroSnapshots,
    maybeSaveQuarterlySnapshot,
    computeMatch,
    rankProducts,
    applyMood,
    loadProfile,
    saveProfile,
    loadSwipes,
    saveSwipes,
    loadMood,
    saveMood,
    clearAll,
    loadCommunityData,
    logManualPlay,
    importManualPlays,
    patchManualPlays,
    rankExpansions,
    deleteManualPlay,
    editManualPlay,
    addManualOwned,
    removeManualOwned,
    readProductDataFromDOM,
    loadFullCatalog,
    getCatalogProducts,
    TYPOLOGY_LABELS,
    TYPOLOGY_ICONS,
    INTERACTION_LABELS,
    INTERACTION_ICONS,
    ALEA_LABELS,
    ALEA_ICONS,
    deriveInteraction,
    deriveAlea,
    MECHANIC_LABELS,
    CATEGORY_LABELS,
    COMMON_MECHANICS,
    COMMON_CATEGORIES,
    tMech,
    tCat,
    isThemeCategory,
    readCustomerDataFromDOM,
    backfillPurchasesFromHistory,
    syncProfileToServer,
    computeVolumeData,
    enrichProfileCoversFromBgg,
    _testNameMatch
  };
})();


/* ────────────────────────────────────────────────
   Controller: Quiz (swipe)
   ──────────────────────────────────────────────── */

(function () {
  if (!window.FrogMatch) return;
  const FM = window.FrogMatch;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function diverseSample(products, count) {
    const valid = products.filter(p => {
      if (!p.w || p.w <= 0) return false;
      const hasMech = Array.isArray(p.mch) && p.mch.length > 0;
      return hasMech;
    });
    if (valid.length === 0) return shuffle(products.slice()).slice(0, count);
    if (valid.length <= count) return shuffle(valid.slice());

    const picked = [];
    const used = new Set();
    const startIdx = Math.floor(Math.random() * valid.length);
    picked.push(valid[startIdx]);
    used.add(valid[startIdx].id);

    const TOP_K = 5;

    while (picked.length < count) {
      const candidates = [];
      for (let i = 0; i < valid.length; i++) {
        if (used.has(valid[i].id)) continue;
        let minDist = Infinity;
        for (const p of picked) {
          const d = productDistance(valid[i], p);
          if (d < minDist) minDist = d;
        }
        candidates.push({ idx: i, dist: minDist });
      }
      if (candidates.length === 0) break;

      candidates.sort((a, b) => b.dist - a.dist);
      const topK = candidates.slice(0, Math.min(TOP_K, candidates.length));
      let totalW = 0;
      for (const c of topK) totalW += Math.max(c.dist, 0.01);
      let r = Math.random() * totalW;
      let chosen = topK[0];
      for (const c of topK) {
        r -= Math.max(c.dist, 0.01);
        if (r <= 0) { chosen = c; break; }
      }
      picked.push(valid[chosen.idx]);
      used.add(valid[chosen.idx].id);
    }

    return shuffle(picked);
  }

  function productDistance(a, b) {
    let d = 0;
    if (a.w != null && b.w != null) d += Math.pow(a.w - b.w, 2);
    if (a.tmax > 0 && b.tmax > 0) d += Math.pow((a.tmax - b.tmax) / 60, 2);
    const mechA = new Set(a.mch || []);
    const mechB = new Set(b.mch || []);
    let intersection = 0;
    for (const m of mechA) if (mechB.has(m)) intersection++;
    const mechSim = (mechA.size + mechB.size) > 0 ? intersection / (mechA.size + mechB.size - intersection || 1) : 0;
    d += (1 - mechSim) * 4;
    return Math.sqrt(d);
  }

  class QuizController {
    constructor(root) {
      this.root = root;
      this.poolSize = parseInt(root.dataset.poolSize, 10) || 12;
      this.resultUrl = root.dataset.resultUrl || '/pages/frogmatch';

      if (!document.querySelector('[data-fm-entry]')) {
        root.hidden = false;
      }

      this.intro = root.querySelector('[data-fm-intro]');
      this.game = root.querySelector('[data-fm-game]');
      this.deck = root.querySelector('[data-fm-deck]');
      this.progress = root.querySelector('[data-fm-progress]');
      this.current = root.querySelector('[data-fm-current]');
      this.total = root.querySelector('[data-fm-total]');
      this.loading = root.querySelector('[data-fm-loading]');

      this.products = FM.readProductDataFromDOM();
      this.pool = diverseSample(this.products, this.poolSize);
      this.swipes = [];
      this.idx = 0;
      this.locked = false;

      this.bindEvents();
      this.total.textContent = String(this.pool.length);
    }

    bindEvents() {
      const startBtn = this.root.querySelector('[data-fm-start]');
      if (startBtn) startBtn.addEventListener('click', () => this.start());
      const backBtn = this.root.querySelector('[data-fm-back]');
      if (backBtn) backBtn.addEventListener('click', () => this.back());
      this.root.querySelectorAll('[data-fm-action]').forEach(btn => {
        btn.addEventListener('click', () => this.handleReaction(btn.dataset.fmAction));
      });
      this.onKey = this.onKey.bind(this);
      document.addEventListener('keydown', this.onKey);
    }

    onKey(e) {
      if (this.game.hidden) return;
      if (e.key === 'ArrowLeft') this.handleReaction('pass');
      else if (e.key === 'ArrowRight') this.handleReaction('love');
      else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') this.handleReaction('unknown');
    }

    start() {
      if (this.pool.length === 0) {
        const empty = document.createElement('p');
        empty.style.cssText = 'color:#FF5C7A;margin-top:16px;font-size:.9rem';
        empty.textContent = 'Catalogo non ancora pronto. Verifica la sync BGG.';
        this.intro.querySelector('.fm-quiz__intro-inner').appendChild(empty);
        return;
      }
      this.intro.hidden = true;
      this.game.hidden = false;
      this.idx = 0;
      this.swipes = [];
      this.renderDeck();
      this.updateProgress();
    }

    back() {
      if (this.swipes.length > 0 && !confirm('Vuoi davvero uscire? Perderai i tuoi swipe.')) return;
      this.game.hidden = true;
      this.intro.hidden = false;
    }

    renderDeck() {
      this.deck.innerHTML = '';
      const visible = Math.min(3, this.pool.length - this.idx);
      for (let i = 0; i < visible; i++) {
        this.deck.appendChild(this.createCard(this.pool[this.idx + i], i));
      }
      const top = this.deck.querySelector('.fm-card[data-stack="0"]');
      if (top) this.attachDrag(top);
    }

    createCard(product, stack) {
      const card = document.createElement('article');
      card.className = 'fm-card';
      card.dataset.stack = String(stack);
      card.dataset.productId = String(product.id);
      card.innerHTML =
        '<div class="fm-card__overlay fm-card__overlay--love">SÌ</div>' +
        '<div class="fm-card__overlay fm-card__overlay--pass">NO</div>' +
        '<div class="fm-card__media" style="background-image:url(\'' + product.img + '\')"></div>' +
        '<div class="fm-card__body"><h2 class="fm-card__title">' + escapeHtml(product.t) + '</h2></div>';
      return card;
    }

    attachDrag(card) {
      let sx = 0, sy = 0, dx = 0, dy = 0, dragging = false;

      const onDown = (e) => {
        if (this.locked) return;
        const pt = e.touches ? e.touches[0] : e;
        sx = pt.clientX; sy = pt.clientY; dx = 0; dy = 0;
        dragging = true; card.style.transition = 'none';
      };
      const onMove = (e) => {
        if (!dragging) return;
        const pt = e.touches ? e.touches[0] : e;
        dx = pt.clientX - sx; dy = pt.clientY - sy;
        card.style.transform = 'translate(' + dx + 'px,' + dy + 'px) rotate(' + (dx * 0.05) + 'deg)';
        card.classList.toggle('is-dragging-love', dx > 60);
        card.classList.toggle('is-dragging-pass', dx < -60);
      };
      const onUp = () => {
        if (!dragging) return;
        dragging = false; card.style.transition = '';
        if (dx > 100) this.handleReaction('love');
        else if (dx < -100) this.handleReaction('pass');
        else if (dy < -100) this.handleReaction('unknown');
        else { card.style.transform = ''; card.classList.remove('is-dragging-love', 'is-dragging-pass'); }
      };

      card.addEventListener('mousedown', onDown);
      card.addEventListener('touchstart', onDown, { passive: true });
      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: true });
      window.addEventListener('mouseup', onUp);
      window.addEventListener('touchend', onUp);
    }

    handleReaction(reaction) {
      if (this.locked || this.idx >= this.pool.length) return;
      this.locked = true;
      const product = this.pool[this.idx];
      this.swipes.push({ productId: product.id, reaction, ts: Date.now() });

      const top = this.deck.querySelector('.fm-card[data-stack="0"]');
      if (top) {
        top.style.transition = 'transform 0.45s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.4s ease';
        top.classList.add('is-leaving-' + reaction);
      }

      this.idx++;
      this.updateProgress();

      setTimeout(() => {
        if (top) top.remove();
        this.deck.querySelectorAll('.fm-card').forEach(c => {
          c.dataset.stack = String(parseInt(c.dataset.stack, 10) - 1);
        });
        const next = this.idx + 2;
        if (next < this.pool.length) {
          this.deck.appendChild(this.createCard(this.pool[next], 2));
        }
        const newTop = this.deck.querySelector('.fm-card[data-stack="0"]');
        if (newTop) this.attachDrag(newTop);
        this.locked = false;
        if (this.idx >= this.pool.length) this.finish();
      }, 320);
    }

    updateProgress() {
      const pct = (this.idx / this.pool.length) * 100;
      this.progress.style.width = pct + '%';
      this.current.textContent = String(Math.min(this.idx + 1, this.pool.length));
    }

    finish() {
      this.loading.hidden = false;
      const profile = FM.buildProfile(this.swipes, this.products, { source: 'swipe' });
      // Backfill acquisti pregressi del customer (Shopify orders) anche per onboarding manuale.
      // Senza questo, chi compila il quiz a mano partiva con purchasedProducts vuoto
      // anche se aveva ordini precedenti su Frogames.it.
      try {
        profile.purchasedProducts = FM.backfillPurchasesFromHistory(profile.purchasedProducts || []);
      } catch (e) { /* silenzioso: backfill è bonus, non bloccante */ }
      FM.saveProfile(profile);
      FM.saveSwipes(this.swipes);
      setTimeout(() => { window.location.href = this.resultUrl; }, 900);
    }
  }

  function init() {
    document.querySelectorAll('[data-fm-quiz]').forEach(root => {
      if (root.__fmInit) return;
      root.__fmInit = true;
      new QuizController(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


/* ────────────────────────────────────────────────
   Controller: Wrapped (Carta Frogger)
   ──────────────────────────────────────────────── */

(function () {
  if (!window.FrogMatch) return;
  const FM = window.FrogMatch;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function tier(pct) {
    if (pct >= 80) return 'high';
    if (pct >= 60) return 'mid';
    return 'low';
  }

  class WrappedController {
    constructor(root) {
      console.log('[FrogMatch] WrappedController init v3 (logPlay debug)');
      this.root = root;
      this.quizUrl = root.dataset.quizUrl || '/pages/frogmatch';
      this.profile = FM.loadProfile();
      console.log('[FrogMatch] profile loaded:', this.profile ? 'YES (' + (this.profile.source || 'unknown') + ')' : 'NO');

      if (!this.profile) {
        const r = root.querySelector('[data-fm-redirect]');
        if (r) r.hidden = false;
        setTimeout(() => { window.location.href = this.quizUrl; }, 200);
        return;
      }

      const scroll = root.querySelector('[data-fm-scroll]');
      if (scroll) scroll.hidden = false;

      this.products = FM.readProductDataFromDOM();
      this.swipes = FM.loadSwipes();

      // Backfill acquisti pregressi (una sola volta per profilo, idempotente)
      try {
        if (!this.profile.purchasesBackfilledV3) {
          this.profile.purchasedProducts = FM.backfillPurchasesFromHistory(this.profile.purchasedProducts || []);
          this.profile.purchasesBackfilledV3 = true;
          FM.saveProfile(this.profile);
        }
      } catch (e) { /* silenzioso */ }

      // bindLogPlay PRIMO: anche se i render lanciano errore, il pulsante resta funzionante
      try { this.bindLogPlay(); } catch (e) { console.warn('[FrogMatch] bindLogPlay early failed:', e); }

      try { this.renderArchetype(); } catch (e) { console.warn('[FrogMatch] renderArchetype:', e); }
      try { this.renderTypologies(); } catch (e) { console.warn('[FrogMatch] renderTypologies:', e); }
      try { this.renderMechanics(); } catch (e) { console.warn('[FrogMatch] renderMechanics:', e); }
      try { this.renderStats(); } catch (e) { console.warn('[FrogMatch] renderStats:', e); }
      try { this.renderActivity(); } catch (e) { console.warn('[FrogMatch] renderActivity:', e); }
      try { this.renderMatches(); } catch (e) { console.warn('[FrogMatch] renderMatches:', e); }
      try { this.renderShare(); } catch (e) { console.warn('[FrogMatch] renderShare:', e); }
      try { this.bindEvents(); } catch (e) { console.warn('[FrogMatch] bindEvents:', e); }

      // Carica community data in background; quando arriva, ri-renderizza i match con communityBoost
      const customer = FM.readCustomerDataFromDOM ? FM.readCustomerDataFromDOM() : null;
      const workerUrl = customer && customer.workerUrl;
      if (workerUrl) {
        FM.loadCommunityData(workerUrl).then(data => {
          if (data) this.renderMatches();
        });
      }
    }

    setText(sel, val) {
      const el = this.root.querySelector(sel);
      if (el) el.textContent = val;
    }

    renderArchetype() {
      const p = this.profile;
      this.setText('[data-fm-archetype-name]', p.archetypeName);
      this.setText('[data-fm-tagline]', p.archetypeTagline || '');
      const article = this.root.querySelector('[data-fm-archetype-article]');
      if (article) article.textContent = '';
      const sec = this.root.querySelector('[data-fm-secondary-name]');
      if (sec && p.topTypologies && p.topTypologies[1]) {
        sec.textContent = FM.TYPOLOGY_LABELS[p.topTypologies[1]] || '';
      } else if (sec) {
        const wrap = sec.closest('.fm-screen__secondary');
        if (wrap) wrap.style.display = 'none';
      }
    }

    renderTypologies() {
      const radarEl = this.root.querySelector('[data-fm-radar]');
      if (!radarEl) return;
      const typs = this.profile.topTypologies || [];
      if (typs.length === 0) {
        radarEl.innerHTML = '<p style="color:var(--fm-fg-mute);text-align:center">Servono più swipe a destra per costruire il profilo.</p>';
        return;
      }
      radarEl.innerHTML = '<div class="fm-tag-cloud fm-tag-cloud--typologies">' +
        typs.map(t => '<span class="fm-tag fm-tag--typology"><span class="fm-tag__icon">' +
          (FM.TYPOLOGY_ICONS[t] || '·') + '</span>' +
          escapeHtml(FM.TYPOLOGY_LABELS[t] || t) + '</span>').join('') +
        '</div>';
    }

    renderMechanics() {
      const legend = this.root.querySelector('[data-fm-radar-legend]');
      if (!legend) return;
      const mech = this.profile.topMechanics || [];
      const cat = (this.profile.topCategories || []).filter(c => FM.isThemeCategory(c));
      const designers = this.profile.topDesigners || [];
      const avoid = this.profile.avoidedMechanics || [];

      let html = '';
      if (mech.length > 0) {
        html += '<li class="fm-feature-row"><span class="fm-feature-row__label">Meccaniche</span>' +
          '<div class="fm-tag-cloud">' + mech.map(m => '<span class="fm-tag">' + escapeHtml(FM.tMech(m)) + '</span>').join('') + '</div></li>';
      }
      if (cat.length > 0) {
        html += '<li class="fm-feature-row"><span class="fm-feature-row__label">Ambientazioni</span>' +
          '<div class="fm-tag-cloud">' + cat.map(c => '<span class="fm-tag">' + escapeHtml(FM.tCat(c)) + '</span>').join('') + '</div></li>';
      }
      if (designers.length > 0) {
        html += '<li class="fm-feature-row"><span class="fm-feature-row__label">Autori preferiti</span>' +
          '<div class="fm-tag-cloud">' + designers.map(d => '<span class="fm-tag fm-tag--designer">' + escapeHtml(d) + '</span>').join('') + '</div></li>';
      }
      if (avoid.length > 0) {
        html += '<li class="fm-feature-row"><span class="fm-feature-row__label">Eviti</span>' +
          '<div class="fm-tag-cloud">' + avoid.map(a => '<span class="fm-tag fm-tag--avoid">' + escapeHtml(FM.tMech(a)) + '</span>').join('') + '</div></li>';
      }

      const interLabels = FM.INTERACTION_LABELS || {};
      const interIcons = FM.INTERACTION_ICONS || {};
      if (this.profile.interactionPreference != null && interLabels[this.profile.interactionPreference]) {
        const i = this.profile.interactionPreference;
        html += '<li class="fm-feature-row"><span class="fm-feature-row__label">Interazione</span>' +
          '<div class="fm-tag-cloud"><span class="fm-tag fm-tag--axis"><span class="fm-tag__icon">' +
          (interIcons[i] || '·') + '</span>' + escapeHtml(interLabels[i]) + '</span></div></li>';
      }

      const aleaLabels = FM.ALEA_LABELS || {};
      const aleaIcons = FM.ALEA_ICONS || {};
      if (this.profile.aleaPreference != null && aleaLabels[this.profile.aleaPreference]) {
        const a = this.profile.aleaPreference;
        html += '<li class="fm-feature-row"><span class="fm-feature-row__label">Alea</span>' +
          '<div class="fm-tag-cloud"><span class="fm-tag fm-tag--axis"><span class="fm-tag__icon">' +
          (aleaIcons[a] || '·') + '</span>' + escapeHtml(aleaLabels[a]) + '</span></div></li>';
      }

      legend.innerHTML = html;
      legend.classList.add('fm-feature-list');
    }

    renderStats() {
      const p = this.profile;
      const PLAYER_LABELS = { '1': 'Solo', '2': '2', '3': '3-4', '5': '5+' };
      let playerVal = '—';
      if (p.playerCounts && p.playerCounts.length > 0) {
        playerVal = p.playerCounts.map(c => PLAYER_LABELS[c] || c).join(' · ');
      } else if (p.playerCountIdeal) {
        playerVal = String(p.playerCountIdeal);
      }
      const timeVal = p.playtimeTarget ? p.playtimeTarget[0] + '-' + p.playtimeTarget[1] + '′' : '—';
      const weightVal = p.weightTarget ? p.weightTarget.toFixed(1) + '/5' : '—';
      this.setText('[data-fm-stat-players]', playerVal);
      this.setText('[data-fm-stat-time]', timeVal);
      this.setText('[data-fm-stat-weight]', weightVal);
    }

    renderActivity() {
      const wrap = this.root.querySelector('[data-fm-activity]');
      const empty = this.root.querySelector('[data-fm-log-empty]');
      if (!wrap) return;
      const act = this.profile.playsActivity;
      if (!act || !act.totalPlays || act.totalPlays === 0) {
        wrap.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      wrap.hidden = false;
      this.setText('[data-fm-act-plays]', String(act.totalPlays));
      const hours = Math.round(act.totalMinutes / 60);
      this.setText('[data-fm-act-hours]', hours > 0 ? String(hours) : '—');
      this.setText('[data-fm-act-unique]', String(act.uniqueGames || 0));

      // Periodo: "set 2024 → mar 2025"
      const periodEl = this.root.querySelector('[data-fm-act-period]');
      if (periodEl && act.fromDate && act.toDate) {
        const from = new Date(act.fromDate);
        const to = new Date(act.toDate);
        const monthNames = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
        const fromStr = monthNames[from.getMonth()] + ' ' + from.getFullYear();
        const toStr = monthNames[to.getMonth()] + ' ' + to.getFullYear();
        periodEl.textContent = fromStr === toStr ? fromStr : (fromStr + ' → ' + toStr);
      }

      // Status badge: 🟢 attivo / 🟡 saltuario / 🟠 occasionale / 🔴 in pausa
      const statusEl = this.root.querySelector('[data-fm-act-status]');
      if (statusEl) {
        const labels = {
          active:  { icon: '🟢', text: 'Attivo · gioca regolarmente' },
          recent:  { icon: '🟡', text: 'Saltuario · partite recenti' },
          casual:  { icon: '🟠', text: 'Occasionale · ultimi mesi' },
          paused:  { icon: '🔴', text: 'In pausa · oltre 6 mesi fa' }
        };
        const s = labels[act.activityStatus] || labels.paused;
        statusEl.innerHTML = '<span class="fm-activity__status-icon">' + s.icon + '</span> ' + escapeHtml(s.text);
        statusEl.hidden = false;
      }

      const mostEl = this.root.querySelector('[data-fm-act-most]');
      const most = this.getMostPlayed();
      if (mostEl && most) {
        const tHours = Math.round(most.minutes / 60 * 10) / 10;
        const hoursStr = most.minutes > 0 ? (tHours >= 1 ? tHours + 'h' : most.minutes + ' min') : '';
        const sep = hoursStr ? ' · ' + hoursStr : '';
        const freshIcon = { active: '🟢', recent: '🟡', casual: '🟠', paused: '⚪' }[most.freshness] || '';
        const freshPrefix = freshIcon ? freshIcon + ' ' : '';
        mostEl.innerHTML = '🏆 Più giocato: ' + freshPrefix + '<strong>' + escapeHtml(most.name || 'gioco') + '</strong> · ' + most.plays + ' partite' + sep;
        mostEl.hidden = false;
      }
    }

    renderMatches() {
      const container = this.root.querySelector('[data-fm-matches]');
      if (!container) return;
      const ranked = FM.rankProducts(this.profile, this.products);
      const top = ranked.slice(0, 6);
      if (top.length === 0) {
        container.innerHTML = '<p style="color:var(--fm-fg-mute);font-size:.9rem">Nessun match ancora. Servono più swipe a destra.</p>';
        return;
      }
      container.innerHTML = '';
      top.forEach(p => {
        const a = document.createElement('a');
        a.className = 'fm-match';
        a.href = p.u;
        // v3: se hideNumber (poca confidenza/score basso) mostra emoji invece di %.
        // Onesto: non sparare un numero finto se non sappiamo abbastanza.
        const pctHtml = p.matchHideNumber
          ? '<span class="fm-match__pct fm-match__pct--badge" data-tier="' + (p.matchTier || 'low') + '">🌿</span>'
          : '<span class="fm-match__pct" data-tier="' + tier(p.matchPercent) + '">' + p.matchPercent + '%</span>';
        a.innerHTML =
          pctHtml +
          '<div class="fm-match__media" style="background-image:url(\'' + p.img + '\')"></div>' +
          '<div class="fm-match__body"><h3 class="fm-match__title">' + escapeHtml(p.t) + '</h3></div>';
        container.appendChild(a);
      });
      const seeAll = this.root.querySelector('[data-fm-see-all]');
      if (seeAll && ranked.length > 6) seeAll.hidden = false;
    }

    renderShare() {
      this.setText('[data-fm-share-archetype]', this.profile.archetypeName);
      const radar = this.root.querySelector('[data-fm-share-radar]');
      if (radar) {
        const typs = this.profile.topTypologies || [];
        radar.innerHTML = typs.slice(0, 3).map(t =>
          '<div style="font-size:.85rem;color:var(--fm-fg);margin:6px 0">' +
          (FM.TYPOLOGY_ICONS[t] || '·') + ' ' + escapeHtml(FM.TYPOLOGY_LABELS[t] || t) + '</div>'
        ).join('');
      }
      const top3 = this.root.querySelector('[data-fm-share-top3]');
      if (top3) {
        const ranked = FM.rankProducts(this.profile, this.products).slice(0, 3);
        if (ranked.length > 0) {
          top3.innerHTML = 'I miei top match:<br><strong>' +
            ranked.map(p => escapeHtml(p.t)).join(' · ') + '</strong>';
        }
      }
    }

    bindEvents() {
      const next = this.root.querySelector('[data-fm-next]');
      if (next) next.addEventListener('click', () => {
        const s1 = this.root.querySelector('[data-fm-screen="1"]');
        if (s1) s1.scrollIntoView({ behavior: 'smooth' });
      });
      const shareBtn = this.root.querySelector('[data-fm-share]');
      if (shareBtn) shareBtn.addEventListener('click', () => this.share());
      const redoBtn = this.root.querySelector('[data-fm-redo]');
      if (redoBtn) redoBtn.addEventListener('click', () => {
        if (confirm('Vuoi rifare la carta da capo? Il tuo profilo attuale verrà sostituito.')) {
          FM.clearAll();
          window.location.href = this.quizUrl;
        }
      });
      const refreshBtn = this.root.querySelector('[data-fm-refresh-bgg]');
      if (refreshBtn && this.profile && this.profile.source === 'bgg' && this.profile.bggUsername) {
        refreshBtn.hidden = false;
        refreshBtn.addEventListener('click', () => {
          window.location.href = this.quizUrl + '#bgg';
        });
      }

      this.bindCommunitySharing();
      // bindLogPlay è già chiamato all'inizio del constructor (resilient)
    }

    bindLogPlay() {
      // Guardia anti-doppio bind (può essere chiamato più volte se WrappedController re-init)
      if (this.root.__fmLogPlayBound) return;
      this.root.__fmLogPlayBound = true;

      const modal = this.root.querySelector('[data-fm-log-modal]');
      const closes = this.root.querySelectorAll('[data-fm-log-close]');
      const dateInput = this.root.querySelector('[data-fm-log-date]');
      const gameInput = this.root.querySelector('[data-fm-log-game]');
      const suggest = this.root.querySelector('[data-fm-log-suggest]');
      const durationGroup = this.root.querySelector('[data-fm-log-duration]');
      const ratingGroup = this.root.querySelector('[data-fm-log-rating]');
      const playersGroup = this.root.querySelector('[data-fm-log-players]');
      const saveBtn = this.root.querySelector('[data-fm-log-save]');
      const status = this.root.querySelector('[data-fm-log-status]');
      if (!modal || !saveBtn) {
        console.warn('[FrogMatch] Modal "Registra partita" non trovato. Verifica upload sections/frogmatch-wrapped.liquid');
        return;
      }

      // Listener delegato globale: cattura il click ovunque sul pulsante "log play",
      // anche se il pulsante viene aggiunto/cambiato dopo (resilient al re-render)
      this.root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-fm-log-play]');
        if (btn && this.root.contains(btn)) {
          e.preventDefault();
          openModal();
        }
      });

      const state = { product: null, bggOnly: null, customTitle: '', date: '', minutes: null, rating: null, players: null };

      // Forza chiusura modal al caricamento (in caso CSS bypassi hidden)
      modal.hidden = true;
      modal.style.display = 'none';

      const openModal = () => {
        if (dateInput) dateInput.value = new Date().toISOString().slice(0, 10);
        state.date = dateInput ? dateInput.value : new Date().toISOString().slice(0, 10);
        modal.hidden = false;
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        if (gameInput) setTimeout(() => gameInput.focus(), 100);
      };
      const closeModal = () => {
        modal.hidden = true;
        modal.style.display = 'none';
        document.body.style.overflow = '';
        state.product = null;
        state.bggOnly = null;
        state.customTitle = '';
        state.minutes = null;
        state.rating = null;
        state.players = null;
        if (gameInput) gameInput.value = '';
        if (suggest) { suggest.innerHTML = ''; suggest.hidden = true; }
        if (durationGroup) durationGroup.querySelectorAll('.fm-chip').forEach(b => b.classList.remove('is-active'));
        if (ratingGroup) ratingGroup.querySelectorAll('.fm-chip').forEach(b => b.classList.remove('is-active'));
        if (playersGroup) playersGroup.querySelectorAll('.fm-chip').forEach(b => b.classList.remove('is-active'));
        if (status) { status.hidden = true; status.textContent = ''; }
        saveBtn.disabled = true;
      };

      // (i pulsanti openModal sono già gestiti via delegated listener sopra)
      closes.forEach(b => b.addEventListener('click', closeModal));

      const updateSaveBtn = () => {
        saveBtn.disabled = !((state.product || state.customTitle.trim().length > 1) && state.date);
      };

      if (gameInput) {
        let bggSearchTimer = null;
        let lastQuery = '';
        const VISIBLE_COUNT = 6; // risultati BGG visibili di default; "Cerca di più" rivela il resto
        let allBggResults = [];
        let bggExpanded = false;

        const renderSuggestions = (queryStr) => {
          if (!suggest) return;
          let html = '';
          const visible = bggExpanded ? allBggResults : allBggResults.slice(0, VISIBLE_COUNT);

          // Match BGG (con thumbnail e aka italiano se disponibile)
          html += visible.map(b => {
            const aka = b.aka ? ' <span class="fm-log-suggest__aka">aka ' + escapeHtml(b.aka) + '</span>' : '';
            const imgTag = b.img ? '<img src="' + escapeHtml(b.img) + '" alt="" loading="lazy">' : '<span class="fm-log-suggest__noimg">🎲</span>';
            // FIX 2026-05-11: aggiunto data-img per salvare l'immagine BGG sul li → state.bggOnly.img → manualPlay.img.
            // Senza: dopo save partita, topPlayed entry hasImg=false → primo favorito sparisce visualmente.
            return '<li class="fm-log-suggest__item fm-log-suggest__item--bgg" data-source="bgg" data-bgg-id="' + b.bggId + '" data-name="' + escapeHtml(b.name) + '" data-img="' + escapeHtml(b.img || '') + '">' +
              imgTag +
              '<span>' + escapeHtml(b.name) + (b.year ? ' (' + b.year + ')' : '') + aka + '</span></li>';
          }).join('');

          // Pulsante "Cerca di più" se ci sono altri risultati nascosti
          if (!bggExpanded && allBggResults.length > VISIBLE_COUNT) {
            const remaining = allBggResults.length - VISIBLE_COUNT;
            html += '<li class="fm-log-suggest__more" data-fm-more>🔍 Cerca di più (' + remaining + ' altri)</li>';
          }

          // Opzione "scrivi a mano" sempre disponibile in fondo
          if (queryStr && queryStr.length >= 2) {
            html += '<li class="fm-log-suggest__item fm-log-suggest__item--free" data-source="free" data-name="' + escapeHtml(queryStr) + '">' +
              '<span>Non trovi il gioco? Salva con questo titolo: <strong>"' + escapeHtml(queryStr) + '"</strong><span class="fm-log-suggest__badge">A MANO</span></span></li>';
          }
          suggest.innerHTML = html;
          suggest.hidden = html.length === 0;

          // Click handler "Cerca di più"
          const moreBtn = suggest.querySelector('[data-fm-more]');
          if (moreBtn) {
            moreBtn.addEventListener('click', () => {
              bggExpanded = true;
              renderSuggestions(queryStr);
            });
          }

          suggest.querySelectorAll('.fm-log-suggest__item').forEach(li => {
            li.addEventListener('click', () => {
              const src = li.dataset.source;
              if (src === 'bgg') {
                state.product = null;
                state.bggOnly = { bggId: parseInt(li.dataset.bggId, 10), name: li.dataset.name, img: li.dataset.img || null };
                state.customTitle = li.dataset.name;
                gameInput.value = li.dataset.name;
              } else if (src === 'free') {
                state.product = null;
                state.bggOnly = null;
                state.customTitle = li.dataset.name;
                gameInput.value = li.dataset.name;
              }
              suggest.hidden = true;
              updateSaveBtn();
            });
          });
        };

        const fetchBggSearch = async (query) => {
          const customer = FM.readCustomerDataFromDOM ? FM.readCustomerDataFromDOM() : null;
          const workerUrl = customer && customer.workerUrl;
          if (!workerUrl) return [];
          try {
            const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/bgg-search?q=' + encodeURIComponent(query));
            if (!res.ok) return [];
            const data = await res.json();
            return data.results || [];
          } catch (e) { return []; }
        };

        gameInput.addEventListener('input', () => {
          const q = gameInput.value.trim();
          state.customTitle = gameInput.value;
          state.product = null;
          state.bggOnly = null;
          bggExpanded = false;
          updateSaveBtn();

          if (q.length < 2) {
            allBggResults = [];
            if (suggest) { suggest.innerHTML = ''; suggest.hidden = true; }
            return;
          }

          if (bggSearchTimer) clearTimeout(bggSearchTimer);
          if (q.length < 3) return;
          lastQuery = q;

          // Loader immediato
          if (suggest) {
            suggest.innerHTML = '<li class="fm-log-suggest__loading">🔍 Cerco su BGG...</li>';
            suggest.hidden = false;
          }

          bggSearchTimer = setTimeout(async () => {
            const bggResults = await fetchBggSearch(q);
            if (q !== lastQuery) return;
            allBggResults = bggResults;
            bggExpanded = false;
            renderSuggestions(q);
          }, 300);
        });
      }

      if (dateInput) dateInput.addEventListener('change', () => {
        state.date = dateInput.value;
        updateSaveBtn();
      });

      const bindChipGroup = (group, key, parser) => {
        if (!group) return;
        group.addEventListener('click', (e) => {
          const btn = e.target.closest('button.fm-chip');
          if (!btn || !group.contains(btn)) return;
          group.querySelectorAll('.fm-chip').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const v = btn.dataset.value;
          state[key] = (v === '' || v == null) ? null : parser(v);
        });
      };
      bindChipGroup(durationGroup, 'minutes', v => parseInt(v, 10));
      bindChipGroup(ratingGroup, 'rating', v => parseInt(v, 10));
      bindChipGroup(playersGroup, 'players', v => parseInt(v, 10));

      // Protezione doppio-bind: se questo handler è già attaccato (binding più
      // volte da re-render), salta. Bug 2026-05-12 segnalato da cliente con
      // partite doppie.
      if (saveBtn.__fmLogPlayBound) return;
      saveBtn.__fmLogPlayBound = true;
      saveBtn.addEventListener('click', () => {
        // Doppia barriera: 1) disable IMMEDIATO 2) check disabled
        if (saveBtn.disabled) return;
        saveBtn.disabled = true;
        let productId = null, bggId = null, title = state.customTitle, img = null;
        if (state.product) {
          productId = state.product.id;
          bggId = state.product.bgg || null;
          title = state.product.t;
          img = state.product.img || null;
        } else if (state.bggOnly) {
          bggId = state.bggOnly.bggId;
          title = state.bggOnly.name;
          img = state.bggOnly.img || null;
        }
        const ownedCheckbox = this.root.querySelector('[data-fm-log-add-owned]');
        const addToCollection = ownedCheckbox ? ownedCheckbox.checked : false;
        const opts = {
          productId, bggId, title, img,
          date: state.date,
          minutes: state.minutes || 0,
          rating: state.rating,
          players: state.players,
          addToCollection
        };
        const result = FM.logManualPlay(opts);
        if (!result.ok) {
          if (status) { status.textContent = 'Errore: ' + (result.error || 'salvataggio fallito'); status.hidden = false; }
          // Re-enable in caso di errore così l'utente può ritentare
          saveBtn.disabled = false;
          return;
        }
        // Aggiorna UI in place
        this.profile = result.profile;
        if (status) { status.textContent = '✓ Partita registrata. Ottimo!'; status.hidden = false; }
        setTimeout(() => {
          closeModal();
          this.renderActivity();
          this.renderMatches();
          // Re-enable per la prossima apertura del modal
          saveBtn.disabled = false;
        }, 600);
      });
    }

    bindCommunitySharing() {
      const hasBggImport = this.profile && this.profile.source === 'bgg';
      // Mostra il toggle solo per utenti con import BGG (gli altri non hanno plays da condividere)
      if (!hasBggImport) return;

      const toggle = this.root.querySelector('[data-fm-share-toggle]');
      const banner = this.root.querySelector('[data-fm-share-banner]');
      const checkbox = this.root.querySelector('[data-fm-toggle-share-plays]');
      const status = this.root.querySelector('[data-fm-toggle-status]');

      const hasChosen = this.profile.shareCommunityPlaysSetAt != null;
      const currentValue = !!this.profile.shareCommunityPlays;

      if (hasChosen) {
        // Utente ha già scelto → mostra il toggle persistente
        if (toggle) toggle.hidden = false;
        if (banner) banner.hidden = true;
        if (checkbox) {
          checkbox.checked = currentValue;
          checkbox.addEventListener('change', () => this.updateShareConsent(checkbox.checked, status));
        }
        if (status) {
          status.textContent = currentValue
            ? 'Attivo · contribuisci ai match più precisi per tutti'
            : 'Disattivo · le tue partite restano private';
        }
      } else {
        // Utente legacy che non ha mai scelto → banner promozionale
        if (banner) banner.hidden = false;
        if (toggle) toggle.hidden = true;
        const enableBtn = this.root.querySelector('[data-fm-banner-enable]');
        const dismissBtn = this.root.querySelector('[data-fm-banner-dismiss]');
        if (enableBtn) enableBtn.addEventListener('click', () => {
          this.updateShareConsent(true, status);
          if (banner) banner.hidden = true;
          if (toggle) {
            toggle.hidden = false;
            if (checkbox) checkbox.checked = true;
            if (status) status.textContent = 'Attivo · grazie! · puoi disattivarlo da qui quando vuoi';
          }
        });
        if (dismissBtn) dismissBtn.addEventListener('click', () => {
          this.updateShareConsent(false, status);
          if (banner) banner.hidden = true;
          if (toggle) {
            toggle.hidden = false;
            if (checkbox) checkbox.checked = false;
            if (status) status.textContent = 'Disattivo · puoi attivarlo da qui se cambi idea';
          }
        });
      }
    }

    updateShareConsent(value, statusEl) {
      this.profile.shareCommunityPlays = !!value;
      this.profile.shareCommunityPlaysSetAt = Date.now();
      FM.saveProfile(this.profile);
      if (statusEl) {
        statusEl.textContent = value
          ? 'Attivo · grazie! · puoi disattivarlo da qui quando vuoi'
          : 'Disattivo · le tue partite restano private';
      }
    }

    share() {
      const text = 'Su Frogames sono ' + this.profile.archetypeName + ' 🐸 Scopri quale Frogger sei tu';
      const url = window.location.origin + this.quizUrl;
      if (navigator.share) {
        navigator.share({ title: 'FrogMatch', text, url }).catch(() => {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(text + ' ' + url).then(() => alert('Link copiato!'));
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-fm-wrapped]').forEach(root => {
      if (root.__fmInit) return;
      root.__fmInit = true;
      new WrappedController(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


/* ────────────────────────────────────────────────
   Controller: Per Te
   ──────────────────────────────────────────────── */

(function () {
  if (!window.FrogMatch) return;
  const FM = window.FrogMatch;

  const MOOD_PRESETS = {
    default: null,
    quick: { playtimeTarget: [15, 45] },
    long: { playtimeTarget: [120, 240] },
    party: { boostTypologies: ['party'], weightTarget: 1.5 },
    quiet: { boostTypologies: ['eurogame'], weightTarget: 3.0 },
    strategic: { boostTypologies: ['eurogame'], weightTarget: 3.8 },
    thematic: { boostTypologies: ['american', 'ibrido'], weightTarget: 3.2 }
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function tier(pct) {
    if (pct >= 80) return 'high';
    if (pct >= 60) return 'mid';
    return 'low';
  }

  // ============================================================
  // FROGGER PROFILE — pagina personale single-page (sostituisce Wrapped)
  // Pattern research-backed 2026: Spotify/Strava/Letterboxd/Discord
  // ============================================================
  class ProfileController {
    constructor(root) {
      this.root = root;
      this.quizUrl = root.dataset.quizUrl || '/pages/frogmatch';
      this.cloudinaryCloud = root.dataset.cloudinaryCloud || '';
      this.cloudinaryPreset = root.dataset.cloudinaryPreset || '';
      // Worker URL: prima dal data-attribute della sezione, poi dal customer bootstrap
      this.workerUrl = root.dataset.workerUrl || '';
      this.profile = FM.loadProfile();

      // Theme Editor preview: NO redirect, mostra messaggio
      const isThemeEditor = (window.Shopify && window.Shopify.designMode) || window.self !== window.top;

      // Redirect se nessun profilo (solo fuori dal Theme Editor)
      if (!this.profile) {
        if (FM.scopriAperto()) {
          const open = root.querySelector('[data-fp-page]');
          if (open) open.hidden = false;
          return;
        }
        const r = root.querySelector('[data-fp-redirect]');
        if (r) r.hidden = false;
        if (isThemeEditor) {
          // In Theme Editor non possiamo redirect: lasciamo il messaggio e bonus messaggio admin
          if (r) {
            r.innerHTML = '<div style="text-align:center;padding:40px 20px;background:#FFF8E1;border:2px dashed #F4A100;border-radius:16px;margin:40px auto;max-width:520px"><div style="font-size:2rem;margin-bottom:12px">🐸</div><h2 style="margin:0 0 8px">Anteprima profilo</h2><p style="margin:0;color:#666;font-size:0.92rem;line-height:1.4">Sei in Theme Editor. Per vedere il profilo reale apri questa pagina come utente loggato dopo aver completato l\'onboarding FrogMatch.</p></div>';
          }
          return;
        }
        setTimeout(() => { window.location.href = this.quizUrl; }, 200);
        return;
      }

      // SAFE MODE check ANTICIPATO: appena prima di qualsiasi compute pesante.
      // ?safe=1 → salta migrazioni, backfill, snapshot, heartbeat, render pesanti.
      // Mostra solo header + favoriti + banner ripristino. Sempre raggiungibile
      // anche con dataset patologici che bloccano applySoloGamerTag/render.
      const safeMode = (() => {
        try { return new URLSearchParams(window.location.search).get('safe') === '1'; }
        catch (e) { return false; }
      })();

      const page = root.querySelector('[data-fp-page]');
      if (page) page.hidden = false;

      this.products = FM.getCatalogProducts();
      this.customer = (FM.readCustomerDataFromDOM && FM.readCustomerDataFromDOM()) || {};
      // Fallback robusto a 3 livelli per workerUrl:
      // 1) data-worker-url della sezione (theme editor setting)
      // 2) customer.workerUrl (snippet customer-bootstrap)
      // 3) hardcoded come ultima risorsa (se entrambi falliscono per cache/config)
      if (!this.workerUrl) this.workerUrl = (this.customer.workerUrl || '');
      if (!this.workerUrl) this.workerUrl = 'https://froghunt.info-frogames.workers.dev';
      if (!this.customer.workerUrl) this.customer.workerUrl = this.workerUrl;

      if (!safeMode) {
        // Migrazione retroattiva: ricalcola tag 'solo' con score combinato (rimuove "Solo" errato dai vecchi profili)
        try {
          const had = (this.profile.topTypologies || []).includes('solo');
          FM.applySoloGamerTag(this.profile, this.products);
          const has = (this.profile.topTypologies || []).includes('solo');
          if (had !== has) FM.saveProfile(this.profile);
        } catch (e) { /* silenzioso */ }

        // Auto-heal UNA-TANTUM: ri-deriva mecc./cat./tipologia/durata dalla collezione BGG
        // arricchita. Per i profili 'bgg' in cui solo il peso veniva aggiornato mentre il
        // resto restava fermo al primo import (bug "profilo di un gioco solo"). Idempotente:
        // il flag tasteRederivedV1 lo esegue una volta. Non scarica nulla: usa i dati già salvati.
        try {
          if (this.profile && this.profile.source === 'bgg' && !this.profile.tasteRederivedV1) {
            const owned = (this.profile.bggCollection && this.profile.bggCollection.owned) || [];
            const enriched = owned.filter(g => g && typeof g === 'object' && Array.isArray(g.mch) && g.mch.length > 0);
            if (enriched.length >= 3) {
              FM.recomputeProfileFromCollection(this.profile, this.products);
              FM.applySoloGamerTag(this.profile, this.products); // ricalcola peso + tipologie valide + archetipo
              this.profile.tasteRederivedV1 = true;
              FM.saveProfile(this.profile);
              console.log('[FrogMatch] taste ri-derivata dalla collezione BGG (' + enriched.length + ' giochi)');
            }
          }
        } catch (e) { /* silenzioso */ }

        // Backfill acquisti pregressi del customer (Shopify orders) — UNA SOLA VOLTA per profilo.
        // Per chi si era iscritto prima del deploy del backfill: al primo accesso al profilo
        // il sistema legge customerData.purchaseHistory e popola purchasedProducts retroattivamente.
        // Idempotente: il flag profile.purchasesBackfilledV3 previene multipli passaggi.
        try {
          if (!this.profile.purchasesBackfilledV3) {
            const before = (this.profile.purchasedProducts || []).length;
            this.profile.purchasedProducts = FM.backfillPurchasesFromHistory(this.profile.purchasedProducts || []);
            this.profile.purchasesBackfilledV3 = true;
            const added = (this.profile.purchasedProducts || []).length - before;
            if (added > 0) {
              console.log('[FrogMatch] Backfill acquisti pregressi: +' + added + ' giochi importati');
            }
            FM.saveProfile(this.profile);
          }
        } catch (e) { /* silenzioso */ }

        // Auto-snapshot trimestrale (persiste in profile.snapshots[] se è passato un trimestre)
        try {
          if (FM.maybeSaveQuarterlySnapshot(this.profile)) FM.saveProfile(this.profile);
        } catch (e) { /* silenzioso */ }

        // Heartbeat: forza sync server al primo boot del giorno (popola KV admin dashboard).
        // FIX 2026-05-11: prima usava saveProfile() che bumpa updatedAt. In scenari
        // multi-device, se il mobile heartbeatava prima che la sync del PC arrivasse,
        // sovrascriveva i dati nuovi del PC con i dati vecchi del mobile (ma con timestamp
        // nuovo). Ora chiama direttamente syncProfileToServer senza toccare updatedAt:
        // server riceve i dati "as-is" e il rispetto del last-write-wins è preservato.
        try {
          const lastBeat = parseInt(localStorage.getItem('fp_last_heartbeat') || '0', 10);
          if (Date.now() - lastBeat > 12 * 3600 * 1000) {
            if (FM.syncProfileToServer) {
              FM.syncProfileToServer(this.profile); // NO bump updatedAt
            }
            localStorage.setItem('fp_last_heartbeat', String(Date.now()));
          }
        } catch (e) { /* silenzioso */ }
      }

      // Profiling per identificare quale render hanga: ?profile=1 logga tempi
      const profileMode = (() => {
        try { return new URLSearchParams(window.location.search).get('profile') === '1'; }
        catch (e) { return false; }
      })();

      const runRender = (label, fn) => {
        const t0 = profileMode ? performance.now() : 0;
        try { fn(); }
        catch (e) { console.warn('[FroggerProfile] ' + label + ':', e); }
        if (profileMode) {
          const dt = (performance.now() - t0).toFixed(1);
          console.log('[FroggerProfile][profile] ' + label + ' = ' + dt + 'ms');
        }
      };

      // Bind log play subito (resilient ai render che potrebbero rompersi)
      try { this.bindLogPlay(); } catch (e) { console.warn('[FroggerProfile] log play bind failed:', e); }
      // L'app (assets/frogmatch-app.js) usa il profilo per il diario: modifica/elimina partite.
      try { window.FrogMatchProfile = this; } catch (e) {}

      // Render le 5 sezioni. Gems è SEMPRE deferito perché è il più costoso
      // (30+ achievement con check su products × topPlayed). Deferring non
      // toglie nulla all'esperienza utente perché la sezione è in fondo alla
      // pagina, ma rende interattivi gli altri controlli prima.
      runRender('hero', () => this.renderHero());
      runRender('favorites', () => this.renderFavorites());
      if (!safeMode) {
        runRender('moment', () => this.renderMoment());
        runRender('calendar', () => this.renderCalendar());
        runRender('challenges', () => this.renderChallenges());
        runRender('drilldown', () => this.renderDrillDown());
        // Defer gems: prima che parta, la pagina è già usabile.
        // Se gems hanga, il resto della pagina resta funzionante.
        const deferredGems = () => {
          try { runRender('gems', () => this.renderGems()); }
          catch (e) { console.warn('[FroggerProfile] gems deferred render failed:', e); }
        };
        if (typeof requestIdleCallback === 'function') {
          requestIdleCallback(deferredGems, { timeout: 3000 });
        } else {
          setTimeout(deferredGems, 100);
        }

        // Catalogo completo dal worker (la pagina profilo ne passa solo 150): quando
        // arriva, le sezioni che usano il catalogo (copertine, ludoteca, gemme) si ridisegnano.
        FM.loadFullCatalog().then(full => {
          if (!full || full.length <= this.products.length) return;
          this.products = full;
          runRender('hero', () => this.renderHero());
          runRender('favorites', () => this.renderFavorites());
          runRender('moment', () => this.renderMoment());
          runRender('calendar', () => this.renderCalendar());
          runRender('challenges', () => this.renderChallenges());
          runRender('drilldown', () => this.renderDrillDown());
          runRender('gems', () => this.renderGems());
        });
      } else {
        console.warn('[FroggerProfile] SAFE MODE attivo: render pesanti skippati');
        const page = this.root.querySelector('[data-fp-page]');
        if (page) {
          const banner = document.createElement('div');
          banner.style.cssText = 'background:#FFF8E1;border:2px dashed #F4A100;border-radius:12px;padding:16px;margin:20px;text-align:center;font-size:14px';
          banner.innerHTML = '⚠️ Modalità sicura attiva. Render completi disabilitati. <a href="' + window.location.pathname + '" style="color:#0066cc;text-decoration:underline">Riprova caricamento completo</a>';
          page.insertBefore(banner, page.firstChild);
        }
      }
      runRender('settings', () => this.bindSettings());

      // Auto-refresh BGG silenzioso se l'ultimo fetch è > 7 giorni
      try { this.maybeAutoRefreshBgg(); } catch (e) { /* silenzioso */ }

      // Pipeline rarità ibrida: fetch badge-stats async, re-render gemme quando arriva
      try { this.loadBadgeStats(); } catch (e) { /* silenzioso */ }

      // Backlog import continuation: per utenti con >1000 partite BGG.
      // Il primo import prende 1000 partite più recenti; qui in background
      // continuiamo a fetchare pagine 11-20, 21-30, ... per importare il backlog storico.
      // DISABILITATO: maybeContinueBacklogImport partiva automaticamente al load del profilo
      // e per power user (>1000 partite) faceva fetch sequenziali al worker per minuti,
      // bloccando UI e dando l'impressione di pagina impallata. Reinserito come trigger
      // manuale (pulsante dedicato in Settings) in una prossima iterazione.
      // try { this.maybeContinueBacklogImport(); } catch (e) { /* silenzioso */ }
    }

    /**
     * Backlog continuation: se il primo import BGG ha più partite dichiarate
     * di quelle archiviate, fetch in background per pagina (chunk da 10).
     * Si interrompe quando: nuove partite = 0, oppure cap 150 pagine (15000 plays).
     *
     * UI: banner sticky bottom-right "Sto recuperando le tue partite (X/Y)…"
     * che si aggiorna ad ogni chunk + si chiude con conferma a fine import.
     * Zero click utente — promessa "servizio completo automatico".
     */
    _showBggProgress(current, total, status) {
      if (!this._bggProgressEl) {
        const el = document.createElement('div');
        el.id = 'fm-bgg-progress';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.style.cssText = [
          'position:fixed','bottom:20px','right:20px','z-index:9999',
          'background:linear-gradient(135deg,#1F1A14 0%,#2A2418 100%)',
          'color:#FAF7F0','padding:14px 20px','border-radius:14px',
          'box-shadow:0 12px 36px rgba(31,26,20,0.4),inset 0 0 0 1px rgba(201,154,46,0.35)',
          "font-family:'Inter',system-ui,sans-serif",'font-size:13.5px',
          'max-width:320px','display:flex','gap:12px','align-items:center',
          'transition:opacity 0.4s ease,transform 0.4s ease',
          'opacity:0','transform:translateY(20px)'
        ].join(';');
        el.innerHTML =
          '<span data-fm-bgg-icon style="font-size:22px;line-height:1;animation:fm-spin 1.4s linear infinite">🎲</span>' +
          '<div style="flex:1;min-width:0">' +
            '<div data-fm-bgg-line style="font-weight:600;line-height:1.3"></div>' +
            '<div data-fm-bgg-sub style="font-size:11.5px;color:rgba(250,247,240,0.6);margin-top:2px;letter-spacing:0.02em">Importazione automatica · zero click</div>' +
          '</div>';
        if (!document.getElementById('fm-bgg-progress-keyframes')) {
          const kf = document.createElement('style');
          kf.id = 'fm-bgg-progress-keyframes';
          kf.textContent = '@keyframes fm-spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}';
          document.head.appendChild(kf);
        }
        document.body.appendChild(el);
        requestAnimationFrame(() => {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        });
        this._bggProgressEl = el;
      }
      const line = this._bggProgressEl.querySelector('[data-fm-bgg-line]');
      const sub = this._bggProgressEl.querySelector('[data-fm-bgg-sub]');
      const icon = this._bggProgressEl.querySelector('[data-fm-bgg-icon]');
      if (status === 'done') {
        if (icon) { icon.style.animation = 'none'; icon.textContent = '✓'; }
        if (line) line.textContent = 'Recuperate ' + (total || current) + ' partite';
        if (sub) sub.textContent = 'Ora la tua ludoteca è completa';
        const self = this;
        setTimeout(function () { self._hideBggProgress(); }, 5000);
      } else {
        if (line) line.textContent = total
          ? 'Sto recuperando: ' + current + ' di ' + total + ' partite…'
          : 'Sto recuperando le tue partite (' + current + ')…';
      }
    }
    _hideBggProgress() {
      if (!this._bggProgressEl) return;
      const el = this._bggProgressEl;
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      const self = this;
      setTimeout(function () {
        try { el.remove(); } catch (e) {}
        self._bggProgressEl = null;
      }, 500);
    }

    async maybeContinueBacklogImport() {
      const act = this.profile && this.profile.playsActivity;
      if (!act || !act.hasMoreToImport) return;
      if (!this.profile.bggUsername) return;
      // Partenza immediata (rimossa pausa 5s) — l'utente vede subito che il
      // sistema sta lavorando, non rimane nel limbo silenzioso.

      const workerUrl = this.workerUrl || (this.customer && this.customer.workerUrl) || '';
      if (!workerUrl) return;

      let nextPage = act.nextPageToFetch || 11;
      const SAFETY_CAP = 150; // 15000 partite max (allineato ARCHIVE_CAP worker)
      let safety = 0;
      const totalTarget = act.bggTotalDeclared || null;

      // Banner subito visibile con stato iniziale
      this._showBggProgress(act.archivedTotal || 0, totalTarget, 'running');

      while (nextPage <= SAFETY_CAP && safety < 15) {
        safety++;
        const endPage = nextPage + 9;
        const url = workerUrl.replace(/\/$/, '')
          + '/api/bgg-plays?username=' + encodeURIComponent(this.profile.bggUsername)
          + '&startPage=' + nextPage + '&endPage=' + endPage + '&nocache=1';
        let data;
        try {
          const res = await fetch(url);
          if (!res.ok) { this._hideBggProgress(); break; }
          data = await res.json();
        } catch (e) {
          console.warn('[FroggerProfile] backlog continuation fetch failed:', e);
          this._hideBggProgress();
          break;
        }
        if (!data || data.newPlaysFetched === 0) { this._hideBggProgress(); break; }
        // Aggiorna banner con il nuovo conteggio
        this._showBggProgress(data.archivedTotal || 0, data.bggTotalDeclared || totalTarget, 'running');

        // Aggiorna l'oggetto playsActivity nel profilo con i nuovi totali
        const updated = {
          fetchedAt: data.fetchedAt || Date.now(),
          fromDate: data.fromDate,
          toDate: data.toDate,
          totalPlays: data.totalPlays,
          totalMinutes: data.totalMinutes,
          last30DaysPlays: data.last30DaysPlays,
          last30DaysMinutes: data.last30DaysMinutes,
          last90DaysMinutes: data.last90DaysMinutes,
          mostRecentPlay: data.mostRecentPlay,
          uniqueGames: data.uniqueGames,
          uniqueGames30d: data.uniqueGames30d,
          uniqueGames90d: data.uniqueGames90d,
          uniqueGames180d: data.uniqueGames180d,
          uniqueGames365d: data.uniqueGames365d,
          totalPlays30d: data.totalPlays30d,
          totalPlays90d: data.totalPlays90d,
          totalPlays180d: data.totalPlays180d,
          totalPlays365d: data.totalPlays365d,
          activityStatus: data.activityStatus,
          companions: (data.companions || []).slice(0, 12),
          badgeStats: data.badgeStats || null,
          topPlayed: (data.topPlayed || []).slice(0, 30),
          playsByDate: data.playsByDate || null,
          archivedTotal: data.archivedTotal || 0,
          bggTotalDeclared: data.bggTotalDeclared || null,
          hasMoreToImport: !!data.hasMoreToImport,
          nextPageToFetch: data.nextPageToFetch || null
        };
        this.profile.playsActivity = updated;
        FM.saveProfile(this.profile);

        // Re-render leggero delle sezioni che dipendono dai plays
        try { this.renderHero(); } catch (e) {}
        try { this.renderMoment(); } catch (e) {}
        try { this.renderCalendar(); } catch (e) {}
        try { this.renderChallenges(); } catch (e) {}

        // Stop se non ci sono più pagine
        if (!data.hasMoreToImport) {
          this._showBggProgress(data.archivedTotal || 0, data.archivedTotal || 0, 'done');
          break;
        }
        if (!data.nextPageToFetch) {
          this._showBggProgress(data.archivedTotal || 0, data.archivedTotal || 0, 'done');
          break;
        }
        nextPage = data.nextPageToFetch;
        // Pausa fra chunk per evitare hammering BGG (Cloudflare friend-of-BGG)
        await new Promise(r => setTimeout(r, 3000));
      }
      // Se siamo usciti per safety cap (hit limite chunks), chiudi pulito
      if (safety >= 15 && this._bggProgressEl) {
        const archived = (this.profile.playsActivity && this.profile.playsActivity.archivedTotal) || 0;
        this._showBggProgress(archived, archived, 'done');
      }
    }

    /**
     * Pipeline rarità ibrida: fetch aggregate da worker, cache 1h.
     * Sotto sample insufficiente (< 50 utenti) usa hardcoded.
     * Sopra: override rarity con valore reale + label "📊 Live".
     */
    async loadBadgeStats() {
      const CACHE_KEY = 'frogmatch_badge_stats_v1';
      const TTL = 60 * 60 * 1000; // 1h
      try {
        const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
        if (cached && cached.fetchedAt && (Date.now() - cached.fetchedAt) < TTL) {
          this.badgeStats = cached.data;
          this.renderGems();
          return;
        }
      } catch (e) {}

      const workerUrl = this.workerUrl || (this.customer && this.customer.workerUrl);
      if (!workerUrl) return;

      try {
        const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/frogmatch/badge-stats');
        if (!res.ok) return;
        const data = await res.json();
        this.badgeStats = data;
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({ fetchedAt: Date.now(), data })); } catch (e) {}
        // Re-render solo se sample sufficiente (altrimenti niente da cambiare)
        if (data && data.sampleSufficient) this.renderGems();
      } catch (e) { /* silenzioso */ }
    }

    setText(sel, val) {
      const el = this.root.querySelector(sel);
      if (el) el.textContent = val;
    }

    // ────────────────────────────────────────
    // 1. HERO — chi sei
    // ────────────────────────────────────────
    renderHero() {
      const p = this.profile;
      const c = this.customer;

      // Avatar: foto utente o iniziali / rana
      this.refreshAvatar();

      // Bind click avatar → upload widget
      const avatarBtn = this.root.querySelector('[data-fp-avatar-trigger]');
      if (avatarBtn && !avatarBtn.__fpBound) {
        avatarBtn.__fpBound = true;
        avatarBtn.addEventListener('click', () => this.openAvatarUpload());
      }

      // Nome: priorità displayName custom → Shopify firstName → BGG username → "Frogger"
      const displayName = p.displayName || c.firstName || p.bggUsername || 'Frogger';
      this.setText('[data-fp-name]', displayName);

      // Handle BGG sotto al nome (se diverso)
      const handle = this.root.querySelector('[data-fp-handle]');
      if (handle && p.bggUsername && p.bggUsername.toLowerCase() !== displayName.toLowerCase()) {
        handle.textContent = '@' + p.bggUsername;
        handle.hidden = false;
      } else if (handle) {
        handle.hidden = true;
      }

      // Bind edit name (inline)
      this.bindNameEdit(displayName);

      // Archetipo
      this.setText('[data-fp-archetype]', p.archetypeName || 'Frogger');

      // Status: linguaggio positivo, mai giudicante. Mostra membership + tag opzionale solo se positivo.
      const statusText = this.root.querySelector('[data-fp-status-text]');
      const statusIcon = this.root.querySelector('[data-fp-status-icon]');
      const memberDuration = this.computeMemberDuration(p.createdAt);
      const status = (p.playsActivity && p.playsActivity.activityStatus) || 'inactive';

      // Solo i 2 status positivi mostrano un tag esplicito; gli altri mostrano solo "nello stagno da X"
      const statusMap = {
        active:   { icon: '🟢', text: 'Frogger attivo · nello stagno da ' + memberDuration },
        recent:   { icon: '🟡', text: 'Frogger ritmato · nello stagno da ' + memberDuration },
        casual:   { icon: '🐸', text: 'Frogger nello stagno da ' + memberDuration },
        paused:   { icon: '🐸', text: 'Frogger nello stagno da ' + memberDuration },
        inactive: { icon: '🌱', text: memberDuration === 'poco tempo' ? 'Appena arrivato nello stagno' : 'Girino nello stagno da ' + memberDuration }
      };
      const s = statusMap[status] || statusMap.inactive;
      if (statusText) statusText.textContent = s.text;
      if (statusIcon) statusIcon.textContent = s.icon;

      // Hero side: motto modificabile inline
      this.renderHeroMotto();

      // Stat band motivazionale (anni · partite · giochi · Froggers) — solo se storia >= 6 mesi
      this.renderHeroStats();
    }

    /**
     * Stat band motivazionale: si attiva quando hai una storia ricca da raccontare.
     * Pattern: Spotify "x minutes listened" — orgoglio immediato all'apertura profilo.
     */
    renderHeroStats() {
      const wrap = this.root.querySelector('[data-fp-hero-stats]');
      if (!wrap) return;
      const p = this.profile;
      const act = p.playsActivity || {};
      const totalPlays = act.totalPlays || 0;
      const uniqueGames = act.uniqueGames || 0;
      const companions = (act.companions || []).length;

      // Calcola anni di storia (da prima play BGG, fallback a createdAt)
      let originTs = p.createdAt || Date.now();
      if (act.fromDate) {
        const firstPlayTs = new Date(act.fromDate).getTime();
        if (firstPlayTs > 0 && firstPlayTs < originTs) originTs = firstPlayTs;
      }
      const yearsOfHistory = Math.floor((Date.now() - originTs) / (365.25 * 86400000));
      const monthsOfHistory = Math.floor((Date.now() - originTs) / (30 * 86400000));

      // Mostra solo se ha qualcosa da raccontare (>= 6 mesi storia o >= 10 partite)
      if (monthsOfHistory < 6 && totalPlays < 10) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;

      const stats = [];
      if (yearsOfHistory >= 1) {
        stats.push({ num: yearsOfHistory, label: yearsOfHistory === 1 ? 'anno di gioco' : 'anni di gioco' });
      } else if (monthsOfHistory >= 6) {
        stats.push({ num: monthsOfHistory, label: 'mesi di gioco' });
      }
      if (totalPlays > 0) stats.push({ num: totalPlays, label: totalPlays === 1 ? 'partita' : 'partite' });
      if (uniqueGames > 0) stats.push({ num: uniqueGames, label: uniqueGames === 1 ? 'gioco' : 'giochi' });
      if (companions > 0) stats.push({ num: companions, label: companions === 1 ? 'compagno' : 'compagni' });

      wrap.innerHTML = stats.map(s =>
        '<div class="fp-hero-stat">' +
          '<span class="fp-hero-stat__num">' + s.num + '</span>' +
          '<span class="fp-hero-stat__label">' + s.label + '</span>' +
        '</div>'
      ).join('');
    }

    /**
     * Display name editabile inline (override Shopify customer.firstName).
     */
    bindNameEdit(currentName) {
      const nameEl = this.root.querySelector('[data-fp-name]');
      const editBtn = this.root.querySelector('[data-fp-name-edit]');
      const inputEl = this.root.querySelector('[data-fp-name-input]');
      if (!nameEl || !inputEl) return;

      const showInput = () => {
        inputEl.value = currentName === 'Frogger' ? '' : currentName;
        nameEl.hidden = true;
        if (editBtn) editBtn.hidden = true;
        inputEl.hidden = false;
        setTimeout(() => { inputEl.focus(); inputEl.select(); }, 50);
      };
      const save = () => {
        const newName = inputEl.value.trim().slice(0, 30);
        if (newName) {
          this.profile.displayName = newName;
        } else {
          delete this.profile.displayName;
        }
        this.profile.updatedAt = Date.now();
        FM.saveProfile(this.profile);
        nameEl.hidden = false;
        inputEl.hidden = true;
        if (editBtn) editBtn.hidden = false;
        this.renderHero();
      };
      const cancel = () => {
        nameEl.hidden = false;
        inputEl.hidden = true;
        if (editBtn) editBtn.hidden = false;
      };

      if (editBtn && !editBtn.__fpBound) {
        editBtn.__fpBound = true;
        editBtn.addEventListener('click', showInput);
      }
      if (!nameEl.__fpBound) {
        nameEl.__fpBound = true;
        nameEl.addEventListener('click', showInput);
      }
      if (!inputEl.__fpBound) {
        inputEl.__fpBound = true;
        inputEl.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); save(); }
          else if (e.key === 'Escape') { e.preventDefault(); cancel(); }
        });
        inputEl.addEventListener('blur', save);
      }
    }

    /**
     * Renderizza il motto personale modificabile inline.
     * Click su edit → input → Enter/blur per salvare, Esc per annullare.
     */
    renderHeroMotto() {
      const wrap = this.root.querySelector('[data-fp-hero-motto]');
      const textEl = this.root.querySelector('[data-fp-motto-text]');
      const inputEl = this.root.querySelector('[data-fp-motto-input]');
      const editBtn = this.root.querySelector('[data-fp-motto-edit]');
      if (!wrap || !textEl || !inputEl) return;

      const motto = (this.profile.motto || '').trim();
      const placeholder = '💭 Tocca per scrivere il tuo motto';

      const showText = () => {
        textEl.hidden = false;
        inputEl.hidden = true;
        if (motto) {
          textEl.textContent = '"' + motto + '"';
          textEl.classList.remove('fp-hero__motto-text--empty');
        } else {
          textEl.textContent = placeholder;
          textEl.classList.add('fp-hero__motto-text--empty');
        }
      };

      const showInput = () => {
        inputEl.value = this.profile.motto || '';
        textEl.hidden = true;
        inputEl.hidden = false;
        setTimeout(() => {
          inputEl.focus();
          inputEl.select();
        }, 50);
      };

      const save = () => {
        const newMotto = inputEl.value.trim().slice(0, 60);
        this.profile.motto = newMotto || null;
        this.profile.updatedAt = Date.now();
        FM.saveProfile(this.profile);
        // Re-render
        this.renderHeroMotto();
      };

      const cancel = () => {
        showText();
      };

      showText();

      // Bind click + edit
      if (!textEl.__fpBound) {
        textEl.__fpBound = true;
        textEl.addEventListener('click', showInput);
      }
      if (editBtn && !editBtn.__fpBound) {
        editBtn.__fpBound = true;
        editBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          showInput();
        });
      }
      if (!inputEl.__fpBound) {
        inputEl.__fpBound = true;
        inputEl.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); save(); }
          else if (e.key === 'Escape') { e.preventDefault(); cancel(); }
        });
        inputEl.addEventListener('blur', save);
      }
    }

    /**
     * Renderizza avatar attuale: foto se esiste, altrimenti iniziali su gradient.
     */
    refreshAvatar() {
      const p = this.profile;
      const c = this.customer;
      const avatarImg = this.root.querySelector('[data-fp-avatar-img]');
      const avatarInitials = this.root.querySelector('[data-fp-avatar-initials]');
      if (p.avatarUrl && avatarImg) {
        avatarImg.src = p.avatarUrl;
        avatarImg.hidden = false;
        if (avatarInitials) avatarInitials.style.display = 'none';
      } else {
        if (avatarImg) {
          avatarImg.hidden = true;
          avatarImg.removeAttribute('src');
        }
        if (avatarInitials) {
          const initials = this.computeInitials(c.firstName || (p.bggUsername || ''));
          avatarInitials.textContent = initials || '🐸';
          avatarInitials.style.display = '';
        }
      }
    }

    /**
     * Apre Cloudinary upload widget.
     * Lazy-load del script da Cloudinary CDN al primo click.
     */
    openAvatarUpload() {
      if (!this.cloudinaryCloud || !this.cloudinaryPreset) {
        alert('⚙️ Configurazione Cloudinary mancante.\n\nLo store admin deve configurarla in Theme Editor → sezione Frogger Profile → Cloud name + Upload preset.\n\nPer ora puoi usare Frogger anche senza foto profilo.');
        return;
      }
      this.loadCloudinaryWidget(() => this.actuallyOpenWidget());
    }

    loadCloudinaryWidget(callback) {
      if (window.cloudinary && window.cloudinary.openUploadWidget) {
        callback();
        return;
      }
      const existing = document.querySelector('script[data-cloudinary-widget]');
      if (existing) {
        existing.addEventListener('load', callback, { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://upload-widget.cloudinary.com/global/all.js';
      script.async = true;
      script.dataset.cloudinaryWidget = '1';
      script.addEventListener('load', callback, { once: true });
      script.addEventListener('error', () => {
        alert('⚠️ Impossibile caricare Cloudinary. Riprova fra qualche secondo.');
      });
      document.head.appendChild(script);
    }

    actuallyOpenWidget() {
      const widget = window.cloudinary.openUploadWidget({
        cloudName: this.cloudinaryCloud,
        uploadPreset: this.cloudinaryPreset,
        sources: ['local', 'camera'],
        multiple: false,
        cropping: true,
        croppingAspectRatio: 1,
        croppingShowDimensions: true,
        croppingDefaultSelectionRatio: 1,
        showSkipCropButton: false,
        clientAllowedFormats: ['jpg', 'jpeg', 'png'],
        maxImageFileSize: 8000000, // 8MB max upload
        maxImageWidth: 800,
        maxImageHeight: 800,
        folder: 'frogger-avatars',
        resourceType: 'image',
        text: {
          en: {
            or: 'oppure',
            menu: { files: 'Carica file', camera: 'Foto' },
            local: { dd_title_single: 'Trascina la tua foto qui', browse: 'Sfoglia' },
            crop: { title: 'Ritaglia la tua foto', crop_btn: 'Ritaglia', skip_btn: 'Salta', reset_btn: 'Reset' }
          }
        },
        styles: {
          palette: {
            window: '#FAF7F0',
            sourceBg: '#FFFFFF',
            windowBorder: '#FFB800',
            tabIcon: '#2D7A4F',
            inactiveTabIcon: '#1F1A14',
            menuIcons: '#2D7A4F',
            link: '#2D7A4F',
            action: '#FFB800',
            inProgress: '#FFB800',
            complete: '#2D7A4F',
            error: '#C2244A',
            textDark: '#1F1A14',
            textLight: '#FFFFFF'
          }
        }
      }, (error, result) => {
        if (error) {
          console.error('[FroggerProfile] Cloudinary error:', error);
          return;
        }
        if (result && result.event === 'success') {
          // Cloudinary auto-applica f_auto, q_auto via upload preset
          // Aggiungiamo trasformazione URL per ottimizzare la dimensione finale
          const rawUrl = result.info.secure_url;
          const optimizedUrl = rawUrl.replace('/upload/', '/upload/c_fill,g_auto,w_400,h_400,q_auto,f_auto/');
          this.profile.avatarUrl = optimizedUrl;
          this.profile.updatedAt = Date.now();
          FM.saveProfile(this.profile);
          this.refreshAvatar();
          widget.close();
        }
      });
    }

    computeInitials(name) {
      if (!name) return '';
      const parts = name.trim().split(/\s+/).filter(Boolean);
      if (parts.length === 0) return '';
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }

    /**
     * Formatta delta tempo "X giorni fa", "5 ore fa", ecc — per footer "aggiornato"
     */
    formatRelativeTime(timestamp) {
      if (!timestamp) return '';
      const diff = Date.now() - timestamp;
      const min = Math.floor(diff / 60000);
      const hours = Math.floor(diff / 3600000);
      const days = Math.floor(diff / 86400000);
      if (min < 1) return 'ora';
      if (min < 60) return min + ' min fa';
      if (hours < 24) return hours + ' ore fa';
      if (days < 7) return days + (days === 1 ? ' giorno fa' : ' giorni fa');
      if (days < 30) return Math.floor(days / 7) + ' settimane fa';
      const months = Math.floor(days / 30);
      return months + (months === 1 ? ' mese fa' : ' mesi fa');
    }

    /**
     * Auto-refresh BGG data se l'ultimo fetch è > 7 giorni.
     * Background, no UI loader → solo aggiornamento silenzioso.
     */
    maybeAutoRefreshBgg() {
      if (!this.profile.bggUsername) return;
      const lastFetch = this.profile.playsActivity && this.profile.playsActivity.fetchedAt;
      const SEVEN_DAYS = 7 * 86400000;
      if (lastFetch && (Date.now() - lastFetch) < SEVEN_DAYS) return;
      // Refresh in background dopo 2 secondi (no race con render iniziale)
      setTimeout(() => {
        try { this.refreshBggData(null); } catch (e) { /* silenzioso */ }
      }, 2000);
    }

    computeMemberDuration(createdAt) {
      if (!createdAt) return 'poco tempo';
      const days = Math.floor((Date.now() - createdAt) / (24 * 60 * 60 * 1000));
      if (days <= 1) return 'poco tempo';
      if (days < 7) return days + ' giorni';
      if (days < 30) {
        const w = Math.floor(days / 7);
        return w + (w === 1 ? ' settimana' : ' settimane');
      }
      if (days < 365) {
        const m = Math.floor(days / 30);
        return m + (m === 1 ? ' mese' : ' mesi');
      }
      const years = (days / 365).toFixed(1);
      return years + ' ann' + (years === '1.0' ? 'o' : 'i');
    }

    // ────────────────────────────────────────
    // 2. GIOCHI DEL CUORE — Four Favorites con selettore modale
    // ────────────────────────────────────────
    renderFavorites() {
      const wrap = this.root.querySelector('[data-fp-favorites]');
      const slots = this.root.querySelectorAll('[data-fp-fav-slot]');
      if (!slots || slots.length === 0) return;

      // Usa quelli salvati o i default (top 4 played con copertina catalogo)
      const fav = (this.profile.fourFavorites && this.profile.fourFavorites.length > 0) ?
        this.profile.fourFavorites :
        this.computeDefaultFavorites();

      // SEMPRE visibile: anche per chi non ha BGG/manuali, gli slot vuoti
      // sono cliccabili e aprono il modal di scelta (search BGG).
      // Migliori dati = match più precisi.
      if (wrap) wrap.hidden = false;

      // FIX 2026-05-11: fallback img lookup multi-fonte.
      const findImgForFav = (game) => {
        if (!game) return null;
        if (game.img) return game.img;
        if (game.bggId) {
          const product = (this.products || []).find(p => p.bgg === game.bggId);
          if (product && product.img) return product.img;
          const act = this.profile.playsActivity || {};
          if (Array.isArray(act.topPlayed)) {
            const tp = act.topPlayed.find(t => t.bggId === game.bggId);
            if (tp && tp.img) return tp.img;
          }
          return 'https://cf.geekdo-images.com/camo/' + game.bggId;
        }
        return null;
      };

      // FIX 2026-06: cerca imgFull (HD) per srcset 2x sulle Four Favorites.
      // Bug: le card sono ~150-200px logical, ma uso thumbnail BGG 200px → su
      // retina (×2 = 400px reali) upscale = sfocato. imgFull (~1000px) HD = nitido.
      const findImgFullForFav = (game) => {
        if (!game) return null;
        if (game.imgFull) return game.imgFull;
        if (game.bggId) {
          // Shopify catalog img è già HD (Shopify CDN dynamic resize)
          const product = (this.products || []).find(p => p.bgg === game.bggId);
          if (product && product.img) return product.img;
          // topPlayed.imgFull (popolato da enrich)
          const act = this.profile.playsActivity || {};
          if (Array.isArray(act.topPlayed)) {
            const tp = act.topPlayed.find(t => t.bggId === game.bggId);
            if (tp && tp.imgFull) return tp.imgFull;
          }
          // bggCollection.owned[].image (popolato da enrich, parser BGG XML)
          if (this.profile.bggCollection && Array.isArray(this.profile.bggCollection.owned)) {
            const item = this.profile.bggCollection.owned.find(it => it && it.id === game.bggId);
            if (item && item.image) return item.image;
          }
          // manualOwned/purchasedProducts imgFull
          if (Array.isArray(this.profile.manualOwned)) {
            const mo = this.profile.manualOwned.find(m => m && m.bggId === game.bggId);
            if (mo && mo.imgFull) return mo.imgFull;
          }
          if (Array.isArray(this.profile.purchasedProducts)) {
            const pp = this.profile.purchasedProducts.find(p => p && p.bggId === game.bggId);
            if (pp && pp.imgFull) return pp.imgFull;
          }
        }
        return null;
      };

      slots.forEach((slot, idx) => {
        const game = fav[idx];
        const imgUrl = game ? findImgForFav(game) : null;
        const imgFullUrl = game ? findImgFullForFav(game) : null;
        if (!game) {
          slot.classList.remove('is-filled');
          slot.innerHTML = '<span class="fp-fav-slot__placeholder">+</span>' +
                          '<span class="fp-fav-slot__hint">Aggiungi gioco</span>';
          slot.setAttribute('data-fp-fav-edit-trigger', '1');
          return;
        }
        slot.classList.add('is-filled');
        if (imgUrl) {
          // Strategia src=HD priority (più affidabile di srcset su mobile):
          // se imgFull disponibile usalo direttamente come src. Browser
          // scala always da HD = nitido sempre. Fallback thumbnail solo se HD assente.
          const finalSrc = imgFullUrl || imgUrl;
          slot.innerHTML =
            '<img class="fp-fav-slot__img" src="' + escapeHtml(finalSrc) + '" alt="' + escapeHtml(game.name || '') + '" loading="lazy" onerror="this.style.display=\'none\';this.parentNode.classList.add(\'is-noimg\')">' +
            '<span class="fp-fav-slot__name">' + escapeHtml(game.name || '') + '</span>';
        } else {
          // Nessuna img: card con iniziale + nome (meglio di "+" vuoto)
          const initial = (game.name || '?').charAt(0).toUpperCase();
          slot.innerHTML =
            '<div class="fp-fav-slot__noimg">' + escapeHtml(initial) + '</div>' +
            '<span class="fp-fav-slot__name">' + escapeHtml(game.name || '') + '</span>';
        }
        slot.setAttribute('data-fp-fav-edit-trigger', '1');
      });

      // Bind click su ogni slot + bottone "Modifica" → apri modal
      const editBtn = this.root.querySelector('[data-fp-fav-edit]');
      if (editBtn && !editBtn.__fpBound) {
        editBtn.__fpBound = true;
        editBtn.addEventListener('click', () => this.openFavoritesEditor());
      }
      slots.forEach(slot => {
        if (slot.__fpBound) return;
        slot.__fpBound = true;
        slot.addEventListener('click', () => this.openFavoritesEditor());
      });

      this.bindFavoritesModal();
    }

    computeDefaultFavorites() {
      const act = this.profile.playsActivity;
      if (!act || !act.topPlayed) return [];
      // FIX 2026-05-11: prima i giochi manualPlay appena salvati potevano scalare
      // in cima a topPlayed (ordinato per weightedPlays) e diventare il favorito #1
      // senza bggId/img → slot vuoto. Ora preferiamo BGG-sourced (con bggId valido)
      // come default; i manuali senza bggId vanno in fondo.
      const out = [];
      const withBgg = [];
      const withoutBgg = [];
      for (const tp of act.topPlayed) {
        if (tp.bggId) withBgg.push(tp);
        else withoutBgg.push(tp);
      }
      const ordered = withBgg.concat(withoutBgg);
      for (const tp of ordered) {
        if (out.length >= 4) break;
        const product = tp.bggId ?
          (this.products || []).find(p => p.bgg === tp.bggId) : null;
        out.push({
          bggId: tp.bggId,
          name: tp.name || 'Gioco',
          img: (product && product.img) || tp.img || null,
          productUrl: product ? product.u : null
        });
      }
      return out;
    }

    /**
     * Apre il modal selettore Four Favorites.
     */
    openFavoritesEditor() {
      const modal = this.root.querySelector('[data-fp-fav-modal]');
      if (!modal) return;
      // Inizializza buffer con favoriti correnti
      this.favBuffer = (this.profile.fourFavorites || this.computeDefaultFavorites()).slice(0, 4);
      while (this.favBuffer.length < 4) this.favBuffer.push(null);
      // Reset cache + search per fresh state
      this.favBggCachedList = null;
      this.favBggSearch = '';
      this.renderFavSlots();
      this.renderFavBggCollection();

      // Auto-switch alla tab "Cerca su BGG" se l'utente NON ha collezione BGG.
      // Per i tester manuali è l'unico modo concreto per scegliere i 4 giochi.
      const hasBggCollection = !!(this.profile.bggCollection && this.profile.bggCollection.owned && this.profile.bggCollection.owned.length > 0);
      const hasPlayedSomething = !!(this.profile.playsActivity && this.profile.playsActivity.topPlayed && this.profile.playsActivity.topPlayed.length > 0);
      if (!hasBggCollection && !hasPlayedSomething) {
        const tabs = this.root.querySelectorAll('[data-fp-fav-tab]');
        const panels = this.root.querySelectorAll('[data-fp-fav-panel]');
        tabs.forEach(t => t.classList.toggle('is-active', t.dataset.fpFavTab === 'search'));
        panels.forEach(p => { p.hidden = p.dataset.fpFavPanel !== 'search'; });
        // Focus sulla search per partire subito a digitare
        setTimeout(() => {
          const si = this.root.querySelector('[data-fp-fav-search-input]');
          if (si) si.focus();
        }, 100);
      }

      modal.hidden = false;
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    bindFavoritesModal() {
      const modal = this.root.querySelector('[data-fp-fav-modal]');
      if (!modal || modal.__fpBound) return;
      modal.__fpBound = true;
      modal.hidden = true;
      modal.style.display = 'none';

      const closes = this.root.querySelectorAll('[data-fp-fav-close]');
      closes.forEach(b => b.addEventListener('click', () => this.closeFavoritesEditor()));

      // Bind tab switch
      const tabs = this.root.querySelectorAll('[data-fp-fav-tab]');
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => t.classList.remove('is-active'));
          tab.classList.add('is-active');
          const which = tab.dataset.fpFavTab;
          this.root.querySelectorAll('[data-fp-fav-panel]').forEach(p => {
            p.hidden = p.dataset.fpFavPanel !== which;
          });
        });
      });

      // Bind search input
      const searchInput = this.root.querySelector('[data-fp-fav-search-input]');
      const searchResults = this.root.querySelector('[data-fp-fav-search-results]');
      if (searchInput && searchResults) {
        let timer = null;
        let lastQuery = '';
        searchInput.addEventListener('input', () => {
          const q = searchInput.value.trim();
          if (q.length < 3) { searchResults.innerHTML = ''; return; }
          if (timer) clearTimeout(timer);
          searchResults.innerHTML = '<li class="fp-fav-modal__loading">🔍 Cerco su BGG...</li>';
          lastQuery = q;
          timer = setTimeout(async () => {
            const workerUrl = this.workerUrl || (this.customer && this.customer.workerUrl) || '';
            if (!workerUrl) { searchResults.innerHTML = '<li class="fp-fav-modal__empty">Worker URL mancante</li>'; return; }
            try {
              const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/bgg-search?q=' + encodeURIComponent(q));
              if (!res.ok || lastQuery !== q) return;
              const data = await res.json();
              this.renderFavSearchResults(data.results || []);
            } catch (e) {
              searchResults.innerHTML = '<li class="fp-fav-modal__empty">Errore di rete</li>';
            }
          }, 350);
        });
      }

      // Bind save
      const saveBtn = this.root.querySelector('[data-fp-fav-save]');
      if (saveBtn) saveBtn.addEventListener('click', () => this.saveFavorites());

      // Bind click su slot per rimuovere
      const slots = this.root.querySelectorAll('[data-fp-fav-modal-slot]');
      slots.forEach(s => {
        s.addEventListener('click', () => {
          const idx = parseInt(s.dataset.fpFavModalSlot, 10);
          this.favBuffer[idx] = null;
          this.renderFavSlots();
          this.renderFavBggCollection();
        });
      });
    }

    closeFavoritesEditor() {
      const modal = this.root.querySelector('[data-fp-fav-modal]');
      if (!modal) return;
      modal.hidden = true;
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    renderFavSlots() {
      const slots = this.root.querySelectorAll('[data-fp-fav-modal-slot]');
      slots.forEach((s, idx) => {
        const g = this.favBuffer[idx];
        if (!g || !g.img) {
          s.classList.remove('is-filled');
          s.innerHTML = '<span class="fp-fav-modal__slot-empty">' + (idx + 1) + '</span>';
        } else {
          s.classList.add('is-filled');
          s.innerHTML = '<img src="' + escapeHtml(g.img) + '" alt="" loading="lazy"><span class="fp-fav-modal__slot-x">×</span>';
        }
      });
    }

    /**
     * Renderizza il pannello "Dalla mia collezione BGG" con i giochi posseduti/giocati
     * Include search box live per trovare velocemente in collezioni grandi
     */
    renderFavBggCollection() {
      const panel = this.root.querySelector('[data-fp-fav-panel="bgg"]');
      if (!panel) return;

      // Computa la lista una volta, poi filtra in JS
      if (!this.favBggCachedList) {
        const act = this.profile.playsActivity;
        const ownedGames = [];
        const seen = new Set();

        // Lookup plays per bggId (per mostrare badge "Xx" anche sui posseduti che hai giocato)
        const playsByBgg = {};
        const enrichImgByBgg = {};
        if (act && act.topPlayed) {
          for (const g of act.topPlayed) {
            if (!g.bggId) continue;
            playsByBgg[g.bggId] = g.plays || 0;
            if (g.img) enrichImgByBgg[g.bggId] = g.img;
          }
        }

        // FIX 2026-06-01: stesso fix di collectCollection — anche il modal
        // Four Favorites deve contare le partite manuali (bug Andrea Minikin).
        const playsByName_fav = {};
        const playsByBggManual_fav = {};
        const playsByDateMap_fav = (act && act.playsByDate) || {};
        const normFav = (s) => (s || '').toLowerCase().trim();
        if (Array.isArray(this.profile.manualPlays)) {
          for (const mp of this.profile.manualPlays) {
            if (!mp || !mp.date) continue;
            const bggDay = playsByDateMap_fav[mp.date];
            if (bggDay && Array.isArray(bggDay.games)) {
              const dup = bggDay.games.some(g =>
                (mp.bggId && g.bggId && g.bggId === mp.bggId) ||
                (g.name && normFav(g.name) === normFav(mp.title))
              );
              if (dup) continue;
            }
            if (mp.bggId) {
              playsByBggManual_fav[mp.bggId] = (playsByBggManual_fav[mp.bggId] || 0) + 1;
            }
            if (mp.title) {
              const k = normFav(mp.title);
              playsByName_fav[k] = (playsByName_fav[k] || 0) + 1;
            }
          }
        }
        const getTotalPlaysFav = (bggId, name) => {
          let n = 0;
          // FIX 2026-06 (doppio conteggio): topPlayed include già le manuali fuse → niente somma.
          if (bggId) n = (playsByBgg[bggId] > 0) ? playsByBgg[bggId] : (playsByBggManual_fav[bggId] || 0);
          if (n === 0 && name) {
            const k = normFav(name);
            if (k && playsByName_fav[k]) n = playsByName_fav[k];
          }
          return n;
        };

        // 1. POSSEDUTI (priorità top): bggCollection.owned
        if (this.profile.bggCollection && Array.isArray(this.profile.bggCollection.owned)) {
          for (const item of this.profile.bggCollection.owned) {
            const id = (typeof item === 'object') ? item.id : item;
            const name = (typeof item === 'object') ? item.name : null;
            const thumb = (typeof item === 'object') ? item.thumbnail : null;
            if (!id || seen.has(id)) continue;
            seen.add(id);
            const product = this.products.find(p => p.bgg === id);
            const resolvedNF = name || (product ? product.t : 'Gioco BGG ' + id);
            ownedGames.push({
              bggId: id,
              name: resolvedNF,
              img: (product && product.img) || enrichImgByBgg[id] || thumb || null,
              plays: getTotalPlaysFav(id, resolvedNF),
              source: 'owned'
            });
          }
        }

        // 2. ACQUISTATI Frogames non già visti.
        // FIX 2026-05-08: prima saltavamo gli acquisti se il prodotto non era
        // nel this.products (paginato 150). Ora usiamo i dati salvati nel
        // purchase (img/url/bggId/title) come fallback — stesso pattern di
        // collectCollection nel drill-down. Così la modal "Giochi del cuore"
        // mostra TUTTI gli acquisti, non solo quelli nella collection corrente.
        if (this.profile.purchasedProducts) {
          for (const purch of this.profile.purchasedProducts) {
            if (!purch.productId) continue;
            const product = this.products.find(p => String(p.id) === String(purch.productId));
            const bggId = (product && product.bgg) || purch.bggId || null;
            if (bggId && seen.has(bggId)) continue;
            if (bggId) seen.add(bggId);
            const resolvedNFP = purch.title || (product && product.t) || 'Gioco';
            ownedGames.push({
              bggId: bggId,
              name: resolvedNFP,
              img: (product && product.img) || purch.img || null,
              plays: getTotalPlaysFav(bggId, resolvedNFP),
              source: 'frogames'
            });
          }
        }

        // 3. GIOCATI con amici (topPlayed non già aggiunti)
        if (act && act.topPlayed) {
          for (const g of act.topPlayed) {
            if (!g.bggId || seen.has(g.bggId)) continue;
            seen.add(g.bggId);
            const product = this.products.find(p => p.bgg === g.bggId);
            ownedGames.push({
              bggId: g.bggId,
              name: g.name,
              img: (product && product.img) || g.img || null,
              plays: g.plays || 0,
              source: 'played'
            });
          }
        }

        // 4. AGGIUNTI A MANO alla ludoteca (per chi non ha BGG sync)
        if (this.profile.manualOwned) {
          for (const m of this.profile.manualOwned) {
            if (m.bggId && seen.has(m.bggId)) continue;
            if (m.bggId) seen.add(m.bggId);
            const product = m.productId
              ? this.products.find(p => String(p.id) === String(m.productId))
              : (m.bggId ? this.products.find(p => p.bgg === m.bggId) : null);
            const resolvedNFM = m.title || (product ? product.t : 'Gioco');
            ownedGames.push({
              bggId: m.bggId || null,
              name: resolvedNFM,
              img: (product && product.img) || (m.bggId ? enrichImgByBgg[m.bggId] : null) || m.img || null,
              plays: getTotalPlaysFav(m.bggId, resolvedNFM),
              source: 'manual'
            });
          }
        }

        this.favBggCachedList = ownedGames;
      }

      const allGames = this.favBggCachedList;
      const search = this.favBggSearch || '';
      const qLow = search.toLowerCase();
      const filtered = qLow ?
        allGames.filter(g => (g.name || '').toLowerCase().includes(qLow)) :
        allGames;

      if (allGames.length === 0) {
        panel.innerHTML = '<div class="fp-fav-modal__empty-cta">' +
          '<div class="fp-fav-modal__empty-icon">📚</div>' +
          '<h4 class="fp-fav-modal__empty-title">La tua ludoteca è ancora vuota</h4>' +
          '<p class="fp-fav-modal__empty-desc">Per popolarla puoi <strong>cercare i tuoi giochi su BGG</strong> usando la tab qui sopra. Più dati ci dai, migliori sono i match.</p>' +
          '<button type="button" class="fp-fav-modal__empty-btn" data-fp-fav-goto-search>🔍 Cerca su BGG ora</button>' +
        '</div>';
        // Bind quick switch alla tab Cerca
        const gotoBtn = panel.querySelector('[data-fp-fav-goto-search]');
        if (gotoBtn) {
          gotoBtn.addEventListener('click', () => {
            const tabs = this.root.querySelectorAll('[data-fp-fav-tab]');
            const panels = this.root.querySelectorAll('[data-fp-fav-panel]');
            tabs.forEach(t => t.classList.toggle('is-active', t.dataset.fpFavTab === 'search'));
            panels.forEach(p => { p.hidden = p.dataset.fpFavPanel !== 'search'; });
            const si = this.root.querySelector('[data-fp-fav-search-input]');
            if (si) si.focus();
          });
        }
        return;
      }

      const selectedKeys = new Set(this.favBuffer.filter(g => g).map(g => g.bggId || g.name));

      const searchBox = '<div class="fp-fav-modal__inline-search">' +
        '<input type="text" class="fp-fav-modal__inline-search-input" data-fp-fav-bgg-search placeholder="🔍 Cerca nei tuoi giochi..." value="' + escapeHtml(search) + '">' +
        '<span class="fp-fav-modal__inline-search-count">' + filtered.length + ' di ' + allGames.length + '</span>' +
        '</div>';

      const renderGameBtn = (g) => {
        const key = g.bggId || g.name;
        const selected = selectedKeys.has(key);
        const imgTag = g.img ?
          '<img src="' + escapeHtml(g.img) + '" alt="" loading="lazy">' :
          '<span class="fp-fav-modal__noimg">🎲</span>';
        const playsBadge = g.plays > 0 ?
          '<span class="fp-fav-modal__game-plays">' + g.plays + 'x</span>' : '';
        return '<button type="button" class="fp-fav-modal__game' + (selected ? ' is-selected' : '') + '" data-fav-bgg="' + (g.bggId || '') + '" data-fav-name="' + escapeHtml(g.name) + '" data-fav-img="' + escapeHtml(g.img || '') + '">' +
          imgTag +
          playsBadge +
          '<span class="fp-fav-modal__game-name">' + escapeHtml(g.name) + '</span>' +
          (selected ? '<span class="fp-fav-modal__game-check">✓</span>' : '') +
          '</button>';
      };

      let gridContent;
      if (filtered.length === 0) {
        gridContent = '<p class="fp-fav-modal__empty">Nessun gioco corrisponde a "' + escapeHtml(search) + '"</p>';
      } else {
        // Raggruppa per source: owned + frogames sotto "Posseduti", played sotto "Giocati con amici"
        const owned = filtered.filter(g => g.source === 'owned' || g.source === 'frogames');
        const played = filtered.filter(g => g.source === 'played');
        let parts = '';
        if (owned.length > 0) {
          parts += '<h4 class="fp-fav-modal__section-title">📚 Posseduti <span>' + owned.length + '</span></h4>' +
            '<div class="fp-fav-modal__grid">' + owned.slice(0, 60).map(renderGameBtn).join('') + '</div>';
        }
        if (played.length > 0) {
          parts += '<h4 class="fp-fav-modal__section-title fp-fav-modal__section-title--played">🎲 Giocati con amici <span>' + played.length + '</span></h4>' +
            '<div class="fp-fav-modal__grid">' + played.slice(0, 60).map(renderGameBtn).join('') + '</div>';
        }
        gridContent = parts;
      }

      panel.innerHTML = searchBox + gridContent;

      // Bind search input (debounced)
      const searchInput = panel.querySelector('[data-fp-fav-bgg-search]');
      if (searchInput) {
        let timer = null;
        searchInput.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            this.favBggSearch = searchInput.value;
            const cursorPos = searchInput.selectionStart;
            this.renderFavBggCollection();
            // Restore focus dopo re-render
            const newInput = this.root.querySelector('[data-fp-fav-bgg-search]');
            if (newInput) {
              newInput.focus();
              newInput.setSelectionRange(cursorPos, cursorPos);
            }
          }, 150);
        });
      }

      // Bind click su giochi
      panel.querySelectorAll('.fp-fav-modal__game').forEach(btn => {
        btn.addEventListener('click', () => this.toggleFav({
          bggId: parseInt(btn.dataset.favBgg, 10) || null,
          name: btn.dataset.favName,
          img: btn.dataset.favImg || null
        }));
      });
    }

    renderFavSearchResults(results) {
      const ul = this.root.querySelector('[data-fp-fav-search-results]');
      if (!ul) return;
      if (results.length === 0) {
        ul.innerHTML = '<li class="fp-fav-modal__empty">Nessun risultato</li>';
        return;
      }
      const selectedKeys = new Set(this.favBuffer.filter(g => g).map(g => g.bggId));
      ul.innerHTML = results.slice(0, 12).map(r => {
        const selected = selectedKeys.has(r.bggId);
        const imgTag = r.img ?
          '<img src="' + escapeHtml(r.img) + '" alt="" loading="lazy">' :
          '<span class="fp-fav-modal__noimg">🎲</span>';
        return '<li class="fp-fav-modal__search-item' + (selected ? ' is-selected' : '') + '" data-fav-bgg="' + r.bggId + '" data-fav-name="' + escapeHtml(r.name) + '" data-fav-img="' + escapeHtml(r.img || '') + '">' +
          imgTag +
          '<span class="fp-fav-modal__search-name">' + escapeHtml(r.name) + (r.year ? ' (' + r.year + ')' : '') + (r.aka ? ' <em>aka ' + escapeHtml(r.aka) + '</em>' : '') + '</span>' +
          (selected ? '<span class="fp-fav-modal__game-check">✓</span>' : '') +
          '</li>';
      }).join('');

      ul.querySelectorAll('.fp-fav-modal__search-item').forEach(li => {
        li.addEventListener('click', () => this.toggleFav({
          bggId: parseInt(li.dataset.favBgg, 10),
          name: li.dataset.favName,
          img: li.dataset.favImg || null
        }));
      });
    }

    toggleFav(game) {
      // Se già nei favoriti, rimuovi
      const existingIdx = this.favBuffer.findIndex(f => f && (
        (f.bggId && f.bggId === game.bggId) ||
        (!f.bggId && f.name === game.name)
      ));
      if (existingIdx >= 0) {
        this.favBuffer[existingIdx] = null;
      } else {
        // Aggiungi al primo slot vuoto
        const emptyIdx = this.favBuffer.findIndex(f => !f);
        if (emptyIdx >= 0) {
          this.favBuffer[emptyIdx] = game;
        } else {
          // Tutti pieni — sostituisci il primo
          alert('Hai già 4 giochi del cuore. Clicca su uno dei 4 in alto per rimuoverlo prima.');
          return;
        }
      }
      this.renderFavSlots();
      this.renderFavBggCollection();
      // Re-render search results se visibili
      const searchInput = this.root.querySelector('[data-fp-fav-search-input]');
      if (searchInput && searchInput.value.trim().length >= 3) {
        searchInput.dispatchEvent(new Event('input'));
      }
    }

    saveFavorites() {
      // Compatta: rimuovi null, max 4
      const cleaned = this.favBuffer.filter(g => g).slice(0, 4);
      this.profile.fourFavorites = cleaned;
      this.profile.updatedAt = Date.now();
      FM.saveProfile(this.profile);
      this.renderFavorites();
      this.closeFavoritesEditor();
    }

    // ────────────────────────────────────────
    // 3. IL TUO MOMENTO — Wrapped mensile (5 scoperte condivisibili)
    // ────────────────────────────────────────
    renderMoment() {
      const wrap = this.root.querySelector('[data-fp-moment]');
      const recap = this.root.querySelector('[data-fp-moment-recap]');
      if (!wrap || !recap) return;

      // "Il tuo momento" è una Wrapped narrativa che richiede storico ricco.
      // Per profili senza partite (BGG o manuali) la sezione resta nascosta
      // e si auto-attiva quando arriva il primo dato.
      const act = this.profile.playsActivity;
      if (!act || !act.totalPlays || act.totalPlays === 0) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;

      // Inizializza lens corrente (smart default solo al primo render)
      if (!this.momentLens) this.momentLens = this.computeSmartDefaultLens();
      this.updateLensButtons();

      const cards = this.computeMomentCards(this.momentLens);
      this.lastMomentCards = cards;

      // Sub-text dinamico per lente
      const subEl = this.root.querySelector('[data-fp-moment-sub]');
      if (subEl) {
        const lensSub = {
          month: 'Le tue scoperte di questo mese in 5 atti',
          last30: 'I tuoi ultimi 30 giorni di tavolo in 5 atti',
          year: 'Quest\'anno raccontato in 5 atti',
          all: 'La tua storia in 5 atti'
        };
        subEl.textContent = lensSub[this.momentLens] || 'Una storia da raccontare in 5 atti';
      }

      // Footer "aggiornato X tempo fa"
      const updatedEl = this.root.querySelector('[data-fp-moment-updated]');
      if (updatedEl) {
        const fetched = act.fetchedAt;
        if (fetched) {
          updatedEl.textContent = 'Aggiornato ' + this.formatRelativeTime(fetched);
          updatedEl.hidden = false;
        } else {
          updatedEl.hidden = true;
        }
      }

      // Bind refresh button
      const refreshBtn = this.root.querySelector('[data-fp-moment-refresh]');
      if (refreshBtn && this.profile.bggUsername && !refreshBtn.__fpBound) {
        refreshBtn.__fpBound = true;
        refreshBtn.addEventListener('click', () => this.refreshBggData(refreshBtn));
      } else if (refreshBtn && !this.profile.bggUsername) {
        refreshBtn.style.display = 'none';
      }

      // Bind lens segmented control (solo una volta)
      if (!this.lensBound) {
        this.lensBound = true;
        this.root.querySelectorAll('[data-fp-lens]').forEach(btn => {
          btn.addEventListener('click', () => {
            this.momentLens = btn.dataset.fpLens;
            this.renderMoment();
            try { this.renderChallenges(); } catch (e) {} // periodo condiviso: aggiorna anche le statistiche
          });
        });
      }

      // Bind share-all button
      const shareAllBtn = this.root.querySelector('[data-fp-moment-share-all]');
      if (shareAllBtn && !shareAllBtn.__fpBound) {
        shareAllBtn.__fpBound = true;
        shareAllBtn.addEventListener('click', () => this.shareMomentImage('all'));
      }

      // Empty state per lente vuota — cascade fallback verso lens più ampia.
      if (cards.length === 0) {
        // Cascade: month → last30 → year → all
        const fallbackMap = { month: 'last30', last30: 'year', year: 'all', all: 'all' };
        const fallback = fallbackMap[this.momentLens] || 'all';
        const lensLabels = {
          month: 'questo mese',
          last30: 'gli ultimi 30 giorni',
          year: 'quest\'anno',
          all: 'questo periodo'
        };
        const fallbackLabels = {
          last30: 'gli ultimi 30 giorni',
          year: 'quest\'anno',
          all: 'sempre'
        };
        recap.innerHTML =
          '<div class="fp-moment__empty">' +
            '<p class="fp-moment__empty-icon">🌱</p>' +
            '<p class="fp-moment__empty-text">Niente per ' + (lensLabels[this.momentLens] || 'questo periodo') + ' ancora.</p>' +
            '<button type="button" class="fp-moment__empty-cta" data-fp-lens-fallback="' + fallback + '">Vedi ' + (fallbackLabels[fallback] || 'sempre') + '</button>' +
          '</div>';
        const cta = recap.querySelector('[data-fp-lens-fallback]');
        if (cta) cta.addEventListener('click', () => {
          this.momentLens = cta.dataset.fpLensFallback;
          this.renderMoment();
          try { this.renderChallenges(); } catch (e) {}
        });
        return;
      }

      // Recap editoriale: estrae i pezzi dai cards (cover/bignum/identity) e li
      // dispone come frase + copertina con testo accanto + numeri tipografici + riga cover.
      recap.innerHTML = this.renderMomentEditorial(cards, this.momentLens);

      // "e altri N giochi" → espande/comprime la griglia extra (richiesta cliente:
      // poterli vedere tutti senza nasconderli per sempre). Ri-render pulito ad ogni lente.
      const gx = recap.querySelector('[data-fp-games-expand]');
      if (gx) {
        gx.addEventListener('click', () => {
          const extra = recap.querySelector('[data-fp-games-extra]');
          if (!extra) return;
          const open = extra.hidden;
          extra.hidden = !open;
          gx.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) {
            gx.innerHTML = 'Mostra meno <span class="fp-moment__games-more-chev" aria-hidden="true">▴</span>';
          } else {
            const n = extra.querySelectorAll('.fp-moment__game').length;
            gx.innerHTML = 'e altri <strong>' + n + '</strong> ' + (n === 1 ? 'gioco' : 'giochi') + ' questo periodo <span class="fp-moment__games-more-chev" aria-hidden="true">▾</span>';
          }
        });
      }

      // Recupera da BGG le copertine mancanti (giochi giocati/manuali fuori catalogo,
      // con bggId ma senza img salvata): le scarica via /api/bgg-batch e ri-renderizza.
      this._enrichMomentCovers(cards, this.momentLens);
    }

    /**
     * Scarica da BGG le copertine dei giochi del recap che hanno un bggId ma nessuna
     * copertina risolvibile localmente. Cache in this._coverCache (+ dedup tentativi).
     * Re-render una sola volta a fine fetch. Best-effort (silenzioso se BGG/worker giù).
     */
    async _enrichMomentCovers(cards, lens) {
      try {
        const base = this.workerUrl ? this.workerUrl.replace(/\/$/, '') : '';
        if (!base) return;
        this._coverCache = this._coverCache || {};
        this._coverFetchTried = this._coverFetchTried || new Set();
        const ids = [];
        const consider = (bggId, cover) => {
          if (!bggId || cover) return;
          if (this._coverCache[bggId] || this._coverFetchTried.has(bggId)) return;
          this._coverFetchTried.add(bggId);
          ids.push(bggId);
        };
        const coverCard = (cards || []).find(c => c.type === 'cover');
        if (coverCard) consider(coverCard.bggId, coverCard.coverImg);
        for (const g of this.getPeriodGames(lens)) consider(g.bggId, g.cover);
        if (ids.length === 0) return;
        let changed = false;
        for (let i = 0; i < ids.length; i += 20) {
          const chunk = ids.slice(i, i + 20);
          try {
            const res = await fetch(base + '/api/bgg-batch?ids=' + chunk.join(','));
            if (!res.ok) continue;
            const data = await res.json();
            for (const m of (data.games || [])) {
              const img = m.imgFull || m.img;
              if (m.id && img) { this._coverCache[m.id] = img; changed = true; }
            }
          } catch (e) { /* best-effort */ }
        }
        if (changed) this.renderMoment();
      } catch (e) { /* best-effort */ }
    }

    /**
     * Frecce ‹ › per navigare il carousel "Il tuo momento" su desktop.
     * Scrolla di una card alla volta. Le frecce si auto-nascondono ai bordi
     * (prev sparisce all'inizio, next alla fine). Su mobile sono nascoste via CSS
     * (lo swipe touch è più naturale). Aggiunto 2026-05-21 per UX desktop:
     * la scrollbar da 6px era inusabile col mouse.
     */
    _bindMomentArrows(carousel, prevArrow, nextArrow) {
      if (!carousel || !prevArrow || !nextArrow) return;

      // Larghezza di scroll = larghezza prima card + gap (14px)
      const scrollAmount = () => {
        const firstCard = carousel.querySelector('.fp-moment-card');
        return firstCard ? firstCard.offsetWidth + 14 : carousel.clientWidth * 0.8;
      };

      const updateArrows = () => {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        // Tolleranza 4px per arrotondamenti
        const atStart = carousel.scrollLeft <= 4;
        const atEnd = carousel.scrollLeft >= maxScroll - 4;
        // Se tutto sta in vista (nessuno scroll possibile) → niente frecce
        const noScroll = maxScroll <= 4;
        prevArrow.hidden = noScroll || atStart;
        nextArrow.hidden = noScroll || atEnd;
      };

      // Bind click (una sola volta per elemento)
      if (!prevArrow.__fpBound) {
        prevArrow.__fpBound = true;
        prevArrow.addEventListener('click', () => {
          carousel.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (!nextArrow.__fpBound) {
        nextArrow.__fpBound = true;
        nextArrow.addEventListener('click', () => {
          carousel.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }
      // Update visibilità su scroll (una sola volta)
      if (!carousel.__fpArrowScrollBound) {
        carousel.__fpArrowScrollBound = true;
        carousel.addEventListener('scroll', () => {
          // throttle leggero via requestAnimationFrame
          if (carousel.__fpArrowRaf) return;
          carousel.__fpArrowRaf = requestAnimationFrame(() => {
            carousel.__fpArrowRaf = null;
            updateArrows();
          });
        });
        window.addEventListener('resize', () => updateArrows());
      }

      // Stato iniziale (dopo che il layout si è assestato)
      requestAnimationFrame(updateArrows);
    }

    /**
     * Recap editoriale "Il tuo momento" (riscrittura strutturata 2026-06-17).
     * Blocchi fissi (niente "marea" variabile da gestire con fallback):
     *   1. Lead identità (archetipo, senza ripetere i numeri della plancia)
     *   2. Gioco del mese (eroe): copertina + testo accanto
     *   3. Plancia numeri: bignum distribuiti su tutta la larghezza
     *   4. Shelf FISSO: i 6 più giocati DOPO l'eroe (mai ripetuto) + "e altri N"
     */
    renderMomentEditorial(cards, lens) {
      const cover = cards.find(c => c.type === 'cover');
      // Ci sono DUE card 'identity': l'archetipo ("LATO DOMINANTE") e il compagno
      // fisso ("COMPAGNO FISSO"). Vanno distinte: prima il codice pescava la prima
      // disponibile → senza archetipo finiva il NOME del compagno (es. "Sabrina")
      // etichettato come "lato dominante".
      const typologyCard = cards.find(c => c.type === 'identity' && /lato dominante/i.test(c.eyebrow || ''));
      const companionCard = cards.find(c => c.type === 'identity' && /compagno/i.test(c.eyebrow || ''));
      const bignums = cards.filter(c => c.type === 'bignum');
      const allGames = this.getPeriodGames(lens);
      const norm = (s) => (s || '').toLowerCase().trim();

      const periodWord = {
        month: 'Questo mese',
        last30: 'Negli ultimi 30 giorni',
        year: 'Quest\'anno',
        all: 'Da quando giochi'
      }[lens] || 'In questo periodo';

      // ── 1. Lead: archetipo se calcolato, altrimenti il numero partite. ──
      let lead = '';
      if (typologyCard && typologyCard.title) {
        lead = periodWord + ' il tuo lato dominante è stato <strong>' + escapeHtml(typologyCard.title) + '</strong>.';
      } else {
        const partiteCard = bignums.find(b => /partit/i.test(b.label || ''));
        if (partiteCard) {
          const n = String(partiteCard.number);
          lead = periodWord + ' hai messo sul tavolo <strong>' + escapeHtml(n) + ' ' + (n === '1' ? 'partita' : 'partite') + '</strong>.';
        }
      }
      // Compagno fisso (solo lente "Sempre"): mostrato come compagno, NON come archetipo.
      if (companionCard && companionCard.title) {
        lead += (lead ? ' ' : '') + 'Il tuo compagno fisso al tavolo è <strong>' + escapeHtml(companionCard.title) + '</strong>.';
      }

      let html = '';
      if (lead) html += '<p class="fp-moment__lead">' + lead + '</p>';

      // ── 2. Gioco del mese (eroe): copertina + testo accanto (mai sopra) ──
      let heroName = null;
      let heroHtml = '';
      if (cover) {
        heroName = cover.title;
        const heroGame = allGames.find(g => norm(g.name) === norm(cover.title));
        const heroPlays = heroGame ? heroGame.plays : null;
        const img = cover.coverImg
          ? '<img src="' + encodeURI(cover.coverImg) + '" alt="' + escapeHtml(cover.title || '') + '" loading="lazy" onerror="this.style.display=\'none\';this.parentNode.classList.add(\'is-noimg\')">'
          : '<span class="fp-moment__hero-cover-fallback">🎲</span>';
        const heroLine = (heroPlays && heroPlays > 1)
          ? 'Ci hai giocato <strong>' + heroPlays + ' volte</strong> — il tuo chiodo fisso.'
          : (cover.footer ? escapeHtml(cover.footer) : '');
        heroHtml = '<div class="fp-moment__hero-game">' +
          '<div class="fp-moment__hero-cover">' + img + '</div>' +
          '<div class="fp-moment__hero-text">' +
            '<p class="fp-moment__hero-eyebrow">' + escapeHtml(cover.eyebrow || '') + '</p>' +
            '<h3 class="fp-moment__hero-title">' + escapeHtml(cover.title || '') + '</h3>' +
            (heroLine ? '<p class="fp-moment__hero-meta">' + heroLine + '</p>' : '') +
          '</div>' +
        '</div>';
      }

      // ── 3. Plancia numeri ──
      let statsHtml = '';
      if (bignums.length > 0) {
        statsHtml = '<div class="fp-moment__stats">' +
          bignums.map(b =>
            '<div class="fp-moment__stat">' +
              '<div class="fp-moment__stat-num">' + escapeHtml(String(b.number)) + '</div>' +
              '<div class="fp-moment__stat-label">' + escapeHtml((b.label || '').toLowerCase()) + '</div>' +
            '</div>'
          ).join('') +
        '</div>';
      }

      // Riga superiore: eroe (sinistra) + plancia numeri (destra) affiancati su
      // desktop → riempie la fascia, niente "buco" a destra. Su mobile si impila.
      if (heroHtml || statsHtml) html += '<div class="fp-moment__top">' + heroHtml + statsHtml + '</div>';

      // ── 4. Shelf: copertine più giocate dopo l'eroe (escluso). Foto-first = on-brand,
      //    quindi default generoso (11); il resto dietro un "e altri N" ESPANDIBILE
      //    (niente più nascondere per sempre — richiesta cliente). L'immagine da
      //    condividere resta separata e tirata: qui espandiamo solo a schermo. ──
      const shelf = allGames.filter(g => norm(g.name) !== norm(heroName));
      if (shelf.length > 0) {
        const MAX = 11;
        const shown = shelf.slice(0, MAX);
        const extra = shelf.slice(MAX);
        const gameCover = (g) => {
          const nm = escapeHtml(g.name || '?');
          // Nome nascosto quando c'è la copertina (altrimenti traspare nelle bande
          // del contain sulle cover verticali). onerror lo rimostra se l'img fallisce.
          const noimg = '<span class="fp-moment__game-noimg"' + (g.cover ? ' style="display:none"' : '') + '>' + nm + '</span>';
          const img = g.cover
            ? '<img src="' + encodeURI(g.cover) + '" alt="' + escapeHtml(g.name || '') + '" loading="lazy" onerror="this.style.display=\'none\';var n=this.parentNode.querySelector(\'.fp-moment__game-noimg\');if(n)n.style.display=\'flex\';">'
            : '';
          return '<div class="fp-moment__game" title="' + escapeHtml(g.name || '') + '">' +
            '<div class="fp-moment__game-cover">' + noimg + img + '</div>' +
            '<span class="fp-moment__game-count">×' + (g.plays || 1) + '</span>' +
          '</div>';
        };
        html += '<p class="fp-moment__games-label">Gli altri giochi che hai messo sul tavolo</p>' +
          '<div class="fp-moment__games">' + shown.map(gameCover).join('') + '</div>';
        if (extra.length > 0) {
          html += '<div class="fp-moment__games fp-moment__games--extra" data-fp-games-extra hidden>' +
              extra.map(gameCover).join('') +
            '</div>' +
            '<button type="button" class="fp-moment__games-more" data-fp-games-expand aria-expanded="false">' +
              'e altri <strong>' + extra.length + '</strong> ' + (extra.length === 1 ? 'gioco' : 'giochi') + ' questo periodo <span class="fp-moment__games-more-chev" aria-hidden="true">▾</span>' +
            '</button>';
        }
      }

      return html || '<p class="fp-moment__lead">Ancora niente da raccontare per questo periodo.</p>';
    }

    /**
     * Giochi del periodo con copertina, per la riga "I giochi che hai messo sul tavolo".
     * Fonde playsByDate (BGG) + manualPlays, dedup per nome, ordina per partite.
     * Copertina BGG-first (g.img), poi catalogo sito come ripiego.
     */
    getPeriodGames(lens) {
      const p = this.profile || {};
      const act = p.playsActivity || {};
      const now = new Date();
      const monthKey = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
      const yearKey = String(now.getFullYear());
      const c30 = new Date(); c30.setDate(c30.getDate() - 30);
      const cutoff30 = c30.getFullYear() + '-' + String(c30.getMonth() + 1).padStart(2, '0') + '-' + String(c30.getDate()).padStart(2, '0');
      const c365 = new Date(); c365.setDate(c365.getDate() - 365);
      const cutoff365 = c365.getFullYear() + '-' + String(c365.getMonth() + 1).padStart(2, '0') + '-' + String(c365.getDate()).padStart(2, '0');
      const match = (date) => {
        if (!date) return false;
        if (lens === 'month') return date.startsWith(monthKey);
        if (lens === 'year') return date.startsWith(yearKey);
        if (lens === 'last30') return date >= cutoff30;
        if (lens === 'last12m') return date >= cutoff365;
        return true;
      };
      // Ripieghi copertina: img giocati (topPlayed), thumbnail collezione BGG,
      // cache /thing recuperata da BGG (_coverCache, popolata da _enrichMomentCovers).
      const tpImg = {};
      for (const g of (act.topPlayed || [])) { if (g && g.bggId && g.img) tpImg[g.bggId] = g.img; }
      const ownThumb = {};
      for (const it of ((p.bggCollection && p.bggCollection.owned) || [])) {
        if (it && typeof it === 'object' && it.id && (it.image || it.thumbnail)) ownThumb[it.id] = it.image || it.thumbnail;
      }
      const cc = this._coverCache || (this._coverCache = {});
      const resolveCov = (bggId, img) => {
        if (img) return img; // BGG-first
        if (bggId) {
          const prod = (this.products || []).find(x => x.bgg === bggId);
          if (prod && prod.img) return prod.img;
          if (tpImg[bggId]) return tpImg[bggId];
          if (ownThumb[bggId]) return ownThumb[bggId];
          if (cc[bggId]) return cc[bggId];
        }
        return null;
      };
      const norm = (s) => (s || '').toLowerCase().trim();
      // Mappa nome→bggId dalle fonti che HANNO il bggId (topPlayed / collezione / manuali).
      // Serve a riagganciare il bggId ai giochi che arrivano da playsByDate SENZA di esso
      // (worker che non lo emette per-partita) → così resolveCov può usare tpImg/ownThumb
      // e l'enrichment BGG può scaricarne la copertina. Senza, restavano scatole grigie
      // in tutte le lenti tranne "Sempre" (che pesca dai topPlayed già con img).
      const nameToBgg = {};
      for (const g of (act.topPlayed || [])) { if (g && g.name && g.bggId) { const k = norm(g.name); if (!nameToBgg[k]) nameToBgg[k] = g.bggId; } }
      for (const it of ((p.bggCollection && p.bggCollection.owned) || [])) { if (it && typeof it === 'object' && it.name && it.id) { const k = norm(it.name); if (!nameToBgg[k]) nameToBgg[k] = it.id; } }
      for (const mp of (Array.isArray(p.manualPlays) ? p.manualPlays : [])) { if (mp && mp.title && mp.bggId) { const k = norm(mp.title); if (!nameToBgg[k]) nameToBgg[k] = mp.bggId; } }
      const map = new Map();
      const addGame = (name, bggId, img, plays) => {
        const key = norm(name);
        if (!key) return;
        if (!bggId && nameToBgg[key]) bggId = nameToBgg[key]; // riaggancia bggId mancante
        let e = map.get(key);
        if (!e) { e = { name: name, bggId: bggId || null, cover: resolveCov(bggId, img), plays: 0 }; map.set(key, e); }
        if (!e.bggId && bggId) e.bggId = bggId;
        e.plays += (plays > 0 ? plays : 1);
        if (!e.cover) { const cv = resolveCov(bggId, img); if (cv) e.cover = cv; }
      };

      // playsByDate + manuali per OGNI lente (match()==true per 'all'). Coerente con
      // computeMomentCards: prima 'all' usava solo act.topPlayed → niente partite manuali.
      const pbd = act.playsByDate || null;
      if (pbd) {
        for (const date in pbd) {
          if (!match(date) || !pbd[date]) continue;
          for (const g of (pbd[date].games || [])) addGame(g.name, g.bggId, g.img, g.plays || 1);
        }
      }
      if (Array.isArray(p.manualPlays)) {
        for (const mp of p.manualPlays) {
          if (!match(mp.date)) continue;
          // Dedup contro BGG playsByDate sulla stessa data (no doppio conteggio).
          const bggDay = pbd && pbd[mp.date];
          if (bggDay && Array.isArray(bggDay.games)) {
            const dup = bggDay.games.some(g =>
              (mp.bggId && g.bggId && g.bggId === mp.bggId) ||
              (g.name && norm(g.name) === norm(mp.title)));
            if (dup) continue;
          }
          addGame(mp.title, mp.bggId, mp.img, 1);
        }
      }
      // "Sempre": pavimento coi conteggi BGG di sempre (per playsByDate troncato >1000).
      if (lens === 'all') {
        for (const g of (act.topPlayed || [])) {
          if (!g || !g.name || (g.plays || 0) <= 0) continue;
          const key = norm(g.name);
          const e = map.get(key);
          if (!e) map.set(key, { name: g.name, bggId: g.bggId || null, cover: resolveCov(g.bggId, g.img), plays: g.plays });
          else { if (!e.bggId && g.bggId) e.bggId = g.bggId; if (g.plays > e.plays) e.plays = g.plays; if (!e.cover) e.cover = resolveCov(g.bggId, g.img); }
        }
      }
      return Array.from(map.values()).sort((a, b) => b.plays - a.plays);
    }

    /**
     * Gioco più giocato REALE (BGG + manuali, deduplicato) — non act.topPlayed[0],
     * che dopo un re-sync BGG perde le partite manuali. Riusa getPeriodGames('all').
     * Arricchisce minuti/freschezza dal topPlayed BGG se il gioco combacia.
     */
    getMostPlayed() {
      const merged = this.getPeriodGames('all');
      if (!merged || merged.length === 0) return null;
      const top = merged[0];
      const act = this.profile.playsActivity || {};
      const norm = (s) => (s || '').toLowerCase().trim();
      const tp = (act.topPlayed || []).find(g =>
        (top.bggId && g.bggId === top.bggId) || (g.name && norm(g.name) === norm(top.name)));
      return {
        name: top.name,
        plays: top.plays,
        bggId: top.bggId || null,
        img: top.cover || (tp && tp.img) || null,
        minutes: tp ? (tp.minutes || 0) : 0,
        freshness: tp ? tp.freshness : null
      };
    }

    /**
     * Pre-fetch immagine cover come dataURL base64.
     * Usa worker /api/img-proxy per bypassare CORS (BGG non manda Access-Control-Allow-Origin).
     */
    async fetchImageAsDataUrl(url) {
      if (!url) return null;
      const workerUrl = this.workerUrl || (this.customer && this.customer.workerUrl) || '';
      // Se URL è già base64 o data: → nulla da fare
      if (url.startsWith('data:')) return url;
      try {
        // Proxy via worker se URL non same-origin (evita CORS)
        let fetchUrl = url;
        if (workerUrl && (url.startsWith('http://') || url.startsWith('https://'))) {
          fetchUrl = workerUrl.replace(/\/$/, '') + '/api/img-proxy?url=' + encodeURIComponent(url);
        }
        const res = await fetch(fetchUrl);
        if (!res.ok) return null;
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (e) {
        console.warn('[FroggerProfile] image fetch failed:', url, e);
        return null;
      }
    }

    /**
     * Condividi tutte le 5 card come singola immagine 9:16 (Instagram Stories ready).
     * Card sono ricreate con stili INLINE assoluti per garantire rendering pulito in html2canvas.
     */
    async shareMomentImage(mode) {
      const cards = this.computeMomentCards(this.momentLens || 'all');
      if (cards.length === 0) return;

      // Pre-converti tutte le coverImg in base64 per evitare problemi CORS in html2canvas
      const btn = this.root.querySelector('[data-fp-moment-share-all]');
      if (btn) { btn.disabled = true; btn.textContent = '🎨 Preparo le immagini...'; }
      for (const c of cards) {
        if (c.type === 'cover' && c.coverImg) {
          const dataUrl = await this.fetchImageAsDataUrl(c.coverImg);
          if (dataUrl) c.coverImg = dataUrl;
          else c.coverImg = null; // se fallisce, fallback a card senza img
        }
      }
      // Anche avatar per header
      let avatarDataUrl = null;
      if (this.profile.avatarUrl) {
        avatarDataUrl = await this.fetchImageAsDataUrl(this.profile.avatarUrl);
      }
      this._shareAvatarDataUrl = avatarDataUrl;

      const displayName = this.profile.displayName || (this.customer && this.customer.firstName) || this.profile.bggUsername || 'Frogger';
      const motto = this.profile.motto ? '"' + this.profile.motto + '"' : '';
      const avatarUrl = this._shareAvatarDataUrl || this.profile.avatarUrl || '';
      const avatarInitials = this.computeInitials(displayName);
      const archetype = this.profile.archetypeName || '';
      const lensLabel = { month: 'QUESTO MESE', last30: 'ULTIMI 30 GIORNI', year: 'QUEST\'ANNO', all: 'IN TOTALE' }[this.momentLens || 'all'] || '';

      // Wrapper Instagram Stories 1080x1920 (9:16)
      const W = 1080, H = 1920;
      const wrapper = document.createElement('div');
      wrapper.style.cssText =
        'position:fixed;left:-99999px;top:0;width:' + W + 'px;height:' + H + 'px;' +
        'padding:60px 50px;box-sizing:border-box;display:flex;flex-direction:column;' +
        'background:linear-gradient(160deg,#FAF7F0 0%,#FFF8E1 50%,#FFE89A 100%);' +
        'font-family:-apple-system,BlinkMacSystemFont,Inter,sans-serif;color:#1F1A14;overflow:hidden;';

      // ── HEADER ──
      const avatarBlock = avatarUrl
        ? '<div style="width:140px;height:140px;border-radius:50%;border:6px solid #FFB800;background-image:url(\'' + avatarUrl + '\');background-size:cover;background-position:center;box-shadow:0 10px 26px rgba(255,184,0,0.32);flex-shrink:0;"></div>'
        : '<div style="width:140px;height:140px;border-radius:50%;border:6px solid #FFB800;background:linear-gradient(135deg,#2D7A4F 0%,#1F5A3A 100%);display:flex;align-items:center;justify-content:center;color:#FFF;font-size:54px;font-weight:800;font-family:Georgia,serif;box-shadow:0 10px 26px rgba(255,184,0,0.32);flex-shrink:0;">' + escapeHtml(avatarInitials || '🐸') + '</div>';

      const headerHtml =
        '<div style="display:flex;align-items:center;gap:28px;margin-bottom:24px;">' +
          avatarBlock +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-size:20px;letter-spacing:0.2em;text-transform:uppercase;color:rgba(31,26,20,0.55);font-weight:800;margin-bottom:8px;">🐸 FROGGER PROFILE</div>' +
            '<div style="font-family:Georgia,serif;font-size:64px;font-weight:800;line-height:1;letter-spacing:-0.025em;margin-bottom:10px;">' + escapeHtml(displayName) + '</div>' +
            (archetype ? '<div style="font-size:22px;font-weight:800;color:#2D7A4F;letter-spacing:0.05em;">' + escapeHtml(archetype.toUpperCase()) + '</div>' : '') +
          '</div>' +
        '</div>' +
        (motto
          ? '<div style="font-family:Georgia,serif;font-style:italic;font-size:28px;color:rgba(31,26,20,0.72);margin-bottom:28px;padding-left:14px;border-left:4px solid #FFB800;line-height:1.3;">' + escapeHtml(motto) + '</div>'
          : '<div style="margin-bottom:24px;"></div>');

      // ── GRID 2 col x 3 righe ──
      const cardW = 470, cardH = 430; // pixel fissi
      let gridHtml = '<div style="display:grid;grid-template-columns:' + cardW + 'px ' + cardW + 'px;gap:20px;flex:1;align-content:start;justify-content:center;">';

      for (let i = 0; i < cards.length; i++) {
        gridHtml += this.renderShareCard(cards[i], i, cards.length, cardW, cardH);
      }

      // CTA slot
      gridHtml += '<div style="width:' + cardW + 'px;height:' + cardH + 'px;background:linear-gradient(135deg,#FFB800 0%,#E8A300 100%);border-radius:22px;padding:36px 24px;box-sizing:border-box;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;color:#1F1A14;box-shadow:0 14px 32px rgba(255,184,0,0.35);">' +
        '<div style="font-size:80px;line-height:1;margin-bottom:18px;">🐸</div>' +
        '<div style="font-size:18px;letter-spacing:0.18em;text-transform:uppercase;font-weight:800;margin-bottom:14px;">SCOPRI</div>' +
        '<div style="font-family:Georgia,serif;font-size:36px;font-weight:800;line-height:1.05;letter-spacing:-0.025em;margin-bottom:18px;">CHI SEI<br>AL TAVOLO</div>' +
        '<div style="font-size:20px;font-weight:700;opacity:0.85;">frogames.it</div>' +
      '</div>';

      gridHtml += '</div>';

      // ── FOOTER ──
      const footerHtml =
        '<div style="margin-top:24px;display:flex;justify-content:space-between;align-items:center;font-size:20px;color:rgba(31,26,20,0.55);font-weight:800;letter-spacing:0.1em;text-transform:uppercase;">' +
          '<span>' + (lensLabel || 'IL TUO MOMENTO') + '</span>' +
          '<span>frogames.it/frogmatch</span>' +
        '</div>';

      wrapper.innerHTML = headerHtml + gridHtml + footerHtml;
      document.body.appendChild(wrapper);

      this.captureAndShare(wrapper, 'Il mio Frogger Profile', () => {
        document.body.removeChild(wrapper);
      });
    }

    /**
     * Renderizza una card per export immagine — stili INLINE assoluti.
     * Usa <table> e <tr> per layout robusto in html2canvas (evita problemi flex/line-height).
     */
    renderShareCard(c, idx, total, w, h) {
      const themes = {
        green: { bg: 'linear-gradient(155deg,#2D7A4F 0%,#1F5938 60%,#142E22 100%)', text: '#FFFFFF', muted: 'rgba(255,255,255,0.7)' },
        yellow: { bg: 'linear-gradient(155deg,#FFB800 0%,#E8A300 50%,#C28800 100%)', text: '#1F1A14', muted: 'rgba(31,26,20,0.65)' },
        dark: { bg: 'linear-gradient(155deg,#1F1A14 0%,#2A2118 50%,#0E0908 100%)', text: '#FFFFFF', muted: 'rgba(255,255,255,0.7)' },
        red: { bg: 'linear-gradient(155deg,#C2244A 0%,#8E1A37 50%,#5B1124 100%)', text: '#FFFFFF', muted: 'rgba(255,255,255,0.7)' },
        purple: { bg: 'linear-gradient(155deg,#5C3A92 0%,#3D2761 50%,#21133A 100%)', text: '#FFFFFF', muted: 'rgba(255,255,255,0.7)' }
      };
      const t = themes[c.theme] || themes.green;
      const num = String(idx + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');

      // Card outer: width/height fissi, padding via inner
      const cardOuter = 'width:' + w + 'px;height:' + h + 'px;border-radius:22px;background:' + t.bg + ';color:' + t.text + ';position:relative;overflow:hidden;box-shadow:0 14px 32px rgba(31,26,20,0.18);box-sizing:border-box;';

      // Header (numerazione + brand) — height fissa 32px
      const renderHeader = (textShadow) => '<div style="display:flex;justify-content:space-between;align-items:center;font-size:14px;letter-spacing:0.14em;text-transform:uppercase;color:' + t.muted + ';font-weight:800;height:32px;line-height:32px;' + (textShadow ? 'text-shadow:0 1px 3px rgba(0,0,0,0.5);color:rgba(255,255,255,0.85);' : '') + '">' +
        '<span>' + num + '</span><span>🐸 FROGMATCH</span></div>';

      // ── COVER: multi-background (gradient + image) per html2canvas reliable + banda nera ──
      if (c.type === 'cover') {
        // Stack di background CSS: layer 1 = gradient nero in basso (overlay leggibilità),
        // layer 2 = immagine BGG cover, layer 3 = gradient theme (fallback se img manca)
        const bgStack = c.coverImg
          ? 'background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0) 40%,rgba(0,0,0,0.55) 60%,rgba(0,0,0,0.92) 100%),url(\'' + c.coverImg + '\') center/cover no-repeat,' + t.bg + ';'
          : 'background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0) 40%,rgba(0,0,0,0.5) 65%,rgba(0,0,0,0.85) 100%),' + t.bg + ';';
        const cardWithBg = 'width:' + w + 'px;height:' + h + 'px;border-radius:22px;color:#FFFFFF;position:relative;overflow:hidden;box-shadow:0 14px 32px rgba(31,26,20,0.18);box-sizing:border-box;' + bgStack;
        return '<div style="' + cardWithBg + '">' +
          // Header in alto
          '<div style="position:absolute;top:24px;left:24px;right:24px;z-index:2;">' +
            renderHeader(true) +
          '</div>' +
          // Testo in basso (sempre leggibile sulla banda nera)
          '<div style="position:absolute;bottom:24px;left:24px;right:24px;z-index:2;">' +
            '<div style="font-size:13px;letter-spacing:0.18em;text-transform:uppercase;font-weight:800;color:#FFB800;margin:0 0 10px 0;line-height:1;">' + escapeHtml(c.eyebrow || '') + '</div>' +
            '<div style="font-family:Georgia,Times,serif;font-size:38px;font-weight:800;line-height:1.1;letter-spacing:-0.015em;margin:0 0 8px 0;color:#FFFFFF;">' + escapeHtml(c.title || '') + '</div>' +
            (c.footer ? '<div style="font-size:17px;color:rgba(255,255,255,0.92);font-weight:600;margin:0;line-height:1.3;">' + escapeHtml(c.footer) + '</div>' : '') +
          '</div>' +
        '</div>';
      }

      // ── BIGNUM: aria sufficiente per il numero, no overflow:hidden che taglia ──
      // Card 470x430. Layout: header Y=24, eyebrow Y=100, number Y=130 (h:160 lh:160 = aria per descender), label Y=305
      if (c.type === 'bignum') {
        return '<div style="' + cardOuter + '">' +
          '<div style="position:absolute;top:24px;left:24px;right:24px;height:32px;">' + renderHeader() + '</div>' +
          '<div style="position:absolute;top:100px;left:24px;right:24px;height:18px;line-height:18px;font-size:14px;letter-spacing:0.18em;text-transform:uppercase;font-weight:800;color:' + t.muted + ';text-align:center;">' + escapeHtml(c.eyebrow || '') + '</div>' +
          '<div style="position:absolute;top:130px;left:24px;right:24px;height:160px;line-height:160px;font-family:Georgia,Times,serif;font-size:110px;font-weight:800;letter-spacing:-0.04em;color:' + t.text + ';text-align:center;">' + escapeHtml(c.number || '') + '</div>' +
          '<div style="position:absolute;top:310px;left:24px;right:24px;height:26px;line-height:26px;font-size:22px;font-weight:800;letter-spacing:0.1em;color:' + t.text + ';text-align:center;">' + escapeHtml(c.label || '') + '</div>' +
          (c.footer ? '<div style="position:absolute;top:360px;left:24px;right:24px;font-size:16px;color:' + t.muted + ';font-weight:600;line-height:1.3;text-align:center;">' + escapeHtml(c.footer) + '</div>' : '') +
        '</div>';
      }

      // ── IDENTITY: icona + titolo gigante con coordinate Y esplicite ──
      // Header Y=24, eyebrow Y=110, icon Y=145, title Y=255, footer Y=325
      if (c.type === 'identity') {
        return '<div style="' + cardOuter + '">' +
          '<div style="position:absolute;top:24px;left:24px;right:24px;height:32px;">' + renderHeader() + '</div>' +
          '<div style="position:absolute;top:110px;left:24px;right:24px;height:18px;line-height:18px;font-size:14px;letter-spacing:0.18em;text-transform:uppercase;font-weight:800;color:' + t.muted + ';text-align:center;">' + escapeHtml(c.eyebrow || '') + '</div>' +
          (c.icon ? '<div style="position:absolute;top:150px;left:24px;right:24px;height:90px;line-height:90px;font-size:80px;text-align:center;">' + c.icon + '</div>' : '') +
          '<div style="position:absolute;top:265px;left:24px;right:24px;font-family:Georgia,Times,serif;font-size:36px;font-weight:800;line-height:1.05;letter-spacing:-0.02em;color:' + t.text + ';text-align:center;">' + escapeHtml((c.title || '').toUpperCase()) + '</div>' +
          (c.footer ? '<div style="position:absolute;top:340px;left:24px;right:24px;font-size:15px;color:' + t.muted + ';font-weight:600;line-height:1.35;text-align:center;">' + escapeHtml(c.footer) + '</div>' : '') +
        '</div>';
      }

      return '<div style="' + cardOuter + '"></div>';
    }

    /**
     * Cattura un elemento DOM in immagine PNG.
     * Su mobile: native share sheet con immagine allegata
     * Su desktop: download diretto del PNG (no Windows share buggy)
     */
    captureAndShare(element, text, cleanup) {
      const url = window.location.origin + (this.quizUrl || '/pages/frogmatch');
      const shareText = '🐸 ' + text + '\n\nScopri quale Frogger sei su frogames.it';
      const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      // Mostra micro-spinner sul share button se esiste
      const btn = this.root.querySelector('[data-fp-moment-share-all]');
      const oldLabel = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = '🎨 Genero immagine...';
      }
      const restoreBtn = () => {
        if (btn) { btn.disabled = false; btn.textContent = oldLabel; }
      };

      // Lazy load html2canvas dal CDN se non caricato
      this.loadHtml2Canvas(() => {
        if (!window.html2canvas) {
          if (cleanup) cleanup();
          restoreBtn();
          this.fallbackTextShare(shareText, url);
          return;
        }
        window.html2canvas(element, {
          useCORS: true,
          allowTaint: false,
          backgroundColor: null,
          scale: 2,
          logging: false
        }).then(canvas => {
          canvas.toBlob(blob => {
            if (cleanup) cleanup();
            if (!blob) {
              restoreBtn();
              this.fallbackTextShare(shareText, url);
              return;
            }
            const file = new File([blob], 'frogger-profile.png', { type: 'image/png' });

            // Solo MOBILE: tenta native share con file
            const canNativeShare = isMobileDevice &&
              navigator.share &&
              navigator.canShare &&
              navigator.canShare({ files: [file] });

            if (canNativeShare) {
              navigator.share({
                title: 'Il mio Frogger Profile',
                text: shareText,
                files: [file]
              }).then(() => {
                restoreBtn();
              }).catch((err) => {
                // Native share annullato o fallito → fallback download
                if (err && err.name !== 'AbortError') {
                  console.warn('[FroggerProfile] native share fail:', err);
                }
                restoreBtn();
                this.downloadBlob(blob, 'frogger-profile.png');
              });
            } else {
              // Desktop o mobile senza supporto file share → download diretto
              restoreBtn();
              this.downloadBlob(blob, 'frogger-profile.png');
              if (btn) {
                btn.textContent = '✓ Scaricato!';
                setTimeout(() => { btn.textContent = oldLabel; }, 1500);
              }
            }
          }, 'image/png');
        }).catch((err) => {
          console.warn('[FroggerProfile] html2canvas error:', err);
          if (cleanup) cleanup();
          restoreBtn();
          this.fallbackTextShare(shareText, url);
        });
      });
    }

    fallbackTextShare(text, url) {
      if (navigator.share) {
        navigator.share({ title: 'Il mio Frogger Profile', text, url }).catch(() => {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(text + '\n' + url).then(() => alert('✓ Testo copiato'));
      } else {
        prompt('Copia il testo:', text + '\n' + url);
      }
    }

    downloadBlob(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    loadHtml2Canvas(callback) {
      if (window.html2canvas) { callback(); return; }
      const existing = document.querySelector('script[data-html2canvas]');
      if (existing) {
        existing.addEventListener('load', callback, { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
      script.async = true;
      script.dataset.html2canvas = '1';
      script.addEventListener('load', callback, { once: true });
      script.addEventListener('error', () => {
        alert('⚠️ Impossibile caricare la libreria immagini. Provo solo testo.');
        callback();
      });
      document.head.appendChild(script);
    }

    /**
     * Genera fino a 5 scoperte stile Spotify Wrapped.
     * lens: 'month' | 'year' | 'all' — filtra periodi e copy
     */
    computeMomentCards(lens) {
      lens = lens || this.computeSmartDefaultLens();
      const p = this.profile;
      const act = p.playsActivity;
      const cards = [];
      const fullMonth = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
      const now = new Date();
      const currentMonth = fullMonth[now.getMonth()];
      const currentYear = now.getFullYear();

      if (!act || !act.totalPlays || act.totalPlays === 0) return [];

      const typsLabel = (FM.TYPOLOGY_LABELS || {});
      const typsIcons = (FM.TYPOLOGY_ICONS || {});
      const _cc = this._coverCache || (this._coverCache = {});
      const findCover = (g) => {
        if (!g) return null;
        // BGG-first: copertina da BGG (g.img), poi catalogo, poi cache /thing recuperata.
        const product = g.bggId ? this.products.find(p => p.bgg === g.bggId) : null;
        return g.img || (product && product.img) || (g.bggId && _cc[g.bggId]) || null;
      };

      // Periodo helpers
      const isYear = lens === 'year';
      const isMonth = lens === 'month';
      const isLast30 = lens === 'last30';
      const isAll = lens === 'all';
      const periodLabel = isMonth ? currentMonth.toUpperCase()
                        : isLast30 ? 'ULTIMI 30 GIORNI'
                        : (isYear ? String(currentYear) : 'SEMPRE');
      const periodLabelLower = isMonth ? 'questo mese'
                              : isLast30 ? 'negli ultimi 30 giorni'
                              : (isYear ? 'quest\'anno' : 'in totale');

      // ════════════════════════════════════════════════════════════
      // FILTRAGGIO PERIODO — calendario per month/year, rolling per last30.
      // last30 (2026-06-XX): aggiunto per evitare "Niente per questo mese"
      // a inizio mese quando le partite sono ancora nel mese precedente.
      // ════════════════════════════════════════════════════════════
      const playsByDate = act.playsByDate || null;
      const monthKey = String(currentYear) + '-' + String(now.getMonth() + 1).padStart(2, '0'); // YYYY-MM
      const yearKey = String(currentYear); // YYYY
      // Cutoff per last30: 30 giorni fa (incluso oggi)
      const last30CutoffDate = new Date();
      last30CutoffDate.setDate(last30CutoffDate.getDate() - 30);
      const last30CutoffKey = last30CutoffDate.getFullYear() + '-' +
        String(last30CutoffDate.getMonth() + 1).padStart(2, '0') + '-' +
        String(last30CutoffDate.getDate()).padStart(2, '0');

      // Aggrega DA playsByDate sul periodo
      let periodPlays = 0, periodMinutes = 0;
      const periodGameCounts = {};
      const periodTopBgg = {};

      // Match predicate: date string vs lens. isAll → tutte le date.
      const matchDate = (date) => {
        if (isAll) return true;
        if (isMonth) return date.startsWith(monthKey);
        if (isYear) return date.startsWith(yearKey);
        if (isLast30) return date >= last30CutoffKey;
        return false;
      };

      // Aggrega da playsByDate + partite manuali, per OGNI lente ("Sempre" incluso).
      // FIX 2026-06-17: prima "Sempre" usava solo act.totalPlays/topPlayed → ignorava
      // le partite manuali e risultava MINORE di "Quest'anno" (impossibile). Ora tutte
      // le lenti sommano la stessa fonte → coerenza garantita (tutto ≥ sotto-periodo).
      if (playsByDate) {
        for (const [date, info] of Object.entries(playsByDate)) {
          if (!matchDate(date) || !info) continue;
          periodPlays += info.plays || 0;
          periodMinutes += info.minutes || 0;
          for (const g of (info.games || [])) {
            periodGameCounts[g.name] = (periodGameCounts[g.name] || 0) + (g.plays || 0);
          }
          if (info.topBggId && info.topName) periodTopBgg[info.topName] = info.topBggId;
        }
      }
      if (Array.isArray(p.manualPlays)) {
        const norm = (s) => (s || '').toLowerCase().trim();
        for (const mp of p.manualPlays) {
          if (!mp.date || !matchDate(mp.date)) continue;
          const bggDay = playsByDate && playsByDate[mp.date];
          if (bggDay && Array.isArray(bggDay.games)) {
            const dup = bggDay.games.some(g =>
              (mp.bggId && g.bggId && g.bggId === mp.bggId) ||
              (g.name && norm(g.name) === norm(mp.title))
            );
            if (dup) continue;
          }
          periodPlays += 1;
          periodMinutes += mp.minutes || 0;
          const name = mp.title || 'Sconosciuto';
          periodGameCounts[name] = (periodGameCounts[name] || 0) + 1;
          if (mp.bggId && !periodTopBgg[name]) periodTopBgg[name] = mp.bggId;
        }
      }
      // Fallback rolling se manca playsByDate
      if (periodPlays === 0 && !playsByDate) {
        if (isAll) {
          periodPlays = act.totalPlays || 0;
          periodMinutes = act.totalMinutes || 0;
        } else if (isMonth || isLast30) {
          periodPlays = (act.totalPlays30d != null) ? act.totalPlays30d : (act.last30DaysPlays || 0);
          periodMinutes = act.last30DaysMinutes || 0;
        } else if (isYear) {
          periodPlays = (act.totalPlays365d != null)
            ? act.totalPlays365d
            : act.topPlayed.reduce((s, g) => s + (g.plays365d || 0), 0);
          periodMinutes = act.topPlayed.reduce((s, g) => s + ((g.plays365d || 0) * (g.bggAvgDuration || (g.minutes && g.plays ? g.minutes / g.plays : 0))), 0);
        }
      }
      // "Sempre": pavimento coi totali BGG (per playsByDate troncato su >1000 partite)
      if (isAll) {
        periodPlays = Math.max(periodPlays, act.totalPlays || 0);
        periodMinutes = Math.max(periodMinutes, act.totalMinutes || 0);
      }

      // filteredTopPlayed: per isAll usa topPlayed totale,
      // per isMonth/isYear usa la classifica derivata da periodGameCounts
      // (unione BGG + manual). Usa periodGameCounts ogni volta che ne abbiamo.
      let filteredTopPlayed;
      if (Object.keys(periodGameCounts).length > 0) {
        // Classifica da periodGameCounts (BGG playsByDate + manuali). Per "Sempre" il
        // conteggio per gioco è il max col totale BGG di sempre (topPlayed.plays), così
        // il gioco top non scende sotto il suo totale storico.
        const tpByName = {};
        for (const tp of (act.topPlayed || [])) tpByName[tp.name] = tp;
        filteredTopPlayed = Object.keys(periodGameCounts)
          .map((name) => {
            const tp = tpByName[name] || {};
            const base = periodGameCounts[name];
            const cnt = isAll ? Math.max(base, tp.plays || 0) : base;
            return Object.assign({}, tp, {
              name,
              plays30d: isMonth ? base : (tp.plays30d || 0),
              plays365d: isYear ? base : (tp.plays365d || 0),
              periodPlays: cnt,
              bggId: tp.bggId || periodTopBgg[name] || null
            });
          })
          .sort((a, b) => (b.periodPlays || 0) - (a.periodPlays || 0));
      } else if (isAll) {
        // Fallback "Sempre" senza playsByDate: classifica BGG di sempre.
        filteredTopPlayed = act.topPlayed.filter(g => (g.plays || 0) > 0)
          .map(g => Object.assign({}, g, { periodPlays: g.plays }))
          .sort((a, b) => (b.plays || 0) - (a.plays || 0));
      } else {
        // Fallback rolling (nessun periodGameCounts): comportamento legacy
        filteredTopPlayed = act.topPlayed.filter(g => {
          if (isMonth) return (g.plays30d || 0) > 0;
          return (g.plays365d || 0) > 0;
        }).sort((a, b) => {
          if (isMonth) return (b.plays30d || 0) - (a.plays30d || 0);
          return (b.plays365d || 0) - (a.plays365d || 0);
        });
      }

      // Count giochi distinti del periodo
      let periodUnique;
      if (Object.keys(periodGameCounts).length > 0) {
        periodUnique = Object.keys(periodGameCounts).length;
        if (isAll) periodUnique = Math.max(periodUnique, act.uniqueGames || 0);
      } else if (isAll) {
        periodUnique = act.uniqueGames || filteredTopPlayed.length;
      } else if (isMonth) {
        periodUnique = (act.uniqueGames30d != null) ? act.uniqueGames30d : filteredTopPlayed.length;
      } else {
        periodUnique = (act.uniqueGames365d != null) ? act.uniqueGames365d : filteredTopPlayed.length;
      }

      // ── Card 1: Top played del periodo (cover) ──
      const topGame = filteredTopPlayed[0];
      if (topGame) {
        const cover = findCover(topGame);
        if (cover) {
          // Conteggio: periodPlays (calcolato per ogni lente, "Sempre" incluso),
          // con fallback al totale BGG.
          const playsCount = (topGame.periodPlays != null)
            ? topGame.periodPlays
            : (topGame.plays || (isMonth ? (topGame.plays30d || 0) : (topGame.plays365d || 0)));
          cards.push({
            type: 'cover',
            eyebrow: isAll ? 'IL TUO GIOCO DI SEMPRE' : 'IL TUO GIOCO DI ' + periodLabel,
            title: topGame.name,
            footer: playsCount + (playsCount === 1 ? ' partita' : ' partite') + ' ' + periodLabelLower,
            coverImg: cover,
            bggId: topGame.bggId || null,
            theme: isMonth ? 'green' : (isYear ? 'red' : 'red')
          });
        }
      }

      // ── Card 2: Numero partite del periodo (bignum) ──
      if (periodPlays > 0) {
        cards.push({
          type: 'bignum',
          eyebrow: isAll ? 'IL TUO TOTALE' : (isMonth ? 'A ' + periodLabel : 'NEL ' + periodLabel),
          number: String(periodPlays),
          label: periodPlays === 1 ? 'PARTITA' : 'PARTITE',
          footer: periodPlays >= 50 ? 'Veterano del tavolo' : (periodPlays >= 20 ? 'Bel ritmo' : (periodPlays >= 5 ? 'In moto' : 'Ogni partita conta')),
          theme: 'yellow'
        });
      }

      // ── Card 3: Tipologia dominante ──
      // Per "all" usa topTypologies del profilo (derivato da tutta la collezione/swipes).
      // Per "month"/"year" deriva la tipologia dominante DAI GIOCHI DEL PERIODO,
      // pesando per plays nel periodo. Se non riusciamo (giochi BGG-only fuori catalogo
      // → niente metadata mch/cat/peso), nascondiamo la card invece di mostrare quella di sempre
      // (sarebbe fuorviante: "lato dominante questo mese" mostrato dal totale storico).
      let primTyp = null;
      if (isAll) {
        primTyp = (p.topTypologiesPrimary || p.topTypologies || [])[0];
      } else {
        const periodTypBag = [];
        for (const g of filteredTopPlayed) {
          const product = g.bggId ? this.products.find(prod => prod.bgg === g.bggId) : null;
          if (!product) continue;
          const typs = FM.deriveTypologies ? FM.deriveTypologies(product) : [];
          const weight = isMonth ? (g.plays30d || 1) : (g.plays365d || 1);
          for (const t of typs) {
            for (let i = 0; i < weight; i++) periodTypBag.push(t);
          }
        }
        if (periodTypBag.length > 0) {
          // Top frequenza
          const counts = {};
          for (const t of periodTypBag) counts[t] = (counts[t] || 0) + 1;
          primTyp = Object.entries(counts).sort((a, b) => b[1] - a[1])[0][0];
        }
      }
      if (primTyp && typsLabel[primTyp]) {
        cards.push({
          type: 'identity',
          eyebrow: isAll ? 'IL TUO LATO DOMINANTE' : 'IL TUO LATO DOMINANTE ' + periodLabelLower.toUpperCase(),
          icon: typsIcons[primTyp] || '🐸',
          title: typsLabel[primTyp],
          footer: isAll ? 'È quello che ti definisce al tavolo' : 'Tra i giochi che hai messo sul tavolo ' + periodLabelLower,
          theme: 'dark'
        });
      }

      // ── Card 4: Ore al tavolo ──
      if (periodMinutes > 0) {
        const hrs = Math.round(periodMinutes / 60);
        if (hrs > 0) cards.push({
          type: 'bignum',
          eyebrow: isAll ? 'AL TAVOLO' : 'AL TAVOLO ' + periodLabelLower.toUpperCase(),
          number: String(hrs),
          label: hrs === 1 ? 'ORA' : 'ORE',
          footer: hrs >= 100 ? 'Frog Legend' : (hrs >= 30 ? 'Tavolo caldo' : 'Inizio promettente'),
          theme: 'green'
        });
      }

      // ── Card 5: Diversità (giochi diversi giocati nel periodo) ──
      if (periodUnique > 0) {
        cards.push({
          type: 'bignum',
          eyebrow: isAll ? 'NEL POND' : 'ESPLORATI ' + periodLabelLower.toUpperCase(),
          number: String(periodUnique),
          label: periodUnique === 1 ? 'GIOCO' : 'GIOCHI DIVERSI',
          footer: periodUnique >= 20 ? 'Esploratore vero' : (periodUnique >= 10 ? 'Bella varietà' : (periodUnique >= 5 ? 'Curiosità accesa' : 'Inizio del viaggio')),
          theme: 'purple'
        });
      }

      // ── Card 6: Compagno di tavolo ──
      // I companions sono aggregati BGG di sempre (no breakdown per periodo),
      // quindi mostriamo questa card SOLO con lente "all" per non essere fuorvianti.
      // Con lente month/year la card resta nascosta (l'utente non vede stat di sempre
      // su un selettore di periodo specifico).
      if (isAll) {
        const companions = act.companions || [];
        if (companions.length > 0) {
          const top = companions[0];
          cards.push({
            type: 'identity',
            eyebrow: 'IL TUO COMPAGNO FISSO',
            icon: '👥',
            title: top.name,
            footer: top.plays + ' partite insieme' + (top.winRate != null ? ' · ' + top.winRate + '% le vince lui' : ''),
            theme: 'dark'
          });
        }
      }

      // Ordering: cover → identity → bignum, max 5
      const ordered = [
        ...cards.filter(c => c.type === 'cover'),
        ...cards.filter(c => c.type === 'identity'),
        ...cards.filter(c => c.type === 'bignum')
      ];
      return ordered.slice(0, 5);
    }

    /**
     * Aggiorna lo stato visivo dei pulsanti lente
     */
    updateLensButtons() {
      this.root.querySelectorAll('[data-fp-lens]').forEach(btn => {
        btn.classList.toggle('is-active', btn.dataset.fpLens === this.momentLens);
      });
    }

    /**
     * Smart default per la lente: Mese se ha plays recenti, Anno se solo dati anno, Sempre fallback
     */
    computeSmartDefaultLens() {
      const act = this.profile.playsActivity;
      if (!act) return 'all';
      const p = this.profile;
      const now = new Date();
      const monthKey = String(now.getFullYear()) + '-' + String(now.getMonth() + 1).padStart(2, '0');
      const yearKey = String(now.getFullYear());

      // Helper: conta partite in un periodo (dedup BGG + manuali)
      const norm = (s) => (s || '').toLowerCase().trim();
      const playsByDate = act.playsByDate || null;
      const countByPrefix = (prefix) => {
        let c = 0;
        if (playsByDate) {
          for (const [d, info] of Object.entries(playsByDate)) {
            if (d.startsWith(prefix) && info) c += info.plays || 0;
          }
        }
        if (Array.isArray(p.manualPlays)) {
          for (const mp of p.manualPlays) {
            if (!mp.date || !mp.date.startsWith(prefix)) continue;
            const bggDay = playsByDate && playsByDate[mp.date];
            if (bggDay && Array.isArray(bggDay.games)) {
              const dup = bggDay.games.some(g =>
                (mp.bggId && g.bggId && g.bggId === mp.bggId) ||
                (g.name && norm(g.name) === norm(mp.title))
              );
              if (dup) continue;
            }
            c += 1;
          }
        }
        return c;
      };
      // Helper: partite negli ultimi 30 giorni (rolling)
      const countLast30 = () => {
        let c = 0;
        const cutoff = new Date();
        cutoff.setDate(cutoff.getDate() - 30);
        const cutoffKey = cutoff.getFullYear() + '-' +
          String(cutoff.getMonth() + 1).padStart(2, '0') + '-' +
          String(cutoff.getDate()).padStart(2, '0');
        if (playsByDate) {
          for (const [d, info] of Object.entries(playsByDate)) {
            if (d >= cutoffKey && info) c += info.plays || 0;
          }
        }
        if (Array.isArray(p.manualPlays)) {
          for (const mp of p.manualPlays) {
            if (!mp.date || mp.date < cutoffKey) continue;
            const bggDay = playsByDate && playsByDate[mp.date];
            if (bggDay && Array.isArray(bggDay.games)) {
              const dup = bggDay.games.some(g =>
                (mp.bggId && g.bggId && g.bggId === mp.bggId) ||
                (g.name && norm(g.name) === norm(mp.title))
              );
              if (dup) continue;
            }
            c += 1;
          }
        }
        return c;
      };

      // Soglie di "ricchezza" per ciascuna lens. Sotto la soglia, evitiamo
      // di partire da quella lens (esperienza povera). Cascade verso lens
      // più ampia finché non troviamo un periodo abbastanza ricco.
      const monthPlays = countByPrefix(monthKey);
      if (monthPlays >= 3) return 'month';
      const last30 = countLast30();
      if (last30 >= 3) return 'last30';
      const yearPlays = countByPrefix(yearKey);
      if (yearPlays >= 5) return 'year';
      return 'all';
    }

    // ────────────────────────────────────────
    // 4. IL TUO CALENDARIO — heatmap + timeline
    // ────────────────────────────────────────
    renderCalendar() {
      const wrap = this.root.querySelector('[data-fp-calendar]');
      const content = this.root.querySelector('[data-fp-cal-content]');
      if (!wrap || !content) return;

      const playsByDate = this.collectPlaysByDate();
      // SEMPRE visibile: anche con 0 partite mostriamo la heatmap vuota
      // (esperienza coerente con BGG import vuoto) + CTA per registrare.
      this.calPlaysByDate = playsByDate;
      wrap.hidden = false;
      this.renderCalendarView();

      // Se nessun dato, aggiungi sotto un CTA "Registra partita" + microcopy
      if (Object.keys(playsByDate).length === 0) {
        content.insertAdjacentHTML('beforeend',
          '<div class="fp-section-cta">' +
            '<p class="fp-section-cta__text">📅 La heatmap si accende a ogni partita. <strong>Registra la prima</strong> e guarda crescere il tuo anno di gioco.</p>' +
            '<button type="button" class="fp-section-cta__btn" data-fm-log-play>🎲 Registra una partita</button>' +
          '</div>'
        );
      }
    }

    /**
     * Aggrega plays per data in formato { 'YYYY-MM-DD': [{ title, bggId, productImg, plays }, ...] }
     *
     * Priorità fonti:
     *  1. playsActivity.playsByDate (worker v7+) — partite REALI per giorno (count corretto)
     *  2. fallback topPlayed.lastPlayed con count=1 (vecchi profili) — meglio gonfiare di 0
     *     che di 100x: 1 entry "evento giocato quel giorno" senza presumere quante partite
     *  3. manualPlays — sempre 1 per entry (corretto by design)
     */
    collectPlaysByDate() {
      const out = {};
      const act = this.profile.playsActivity;

      // FONTE 1 — playsByDate dal worker (v7+): conteggio reale per giorno
      if (act && act.playsByDate && typeof act.playsByDate === 'object') {
        for (const [date, info] of Object.entries(act.playsByDate)) {
          if (!info) continue;
          if (!out[date]) out[date] = [];
          const games = (info.games || []);
          for (const g of games) {
            const product = info.topBggId ? this.products.find(p => p.bgg === info.topBggId) : null;
            out[date].push({
              title: g.name,
              bggId: info.topBggId || null,
              img: product ? product.img : null,
              plays: g.plays || 1
            });
          }
          // Se per qualche motivo games è vuoto ma plays>0, almeno un evento generico
          if (games.length === 0 && info.plays > 0) {
            out[date].push({ title: 'Partita BGG', bggId: null, img: null, plays: info.plays });
          }
        }
      }
      // FONTE 2 — fallback topPlayed (per profili vecchi senza playsByDate)
      else if (act && act.topPlayed) {
        for (const g of act.topPlayed) {
          if (!g.lastPlayed) continue;
          if (!out[g.lastPlayed]) out[g.lastPlayed] = [];
          const product = g.bggId ? this.products.find(p => p.bgg === g.bggId) : null;
          out[g.lastPlayed].push({
            title: g.name,
            bggId: g.bggId,
            img: product ? product.img : null,
            plays: 1 // FIX BUG: era g.plays (totale di sempre) → marzo gonfiato di 244
          });
        }
      }

      // FONTE 3 — Manual plays con date precise (sempre 1 per entry).
      // DEDUP 2026-05-25: se la stessa partita è GIÀ presente da BGG (FONTE 1) per
      // la medesima data (stesso gioco), NON la ricontiamo — la arricchiamo solo con
      // il flag manual + extras. Caso Danilo: ha loggato su FrogMatch una partita che
      // è anche su BGG → prima contava doppio (+1 partita, +durata).
      // FIX 2026-06-07: il dedup match SOLO entry da BGG (non manual). Altrimenti
      // 2 manualPlays dello stesso gioco nello stesso giorno collassavano a 1.
      // Caso Andrea: ieri 2 partite stesso gioco → calendario ne vedeva 1.
      if (this.profile.manualPlays) {
        const norm = (s) => (s || '').toLowerCase().trim();
        for (const p of this.profile.manualPlays) {
          if (!p.date) continue;
          if (!out[p.date]) out[p.date] = [];
          // Cerca SOLO tra le entry NON manual (cioè da BGG FONTE 1).
          // Se trovo una manual già presente → quella era una manualPlay precedente,
          // non è la stessa partita: la nuova va aggiunta come entry separata.
          const existing = out[p.date].find(e =>
            !e.manual && (
              (p.bggId && e.bggId && e.bggId === p.bggId) ||
              (e.title && p.title && norm(e.title) === norm(p.title))
            )
          );
          if (existing) {
            // Stessa partita già contata via BGG → non duplicare, solo arricchisci
            existing.manual = true;
            if (Array.isArray(p.extras) && p.extras.length > 0) existing.extras = p.extras;
            continue;
          }
          const product = p.productId ? this.products.find(x => String(x.id) === String(p.productId)) : null;
          out[p.date].push({
            title: p.title,
            bggId: p.bggId,
            img: product ? product.img : null,
            plays: 1,
            manual: true,
            extras: Array.isArray(p.extras) ? p.extras : []
          });
        }
      }
      return out;
    }

    renderCalendarView() {
      const content = this.root.querySelector('[data-fp-cal-content]');
      if (!content) return;
      // Blocco unico "statistiche del mese": obiettivo + ultime settimane insieme
      // (prima erano due card separate → ridondante). Record/abitudini restano sotto.
      const pbd = this.calPlaysByDate || {};
      const hasPlays = Object.keys(pbd).length > 0;
      if (hasPlays) {
        content.innerHTML = '<div class="fp-statblock">' +
          this.renderChallengeGoal(pbd) +
          this.renderCalendarRecent() +
        '</div>';
        this.bindChallengeGoal();
      } else {
        content.innerHTML = this.renderCalendarRecent();
      }
      this.bindCalendarDays();
    }

    /**
     * Calcola KPI calendario: giorni giocati, miglior mese, streak max consecutivi
     */
    computeCalendarStats() {
      const playsByDate = this.calPlaysByDate || {};
      const dates = Object.keys(playsByDate).sort();
      const monthNamesShort = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];

      const daysPlayed = dates.length;

      // Miglior mese (per numero plays totali)
      const monthAgg = {};
      for (const d of dates) {
        const key = d.slice(0, 7);
        if (!monthAgg[key]) monthAgg[key] = 0;
        for (const p of playsByDate[d]) monthAgg[key] += p.plays || 1;
      }
      let bestMonthKey = null, bestMonthCount = 0;
      for (const k in monthAgg) {
        if (monthAgg[k] > bestMonthCount) { bestMonthCount = monthAgg[k]; bestMonthKey = k; }
      }
      let bestMonthLabel = '—';
      if (bestMonthKey) {
        const [y, m] = bestMonthKey.split('-');
        bestMonthLabel = monthNamesShort[parseInt(m, 10) - 1] + ' ’' + y.slice(2);
      }

      // Streak max: giorni consecutivi con almeno 1 play
      let maxStreak = 0, curStreak = 0, prevTs = null;
      const ONE_DAY = 86400000;
      for (const dStr of dates) {
        const ts = new Date(dStr + 'T00:00:00').getTime();
        if (prevTs !== null && ts - prevTs === ONE_DAY) {
          curStreak += 1;
        } else {
          curStreak = 1;
        }
        if (curStreak > maxStreak) maxStreak = curStreak;
        prevTs = ts;
      }

      // Ritmo mensile: ultimi 12 mesi (per le barre) + media partite/mese attivo.
      const now2 = new Date();
      let totalPlays = 0, activeMonths = 0;
      for (const k in monthAgg) { totalPlays += monthAgg[k]; if (monthAgg[k] > 0) activeMonths += 1; }
      const monthly = [];
      for (let i = 11; i >= 0; i--) {
        const d = new Date(now2.getFullYear(), now2.getMonth() - i, 1);
        const key = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
        monthly.push({ key, label: monthNamesShort[d.getMonth()], month: d.getMonth(), year: d.getFullYear(), count: monthAgg[key] || 0, isCurrent: i === 0 });
      }
      const avgPerMonth = activeMonths > 0 ? Math.round(totalPlays / activeMonths) : 0;

      return { daysPlayed, bestMonthLabel, bestMonthCount, maxStreak, monthly, avgPerMonth, totalPlays };
    }

    renderCalendarStatBand(s) {
      return '<div class="fp-cal-stats">' +
        '<div class="fp-cal-stat"><span class="fp-cal-stat__num">' + s.daysPlayed + '</span><span class="fp-cal-stat__label">giorni giocati</span></div>' +
        '<div class="fp-cal-stat"><span class="fp-cal-stat__num">' + (s.bestMonthCount || 0) + '</span><span class="fp-cal-stat__label">miglior mese · ' + s.bestMonthLabel + '</span></div>' +
        '<div class="fp-cal-stat"><span class="fp-cal-stat__num">' + (s.avgPerMonth || 0) + '</span><span class="fp-cal-stat__label">media partite / mese</span></div>' +
      '</div>';
    }

    /**
     * Ritmo mensile (sostituisce la heatmap GitHub a celle-giorno, troppo vuota per i
     * giochi da tavolo). Una barra per mese, ultimi 12 mesi — racconta i picchi/valli
     * senza il deserto di giorni vuoti. Mese corrente evidenziato.
     */
    renderCalendarRhythm(s) {
      const monthly = (s && s.monthly) || [];
      const max = monthly.reduce((mx, m) => Math.max(mx, m.count), 0);
      const bars = monthly.map(m => {
        const pct = max > 0 ? Math.round((m.count / max) * 100) : 0;
        const h = m.count > 0 ? Math.max(8, pct) : 0;
        return '<div class="fp-cal-rh__col' + (m.isCurrent ? ' is-current' : '') + '" title="' + m.label + ' ' + m.year + ': ' + m.count + (m.count === 1 ? ' partita' : ' partite') + '">' +
          '<span class="fp-cal-rh__val">' + (m.count > 0 ? m.count : '') + '</span>' +
          '<div class="fp-cal-rh__bar-wrap"><div class="fp-cal-rh__bar" style="height:' + h + '%"></div></div>' +
          '<span class="fp-cal-rh__mlabel">' + escapeHtml(m.label) + '</span>' +
        '</div>';
      }).join('');
      return '<p class="fp-cal-rh__caption">Il tuo ritmo · ultimi 12 mesi</p>' +
        '<div class="fp-cal-rh">' + bars + '</div>';
    }

    /**
     * "Le tue ultime settimane": texture giorno-per-giorno RECENTE (6 settimane).
     * È l'unico angolo non-doppione: "Il tuo momento" dà gli aggregati, qui il QUANDO.
     * Niente copertine (sarebbero come lo shelf/giochi del cuore). Solo intensità + recency.
     */
    renderCalendarRecent() {
      const pbd = this.calPlaysByDate || {};
      const today = new Date(); today.setHours(0, 0, 0, 0);
      const todayTs = today.getTime();
      const ONE = 86400000;
      const monthShort = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];

      const groupDay = (plays) => {
        const g = {};
        plays.forEach(p => { const t = p.title || 'Sconosciuto'; g[t] = (g[t] || 0) + (p.plays || 1); });
        const sorted = Object.entries(g).sort((a, b) => b[1] - a[1]);
        const shown = sorted.slice(0, 3).map(([n, c]) => n + (c > 1 ? ' ×' + c : '')).join(' · ');
        return shown + (sorted.length > 3 ? ' · +' + (sorted.length - 3) : '');
      };

      // Recency: partite ultimi 30 giorni + ultima volta
      const cutoff30 = todayTs - 29 * ONE;
      let recent30 = 0, lastTs = null;
      for (const d in pbd) {
        const ts = new Date(d + 'T00:00:00').getTime();
        const total = (pbd[d] || []).reduce((s, p) => s + (p.plays || 1), 0);
        if (total > 0) {
          if (ts >= cutoff30) recent30 += total;
          if (lastTs === null || ts > lastTs) lastTs = ts;
        }
      }
      let lastLabel = '—';
      if (lastTs !== null) {
        const diff = Math.round((todayTs - lastTs) / ONE);
        lastLabel = diff <= 0 ? 'oggi' : (diff === 1 ? 'ieri' : diff + ' giorni fa');
      }

      // Griglia ~30 giorni (5 settimane lun→dom) in SVG (robusta) + celle CLICCABILI
      // con etichette giorni/mesi e oggi evidenziato. Tap su un giorno → pannello dettaglio.
      const WEEKS = 5, CELL = 20, GAP = 5, STEP = CELL + GAP, LEFT = 16, TOP = 14;
      const PALETTE = ['#EDEAE2', '#C7E6D2', '#9FD3B4', '#5CAE83', '#2D7A4F'];
      const wd = ['L', 'M', 'M', 'G', 'V', 'S', 'D'];
      const todayIso = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
      const dow = (today.getDay() + 6) % 7; // 0 = lunedì
      const cur = new Date(today); cur.setDate(cur.getDate() - dow - (WEEKS - 1) * 7);
      let rects = '', labels = '';
      for (let r = 0; r < 7; r++) labels += '<text x="' + (LEFT - 5) + '" y="' + (TOP + r * STEP + CELL * 0.72) + '" text-anchor="end" font-size="9" fill="#a8a39a">' + wd[r] + '</text>';
      let lastMo = -1, lastActiveIso = null;
      for (let w = 0; w < WEEKS; w++) {
        for (let r = 0; r < 7; r++) {
          const mo = cur.getMonth();
          const iso = cur.getFullYear() + '-' + String(mo + 1).padStart(2, '0') + '-' + String(cur.getDate()).padStart(2, '0');
          const future = cur.getTime() > todayTs;
          const arr = (!future && pbd[iso]) ? pbd[iso] : null;
          const total = arr ? arr.reduce((s, p) => s + (p.plays || 1), 0) : 0;
          const lvl = total === 0 ? 0 : total >= 4 ? 4 : total >= 3 ? 3 : total >= 2 ? 2 : 1;
          const px = LEFT + w * STEP, py = TOP + r * STEP;
          if (!future) {
            if (total > 0) lastActiveIso = iso;
            const ring = iso === todayIso ? ' stroke="#1F1A14" stroke-width="1.5"' : '';
            rects += '<rect x="' + px + '" y="' + py + '" width="' + CELL + '" height="' + CELL + '" rx="3" fill="' + PALETTE[lvl] + '" data-iso="' + iso + '" style="cursor:pointer"' + ring + '></rect>';
            if (r === 0 && mo !== lastMo) { labels += '<text x="' + px + '" y="10" font-size="9" fill="#a8a39a">' + monthShort[mo].toUpperCase() + '</text>'; lastMo = mo; }
          }
          cur.setDate(cur.getDate() + 1);
        }
      }
      const SVGW = LEFT + WEEKS * STEP - GAP, SVGH = TOP + 7 * STEP - GAP;
      const grid = '<svg width="' + SVGW + '" height="' + SVGH + '" viewBox="0 0 ' + SVGW + ' ' + SVGH + '" data-fp-cal-grid role="img" aria-label="Calendario ultimi 30 giorni, tocca un giorno">' + labels + rects + '</svg>';
      const legSq = (c) => '<svg width="11" height="11" viewBox="0 0 11 11" style="vertical-align:-1px"><rect width="11" height="11" rx="2" fill="' + c + '"/></svg>';
      const defaultIso = lastActiveIso || todayIso;

      return '<div class="fp-cal-rc">' +
        '<div class="fp-cal-rc__gridwrap">' + grid + '</div>' +
        '<div class="fp-cal-rc__detail">' +
          '<p class="fp-cal-rc__caption">Ultimi 30 giorni · <strong>' + recent30 + '</strong> ' + (recent30 === 1 ? 'partita' : 'partite') + ' · ultima: ' + lastLabel + '</p>' +
          '<div class="fp-cal-rc__day" data-fp-cal-detail>' + this.renderDayDetail(defaultIso) + '</div>' +
          '<div class="fp-cal-rc__legend">Meno ' + PALETTE.map(legSq).join('') + ' Più</div>' +
        '</div>' +
      '</div>';
    }

    /** Dettaglio di un giorno: cosa hai giocato (nome + ×N). */
    renderDayDetail(iso) {
      const pbd = this.calPlaysByDate || {};
      const arr = pbd[iso];
      const monthShort = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
      const dowFull = ['Domenica','Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'];
      const d = new Date(iso + 'T00:00:00');
      const dateLabel = dowFull[d.getDay()] + ' ' + d.getDate() + ' ' + monthShort[d.getMonth()];
      if (!arr || arr.length === 0) {
        return '<p class="fp-cal-rc__dayttl">' + dateLabel + '</p><p class="fp-cal-rc__dayempty">Nessuna partita registrata.</p>';
      }
      const g = {};
      arr.forEach(p => { const t = p.title || 'Sconosciuto'; g[t] = (g[t] || 0) + (p.plays || 1); });
      const tot = arr.reduce((s, p) => s + (p.plays || 1), 0);
      const items = Object.entries(g).sort((a, b) => b[1] - a[1]).map(([n, c]) =>
        '<li class="fp-cal-rc__dayitem">' + escapeHtml(n) + (c > 1 ? ' <span class="fp-cal-rc__x">×' + c + '</span>' : '') + '</li>').join('');
      return '<p class="fp-cal-rc__dayttl">' + dateLabel + ' · <strong>' + tot + '</strong> ' + (tot === 1 ? 'partita' : 'partite') + '</p>' +
        '<ul class="fp-cal-rc__daylist">' + items + '</ul>';
    }

    /** Click sui giorni del calendario → mostra le partite di quel giorno nel pannello. */
    bindCalendarDays() {
      const grid = this.root.querySelector('[data-fp-cal-grid]');
      const detail = this.root.querySelector('[data-fp-cal-detail]');
      if (!grid || !detail) return;
      grid.addEventListener('click', (e) => {
        const cell = e.target.closest('[data-iso]');
        if (!cell) return;
        grid.querySelectorAll('[data-iso]').forEach(c => { c.setAttribute('stroke', 'transparent'); c.setAttribute('stroke-width', '0'); });
        cell.setAttribute('stroke', '#1F1A14'); cell.setAttribute('stroke-width', '2');
        detail.innerHTML = this.renderDayDetail(cell.getAttribute('data-iso'));
      });
    }

    /**
     * Heatmap GitHub-style: tabella 7 righe (Lun..Dom) × N colonne (settimane).
     * Range adattivo da prima play (min 12 mesi, max 24 mesi).
     * Niente cover, solo intensità verde Frogames.
     */
    renderCalendarHeatmap() {
      const playsByDate = this.calPlaysByDate || {};
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const monthLabels = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];

      // SEMPRE 13 mesi (mese corrente + 12 precedenti). Le plays più vecchie sono comunque visibili
      // nella timeline del Viaggio Frogger e nel drill "Le tue partite".
      // Lo "scorrimento" avviene in blocco al 1° del mese successivo (mai mezzi mesi).
      const monthsBack = 13;

      const groupCellsToString = (plays) => {
        const grouped = {};
        plays.forEach(p => {
          const t = p.title || 'Sconosciuto';
          grouped[t] = (grouped[t] || 0) + (p.plays || 1);
        });
        const sorted = Object.entries(grouped).sort((a, b) => b[1] - a[1]);
        if (sorted.length === 1) return sorted[0][0] + (sorted[0][1] > 1 ? ' ×' + sorted[0][1] : '');
        if (sorted.length <= 3) return sorted.map(([n, c]) => n + (c > 1 ? ' ×' + c : '')).join(' · ');
        const top = sorted.slice(0, 2).map(([n, c]) => n + (c > 1 ? ' ×' + c : '')).join(' · ');
        return top + ' · +' + (sorted.length - 2) + ' altri';
      };

      // ── SVG layout costanti ──
      const CELL = 13;
      const GAP = 2;
      const STEP = CELL + GAP; // 15
      const HDR = 22;          // spazio label mese
      const GRID_H = 7 * CELL + 6 * GAP; // 7 righe = 103
      const TOTAL_H = HDR + GRID_H + 4;
      const MONTH_GAP = 10;
      const NEWYEAR_GAP = 14;

      // ── Genera mesi ──
      // Layout COMPATTO: giorno 1 in alto-sinistra, riempi colonna per colonna (top→bottom),
      // poi colonna successiva. Padding solo in fondo all'ultima colonna.
      const months = [];
      for (let i = monthsBack - 1; i >= 0; i--) {
        const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        const year = d.getFullYear();
        const monthIdx = d.getMonth();
        const daysInMonth = new Date(year, monthIdx + 1, 0).getDate();

        // Costruisci array celle in ordine 1, 2, 3, ..., daysInMonth
        // poi distribuisci in colonne da 7 (col 0 = giorni 1-7, col 1 = 8-14, ...)
        const cellsLinear = [];
        for (let day = 1; day <= daysInMonth; day++) {
          const cellDate = new Date(year, monthIdx, day);
          if (cellDate > today) break;
          const iso = year + '-' + String(monthIdx + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
          const plays = playsByDate[iso] || null;
          const totalPlays = plays ? plays.reduce((s, p) => s + (p.plays || 1), 0) : 0;
          cellsLinear.push({ iso, plays, totalPlays, day });
        }

        // Spezza in colonne da 7 righe
        const numCols = Math.ceil(daysInMonth / 7);
        const weeks = [];
        for (let col = 0; col < numCols; col++) {
          const colArr = new Array(7).fill(null);
          for (let row = 0; row < 7; row++) {
            const idx = col * 7 + row;
            if (idx < cellsLinear.length) colArr[row] = cellsLinear[idx];
          }
          weeks.push(colArr);
        }
        months.push({ year, monthIdx, weeks });
      }

      // ── Costruisci SVG ──
      let svgInner = '';
      let cursorX = 4; // padding sinistro iniziale
      let lastYear = -1;
      months.forEach(m => {
        const isNewYear = (lastYear !== -1 && m.year !== lastYear);
        if (isNewYear) {
          // divider tratteggiato verde
          const dx = cursorX + (NEWYEAR_GAP / 2);
          svgInner += '<line x1="' + dx + '" y1="6" x2="' + dx + '" y2="' + (TOTAL_H - 4) + '" stroke="rgba(45,122,79,0.5)" stroke-width="1" stroke-dasharray="3 3" />';
          cursorX += NEWYEAR_GAP;
        }

        // Label mese (+ anno se cambia)
        const showYear = (m.year !== lastYear);
        const labelTxt = monthLabels[m.monthIdx];
        svgInner += '<text x="' + cursorX + '" y="14" class="fp-hm__svgtxt">' + labelTxt + '</text>';
        if (showYear) {
          const xOffset = cursorX + labelTxt.length * 7 + 4;
          svgInner += '<text x="' + xOffset + '" y="14" class="fp-hm__svgyr">’' + String(m.year).slice(2) + '</text>';
        }

        // Rect per ogni giorno
        for (let col = 0; col < m.weeks.length; col++) {
          for (let row = 0; row < 7; row++) {
            const cell = m.weeks[col][row];
            if (!cell) continue; // padding: niente rect
            const x = cursorX + col * STEP;
            const y = HDR + row * STEP;
            let fill, attrs = '';
            if (cell.totalPlays === 0) {
              fill = 'rgba(31,26,20,0.07)';
              attrs = ' data-fp-hm-date="' + cell.iso + '" data-fp-hm-plays="0"';
            } else {
              const lvl = cell.totalPlays >= 5 ? 4 : cell.totalPlays >= 3 ? 3 : cell.totalPlays === 2 ? 2 : 1;
              const fills = ['', 'rgba(45,122,79,0.32)', 'rgba(45,122,79,0.55)', 'rgba(45,122,79,0.78)', '#2D7A4F'];
              fill = fills[lvl];
              const titles = groupCellsToString(cell.plays);
              attrs = ' data-fp-hm-date="' + cell.iso + '" data-fp-hm-plays="' + cell.totalPlays + '" data-fp-hm-titles="' + escapeHtml(titles) + '" class="fp-hm__rect--int"';
            }
            svgInner += '<rect x="' + x + '" y="' + y + '" width="' + CELL + '" height="' + CELL + '" rx="2" fill="' + fill + '"' + attrs + ' />';
          }
        }

        cursorX += m.weeks.length * STEP - GAP + MONTH_GAP;
        lastYear = m.year;
      });

      const totalW = cursorX + 4;

      const legend = '<div class="fp-hm__legend">' +
        '<span class="fp-hm__legend-text">Meno</span>' +
        '<span class="fp-hm__legend-sw" style="background:rgba(31,26,20,0.07)"></span>' +
        '<span class="fp-hm__legend-sw" style="background:rgba(45,122,79,0.32)"></span>' +
        '<span class="fp-hm__legend-sw" style="background:rgba(45,122,79,0.55)"></span>' +
        '<span class="fp-hm__legend-sw" style="background:rgba(45,122,79,0.78)"></span>' +
        '<span class="fp-hm__legend-sw" style="background:#2D7A4F"></span>' +
        '<span class="fp-hm__legend-text">Più</span>' +
      '</div>';

      return '<div class="fp-hm">' +
        '<div class="fp-hm__scroll">' +
          '<svg class="fp-hm__svg" width="' + totalW + '" height="' + TOTAL_H + '" viewBox="0 0 ' + totalW + ' ' + TOTAL_H + '" xmlns="http://www.w3.org/2000/svg">' + svgInner + '</svg>' +
        '</div>' +
        legend +
        '<div class="fp-hm__tooltip" data-fp-hm-tooltip hidden></div>' +
      '</div>';
    }

    /**
     * Bind tooltip dinamico per heatmap (hover desktop, tap mobile).
     */
    bindCalendarTooltip() {
      const root = this.root;
      // Heatmap
      const hmCells = root.querySelectorAll('[data-fp-hm-date]');
      const hmTip = root.querySelector('[data-fp-hm-tooltip]');
      const hmContainer = root.querySelector('.fp-hm');
      const monthNamesLong = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
      const showHmTip = (cell, e) => {
        if (!hmTip || !hmContainer) return;
        const iso = cell.dataset.fpHmDate;
        const plays = parseInt(cell.dataset.fpHmPlays || '0', 10);
        const titles = cell.dataset.fpHmTitles || '';
        const [y, m, d] = iso.split('-');
        const dateLabel = parseInt(d, 10) + ' ' + monthNamesLong[parseInt(m, 10) - 1] + ' ' + y;
        let body;
        if (plays === 0) {
          body = '<strong>' + dateLabel + '</strong><br>Nessuna partita';
        } else {
          body = '<strong>' + dateLabel + '</strong><br>' + plays + ' ' + (plays === 1 ? 'partita' : 'partite') +
            (titles ? '<br><span class="fp-hm__tooltip-titles">' + titles + '</span>' : '');
        }
        hmTip.innerHTML = body;
        hmTip.hidden = false;
        const rect = cell.getBoundingClientRect();
        const cRect = hmContainer.getBoundingClientRect();
        hmTip.style.left = (rect.left - cRect.left + rect.width / 2) + 'px';
        hmTip.style.top = (rect.top - cRect.top - 10) + 'px';
      };
      const hideHmTip = () => { if (hmTip) hmTip.hidden = true; };
      hmCells.forEach(cell => {
        cell.addEventListener('mouseenter', (e) => showHmTip(cell, e));
        cell.addEventListener('mouseleave', hideHmTip);
        // CLICK: se ha partite → apri modal con dettagli. Senza partite → solo tooltip.
        cell.addEventListener('click', (e) => {
          e.stopPropagation();
          const plays = parseInt(cell.dataset.fpHmPlays || '0', 10);
          if (plays > 0) {
            hideHmTip();
            this.openCalendarDayModal(cell.dataset.fpHmDate);
          } else {
            showHmTip(cell, e);
          }
        });
      });
      if (hmContainer) {
        hmContainer.addEventListener('click', (e) => {
          if (!e.target.closest('[data-fp-hm-date]')) hideHmTip();
        });
      }
    }

    /**
     * Apre modal con il dettaglio delle partite di un giorno.
     * Mostra: data, lista giochi con cover + numero partite + meta (minuti/voto/giocatori se manuale).
     */
    openCalendarDayModal(iso) {
      if (!iso) return;
      const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
      const dayPlays = playsByDate[iso] || [];
      if (dayPlays.length === 0) return;

      const monthNames = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
      const [y, m, d] = iso.split('-');
      const dateLabel = parseInt(d, 10) + ' ' + monthNames[parseInt(m, 10) - 1] + ' ' + y;

      // Aggrega per gioco (stesso titolo su stesso giorno → somma plays)
      const byGame = {};
      for (const p of dayPlays) {
        const key = p.title || 'Sconosciuto';
        if (!byGame[key]) {
          byGame[key] = {
            title: key,
            bggId: p.bggId || null,
            img: p.img || null,
            plays: 0,
            manualEntries: [] // per dettagli minuti/voto/giocatori
          };
        }
        byGame[key].plays += (p.plays || 1);
        if (p.manual) byGame[key].manualEntries.push(p);
      }
      const games = Object.values(byGame).sort((a, b) => b.plays - a.plays);
      const totalPlays = games.reduce((s, g) => s + (g.plays || 0), 0);

      // Cerca manualPlays per dettagli aggiuntivi
      const manualOnDate = (this.profile.manualPlays || []).filter(mp => mp.date === iso);
      const manualByTitle = {};
      manualOnDate.forEach(mp => {
        const key = mp.title || 'Sconosciuto';
        if (!manualByTitle[key]) manualByTitle[key] = [];
        manualByTitle[key].push(mp);
      });

      const escapeHtmlFn = (typeof escapeHtml === 'function') ? escapeHtml : ((s) => String(s || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])));

      const gamesHtml = games.map(g => {
        const cover = g.img
          ? '<img class="fp-cal-modal__cover" src="' + escapeHtmlFn(g.img) + '" alt="" loading="lazy">'
          : '<span class="fp-cal-modal__cover fp-cal-modal__cover--noimg">🎲</span>';
        const playsLabel = g.plays + (g.plays === 1 ? ' partita' : ' partite');
        const manuals = manualByTitle[g.title] || [];
        const meta = [];
        // Aggrega tutti gli extras delle manualPlays di questo gioco per questo giorno.
        // Se l'utente ha loggato 2 partite di Villainous lo stesso giorno con set diversi,
        // mostriamo l'unione delle espansioni/set usati (deduplicati per bggId).
        const extrasMap = new Map(); // bggId -> {name, type}
        manuals.forEach(mp => {
          const parts = [];
          if (mp.minutes && mp.minutes > 0) {
            const hrs = (mp.minutes / 60).toFixed(1);
            parts.push(mp.minutes >= 60 ? hrs + 'h' : mp.minutes + ' min');
          }
          if (mp.players) parts.push(mp.players + ' giocatori');
          if (mp.rating) parts.push('⭐ ' + mp.rating);
          if (parts.length > 0) meta.push(parts.join(' · '));
          // Colleziona extras (espansioni / set combinati)
          if (Array.isArray(mp.extras)) {
            mp.extras.forEach(e => {
              if (e && e.bggId && !extrasMap.has(e.bggId)) {
                extrasMap.set(e.bggId, { name: e.name, type: e.type || 'expansion' });
              }
            });
          }
        });
        const metaHtml = meta.length > 0
          ? '<div class="fp-cal-modal__meta">' + meta.map(m => '<span>' + escapeHtmlFn(m) + '</span>').join('') + '</div>'
          : '';
        // Render extras differenziato per tipo (espansione vs set combinato)
        let extrasHtml = '';
        if (extrasMap.size > 0) {
          const exps = [];
          const stds = [];
          extrasMap.forEach(v => { (v.type === 'standalone' ? stds : exps).push(v); });
          const rows = [];
          if (exps.length > 0) {
            rows.push('<div class="fp-cal-modal__extra fp-cal-modal__extra--exp">🃏 + ' +
              exps.map(e => escapeHtmlFn(e.name)).join(' · ') + '</div>');
          }
          if (stds.length > 0) {
            rows.push('<div class="fp-cal-modal__extra fp-cal-modal__extra--std">🎁 Set combinato: ' +
              stds.map(e => escapeHtmlFn(e.name)).join(' + ') + '</div>');
          }
          extrasHtml = '<div class="fp-cal-modal__extras">' + rows.join('') + '</div>';
        }
        return '<div class="fp-cal-modal__game">' +
          cover +
          '<div class="fp-cal-modal__game-body">' +
            '<div class="fp-cal-modal__game-title">' + escapeHtmlFn(g.title) + '</div>' +
            '<div class="fp-cal-modal__game-plays">' + playsLabel + '</div>' +
            metaHtml +
            extrasHtml +
          '</div>' +
        '</div>';
      }).join('');

      // Build overlay
      const existing = document.querySelector('[data-fp-cal-modal-overlay]');
      if (existing) existing.remove();
      const overlay = document.createElement('div');
      overlay.setAttribute('data-fp-cal-modal-overlay', '1');
      overlay.className = 'fp-cal-modal-overlay';
      overlay.innerHTML = '<div class="fp-cal-modal" role="dialog" aria-label="Dettagli partite">' +
        '<button class="fp-cal-modal__close" aria-label="Chiudi">×</button>' +
        '<div class="fp-cal-modal__head">' +
          '<div class="fp-cal-modal__date">📅 ' + escapeHtmlFn(dateLabel) + '</div>' +
          '<div class="fp-cal-modal__total">' + totalPlays + (totalPlays === 1 ? ' partita registrata' : ' partite registrate') + '</div>' +
        '</div>' +
        '<div class="fp-cal-modal__games">' + gamesHtml + '</div>' +
      '</div>';
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';

      const close = () => {
        overlay.remove();
        document.body.style.overflow = '';
      };
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) close();
      });
      overlay.querySelector('.fp-cal-modal__close').addEventListener('click', close);
      document.addEventListener('keydown', function onKey(e) {
        if (e.key === 'Escape') {
          close();
          document.removeEventListener('keydown', onKey);
        }
      });
    }

    // ────────────────────────────────────────
    // 4b. LE TUE SFIDE — Goal mensile + Record + Abitudini + Community (coming soon)
    // ────────────────────────────────────────
    renderChallenges() {
      const wrap = this.root.querySelector('[data-fp-challenges]');
      const body = this.root.querySelector('[data-fp-challenges-body]');
      if (!wrap || !body) return;

      const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
      wrap.hidden = false;

      // Empty state: anche con 0 plays mostra goal modificabile + community soon
      if (Object.keys(playsByDate).length === 0) {
        const monthLabels = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
        const now = new Date();
        const monthName = monthLabels[now.getMonth()];

        // Mostra il goal anche senza plays: il tester può fissarlo da subito
        const stored = this.profile.monthlyGoal;
        const goalValue = (stored && typeof stored.value === 'number' && stored.value > 0) ? stored.value : null;

        const goalRing = goalValue
          ? '<svg width="120" height="120" viewBox="0 0 120 120" aria-hidden="true">' +
              '<circle cx="60" cy="60" r="50" fill="none" stroke="#f0e6c8" stroke-width="10"/>' +
              '<circle cx="60" cy="60" r="50" fill="none" stroke="#ffb800" stroke-width="10" stroke-dasharray="0 314" stroke-linecap="round" transform="rotate(-90 60 60)"/>' +
              '<text x="60" y="58" text-anchor="middle" font-size="22" font-weight="700" fill="#1f1a14">0</text>' +
              '<text x="60" y="78" text-anchor="middle" font-size="11" fill="#665">/ ' + goalValue + '</text>' +
            '</svg>'
          : '<svg width="120" height="120" viewBox="0 0 120 120" aria-hidden="true">' +
              '<circle cx="60" cy="60" r="50" fill="none" stroke="#f0e6c8" stroke-width="10"/>' +
              '<text x="60" y="58" text-anchor="middle" font-size="22" font-weight="700" fill="#998">0</text>' +
              '<text x="60" y="78" text-anchor="middle" font-size="11" fill="#aaa">/ —</text>' +
            '</svg>';

        const hintText = goalValue
          ? 'Obiettivo di ' + monthName + ': <strong>' + goalValue + ' partite</strong>. Quando registri una partita la barra si riempie.'
          : 'Imposta tu un obiettivo personale per ' + monthName + ' — quante partite vuoi giocare? Niente pressione, solo per il piacere di tracciare.';

        body.innerHTML =
          // Goal con bottone Modifica/Imposta
          '<div class="fp-ch-block fp-ch-block--goal fp-ch-block--empty">' +
            '<div class="fp-ch-block__head">' +
              '<h3 class="fp-ch-block__title">🎯 Goal di ' + monthName + '</h3>' +
              '<button type="button" class="fp-ch__goal-edit" data-fp-goal-edit aria-label="' + (goalValue ? 'Modifica obiettivo' : 'Imposta obiettivo') + '">' + (goalValue ? 'Modifica' : 'Imposta') + '</button>' +
            '</div>' +
            '<div class="fp-ch-goal__placeholder">' +
              goalRing +
              '<p class="fp-ch-goal__hint">' + hintText + '</p>' +
            '</div>' +
          '</div>' +
          // Community coming soon
          this.renderChallengeCommunity() +
          // CTA primaria
          '<div class="fp-section-cta">' +
            '<p class="fp-section-cta__text">⚡ Le statistiche complete (record, abitudini, streak) si attivano alla prima partita.</p>' +
            '<button type="button" class="fp-section-cta__btn" data-fm-log-play>🎲 Registra una partita</button>' +
          '</div>';

        // Bind bottone modifica/imposta goal anche in stato vuoto
        this.bindChallengeGoal();
        return;
      }
      this.calPlaysByDate = playsByDate;

      // L'obiettivo mensile è ora nel blocco calendario (renderCalendarView).
      // Qui: hub statistiche a 2 lenti (Persone + Giochi) + community.
      // (renderChallengeInsights record/abitudini lasciato inerte, sostituito.)
      const insightBlock = this.renderStatsHub(playsByDate);
      const communityBlock = this.renderChallengeCommunity();

      body.innerHTML = insightBlock + communityBlock;
      this.bindStatsHub();
    }

    /**
     * Calcola goal mensile suggerito = media plays/mese × 1.2 (arrotondato).
     * Override utente sovrascrive il default.
     */
    computeMonthlyGoalSuggested(playsByDate) {
      // Aggrega plays per mese
      const monthCounts = {};
      for (const d in playsByDate) {
        const m = d.slice(0, 7);
        monthCounts[m] = (monthCounts[m] || 0) + playsByDate[d].reduce((s, p) => s + (p.plays || 1), 0);
      }
      const months = Object.keys(monthCounts);
      if (months.length === 0) return 5;

      // Media solo sui mesi con plays (se mai hai giocato a luglio, non zavorra il calcolo)
      const total = Object.values(monthCounts).reduce((s, v) => s + v, 0);
      const avg = total / months.length;
      const suggested = Math.max(3, Math.round(avg * 1.2));
      return Math.min(suggested, 60); // cap sano
    }

    getMonthlyGoal(playsByDate) {
      const stored = this.profile.monthlyGoal;
      if (stored && typeof stored.value === 'number' && stored.value > 0) {
        return { value: stored.value, isAuto: false };
      }
      return { value: this.computeMonthlyGoalSuggested(playsByDate), isAuto: true };
    }

    /**
     * Blocco B — Goal mensile con anello SVG + microcopy motivazionale
     */
    renderChallengeGoal(playsByDate) {
      const monthLabels = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
      const now = new Date();
      const monthName = monthLabels[now.getMonth()];
      const curKey = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');

      // Plays del mese corrente
      let curPlays = 0;
      for (const d in playsByDate) {
        if (d.startsWith(curKey)) {
          curPlays += playsByDate[d].reduce((s, p) => s + (p.plays || 1), 0);
        }
      }

      const { value: goal, isAuto } = this.getMonthlyGoal(playsByDate);
      const pct = Math.min(100, Math.round((curPlays / goal) * 100));
      const completed = curPlays >= goal;

      // Proiezione fine mese
      const dayOfMonth = now.getDate();
      const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
      const dayFraction = dayOfMonth / daysInMonth;
      const projectedTotal = dayFraction > 0 ? Math.round(curPlays / dayFraction) : 0;
      const daysLeft = daysInMonth - dayOfMonth;

      // Microcopy motivazionale (mai negativo)
      let copy;
      if (completed) {
        copy = '🎉 Obiettivo centrato! Sei a <strong>' + curPlays + '</strong> partite, oltre il goal.';
      } else if (curPlays === 0) {
        copy = 'Inizia il mese: la prima partita vale doppio in motivazione.';
      } else if (projectedTotal >= goal) {
        copy = '<strong>A questo ritmo arrivi a ' + projectedTotal + '</strong> → ce la fai 💪';
      } else if (curPlays >= goal * 0.75) {
        copy = 'Sei a <strong>' + (goal - curPlays) + '</strong> dal traguardo, mancano ' + daysLeft + ' giorni.';
      } else {
        copy = '<strong>' + curPlays + '</strong> partite a ' + monthName + '. Continua così.';
      }

      // Anello SVG (cerchio progresso)
      const RING_R = 54;
      const RING_C = 2 * Math.PI * RING_R;
      const dashOffset = RING_C * (1 - pct / 100);

      const ringSvg = '<svg class="fp-ch-ring" width="140" height="140" viewBox="0 0 140 140">' +
        '<circle cx="70" cy="70" r="' + RING_R + '" fill="none" stroke="rgba(45,122,79,0.12)" stroke-width="10" />' +
        '<circle cx="70" cy="70" r="' + RING_R + '" fill="none" stroke="' + (completed ? '#2D7A4F' : '#5BA76B') + '" stroke-width="10" stroke-linecap="round" stroke-dasharray="' + RING_C + '" stroke-dashoffset="' + dashOffset + '" transform="rotate(-90 70 70)" />' +
        '<text x="70" y="74" text-anchor="middle" class="fp-ch-ring__num">' + curPlays + '</text>' +
        '<text x="70" y="92" text-anchor="middle" class="fp-ch-ring__den">/ ' + goal + '</text>' +
      '</svg>';

      return '<div class="fp-ch__goal">' +
        '<div class="fp-ch__goal-head">' +
          '<h3 class="fp-ch__block-title">🎯 Il tuo obiettivo di ' + monthName + '</h3>' +
          '<button type="button" class="fp-ch__goal-edit" data-fp-goal-edit aria-label="Modifica obiettivo">Modifica</button>' +
        '</div>' +
        '<div class="fp-ch__goal-body">' +
          ringSvg +
          '<div class="fp-ch__goal-info">' +
            '<p class="fp-ch__goal-copy">' + copy + '</p>' +
            (isAuto ? '<p class="fp-ch__goal-hint">💡 Ti suggeriamo <strong>' + goal + '</strong> partite (basato sulle tue medie). Cambialo come vuoi.</p>' : '') +
          '</div>' +
        '</div>' +
      '</div>';
    }

    bindChallengeGoal() {
      const editBtn = this.root.querySelector('[data-fp-goal-edit]');
      if (!editBtn || editBtn.__fpBound) return;
      editBtn.__fpBound = true;
      editBtn.addEventListener('click', () => this.openGoalEditor());
    }

    openGoalEditor() {
      const playsByDate = this.calPlaysByDate || {};
      const { value: current, isAuto } = this.getMonthlyGoal(playsByDate);
      const suggested = this.computeMonthlyGoalSuggested(playsByDate);

      // Overlay modale
      const overlay = document.createElement('div');
      overlay.className = 'fp-modal-overlay';
      overlay.innerHTML =
        '<div class="fp-modal" role="dialog" aria-modal="true" aria-label="Imposta obiettivo">' +
          '<button type="button" class="fp-modal__close" aria-label="Chiudi">×</button>' +
          '<h3 class="fp-modal__title">🎯 Quante partite vuoi giocare questo mese?</h3>' +
          '<p class="fp-modal__sub">Ti suggeriamo <strong>' + suggested + '</strong>, ma decidi tu. Niente penalità se non lo raggiungi.</p>' +
          '<div class="fp-modal__goal">' +
            '<button type="button" class="fp-modal__step" data-step="-1" aria-label="Diminuisci">−</button>' +
            '<input type="number" class="fp-modal__input" data-fp-goal-input value="' + current + '" min="1" max="200" />' +
            '<button type="button" class="fp-modal__step" data-step="+1" aria-label="Aumenta">+</button>' +
          '</div>' +
          '<div class="fp-modal__presets">' +
            (function() {
              const fixed = [
                { value: 5, label: 'Tranquillo' },
                { value: 15, label: 'Sfidante' },
                { value: 30, label: 'Eroico' },
              ];
              const filtered = fixed.filter(p => p.value !== suggested);
              return '<button type="button" class="fp-modal__preset fp-modal__preset--suggested" data-preset="' + suggested + '">Suggerito · ' + suggested + '</button>' +
                filtered.map(p => '<button type="button" class="fp-modal__preset" data-preset="' + p.value + '">' + p.label + ' · ' + p.value + '</button>').join('');
            })() +
          '</div>' +
          '<div class="fp-modal__actions">' +
            '<button type="button" class="fp-modal__btn fp-modal__btn--ghost" data-fp-goal-reset>Usa suggerito</button>' +
            '<button type="button" class="fp-modal__btn fp-modal__btn--primary" data-fp-goal-save>Salva</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(overlay);

      const input = overlay.querySelector('[data-fp-goal-input]');
      const close = () => overlay.remove();

      overlay.querySelector('.fp-modal__close').addEventListener('click', close);
      overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

      overlay.querySelectorAll('[data-step]').forEach(btn => {
        btn.addEventListener('click', () => {
          const step = parseInt(btn.dataset.step, 10);
          const cur = Math.max(1, Math.min(200, parseInt(input.value || '1', 10) + step));
          input.value = cur;
        });
      });

      overlay.querySelectorAll('[data-preset]').forEach(btn => {
        btn.addEventListener('click', () => { input.value = btn.dataset.preset; });
      });

      overlay.querySelector('[data-fp-goal-reset]').addEventListener('click', () => {
        delete this.profile.monthlyGoal;
        FM.saveProfile(this.profile);
        close();
        this.renderCalendar();   // l'anello obiettivo vive qui ora
        this.renderChallenges(); // (empty-state goal per chi ha 0 partite)
      });

      overlay.querySelector('[data-fp-goal-save]').addEventListener('click', () => {
        const v = Math.max(1, Math.min(200, parseInt(input.value || '0', 10) || 1));
        this.profile.monthlyGoal = { value: v, lastUpdated: new Date().toISOString() };
        FM.saveProfile(this.profile);
        close();
        this.renderCalendar();   // l'anello obiettivo vive qui ora
        this.renderChallenges(); // (empty-state goal per chi ha 0 partite)
      });
    }

    /**
     * Blocco C — Record + Abitudini (insights passive Spotify-Wrapped style)
     */
    renderChallengeInsights(playsByDate) {
      const records = this.computeChallengeRecords(playsByDate);
      const habits = this.computeChallengeHabits(playsByDate);

      let html = '<div class="fp-ch__insights">';

      if (records.length > 0) {
        html += '<div class="fp-ch__col">' +
          '<h3 class="fp-ch__block-title">🏅 I tuoi record</h3>' +
          '<ul class="fp-ch__records">' +
            records.map(r =>
              '<li class="fp-ch__record">' +
                '<span class="fp-ch__record-icon">' + r.icon + '</span>' +
                '<div class="fp-ch__record-body">' +
                  '<span class="fp-ch__record-label">' + escapeHtml(r.label) + '</span>' +
                  '<span class="fp-ch__record-value">' + escapeHtml(r.value) + '</span>' +
                '</div>' +
              '</li>'
            ).join('') +
          '</ul>' +
        '</div>';
      }

      if (habits.length > 0) {
        html += '<div class="fp-ch__col">' +
          '<h3 class="fp-ch__block-title">🌀 Le tue abitudini</h3>' +
          '<ul class="fp-ch__habits">' +
            habits.map(h =>
              '<li class="fp-ch__habit">' +
                '<span class="fp-ch__habit-icon">' + h.icon + '</span>' +
                '<span class="fp-ch__habit-text">' + h.text + '</span>' +
              '</li>'
            ).join('') +
          '</ul>' +
        '</div>';
      }

      html += '</div>';
      return html;
    }

    /**
     * Records personali per le Sfide.
     * Esclude quelli già nello stat band del calendario (giorni giocati, miglior mese, streak max).
     */
    computeChallengeRecords(playsByDate) {
      const out = [];
      const dates = Object.keys(playsByDate);

      // Più partite in un giorno
      let bestDay = null, bestDayPlays = 0;
      dates.forEach(d => {
        const tot = playsByDate[d].reduce((s, p) => s + (p.plays || 1), 0);
        if (tot > bestDayPlays) { bestDayPlays = tot; bestDay = d; }
      });
      if (bestDayPlays > 0) {
        const monthNames = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
        const [y, m, dy] = bestDay.split('-');
        const label = parseInt(dy, 10) + ' ' + monthNames[parseInt(m, 10) - 1] + ' ’' + y.slice(2);
        out.push({ icon: '🎯', label: 'Più partite in un giorno', value: bestDayPlays + ' (' + label + ')' });
      }

      // Più giochi diversi in un mese
      const monthGames = {};
      dates.forEach(d => {
        const m = d.slice(0, 7);
        if (!monthGames[m]) monthGames[m] = new Set();
        playsByDate[d].forEach(p => monthGames[m].add(p.bggId || p.title));
      });
      let bestMonthVar = null, bestMonthVarCount = 0;
      Object.entries(monthGames).forEach(([m, set]) => {
        if (set.size > bestMonthVarCount) { bestMonthVarCount = set.size; bestMonthVar = m; }
      });
      if (bestMonthVarCount > 0) {
        const monthNames = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
        const [y, m] = bestMonthVar.split('-');
        out.push({ icon: '🌈', label: 'Più giochi diversi in un mese', value: bestMonthVarCount + ' titoli (' + monthNames[parseInt(m, 10) - 1] + ' ’' + y.slice(2) + ')' });
      }

      // Streak corrente (giorni consecutivi che includono oggi o ieri)
      const sorted = dates.slice().sort().reverse();
      if (sorted.length > 0) {
        const ONE_DAY = 86400000;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const todayTs = today.getTime();
        let streak = 0;
        let expectedTs = todayTs;
        let started = false;
        for (const d of sorted) {
          const ts = new Date(d + 'T00:00:00').getTime();
          if (!started) {
            if (ts === todayTs || ts === todayTs - ONE_DAY) {
              streak = 1;
              expectedTs = ts - ONE_DAY;
              started = true;
            } else break;
          } else {
            if (ts === expectedTs) {
              streak += 1;
              expectedTs -= ONE_DAY;
            } else break;
          }
        }
        if (streak > 0) {
          out.push({ icon: '🔥', label: 'Streak corrente', value: streak + ' giorn' + (streak === 1 ? 'o' : 'i') + ' di fila' });
        }
      }

      // Gioco più giocato REALE (BGG + manuali, deduplicato). Prima contava i GIORNI
      // distinti ("più sessioni") → mostrava un gioco diverso dal più giocato vero
      // (es. Maquis 6 giorni invece di Carnivore 15 partite). Ora coerente con gli altri.
      const mostP = this.getMostPlayed ? this.getMostPlayed() : null;
      if (mostP && mostP.plays > 1) {
        out.push({ icon: '♻', label: 'Gioco più giocato', value: mostP.name + ' · ' + mostP.plays + ' partite' });
      }

      return out;
    }

    /**
     * Insight abitudini Spotify-Wrapped style: frasi naturali, motivazionali.
     */
    computeChallengeHabits(playsByDate) {
      const out = [];
      const dates = Object.keys(playsByDate);
      if (dates.length === 0) return out;

      // Giorno della settimana preferito
      const dowLabels = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
      const dowCounts = [0, 0, 0, 0, 0, 0, 0];
      let totalPlays = 0;
      dates.forEach(d => {
        const dow = new Date(d + 'T00:00:00').getDay();
        const tot = playsByDate[d].reduce((s, p) => s + (p.plays || 1), 0);
        dowCounts[dow] += tot;
        totalPlays += tot;
      });
      let bestDow = 0, bestDowVal = 0;
      dowCounts.forEach((v, i) => { if (v > bestDowVal) { bestDowVal = v; bestDow = i; } });
      if (bestDowVal > 0 && totalPlays > 0) {
        const pct = Math.round((bestDowVal / totalPlays) * 100);
        out.push({ icon: '📅', text: 'Giochi più di <strong>' + dowLabels[bestDow] + '</strong> (' + pct + '% delle tue partite)' });
      }

      // Streak settimane consecutive con almeno 1 play
      const weekKeys = new Set();
      dates.forEach(d => {
        const dt = new Date(d + 'T00:00:00');
        // Lunedì della settimana
        const dow = (dt.getDay() + 6) % 7;
        const monday = new Date(dt);
        monday.setDate(monday.getDate() - dow);
        const wk = monday.getFullYear() + '-' + Math.floor(((monday - new Date(monday.getFullYear(), 0, 1)) / 86400000 + 1) / 7);
        weekKeys.add(wk);
      });
      const weeks = Array.from(weekKeys).sort();
      // Conta consecutive ending settimana corrente
      const today = new Date();
      const dow = (today.getDay() + 6) % 7;
      const thisMonday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - dow);
      let weekStreak = 0;
      let cursor = new Date(thisMonday);
      while (true) {
        const wk = cursor.getFullYear() + '-' + Math.floor(((cursor - new Date(cursor.getFullYear(), 0, 1)) / 86400000 + 1) / 7);
        if (weekKeys.has(wk)) {
          weekStreak += 1;
          cursor.setDate(cursor.getDate() - 7);
        } else break;
      }
      if (weekStreak >= 2) {
        out.push({ icon: '🔥', text: '<strong>' + weekStreak + ' settimane consecutive</strong> con almeno una partita' });
      }

      // Mese più frequentato (storicamente quale mese tipo è)
      const monthOfYearCounts = [0,0,0,0,0,0,0,0,0,0,0,0];
      dates.forEach(d => {
        const m = parseInt(d.slice(5, 7), 10) - 1;
        const tot = playsByDate[d].reduce((s, p) => s + (p.plays || 1), 0);
        monthOfYearCounts[m] += tot;
      });
      let topMonth = 0, topMonthVal = 0;
      monthOfYearCounts.forEach((v, i) => { if (v > topMonthVal) { topMonthVal = v; topMonth = i; } });
      const monthLabels = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
      if (topMonthVal > 0) {
        const now = new Date();
        const isCurrentTopMonth = (now.getMonth() === topMonth);
        const text = isCurrentTopMonth
          ? 'Sei nel tuo mese tipo: <strong>' + monthLabels[topMonth] + '</strong> è quando giochi di più'
          : 'Il tuo mese tipo è <strong>' + monthLabels[topMonth] + '</strong>';
        out.push({ icon: '📈', text });
      }

      // Confronto mese corrente vs media
      const curKey = new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0');
      let curPlays = 0;
      dates.forEach(d => {
        if (d.startsWith(curKey)) curPlays += playsByDate[d].reduce((s, p) => s + (p.plays || 1), 0);
      });
      const monthCounts = {};
      dates.forEach(d => {
        const m = d.slice(0, 7);
        if (m === curKey) return;
        monthCounts[m] = (monthCounts[m] || 0) + playsByDate[d].reduce((s, p) => s + (p.plays || 1), 0);
      });
      const pastMonths = Object.values(monthCounts);
      if (pastMonths.length >= 2) {
        const avg = pastMonths.reduce((s, v) => s + v, 0) / pastMonths.length;
        const dayFraction = new Date().getDate() / new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
        const projected = dayFraction > 0 ? curPlays / dayFraction : 0;
        if (avg > 0 && projected > 0) {
          if (projected >= avg * 1.2) {
            out.push({ icon: '🚀', text: 'Questo mese sei <strong>sopra il tuo passo medio</strong>' });
          } else if (projected >= avg * 0.8) {
            out.push({ icon: '✅', text: 'Questo mese sei <strong>in linea col tuo passo medio</strong>' });
          }
          // Niente messaggio se sotto il passo (no demotivazione)
        }
      }

      return out;
    }

    /**
     * Blocco A — Coming soon community challenges
     */
    renderChallengeCommunity() {
      // Disattivato temporaneamente per alleggerire (2026-06-26). Per riattivare: rimuovi questa riga.
      return '';
      return '<div class="fp-ch__community">' +
        '<div class="fp-ch__community-icon">🐸</div>' +
        '<h3 class="fp-ch__community-title">Sfide community · presto</h3>' +
        '<p class="fp-ch__community-desc">Una sfida al mese da affrontare insieme agli altri Froggers, badge stagionali e classifica amici. Stiamo costruendo lo stagno.</p>' +
        '<span class="fp-ch__community-badge">Coming Soon</span>' +
      '</div>';
    }

    // ════════════════════════════════════════════════════════════════
    // HUB STATISTICHE — due lenti cliccabili (Persone + Giochi)
    // Ispirato a BG Stats (profondità: nemesi, win rate) + BGG (drill-down),
    // ma servito foto-first e a divulgazione progressiva: 2 titolari in
    // superficie, il resto dietro un click. Sostituisce record+abitudini.
    // ════════════════════════════════════════════════════════════════

    /**
     * Aggrega le persone con cui giochi + il record testa-a-testa.
     * Base: getMergedCompanions (BGG + manuali). Esiti SOLO dai play manuali
     * (l'unica fonte con vincitore). Ritorna nemesi/rivale + spalla.
     */
    computePeopleStats(period) {
      period = period || this._statPeriod();
      const inRange = this._rangePredicate(period);
      const PLACEHOLDER = new Set(['sfidante', 'automa', 'bot', 'tu', 'io', 'me', '']);
      const hidden = new Set(
        (Array.isArray(this.profile.hiddenCompanions) ? this.profile.hiddenCompanions : [])
          .map(n => String(n || '').trim().toLowerCase())
      );
      // Persone + esiti dai play manuali (gli unici con data + vincitore).
      const map = new Map();
      const getE = (name) => {
        const norm = String(name).trim().toLowerCase();
        let e = map.get(norm);
        if (!e) { e = { name: String(name).trim(), plays: 0, myWins: 0, myLosses: 0, coopWins: 0, coopLosses: 0, fromBgg: false }; map.set(norm, e); }
        return e;
      };
      for (const mp of (this.profile.manualPlays || [])) {
        if (!inRange(mp.date) || !Array.isArray(mp.playersList) || !mp.playersList.length) continue;
        const oc = mp.outcome;
        for (const pl of mp.playersList) {
          if (!pl || pl.isBot || pl.isMe || !pl.name) continue;
          const norm = String(pl.name).trim().toLowerCase();
          if (PLACEHOLDER.has(norm) || hidden.has(norm)) continue;
          const e = getE(pl.name);
          e.plays++;
          if (oc === 'win') e.myWins++;
          else if (oc === 'loss') e.myLosses++;
          else if (oc === 'coop_win') e.coopWins++;
          else if (oc === 'coop_loss') e.coopLosses++;
        }
      }
      // "Sempre": fonde anche i compagni BGG (plays di sempre, senza esiti).
      if (period === 'all') {
        for (const c of this.getMergedCompanions()) {
          if (!c || !c.name) continue;
          const norm = String(c.name).trim().toLowerCase();
          if (PLACEHOLDER.has(norm) || hidden.has(norm)) continue;
          const e = getE(c.name);
          e.plays = Math.max(e.plays, c.plays || 0);
          if (c.fromBgg) e.fromBgg = true;
        }
      }
      const people = Array.from(map.values());
      for (const person of people) {
        person.decided = person.myWins + person.myLosses;
        person.hth = person.decided > 0 ? Math.round((person.myWins / person.decided) * 100) : null;
      }
      // Nemesi / rivale: avversario più tosto (win rate più basso), min 3 partite decise
      let nemesis = null;
      const rivals = people.filter(p => p.decided >= 3);
      if (rivals.length) {
        rivals.sort((a, b) => (a.hth - b.hth) || (b.myLosses - a.myLosses));
        nemesis = rivals[0];
      }
      // Spalla: miglior compagno di coop (più vittorie insieme) o, in mancanza, chi vedi di più
      let ally = null;
      if (people.length) {
        const coopers = people
          .filter(p => (p.coopWins + p.coopLosses) >= 2)
          .sort((a, b) => (b.coopWins - a.coopWins) || ((b.coopWins + b.coopLosses) - (a.coopWins + a.coopLosses)));
        ally = coopers.length ? coopers[0] : people.slice().sort((a, b) => b.plays - a.plays)[0];
      }
      // Evita che nemesi e spalla siano la stessa persona
      if (nemesis && ally && nemesis.name === ally.name) {
        const alt = people.filter(p => p.name !== nemesis.name).sort((a, b) => b.plays - a.plays)[0];
        if (alt) ally = alt;
      }
      const hasOutcomes = people.some(p => p.decided > 0 || (p.coopWins + p.coopLosses) > 0);
      return { people, nemesis, ally, hasOutcomes };
    }

    /** Win rate per gioco, dai play manuali con esito (filtrabile per periodo). */
    computeGameOutcomes(period) {
      const inRange = this._rangePredicate(period || this._statPeriod());
      const map = new Map();
      const norm = (s) => (s || '').toLowerCase().trim();
      for (const mp of (this.profile.manualPlays || [])) {
        if (!inRange(mp.date)) continue;
        const oc = mp.outcome;
        const win = oc === 'win' || oc === 'coop_win';
        const loss = oc === 'loss' || oc === 'coop_loss';
        if (!win && !loss) continue;
        const key = mp.bggId ? ('b' + mp.bggId) : ('n' + norm(mp.title));
        if (key === 'n') continue;
        let e = map.get(key);
        if (!e) { e = { name: mp.title || 'Gioco', bggId: mp.bggId || null, wins: 0, losses: 0 }; map.set(key, e); }
        if (win) e.wins++; else e.losses++;
      }
      return Array.from(map.values()).map(e => {
        const decided = e.wins + e.losses;
        return { name: e.name, bggId: e.bggId, wins: e.wins, losses: e.losses, decided, winRate: Math.round((e.wins / decided) * 100) };
      });
    }

    /** Classifica giochi (per partite) con win rate attaccato + evidenze + polvere. */
    computeGameStats(period) {
      period = period || this._statPeriod();
      const norm = (s) => (s || '').toLowerCase().trim();
      const outcomes = this.computeGameOutcomes(period);
      const byBgg = new Map(), byName = new Map();
      for (const o of outcomes) { if (o.bggId) byBgg.set(o.bggId, o); byName.set(norm(o.name), o); }
      const played = (this.getPeriodGames ? this.getPeriodGames(this._periodToLens(period)) : []) || [];
      const list = played.map(g => {
        const o = (g.bggId && byBgg.get(g.bggId)) || byName.get(norm(g.name)) || null;
        return {
          name: g.name, bggId: g.bggId || null, cover: g.cover || null, plays: g.plays || 0,
          wins: o ? o.wins : 0, losses: o ? o.losses : 0,
          decided: o ? o.decided : 0, winRate: o ? o.winRate : null
        };
      });
      const eligible = list.filter(g => g.decided >= 3);
      let champion = null, nemesisGame = null;
      if (eligible.length) {
        champion = eligible.slice().sort((a, b) => (b.winRate - a.winRate) || (b.decided - a.decided))[0];
        const worst = eligible.slice().sort((a, b) => (a.winRate - b.winRate) || (b.decided - a.decided))[0];
        if (worst && worst.winRate < 50 && worst.name !== champion.name) nemesisGame = worst;
      }
      const workhorse = list.length ? list[0] : null;
      let owned = [];
      try { owned = this.collectCollection() || []; } catch (e) { owned = []; }
      const dusty = owned.filter(g => (g.plays || 0) === 0 && (g.extrasPlays || 0) === 0);
      return { list, outcomes, champion, nemesisGame, workhorse, dusty, owned };
    }

    /** Guscio di una lente: header con titolo + toggle "vedi tutti". */
    renderStatLensShell(key, icon, title, count, inner, moreLabel) {
      const toggle = (count > 2)
        ? '<button type="button" class="fp-stat-lens__toggle" data-fp-stat-toggle="' + key + '" aria-expanded="false">' +
            (moreLabel || 'Vedi tutti') + '<span class="fp-stat-lens__count">' + count + '</span></button>'
        : '';
      return '<section class="fp-stat-lens" data-fp-stat-lens="' + key + '">' +
        '<div class="fp-stat-lens__head">' +
          '<h3 class="fp-stat-lens__title">' + icon + ' ' + title + '</h3>' + toggle +
        '</div>' + inner +
      '</section>';
    }

    renderStatsHub(playsByDate) {
      const period = this._statPeriod();
      const periodBar = this.renderStatPeriodControl(period);
      const overview = this.renderStatOverview(playsByDate);
      const people = this.renderStatLensPeople(this.computePeopleStats());
      const games = this.renderStatLensGames(this.computeGameStats());
      const habits = this.renderStatHabits(playsByDate);
      return '<div class="fp-stats">' +
        periodBar +
        overview +
        '<div class="fp-stats__cols">' + people + games + '</div>' +
        habits +
      '</div>';
    }

    /** Segmented control periodo LOCALE alle statistiche, sincronizzato con "Il tuo momento". */
    renderStatPeriodControl(period) {
      const opts = [
        { k: 'month', label: 'Mese' },
        { k: 'last30', label: '30 gg' },
        { k: 'year', label: 'Anno' },
        { k: 'all', label: 'Sempre' }
      ];
      return '<div class="fp-stats__periodbar">' +
        '<span class="fp-stats__periodlbl">Periodo</span>' +
        '<div class="fp-stat-period" role="group" aria-label="Periodo statistiche">' +
          opts.map(o => '<button type="button" class="fp-stat-period__btn' + (o.k === period ? ' is-active' : '') + '" data-fp-stat-period="' + o.k + '" aria-pressed="' + (o.k === period ? 'true' : 'false') + '">' + o.label + '</button>').join('') +
        '</div>' +
      '</div>';
    }

    _periodLabel(p) {
      return { month: 'Questo mese', last30: 'Ultimi 30 giorni', year: 'Quest’anno', last12m: 'Ultimi 12 mesi', all: 'Da quando giochi' }[p] || 'In questo periodo';
    }

    /** Streak corrente: giorni consecutivi (oggi o ieri inclusi) con almeno 1 partita. */
    _currentStreak(playsByDate) {
      const set = new Set(Object.keys(playsByDate || {}));
      if (!set.size) return 0;
      const fmt = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      const cur = new Date(); cur.setHours(0, 0, 0, 0);
      if (!set.has(fmt(cur))) { cur.setDate(cur.getDate() - 1); if (!set.has(fmt(cur))) return 0; }
      let streak = 0;
      while (set.has(fmt(cur))) { streak++; cur.setDate(cur.getDate() - 1); }
      return streak;
    }

    /** Periodo condiviso con "Il tuo momento": il suo switch comanda anche le statistiche. */
    _statPeriod() { return this.momentLens || 'all'; }
    _periodToLens(p) { return p || 'all'; } // month/last30/year/last12m/all sono già lens di getPeriodGames
    _rangePredicate(p) {
      const now = new Date();
      if (p === 'month') { const k = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0'); return (d) => !!d && d.indexOf(k) === 0; }
      if (p === 'year') { const k = String(now.getFullYear()); return (d) => !!d && d.indexOf(k) === 0; }
      if (p === 'last30' || p === 'last12m') {
        const c = new Date(); c.setDate(c.getDate() - (p === 'last30' ? 30 : 365));
        const cutoff = c.getFullYear() + '-' + String(c.getMonth() + 1).padStart(2, '0') + '-' + String(c.getDate()).padStart(2, '0');
        return (d) => !!d && d >= cutoff;
      }
      return () => true;
    }

    /** Numeri-vanto per il colpo d'occhio (zona ①), filtrabile per periodo. */
    computeOverviewStats(playsByDate, period) {
      period = period || this._statPeriod();
      const inRange = this._rangePredicate(period);
      const act = this.profile.playsActivity || {};
      const played = (this.getPeriodGames ? this.getPeriodGames(this._periodToLens(period)) : []) || [];
      const totalPlays = played.reduce((s, g) => s + (g.plays || 0), 0);
      const uniqueGames = played.length;
      // Ore: di sempre dall'attività BGG; per periodo, dalle durate dei play manuali in range.
      let hours;
      if (period === 'all') {
        hours = Math.round((act.totalMinutes || 0) / 60);
      } else {
        let mins = 0;
        for (const mp of (this.profile.manualPlays || [])) { if (inRange(mp.date)) mins += mp.minutes || 0; }
        hours = Math.round(mins / 60);
      }
      // H-index: h giochi giocati almeno h volte ciascuno
      const counts = played.map(g => g.plays || 0).sort((a, b) => b - a);
      let h = 0; for (let i = 0; i < counts.length; i++) { if (counts[i] >= i + 1) h = i + 1; else break; }
      let w = 0, l = 0;
      for (const o of this.computeGameOutcomes(period)) { w += o.wins; l += o.losses; }
      const decided = w + l;
      const winRate = decided > 0 ? Math.round((w / decided) * 100) : null;
      const curKey = new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0');
      let curMonth = 0;
      for (const d in playsByDate) {
        if (d.indexOf(curKey) === 0) curMonth += playsByDate[d].reduce((s, p) => s + (p.plays || 1), 0);
      }
      const streak = this._currentStreak(playsByDate);
      return { totalPlays, uniqueGames, hours, h, winRate, decided, w, l, curMonth, streak, period };
    }

    /** Zona ① — fascia di numeroni sempre visibili. */
    renderStatOverview(playsByDate) {
      const s = this.computeOverviewStats(playsByDate);
      // Solo numeri ANALITICI: il volume (partite/ore/giochi) lo mostra "Il tuo momento".
      const tiles = [
        s.winRate != null ? { num: s.winRate + '%', label: 'Win rate', sub: s.decided + ' partite decise', info: 'La percentuale di partite che hai vinto, sul totale di quelle in cui hai segnato l\'esito (vinta o persa).' } : null,
        s.decided > 0 ? { num: s.w + '–' + s.l, label: 'Record V–S', sub: 'vinte e perse' } : null,
        s.h > 0 ? { num: s.h, label: 'H-index', sub: s.h + ' giochi giocati almeno ' + s.h + ' volte', info: 'Misura la costanza: hai H-index ' + s.h + ' perché ci sono ' + s.h + ' giochi giocati almeno ' + s.h + ' volte ciascuno. Sale solo se approfondisci più titoli, non ripetendone uno solo.' } : null,
        s.streak > 0 ? { num: s.streak, label: s.streak === 1 ? 'giorno di fila' : 'giorni di fila', sub: 'con una partita', info: 'Giorni di calendario consecutivi (incluso oggi o ieri) in cui hai registrato almeno una partita.' } : null
      ].filter(Boolean);
      if (!tiles.length) return '';
      return '<div class="fp-stat-overview">' + tiles.map(t =>
        '<div class="fp-stat-tile">' +
          (t.info ? '<button type="button" class="fp-stat-tile__info" aria-label="Cosa significa" aria-expanded="false">?</button>' : '') +
          '<span class="fp-stat-tile__num">' + t.num + '</span>' +
          '<span class="fp-stat-tile__label">' + t.label + '</span>' +
          (t.sub ? '<span class="fp-stat-tile__sub">' + t.sub + '</span>' : '') +
          (t.info ? '<span class="fp-stat-tile__pop" hidden>' + t.info + '</span>' : '') +
        '</div>'
      ).join('') + '</div>';
    }

    /** Zona ④ — abitudini narrative (riusa computeChallengeHabits). */
    renderStatHabits(playsByDate) {
      const habits = this.computeChallengeHabits ? this.computeChallengeHabits(playsByDate) : [];
      if (!habits || !habits.length) return '';
      return '<div class="fp-stat-habits">' +
        '<h3 class="fp-stat-lens__title fp-stat-habits__title">🌀 Le tue abitudini</h3>' +
        '<div class="fp-stat-habits__chips">' +
          habits.map(h => '<span class="fp-stat-chip">' + h.icon + ' ' + h.text + '</span>').join('') +
        '</div>' +
      '</div>';
    }

    /** Zona ② — classifica persone con top-5 in superficie + nemesi/spalla evidenziate. */
    renderStatLensPeople(ps) {
      const people = ps.people || [];
      if (people.length === 0) {
        let msg;
        if (this._statPeriod() !== 'all') {
          // I compagni BGG sono un aggregato di SEMPRE (senza data per-partita): non si
          // possono dividere per periodo lato client. Se l'utente ne ha, non dire il falso
          // "nessuna partita con altri" → spiega dove sono e come averli anche per periodo.
          let hasBggComp = false;
          try { hasBggComp = this.getMergedCompanions().some(c => c && c.name); } catch (e) {}
          msg = hasBggComp
            ? 'I tuoi compagni arrivano da BGG e non sono divisi per periodo — li trovi in <strong>«Sempre»</strong>. Per vederli anche qui, registra le partite a mano indicando chi c\'era.'
            : 'Nessuna partita con altri giocatori in questo periodo. Registra le partite indicando <strong>chi c\'era</strong> per far comparire nemesi e spalle.';
        } else {
          msg = 'Registra le partite indicando <strong>chi c\'era</strong> e <strong>chi ha vinto</strong>: qui nascono nemesi, spalle e i tuoi testa-a-testa.';
        }
        return '<section class="fp-stat-lens">' +
          '<div class="fp-stat-lens__head"><h3 class="fp-stat-lens__title">👥 Le tue persone</h3></div>' +
          '<div class="fp-stat-empty">' + msg + '</div>' +
        '</section>';
      }
      const nemName = ps.nemesis ? ps.nemesis.name : null;
      const allyName = ps.ally ? ps.ally.name : null;
      const byPlays = people.slice().sort((a, b) => b.plays - a.plays);
      const surface = byPlays.slice(0, 5);
      const ensure = (name) => { if (name && !surface.some(p => p.name === name)) { const p = people.find(x => x.name === name); if (p) surface.push(p); } };
      ensure(nemName); ensure(allyName);
      const inSurface = new Set(surface.map(p => p.name));
      const rest = byPlays.filter(p => !inSurface.has(p.name));
      const row = (c, rank) => {
        const badge = (c.name === nemName) ? ' <span class="fp-stat-badge" title="La tua nemesi">🥷</span>'
                    : (c.name === allyName) ? ' <span class="fp-stat-badge" title="La tua spalla">🤝</span>' : '';
        const manual = (c.fromBgg === false) ? ' <span class="fp-stat-row__tag" title="Dalle partite registrate a mano">✋</span>' : '';
        const right = (c.decided > 0)
          ? '<span class="fp-stat-row__rec">' + c.myWins + 'V–' + c.myLosses + 'S</span>' +
            '<span class="fp-stat-bar"><span class="fp-stat-bar__fill" style="width:' + c.hth + '%"></span></span>' +
            '<span class="fp-stat-row__pct">' + c.hth + '%</span>'
          : '<span class="fp-stat-row__meta">' + c.plays + (c.plays === 1 ? ' partita' : ' partite') + '</span>';
        return '<li class="fp-stat-row fp-stat-row--click" data-fp-person="' + escapeHtml(c.name || '') + '" role="button" tabindex="0">' +
          '<span class="fp-stat-rank' + (rank === 1 ? ' fp-stat-rank--first' : '') + '">' + rank + '</span>' +
          '<span class="fp-statcard__avatar fp-statcard__avatar--sm">' + escapeHtml((c.name || '?').slice(0, 1).toUpperCase()) + '</span>' +
          '<span class="fp-stat-row__name">' + escapeHtml(c.name || '—') + badge + manual + '</span>' +
          right +
          '<span class="fp-stat-row__chev" aria-hidden="true">›</span>' +
        '</li>';
      };
      const toggle = rest.length
        ? '<button type="button" class="fp-stat-lens__toggle" data-fp-stat-toggle="people" aria-expanded="false">Tutte<span class="fp-stat-lens__count">' + people.length + '</span></button>'
        : '';
      const drill = rest.length
        ? '<div class="fp-stat-drill" data-fp-drill-panel="people" hidden><ul class="fp-stat-list">' + rest.map((c, i) => row(c, surface.length + i + 1)).join('') + '</ul></div>'
        : '';
      return '<section class="fp-stat-lens" data-fp-stat-lens="people">' +
        '<div class="fp-stat-lens__head"><h3 class="fp-stat-lens__title">👥 Le tue persone</h3>' + toggle + '</div>' +
        '<ul class="fp-stat-board">' + surface.map((c, i) => row(c, i + 1)).join('') + '</ul>' + drill +
      '</section>';
    }

    /** Zona ③ — classifica giochi con top-5 in superficie + imbattibile/bestia nera. */
    renderStatLensGames(gs) {
      const list = gs.list || [];
      if (!list.length) {
        const msg = this._statPeriod() !== 'all'
          ? 'Nessuna partita in questo periodo.'
          : 'Registra qualche partita (meglio con l\'esito) e qui vedrai i più giocati, i tuoi win rate e quelli che prendono polvere.';
        return '<section class="fp-stat-lens">' +
          '<div class="fp-stat-lens__head"><h3 class="fp-stat-lens__title">🎲 I tuoi giochi</h3></div>' +
          '<div class="fp-stat-empty">' + msg + '</div>' +
        '</section>';
      }
      const champName = gs.champion ? gs.champion.name : null;
      const nemName = gs.nemesisGame ? gs.nemesisGame.name : null;
      // Ordina per WIN RATE (giochi con ≥3 partite decise in alto, per %), poi il resto per partite.
      // Diverso dallo scaffale "più giocati" del momento → niente doppione.
      const ranked = list.slice().sort((a, b) => {
        const aw = a.decided >= 3, bw = b.decided >= 3;
        if (aw && bw) return (b.winRate - a.winRate) || (b.plays - a.plays);
        if (aw !== bw) return aw ? -1 : 1;
        return b.plays - a.plays;
      });
      const surface = ranked.slice(0, 5);
      const ensure = (name) => { if (name && !surface.some(g => g.name === name)) { const g = ranked.find(x => x.name === name); if (g) surface.push(g); } };
      ensure(champName); ensure(nemName);
      const inSurface = new Set(surface.map(g => g.name));
      const rest = ranked.filter(g => !inSurface.has(g.name));
      const row = (g, rank) => {
        const covAttr = g.bggId ? ' data-fp-cover-bgg="' + g.bggId + '"' : (g.name ? ' data-fp-cover-name="' + escapeHtml(g.name) + '"' : '');
        const cov = g.cover
          ? '<span class="fp-stat-row__cover"><img src="' + encodeURI(g.cover) + '" alt="" loading="lazy" onerror="this.parentNode.classList.add(\'fp-stat-row__cover--empty\');this.parentNode.textContent=\'🎲\'"></span>'
          : '<span class="fp-stat-row__cover fp-stat-row__cover--empty"' + covAttr + '>🎲</span>';
        const badge = (g.name === champName) ? ' <span class="fp-stat-badge" title="Imbattibile">🏆</span>'
                    : (g.name === nemName) ? ' <span class="fp-stat-badge" title="La tua bestia nera">🐉</span>' : '';
        const right = (g.decided > 0)
          ? '<span class="fp-stat-bar"><span class="fp-stat-bar__fill" style="width:' + g.winRate + '%"></span></span><span class="fp-stat-row__pct">' + g.winRate + '%</span>'
          : '';
        return '<li class="fp-stat-row fp-stat-row--game fp-stat-row--click" data-fp-game-id="' + (g.bggId || '') + '" data-fp-game-name="' + escapeHtml(g.name) + '" role="button" tabindex="0">' +
          '<span class="fp-stat-rank' + (rank === 1 ? ' fp-stat-rank--first' : '') + '">' + rank + '</span>' +
          cov +
          '<span class="fp-stat-row__name">' + escapeHtml(g.name) + badge + '</span>' +
          '<span class="fp-stat-row__plays">' + g.plays + '×</span>' +
          right +
          '<span class="fp-stat-row__chev" aria-hidden="true">›</span>' +
        '</li>';
      };
      const dusty = (this._statPeriod() === 'all' && gs.dusty && gs.dusty.length)
        ? ' · 🕸️ ' + gs.dusty.length + (gs.dusty.length === 1 ? ' mai uscito dalla scatola' : ' mai usciti dalla scatola') : '';
      const subHtml = '<p class="fp-stat-lens__sub">Dove vinci di più' + dusty + '</p>';
      const toggle = rest.length
        ? '<button type="button" class="fp-stat-lens__toggle" data-fp-stat-toggle="games" aria-expanded="false">Tutti<span class="fp-stat-lens__count">' + list.length + '</span></button>'
        : '';
      const drill = rest.length
        ? '<div class="fp-stat-drill" data-fp-drill-panel="games" hidden><ul class="fp-stat-list fp-stat-list--games">' + rest.map((g, i) => row(g, surface.length + i + 1)).join('') + '</ul></div>'
        : '';
      return '<section class="fp-stat-lens" data-fp-stat-lens="games">' +
        '<div class="fp-stat-lens__head"><h3 class="fp-stat-lens__title">🎲 I tuoi giochi</h3>' + toggle + '</div>' +
        subHtml +
        '<ul class="fp-stat-board">' + surface.map((g, i) => row(g, i + 1)).join('') + '</ul>' + drill +
      '</section>';
    }

    bindStatsHub() {
      const root = this.root;
      if (!root) return;
      // Controllo periodo locale → comanda lo stesso stato di "Il tuo momento".
      root.querySelectorAll('[data-fp-stat-period]').forEach(btn => {
        if (btn.__fpStatBound) return; btn.__fpStatBound = true;
        btn.addEventListener('click', () => {
          const p = btn.getAttribute('data-fp-stat-period');
          if (!p || p === this.momentLens) return;
          this.momentLens = p;
          try { this.renderMoment(); } catch (e) {} // aggiorna recap + linguette de "Il tuo momento"
          this.renderChallenges(); // ri-renderizza le statistiche col nuovo periodo
        });
      });
      root.querySelectorAll('[data-fp-stat-toggle]').forEach(btn => {
        if (btn.__fpStatBound) return; btn.__fpStatBound = true;
        btn.addEventListener('click', () => {
          const key = btn.getAttribute('data-fp-stat-toggle');
          const panel = root.querySelector('[data-fp-drill-panel="' + key + '"]');
          if (!panel) return;
          const open = panel.hidden;
          panel.hidden = !open;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.classList.toggle('is-open', open);
        });
      });
      const activate = (el, fn) => {
        if (el.__fpStatBound) return; el.__fpStatBound = true;
        el.addEventListener('click', fn);
        el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(); } });
      };
      root.querySelectorAll('[data-fp-person]').forEach(el =>
        activate(el, () => this.openPersonDetail(el.getAttribute('data-fp-person'))));
      root.querySelectorAll('[data-fp-game-id]').forEach(el =>
        activate(el, () => this.openGameDetail(el.getAttribute('data-fp-game-id'), el.getAttribute('data-fp-game-name'))));
      // "?" sui numeroni → apre/chiude la spiegazione in chiaro
      root.querySelectorAll('.fp-stat-tile__info').forEach(btn => {
        if (btn.__fpStatBound) return; btn.__fpStatBound = true;
        btn.addEventListener('click', () => {
          const pop = btn.parentNode.querySelector('.fp-stat-tile__pop');
          if (!pop) return;
          const open = pop.hidden;
          pop.hidden = !open;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
      // Le righe-gioco della classifica possono non avere cover locale (play manuali
      // senza img): scaricale da BGG e riempile, come nei modal.
      this._enrichStatCovers(root);
    }

    // ── Modal di dettaglio (persona / gioco): "da un punto apre tutto il resto" ──

    _fmtStatDate(iso) {
      if (!iso) return '';
      const M = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
      const p = String(iso).split('-');
      if (p.length < 3) return iso;
      return parseInt(p[2], 10) + ' ' + (M[parseInt(p[1], 10) - 1] || '') + ' ' + p[0];
    }

    _statCoverMaps() {
      let owned = [];
      try { owned = this.collectCollection() || []; } catch (e) { owned = []; }
      const byBgg = new Map(), byName = new Map();
      const norm = (s) => (s || '').toLowerCase().trim();
      for (const g of owned) {
        if (g.bggId && g.img && !byBgg.has(g.bggId)) byBgg.set(g.bggId, g.img);
        if (g.name && g.img && !byName.has(norm(g.name))) byName.set(norm(g.name), g.img);
      }
      const played = (this.getPeriodGames ? this.getPeriodGames('all') : []) || [];
      for (const g of played) {
        if (g.bggId && g.cover && !byBgg.has(g.bggId)) byBgg.set(g.bggId, g.cover);
        if (g.name && g.cover && !byName.has(norm(g.name))) byName.set(norm(g.name), g.cover);
      }
      const cc = this._coverCache || {};
      return {
        cover: (bggId, name) => (bggId && byBgg.get(bggId)) || (name && byName.get(norm(name))) || (bggId && cc[bggId]) || null
      };
    }

    _applyCover(el, img) {
      if (!el || !img) return;
      el.classList.remove('fp-sd__rowcover--empty', 'fp-sd__cover--empty', 'fp-stat-row__cover--empty');
      el.innerHTML = '<img src="' + encodeURI(img) + '" alt="" loading="lazy" onerror="this.parentNode.textContent=\'🎲\'">';
    }

    /** I play manuali non salvano l'img: scarica le cover mancanti da BGG (per id, e per nome come ripiego). */
    async _enrichStatCovers(scope) {
      try {
        if (!scope) return;
        const wu = this.workerUrl || (this.customer && this.customer.workerUrl) || '';
        const base = wu ? wu.replace(/\/$/, '') : '';
        if (!base) return;
        this._coverCache = this._coverCache || {};
        this._coverNameCache = this._coverNameCache || {};
        const lc = (s) => (s || '').toLowerCase();
        // 1) Per bggId (batch)
        const idSpans = Array.from(scope.querySelectorAll('[data-fp-cover-bgg]'));
        const needIds = [];
        for (const el of idSpans) {
          const id = parseInt(el.getAttribute('data-fp-cover-bgg'), 10);
          if (!id) continue;
          if (this._coverCache[id]) this._applyCover(el, this._coverCache[id]);
          else needIds.push(id);
        }
        const uniqIds = Array.from(new Set(needIds));
        for (let i = 0; i < uniqIds.length; i += 20) {
          try {
            const res = await fetch(base + '/api/bgg-batch?ids=' + uniqIds.slice(i, i + 20).join(','));
            if (!res.ok) continue;
            const data = await res.json();
            for (const m of (data.games || [])) { const img = m.imgFull || m.img; if (m.id && img) this._coverCache[m.id] = img; }
          } catch (e) { /* best-effort */ }
        }
        // 2) Per nome (placeholder senza bggId) — con tetto per non floodare
        const nameSpans = Array.from(scope.querySelectorAll('[data-fp-cover-name]'));
        const needNames = [];
        for (const el of nameSpans) {
          const nm = el.getAttribute('data-fp-cover-name'); const k = lc(nm);
          if (!k) continue;
          if (this._coverNameCache[k]) this._applyCover(el, this._coverNameCache[k]);
          else if (this._coverNameCache[k] !== null) needNames.push(nm);
        }
        for (const nm of Array.from(new Set(needNames)).slice(0, 12)) {
          try {
            const res = await fetch(base + '/api/bgg-thumb-by-name?q=' + encodeURIComponent(nm));
            const j = res.ok ? await res.json() : null;
            this._coverNameCache[lc(nm)] = (j && (j.imgFull || j.img)) || null;
          } catch (e) { /* best-effort */ }
        }
        // Applica (se ancora in DOM)
        if (!scope.isConnected) return;
        for (const el of idSpans) { const id = parseInt(el.getAttribute('data-fp-cover-bgg'), 10); if (id && this._coverCache[id]) this._applyCover(el, this._coverCache[id]); }
        for (const el of nameSpans) { const k = lc(el.getAttribute('data-fp-cover-name')); if (k && this._coverNameCache[k]) this._applyCover(el, this._coverNameCache[k]); }
      } catch (e) { /* best-effort */ }
    }

    /** Tutto su una persona: record, win rate, coop, breakdown per gioco. */
    computePersonDetail(name) {
      const norm = (s) => (s || '').toLowerCase().trim();
      const target = norm(name);
      const games = new Map();
      let manual = 0, myWins = 0, myLosses = 0, coopWins = 0, coopLosses = 0, lastDate = null, firstDate = null;
      for (const mp of (this.profile.manualPlays || [])) {
        if (!Array.isArray(mp.playersList)) continue;
        if (!mp.playersList.some(p => p && !p.isBot && !p.isMe && norm(p.name) === target)) continue;
        manual++;
        if (mp.date) { if (!lastDate || mp.date > lastDate) lastDate = mp.date; if (!firstDate || mp.date < firstDate) firstDate = mp.date; }
        const oc = mp.outcome, win = oc === 'win', loss = oc === 'loss', cw = oc === 'coop_win', cl = oc === 'coop_loss';
        if (win) myWins++; else if (loss) myLosses++; else if (cw) coopWins++; else if (cl) coopLosses++;
        const key = mp.bggId ? ('b' + mp.bggId) : ('n' + norm(mp.title));
        let g = games.get(key);
        if (!g) { g = { bggId: mp.bggId || null, name: mp.title || 'Gioco', plays: 0, wins: 0, losses: 0 }; games.set(key, g); }
        g.plays++; if (win || cw) g.wins++; else if (loss || cl) g.losses++;
      }
      const decided = myWins + myLosses;
      const merged = this.getMergedCompanions().find(p => norm(p.name) === target);
      return {
        name: (merged && merged.name) || name,
        plays: merged ? Math.max(merged.plays, manual) : manual,
        manual, myWins, myLosses, coopWins, coopLosses, decided,
        winRate: decided > 0 ? Math.round((myWins / decided) * 100) : null,
        games: Array.from(games.values()).sort((a, b) => b.plays - a.plays),
        lastDate, firstDate
      };
    }

    /** Tutto su un gioco: record, win rate, ore, avversari, storico. */
    computeGameDetail(bggId, name) {
      const norm = (s) => (s || '').toLowerCase().trim();
      const idNum = bggId ? parseInt(bggId, 10) : null;
      const tname = norm(name);
      const opp = new Map();
      let manual = 0, wins = 0, losses = 0, minutes = 0, lastDate = null, firstDate = null;
      for (const mp of (this.profile.manualPlays || [])) {
        const isMatch = (idNum && mp.bggId) ? (mp.bggId === idNum) : (norm(mp.title) === tname);
        if (!isMatch) continue;
        manual++;
        minutes += mp.minutes || 0;
        if (mp.date) { if (!lastDate || mp.date > lastDate) lastDate = mp.date; if (!firstDate || mp.date < firstDate) firstDate = mp.date; }
        const oc = mp.outcome, win = oc === 'win' || oc === 'coop_win', loss = oc === 'loss' || oc === 'coop_loss';
        if (win) wins++; else if (loss) losses++;
        if (Array.isArray(mp.playersList)) {
          for (const pl of mp.playersList) {
            if (!pl || pl.isBot || pl.isMe || !pl.name) continue;
            const k = norm(pl.name);
            let o = opp.get(k);
            if (!o) { o = { name: pl.name.trim(), plays: 0, wins: 0, losses: 0 }; opp.set(k, o); }
            o.plays++; if (win) o.wins++; else if (loss) o.losses++;
          }
        }
      }
      const played = (this.getPeriodGames ? this.getPeriodGames('all') : []) || [];
      const pg = played.find(g => (idNum && g.bggId === idNum) || norm(g.name) === tname);
      const decided = wins + losses;
      return {
        name: (pg && pg.name) || name, bggId: idNum,
        cover: this._statCoverMaps().cover(idNum, name),
        plays: pg ? Math.max(pg.plays, manual) : manual,
        manual, wins, losses, decided,
        winRate: decided > 0 ? Math.round((wins / decided) * 100) : null,
        hours: Math.round(minutes / 60), minutes,
        opponents: Array.from(opp.values()).sort((a, b) => b.plays - a.plays),
        lastDate, firstDate
      };
    }

    _openStatModal(inner, extraClass) {
      const overlay = document.createElement('div');
      overlay.className = 'fp-modal-overlay fp-sd-overlay' + (extraClass ? (' ' + extraClass) : '');
      overlay.innerHTML = '<div class="fp-modal fp-sd" role="dialog" aria-modal="true">' +
        '<button type="button" class="fp-modal__close" aria-label="Chiudi">×</button>' + inner + '</div>';
      document.body.appendChild(overlay);
      const onKey = (e) => { if (e.key === 'Escape') close(); };
      const close = () => { overlay.remove(); document.removeEventListener('keydown', onKey); };
      overlay.querySelector('.fp-modal__close').addEventListener('click', close);
      overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
      document.addEventListener('keydown', onKey);
      return overlay;
    }

    openPersonDetail(name) {
      const d = this.computePersonDetail(name);
      const ps = this.computePeopleStats();
      const isNem = ps.nemesis && ps.nemesis.name === d.name;
      const isAlly = ps.ally && ps.ally.name === d.name;
      const eyebrow = isNem ? '🥷 La tua nemesi' : isAlly ? '🤝 La tua spalla' : 'Compagno di tavolo';
      const cm = this._statCoverMaps();
      const stat = (num, label) => '<div class="fp-sd__stat"><span class="fp-sd__stat-num">' + num + '</span><span class="fp-sd__stat-label">' + label + '</span></div>';
      let stats = stat(d.plays, d.plays === 1 ? 'partita insieme' : 'partite insieme');
      if (d.decided > 0) {
        stats += stat(d.myWins + '–' + d.myLosses, 'record V–S');
        stats += stat(d.winRate + '%', 'li batti');
      }
      if (d.coopWins + d.coopLosses > 0) stats += stat(d.coopWins, d.coopWins === 1 ? 'vinta in coop' : 'vinte in coop');
      let gamesHtml;
      if (d.games.length) {
        gamesHtml = '<ul class="fp-sd__list">' + d.games.map(g => {
          const cov = cm.cover(g.bggId, g.name);
          const dec = g.wins + g.losses;
          const right = dec > 0
            ? '<span class="fp-sd__rowrec">' + g.wins + 'V–' + g.losses + 'S</span>'
            : '<span class="fp-sd__rowmeta">' + g.plays + '×</span>';
          const covAttr = g.bggId ? ' data-fp-cover-bgg="' + g.bggId + '"' : (g.name ? ' data-fp-cover-name="' + escapeHtml(g.name) + '"' : '');
          const covHtml = cov
            ? '<span class="fp-sd__rowcover"><img src="' + encodeURI(cov) + '" alt="" loading="lazy" onerror="this.parentNode.classList.add(\'fp-sd__rowcover--empty\');this.parentNode.textContent=\'🎲\'"></span>'
            : '<span class="fp-sd__rowcover fp-sd__rowcover--empty"' + covAttr + '>🎲</span>';
          return '<li class="fp-sd__row">' +
            covHtml +
            '<span class="fp-sd__rowname">' + escapeHtml(g.name) + '</span>' +
            '<span class="fp-sd__rowmeta">' + g.plays + '×</span>' + right +
          '</li>';
        }).join('') + '</ul>';
      } else {
        gamesHtml = '<p class="fp-sd__empty">Nessuna partita registrata a mano con i giocatori. Aggiungi chi c\'era quando registri per popolare questa scheda.</p>';
      }
      const last = d.lastDate ? '<span class="fp-sd__metaline">Ultima partita insieme · ' + this._fmtStatDate(d.lastDate) + '</span>' : '';
      const inner =
        '<div class="fp-sd__hero' + (isNem ? ' fp-sd__hero--rival' : '') + '">' +
          '<span class="fp-sd__avatar">' + escapeHtml((d.name || '?').slice(0, 1).toUpperCase()) + '</span>' +
          '<div class="fp-sd__herotext"><span class="fp-sd__eyebrow">' + eyebrow + '</span>' +
            '<h3 class="fp-sd__name">' + escapeHtml(d.name) + '</h3>' + last + '</div>' +
        '</div>' +
        '<div class="fp-sd__stats">' + stats + '</div>' +
        '<div class="fp-sd__section"><h4>I vostri giochi</h4>' + gamesHtml + '</div>' +
        '<p class="fp-sd__note">Record e percentuali dalle partite competitive registrate con l\'esito.</p>';
      const overlay = this._openStatModal(inner);
      this._enrichStatCovers(overlay);
    }

    openGameDetail(bggId, name) {
      const d = this.computeGameDetail(bggId, name);
      const gs = this.computeGameStats();
      const isChamp = gs.champion && gs.champion.name === d.name;
      const isNem = gs.nemesisGame && gs.nemesisGame.name === d.name;
      const eyebrow = isChamp ? '🏆 Imbattibile' : isNem ? '🐉 La tua bestia nera' : 'Dalla tua ludoteca';
      const stat = (num, label) => '<div class="fp-sd__stat"><span class="fp-sd__stat-num">' + num + '</span><span class="fp-sd__stat-label">' + label + '</span></div>';
      let stats = stat(d.plays, d.plays === 1 ? 'partita' : 'partite');
      if (d.decided > 0) { stats += stat(d.wins + '–' + d.losses, 'record V–S'); stats += stat(d.winRate + '%', 'win rate'); }
      if (d.hours > 0) stats += stat(d.hours + 'h', 'al tavolo');
      let oppHtml;
      if (d.opponents.length) {
        oppHtml = '<ul class="fp-sd__list">' + d.opponents.map(o => {
          const dec = o.wins + o.losses;
          const right = dec > 0 ? '<span class="fp-sd__rowrec">' + o.wins + 'V–' + o.losses + 'S</span>' : '';
          return '<li class="fp-sd__row">' +
            '<span class="fp-sd__rowav">' + escapeHtml((o.name || '?').slice(0, 1).toUpperCase()) + '</span>' +
            '<span class="fp-sd__rowname">' + escapeHtml(o.name) + '</span>' +
            '<span class="fp-sd__rowmeta">' + o.plays + '×</span>' + right +
          '</li>';
        }).join('') + '</ul>';
      } else {
        oppHtml = '<p class="fp-sd__empty">Nessun avversario registrato per questo gioco. Aggiungi i giocatori quando registri una partita.</p>';
      }
      const last = d.lastDate ? '<span class="fp-sd__metaline">Ultima partita · ' + this._fmtStatDate(d.lastDate) + '</span>' : '';
      const coverAttr = d.bggId ? ' data-fp-cover-bgg="' + d.bggId + '"' : (d.name ? ' data-fp-cover-name="' + escapeHtml(d.name) + '"' : '');
      const cover = d.cover
        ? '<span class="fp-sd__cover"><img src="' + encodeURI(d.cover) + '" alt="" loading="lazy" onerror="this.parentNode.classList.add(\'fp-sd__cover--empty\');this.parentNode.textContent=\'🎲\'"></span>'
        : '<span class="fp-sd__cover fp-sd__cover--empty"' + coverAttr + '>🎲</span>';
      const inner =
        '<div class="fp-sd__hero' + (isNem ? ' fp-sd__hero--rival' : '') + '">' +
          cover +
          '<div class="fp-sd__herotext"><span class="fp-sd__eyebrow">' + eyebrow + '</span>' +
            '<h3 class="fp-sd__name">' + escapeHtml(d.name) + '</h3>' + last + '</div>' +
        '</div>' +
        '<div class="fp-sd__stats">' + stats + '</div>' +
        '<div class="fp-sd__section"><h4>Con chi l\'hai giocato</h4>' + oppHtml + '</div>' +
        '<p class="fp-sd__note">Win rate e avversari dalle partite registrate con l\'esito.</p>';
      const overlay = this._openStatModal(inner);
      this._enrichStatCovers(overlay);
    }

    // ────────────────────────────────────────
    // 5. LE TUE GEMME — Achievement multi-tier (Duolingo split: Milestones + Records)
    // ────────────────────────────────────────
    /**
     * Sistema Recently Earned: tiene traccia di quando ogni badge è stato sbloccato.
     * Al primo run i badge già sbloccati ricevono timestamp = 1 (passato lontano, no banner).
     * I NUOVI sblocchi successivi prendono il timestamp corrente → appariranno nel banner.
     */
    updateUnlockedTimestamps(achievements) {
      if (!this.profile.unlockedBadges) this.profile.unlockedBadges = {};
      const ub = this.profile.unlockedBadges;
      const isFirstRun = Object.keys(ub).length === 0;
      let dirty = false;
      achievements.forEach(a => {
        // Primo unlock
        if (a.unlocked && !ub[a.id]) {
          ub[a.id] = { unlockedAt: isFirstRun ? 1 : Date.now() };
          if (a.isTiered) ub[a.id].maxTier = a.currentTier;
          dirty = true;
          return;
        }
        // Tiered: aggiorna se hai raggiunto un tier più alto
        if (a.unlocked && a.isTiered && ub[a.id]) {
          const prev = ub[a.id].maxTier;
          if (typeof prev !== 'number' || a.currentTier > prev) {
            ub[a.id].maxTier = a.currentTier;
            ub[a.id].lastTierUpAt = isFirstRun ? 1 : Date.now();
            dirty = true;
          }
        }
      });
      if (dirty) {
        try { FM.saveProfile(this.profile); } catch (e) {}
      }
    }

    renderGems() {
      const wrap = this.root.querySelector('[data-fp-gems]');
      const content = this.root.querySelector('[data-fp-gems-content]');
      if (!wrap || !content) return;

      const achievements = this.computeAchievements();
      if (achievements.length === 0) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;

      // Stat header + Recently Earned banner
      const unlocked = achievements.filter(a => a.unlocked);
      const total = achievements.length;
      const rarestUnlocked = unlocked.slice().sort((a, b) => (a.rarity || 100) - (b.rarity || 100))[0];

      let html = '';

      // Stat header
      html += '<div class="fp-gems__statbar">' +
        '<div class="fp-gems__stat"><span class="fp-gems__stat-num">' + unlocked.length + '/' + total + '</span><span class="fp-gems__stat-label">gemme sbloccate</span></div>' +
        (rarestUnlocked ? '<div class="fp-gems__stat fp-gems__stat--rare"><span class="fp-gems__stat-num">' + rarestUnlocked.icon + '</span><span class="fp-gems__stat-label">la più rara · solo ' + (rarestUnlocked.rarity || '?') + '% lo ha</span></div>' : '') +
      '</div>';

      // ✨ Ultimi 3 sbloccati — sempre (non più finestra 7gg): i 3 più recenti per data.
      const ub = this.profile.unlockedBadges || {};
      const recent = unlocked
        .map(a => ({ a, ts: (ub[a.id] && ub[a.id].unlockedAt) || 0 }))
        .sort((a, b) => b.ts - a.ts)
        .slice(0, 3);
      const recentIds = new Set(recent.map(r => r.a.id));

      if (recent.length > 0) {
        html += '<div class="fp-gems__recent">' +
          '<h3 class="fp-gems__recent-title">✨ Ultimi sbloccati</h3>' +
          '<div class="fp-gems__recent-row">' +
            recent.map(({ a, ts }) => {
              let ago = '';
              // ts = 1 vuol dire "sbloccata prima che segnassimo la data": niente "20768 giorni fa".
              if (ts && ts > 86400000) {
                const days = Math.floor((Date.now() - ts) / 86400000);
                ago = days === 0 ? 'oggi' : days === 1 ? 'ieri' : days + ' giorni fa';
              }
              return '<div class="fp-gems__recent-item">' +
                '<div class="fp-gems__recent-icon">' + a.icon + '</div>' +
                '<div class="fp-gems__recent-name">' + escapeHtml(a.name) + '</div>' +
                (ago ? '<div class="fp-gems__recent-ago">' + ago + '</div>' : '') +
              '</div>';
            }).join('') +
          '</div>' +
        '</div>';
      }

      // Famiglie come PULSANTI (segmented) + una sola griglia a capo per la categoria attiva.
      // Niente più 5 caroselli impilati: pagina corta e costante.
      const familyOrder = [
        { id: 'identita', label: '🐸 Identità' },
        { id: 'maestria', label: '🎯 Maestria' },
        { id: 'esplorazione', label: '🌍 Esplorazione' },
        { id: 'compagnia', label: '🤝 Compagnia' },
        { id: 'collezionismo', label: '💎 Collezionismo' }
      ];
      const families = familyOrder
        .map(fam => Object.assign({}, fam, { achs: achievements.filter(a => (a.family || 'maestria') === fam.id) }))
        .filter(f => f.achs.length > 0);

      if (families.length > 0) {
        // Categoria attiva persistita tra i re-render; default = prima (Identità).
        if (!this.selectedGemFamily || !families.some(f => f.id === this.selectedGemFamily)) {
          this.selectedGemFamily = families[0].id;
        }
        const activeFam = families.find(f => f.id === this.selectedGemFamily) || families[0];

        // Pulsanti categoria con conteggio sbloccati/totale
        html += '<div class="fp-gems__tabs" role="tablist">' +
          families.map(f => {
            const u = f.achs.filter(a => a.unlocked).length;
            const isActive = f.id === activeFam.id;
            return '<button type="button" class="fp-gems__tab' + (isActive ? ' is-active' : '') + '" data-fp-gem-tab="' + f.id + '" role="tab" aria-selected="' + (isActive ? 'true' : 'false') + '">' +
              '<span class="fp-gems__tab-label">' + f.label + '</span>' +
              '<span class="fp-gems__tab-count">' + u + '/' + f.achs.length + '</span>' +
            '</button>';
          }).join('') +
        '</div>';

        // Griglia (a capo automatico) della sola categoria attiva.
        // Ordine: sbloccati (rari su) → a un passo → mystery.
        const famAchs = activeFam.achs;
        const famUnlocked = famAchs.filter(a => a.unlocked).sort((a, b) => (a.rarity || 100) - (b.rarity || 100));
        const famClose = famAchs.filter(a => !a.unlocked && (a.progress || 0) >= 30);
        const famDistant = famAchs.filter(a => !a.unlocked && (a.progress || 0) < 30);
        html += '<div class="fp-gems__grid" data-fp-gems-grid>' +
          famUnlocked.map(a => this.renderBadge(a, false, recentIds.has(a.id))).join('') +
          famClose.map(a => this.renderBadge(a, false, false)).join('') +
          famDistant.map(a => this.renderBadge(a, true, false)).join('') +
        '</div>';
      }

      content.innerHTML = html;

      // Bind pulsanti categoria → cambia famiglia attiva e ri-renderizza.
      content.querySelectorAll('[data-fp-gem-tab]').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = btn.getAttribute('data-fp-gem-tab');
          if (!id || id === this.selectedGemFamily) return;
          this.selectedGemFamily = id;
          this.renderGems();
        });
      });

      // Bind click sui badge cliccabili (con triggeredBy) → modal con i giochi-trigger
      const allAchsById = {};
      achievements.forEach(a => { allAchsById[a.id] = a; });
      content.querySelectorAll('[data-fp-badge-id]').forEach(el => {
        if (el.__fpBadgeBound) return;
        el.__fpBadgeBound = true;
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const id = el.dataset.fpBadgeId;
          const ach = allAchsById[id];
          if (ach) this.openBadgeTriggerModal(ach);
        });
        el.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const id = el.dataset.fpBadgeId;
            const ach = allAchsById[id];
            if (ach) this.openBadgeTriggerModal(ach);
          }
        });
      });
    }

    /**
     * Apre modal con i dettagli di un badge:
     * - triggerHeader (es. "📅 Il 15 mar 2026 — 4 partite", "👥 Giulia — 12 partite")
     * - triggeredBy (lista giochi)
     * Almeno uno dei due deve esserci, altrimenti niente modal.
     */
    openBadgeTriggerModal(ach) {
      if (!ach) return;
      const hasList = Array.isArray(ach.triggeredBy) && ach.triggeredBy.length > 0;
      const hasHeader = !!ach.triggerHeader;
      if (!hasList && !hasHeader) return;

      const overlay = document.createElement('div');
      overlay.className = 'fp-modal-overlay fp-badge-modal-overlay';

      const games = hasList ? ach.triggeredBy : [];
      const gamesHtml = games.map(g => {
        // Render speciale per "compagno" (Padrone di Casa, Network)
        if (g.isCompanion) {
          const initial = (g.name || '?').slice(0, 1).toUpperCase();
          const meta = [];
          meta.push(g.plays + (g.plays === 1 ? ' partita insieme' : ' partite insieme'));
          if (g.winRate != null) meta.push(g.winRate + '% gli vince');
          if (g.topGames && g.topGames.length > 0) meta.push('Top: ' + g.topGames.slice(0, 2).join(' · '));
          return '<div class="fp-badge-modal__game fp-badge-modal__game--companion">' +
            '<span class="fp-badge-modal__companion-avatar">' + escapeHtml(initial) + '</span>' +
            '<div class="fp-badge-modal__game-meta">' +
              '<span class="fp-badge-modal__game-name">' + escapeHtml(g.name || '—') + '</span>' +
              (meta.length > 0 ? '<span class="fp-badge-modal__game-plays">' + escapeHtml(meta.join(' · ')) + '</span>' : '') +
            '</div>' +
          '</div>';
        }
        const product = g.bggId ? this.products.find(p => p.bgg === g.bggId) : null;
        const cover = (product && product.img) || g.img || null;
        const url = product ? product.u : null;
        const meta = [];
        if (g.plays) meta.push(g.plays + (g.plays === 1 ? ' partita' : ' partite'));
        // Ore al tavolo (per Frog Marathon)
        if (typeof g.hoursAtTable === 'number' && g.hoursAtTable > 0) {
          meta.push(g.hoursAtTable + 'h al tavolo');
        }
        // Tipologia rappresentata (per Eclettico/Versatile)
        if (g.typologyLabel) meta.push(g.typologyLabel);
        // Decennio (per Viaggio nel Tempo)
        if (g.decadeLabel) meta.push(g.decadeLabel);
        // Anno (per Vintage Hunter, Cult Master, New Wave)
        if (g.yr && (ach.id === 'vintage_hunter' || ach.id === 'cult_master' || ach.id === 'new_wave' || ach.id === 'anteprima')) {
          meta.push('Anno ' + g.yr);
        }
        // Peso (per Curator, Big Box)
        if (typeof g.weight === 'number' && g.weight > 0) {
          meta.push('Peso ' + g.weight.toFixed(1));
        }
        // Durata (per Filler Lover, Marathon Owner)
        if (typeof g.durationMin === 'number' && g.durationMin > 0) {
          meta.push(g.durationMin + ' min');
        }
        // Mostra rank BGG se rilevante (es. badge nicchia)
        if (typeof g.rk === 'number' && g.rk > 0) {
          meta.push('BGG rank #' + g.rk);
        } else if (typeof g.rk === 'number' && g.rk === 0 && ach.id === 'trovatore') {
          meta.push('non classificato');
        }
        const inner = (cover
          ? '<img class="fp-badge-modal__game-img" src="' + escapeHtml(cover) + '" alt="" loading="lazy">'
          : '<span class="fp-badge-modal__game-noimg">🎲</span>') +
          '<div class="fp-badge-modal__game-meta">' +
            '<span class="fp-badge-modal__game-name">' + escapeHtml(g.name || 'Gioco') + '</span>' +
            (meta.length > 0 ? '<span class="fp-badge-modal__game-plays">' + meta.join(' · ') + '</span>' : '') +
          '</div>';
        return url
          ? '<a class="fp-badge-modal__game" href="' + escapeHtml(url) + '">' + inner + '</a>'
          : '<div class="fp-badge-modal__game">' + inner + '</div>';
      }).join('');

      // Subtitle: solo se ci sono GIOCHI veri (non placeholder)
      const isPlaceholderOnly = games.length === 1 && games[0] && !games[0].bggId && /non disponibil/i.test(games[0].name || '');
      let subtitle = '';
      if (hasList && !isPlaceholderOnly) {
        subtitle = games.length === 1
          ? 'Il gioco che ha fatto scattare questa gemma'
          : 'I giochi che hanno fatto scattare questa gemma';
      } else if (hasHeader) {
        subtitle = 'Dettagli del traguardo';
      }
      const subtitleHtml = subtitle
        ? '<p class="fp-badge-modal__sub">' + escapeHtml(subtitle) + '</p>'
        : '';

      // Header opzionale custom (es. Maratona: "📅 Il 15 mar 2026 — 4 partite",
      // Amico Fidato: "👥 Giulia — 12 partite insieme · 60% le vince lei")
      const triggerHeaderHtml = ach.triggerHeader
        ? '<div class="fp-badge-modal__trigger-header">' + escapeHtml(ach.triggerHeader) + '</div>'
        : '';

      // Lista giochi: skip se solo placeholder ("Top giochi non disponibili")
      const showGamesList = hasList && !isPlaceholderOnly;
      const gamesListHtml = showGamesList
        ? '<div class="fp-badge-modal__games">' + gamesHtml + '</div>'
        : (hasList && isPlaceholderOnly
            ? '<p class="fp-badge-modal__note">BGG non ha dettagli aggiuntivi su questo traguardo.</p>'
            : '');

      overlay.innerHTML =
        '<div class="fp-modal fp-badge-modal" role="dialog" aria-modal="true" aria-label="Dettagli gemma">' +
          '<button type="button" class="fp-modal__close" aria-label="Chiudi">×</button>' +
          '<div class="fp-badge-modal__head">' +
            '<div class="fp-badge-modal__icon">' + (ach.icon || '🏆') + '</div>' +
            '<div>' +
              '<h3 class="fp-badge-modal__title">' + escapeHtml(ach.name) + '</h3>' +
              subtitleHtml +
            '</div>' +
          '</div>' +
          triggerHeaderHtml +
          gamesListHtml +
        '</div>';

      document.body.appendChild(overlay);
      const close = () => overlay.remove();
      overlay.querySelector('.fp-modal__close').addEventListener('click', close);
      overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
      // Close su ESC
      const escHandler = (e) => { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', escHandler); } };
      document.addEventListener('keydown', escHandler);
    }

    renderBadge(a, mystery, isNew) {
      const tierLabels = { gold: '🥇', silver: '🥈', bronze: '🥉' };
      const tierTitle = { gold: 'BGG verificato', silver: 'Mix BGG + manuale', bronze: 'Manuale' };
      const tierBadge = a.tier && tierLabels[a.tier] ?
        '<span class="fp-badge__tier" title="' + tierTitle[a.tier] + '">' + tierLabels[a.tier] + '</span>' : '';
      const rarityLabel = a.unlocked && a.rarity != null ?
        '<span class="fp-badge__rarity' + (a.rarityLive ? ' fp-badge__rarity--live' : '') + '" title="' + (a.rarityLive ? '📊 Live (su ' + a.raritySampleSize + ' Frogger)' : 'Stima preliminare') + '">' +
          (a.rarityLive ? '📊 ' : '') + 'Solo ' + a.rarity + '% lo ha' +
        '</span>' : '';
      const newRibbon = isNew ? '<span class="fp-badge__new-ribbon">NUOVO</span>' : '';
      const newCls = isNew ? ' fp-badge--new' : '';

      // Data sblocco (se conosciuta e non placeholder retroattivo "1")
      const ub = (this.profile.unlockedBadges || {})[a.id];
      const ts = ub && ub.unlockedAt;
      const unlockedDate = (a.unlocked && ts && ts > 1) ? this.formatUnlockedDate(ts) : '';
      const unlockedDateHtml = unlockedDate
        ? '<div class="fp-badge__unlocked-date">' + unlockedDate + '</div>'
        : '';

      // Classe + dataset cliccabile se c'è almeno un trigger (lista giochi o header info)
      const hasTriggerList = Array.isArray(a.triggeredBy) && a.triggeredBy.length > 0;
      const hasTriggerHeader = !!a.triggerHeader;
      const hasTrigger = a.unlocked && (hasTriggerList || hasTriggerHeader);
      const clickableCls = hasTrigger ? ' fp-badge--clickable' : '';
      const clickableAttr = hasTrigger ? ' data-fp-badge-id="' + escapeHtml(a.id) + '" tabindex="0" role="button" aria-label="Vedi dettagli ' + escapeHtml(a.name) + '"' : '';

      if (mystery && !a.unlocked) {
        return '<div class="fp-badge fp-badge--mystery">' +
          '<div class="fp-badge__icon-wrap">🔒</div>' +
          '<div class="fp-badge__name">Mistero</div>' +
          '<div class="fp-badge__desc">' + (a.hint || 'Continua a giocare per scoprirlo') + '</div>' +
          '</div>';
      }

      // ── TIERED BADGE (Bronzo→...→Leggendario) ──
      if (a.isTiered) {
        const total = a.tierTotal || 5;
        const cur = a.currentTier;
        let pips = '';
        for (let i = 0; i < total; i++) {
          pips += '<span class="fp-badge__pip' + (i <= cur ? ' fp-badge__pip--on' : '') + '"></span>';
        }
        if (!a.unlocked) {
          const pct = Math.round(a.progress || 0);
          return '<div class="fp-badge fp-badge--progress fp-badge--tiered">' +
            '<div class="fp-badge__icon-wrap fp-badge__icon-wrap--locked">' + a.icon + '</div>' +
            '<div class="fp-badge__name">' + escapeHtml(a.name) + '</div>' +
            '<div class="fp-badge__desc">' + escapeHtml(a.label || a.desc) + '</div>' +
            '<div class="fp-badge__pips">' + pips + '</div>' +
            '<div class="fp-badge__progress"><div class="fp-badge__progress-bar" style="width:' + pct + '%"></div></div>' +
            '</div>';
        }
        const tierClass = ['bronze', 'silver', 'gold', 'diamond', 'legend'][cur] || 'bronze';
        const nextLine = a.nextTier
          ? '<div class="fp-badge__next">→ ' + escapeHtml(a.nextTier.label) + ' a ' + a.nextTier.value + '</div>'
          : '<div class="fp-badge__next fp-badge__next--max">⭐ Tier massimo</div>';
        const pct = Math.round(a.progress || 0);
        const progBar = a.nextTier
          ? '<div class="fp-badge__progress"><div class="fp-badge__progress-bar" style="width:' + pct + '%"></div></div>'
          : '';
        return '<div class="fp-badge fp-badge--unlocked fp-badge--tiered fp-badge--rank-' + tierClass + newCls + clickableCls + '"' + clickableAttr + '>' +
          newRibbon +
          '<div class="fp-badge__rank-label">' + escapeHtml(a.tierLabel || '') + '</div>' +
          '<div class="fp-badge__icon-wrap">' + a.icon + '</div>' +
          '<div class="fp-badge__name">' + escapeHtml(a.name) + '</div>' +
          '<div class="fp-badge__desc">' + escapeHtml(a.label || a.desc) + '</div>' +
          '<div class="fp-badge__pips">' + pips + '</div>' +
          progBar +
          nextLine +
          (rarityLabel || '') +
          unlockedDateHtml +
          '</div>';
      }

      // ── SINGLE BADGE (legacy) ──
      if (!a.unlocked) {
        const pct = Math.round(a.progress || 0);
        return '<div class="fp-badge fp-badge--progress">' +
          '<div class="fp-badge__icon-wrap fp-badge__icon-wrap--locked">' + a.icon + '</div>' +
          '<div class="fp-badge__name">' + escapeHtml(a.name) + '</div>' +
          '<div class="fp-badge__desc">' + escapeHtml(a.label || a.desc) + '</div>' +
          '<div class="fp-badge__progress"><div class="fp-badge__progress-bar" style="width:' + pct + '%"></div></div>' +
          '<div class="fp-badge__progress-pct">' + pct + '%</div>' +
          '</div>';
      }

      return '<div class="fp-badge fp-badge--unlocked' + (a.tier ? ' fp-badge--tier-' + a.tier : '') + newCls + clickableCls + '"' + clickableAttr + '>' +
        newRibbon +
        tierBadge +
        '<div class="fp-badge__icon-wrap">' + a.icon + '</div>' +
        '<div class="fp-badge__name">' + escapeHtml(a.name) + '</div>' +
        '<div class="fp-badge__desc">' + escapeHtml(a.desc) + '</div>' +
        rarityLabel +
        unlockedDateHtml +
        '</div>';
    }

    /**
     * Helper streak master: trova streak più lungo + aggrega giochi del periodo.
     * Cached per render (un solo compute per re-render).
     */
    _streakMasterCompute() {
      if (this._streakCache && this._streakCache._key === (this.calPlaysByDate ? 'cached' : 'fresh')) return this._streakCache;
      const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
      const dates = Object.keys(playsByDate).sort();
      if (dates.length === 0) {
        this._streakCache = { _key: 'cached', games: [], header: null };
        return this._streakCache;
      }
      let bestStart = dates[0], bestEnd = dates[0], bestLen = 1;
      let curLen = 1;
      for (let i = 1; i < dates.length; i++) {
        const prev = new Date(dates[i - 1]);
        const cur = new Date(dates[i]);
        const diffDays = Math.round((cur - prev) / 86400000);
        if (diffDays === 1) {
          curLen++;
          if (curLen > bestLen) {
            bestLen = curLen;
            bestStart = dates[i - curLen + 1];
            bestEnd = dates[i];
          }
        } else {
          curLen = 1;
        }
      }
      const months = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
      const fmt = (iso) => {
        const d = new Date(iso + 'T00:00:00');
        return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
      };
      const gamesMap = {};
      // BUGFIX 2026-05-08: il vecchio codice usava `new Date(curIso + 'T00:00:00')`
      // (locale) + `toISOString().slice(0,10)` (UTC) → in fuso UTC+ (Italia) ogni
      // iterazione tornava al giorno precedente → LOOP INFINITO. Sostituito con
      // costruzione esplicita YYYY-MM-DD lavorando sui componenti, no Date.
      const advanceIso = (iso) => {
        const [y, m, d] = iso.split('-').map(Number);
        const dt = new Date(Date.UTC(y, m - 1, d));
        dt.setUTCDate(dt.getUTCDate() + 1);
        return dt.getUTCFullYear() + '-' +
          String(dt.getUTCMonth() + 1).padStart(2, '0') + '-' +
          String(dt.getUTCDate()).padStart(2, '0');
      };
      let curIso = bestStart;
      let safety = 0; // safety net contro qualsiasi imprevisto futuro
      while (curIso <= bestEnd && safety < 20000) {
        safety++;
        const arr = playsByDate[curIso] || [];
        for (const g of arr) {
          const k = g.title || g.name || 'Gioco';
          if (!gamesMap[k]) gamesMap[k] = { name: k, bggId: g.bggId, img: g.img || null, plays: 0 };
          gamesMap[k].plays += (g.plays || 1);
        }
        curIso = advanceIso(curIso);
      }
      const games = Object.values(gamesMap).sort((a, b) => b.plays - a.plays).slice(0, 8);
      const header = bestLen >= 7
        ? '🔥 ' + bestLen + ' giorni di fila — dal ' + fmt(bestStart) + ' al ' + fmt(bestEnd)
        : null;
      this._streakCache = { _key: 'cached', games, header };
      return this._streakCache;
    }

    /**
     * Format data sblocco badge: "oggi", "ieri", "X giorni fa" entro 30gg,
     * altrimenti "il GG mese 'AA" (es. "il 5 mag '26").
     */
    formatUnlockedDate(ts) {
      if (!ts || ts < 86400000) return '';
      const days = Math.floor((Date.now() - ts) / 86400000);
      if (days < 0) return '';
      if (days === 0) return 'Sbloccato oggi';
      if (days === 1) return 'Sbloccato ieri';
      if (days < 30) return 'Sbloccato ' + days + ' giorni fa';
      const d = new Date(ts);
      const months = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
      return 'Sbloccato il ' + d.getDate() + ' ' + months[d.getMonth()] + ' \'' + String(d.getFullYear()).slice(2);
    }

    /**
     * Determina la "purezza dati" del profilo per badge tier (oro/argento/bronzo).
     * BGG-only = oro · mix = argento · manual-only = bronzo
     */
    dataTier() {
      const p = this.profile;
      const hasBgg = !!(p.playsActivity && p.playsActivity.totalPlays > 0 &&
                       (p.source === 'bgg' || p.bggUsername));
      const hasManual = !!(p.manualPlays && p.manualPlays.length > 0);
      if (hasBgg && !hasManual) return 'gold';
      if (hasBgg && hasManual) return 'silver';
      if (hasManual) return 'bronze';
      return null;
    }

    /**
     * Computa lo stato di tutti gli achievement basandosi sul profilo corrente.
     * Ritorna array con { id, name, icon, desc, unlocked, progress, tier, rarity }
     */
    computeAchievements() {
      const p = this.profile;
      const act = p.playsActivity || {};
      const tier = this.dataTier();
      const out = [];

      // PERFORMANCE FIX 2026-05-08:
      // Build product lookup map: bggId → product. Trasforma TUTTE le
      // chiamate this.products.find(p => p.bgg === bggId) (sparse in 30+
      // achievement check/getTriggeredBy) da O(N) a O(1).
      // Su profili BGG con 500+ giochi posseduti × 30 badge × 150 prodotti
      // catalogo, il guadagno è ~150x e fa la differenza tra 30s e 200ms.
      if (!this._productsByBgg) {
        this._productsByBgg = new Map();
        for (const prod of (this.products || [])) {
          if (prod.bgg) this._productsByBgg.set(prod.bgg, prod);
        }
      }
      const productsByBgg = this._productsByBgg;

      // STICKY UNLOCK (Steam pattern): una volta sbloccato, RESTA sbloccato
      const stickyBadges = (this.profile.unlockedBadges) || {};

      // Per-badge profiling: ?profile=1 logga tempo di ogni check/measure/getTriggeredBy
      const _badgeProfile = (() => {
        try { return new URLSearchParams(window.location.search).get('profile') === '1'; }
        catch (e) { return false; }
      })();

      const addAchievement = (def) => {
        if (_badgeProfile) console.log('[FroggerProfile][badge-START] ' + def.id);
        const _t0 = _badgeProfile ? performance.now() : 0;
        let result;
        // Trigger info (giochi che hanno fatto sbloccare il badge):
        // - Single check: il check stesso può ritornare triggeredBy nel result.
        // - Tiered: opzionale def.getTriggeredBy(p, act) chiamato a parte.

        if (def.tiers && def.measure) {
          // ── TIERED ACHIEVEMENT (Bronzo→...→Leggendario) ──
          const value = def.measure(p, act) || 0;
          let currentTier = -1;
          for (let i = 0; i < def.tiers.length; i++) {
            if (value >= def.tiers[i].value) currentTier = i;
          }
          // Sticky: se in passato avevi raggiunto un tier maggiore, mantienilo
          const sticky = stickyBadges[def.id];
          if (sticky && typeof sticky.maxTier === 'number' && sticky.maxTier > currentTier) {
            currentTier = sticky.maxTier;
          }
          const isUnlocked = currentTier >= 0;
          const next = (currentTier + 1 < def.tiers.length) ? def.tiers[currentTier + 1] : null;
          const cur = isUnlocked ? def.tiers[currentTier] : def.tiers[0];
          let progress = 0;
          if (isUnlocked && next) {
            const span = next.value - cur.value;
            progress = Math.max(0, Math.min(100, ((value - cur.value) / span) * 100));
          } else if (!isUnlocked) {
            progress = Math.min(100, (value / def.tiers[0].value) * 100);
          } else {
            progress = 100;
          }
          result = {
            unlocked: isUnlocked,
            isTiered: true,
            value,
            currentTier,
            tierLabel: isUnlocked ? cur.label : null,
            tierName: isUnlocked ? (def.name + ' ' + cur.label) : def.name,
            tierTotal: def.tiers.length,
            nextTier: next,
            rarity: isUnlocked ? cur.rarity : (def.tiers[0].rarity || 70),
            progress,
            label: def.formatLabel ? def.formatLabel(value, cur, next) : (value + (next ? ' / ' + next.value : ''))
          };
        } else {
          // ── SINGLE ACHIEVEMENT (legacy) ──
          result = def.check(p, act) || {};
          if (stickyBadges[def.id] && !result.unlocked) {
            result.unlocked = true;
            result.stickyRecover = true;
          }
        }

        // Trigger info per tiered (i single già la portano dal check)
        if (def.getTriggeredBy && result.unlocked && !result.triggeredBy) {
          try {
            result.triggeredBy = def.getTriggeredBy(p, act) || [];
          } catch (e) { result.triggeredBy = []; }
        }
        if (def.getTriggerHeader && result.unlocked && !result.triggerHeader) {
          try {
            result.triggerHeader = def.getTriggerHeader(p, act) || null;
          } catch (e) { result.triggerHeader = null; }
        }

        out.push(Object.assign({
          id: def.id,
          name: def.name,
          icon: def.icon,
          desc: def.desc,
          hint: def.hint,
          rarity: def.rarity,
          family: def.family || 'maestria',
          tier
          // Note: result può contenere `triggeredBy: [{ bggId, name, plays, img }]`
          // popolato dal check, che il render esporrà come modal cliccabile.
        }, result));

        if (_badgeProfile) {
          const dt = performance.now() - _t0;
          // Log SEMPRE in profile mode (anche <50ms): l'ultimo loggato prima
          // del freeze identifica il colpevole.
          console.log('[FroggerProfile][badge-END] ' + def.id + ' = ' + dt.toFixed(1) + 'ms');
        }
      };

      // 🐸 IDENTITÀ
      addAchievement({
        id: 'frogger_veterano',
        icon: '🐸',
        name: 'Frogger Veterano',
        desc: 'Membro da 1 anno',
        family: 'identita',
        rarity: 8,
        check: (p) => {
          if (!p.createdAt) return { unlocked: false, progress: 0 };
          const days = (Date.now() - p.createdAt) / 86400000;
          return { unlocked: days >= 365, progress: Math.min(100, (days / 365) * 100), label: Math.floor(days) + ' giorni nello stagno' };
        }
      });

      // 🎯 MAESTRIA — Tiered
      addAchievement({
        id: 'specialista',
        icon: '💎',
        name: 'Specialista',
        desc: 'Partite ripetute dello stesso gioco',
        family: 'maestria',
        tiers: [
          { value: 10, label: 'Bronzo', rarity: 65 },
          { value: 25, label: 'Argento', rarity: 35 },
          { value: 50, label: 'Oro', rarity: 14 },
          { value: 100, label: 'Diamante', rarity: 5 },
          { value: 200, label: 'Leggendario', rarity: 1 }
        ],
        measure: (p, act) => {
          const top = (act.topPlayed || [])[0];
          return top ? top.plays : 0;
        },
        formatLabel: (v, cur, next) => {
          if (next) return v + '/' + next.value + ' partite';
          return v + ' partite · max raggiunto';
        },
        getTriggeredBy: (p, act) => {
          // Top 3 giochi più giocati (focus sul "preferito" che ha fatto scattare il badge)
          return (act.topPlayed || []).slice(0, 3).map(g => ({
            bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null
          }));
        }
      });

      addAchievement({
        id: 'dedicato',
        icon: '🎲',
        name: 'Dedicato',
        desc: 'Partite totali loggate',
        family: 'maestria',
        tiers: [
          { value: 25, label: 'Bronzo', rarity: 60 },
          { value: 100, label: 'Argento', rarity: 30 },
          { value: 300, label: 'Oro', rarity: 12 },
          { value: 700, label: 'Diamante', rarity: 4 },
          { value: 2000, label: 'Leggendario', rarity: 0.5 }
        ],
        measure: (p, act) => act.totalPlays || 0,
        formatLabel: (v, cur, next) => next ? v + '/' + next.value + ' partite' : v + ' partite',
        getTriggeredBy: (p, act) => (act.topPlayed || []).slice(0, 6).map(g => ({
          bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null
        }))
      });

      addAchievement({
        id: 'frog_marathon',
        icon: '⏱',
        name: 'Frog Marathon',
        desc: 'Ore al tavolo',
        family: 'maestria',
        tiers: [
          { value: 25, label: 'Bronzo', rarity: 50 },
          { value: 100, label: 'Argento', rarity: 25 },
          { value: 300, label: 'Oro', rarity: 10 },
          { value: 750, label: 'Diamante', rarity: 3 },
          { value: 1500, label: 'Leggendario', rarity: 0.5 }
        ],
        measure: (p, act) => Math.round((act.totalMinutes || 0) / 60),
        formatLabel: (v, cur, next) => next ? v + 'h / ' + next.value + 'h' : v + 'h al tavolo',
        getTriggeredBy: (p, act) => {
          // Giochi ordinati per ore al tavolo (minutes), non per plays
          return (act.topPlayed || [])
            .filter(g => (g.minutes || 0) > 0)
            .sort((a, b) => (b.minutes || 0) - (a.minutes || 0))
            .slice(0, 6)
            .map(g => ({
              bggId: g.bggId,
              name: g.name,
              plays: g.plays,
              img: g.img || null,
              hoursAtTable: Math.round((g.minutes || 0) / 60)
            }));
        }
      });

      // 🌍 ESPLORAZIONE
      addAchievement({
        id: 'trovatore',
        icon: '🌌',
        name: 'Trovatore di Nicchie',
        desc: 'Hai loggato un gioco di nicchia (BGG rank > 5000 o non classificato)',
        hint: 'Trova quei giochi rari che pochi conoscono',
        family: 'esplorazione',
        rarity: 15,
        check: (p, act) => {
          // Definizione "nicchia" = BGG rank > 5000 (top 5000 = mainstream).
          // rank == 0 / Not Ranked = giochi così di nicchia che BGG non li classifica.
          // Fallback se rk non popolato (worker pre-v11): NON considerare nicchia
          // (meglio under-trigger che falso positivo come "Cascadia trovatore di nicchia").
          const NICHE_RANK_THRESHOLD = 5000;
          const niche = (act.topPlayed || []).filter(g => {
            if (!g.bggId) return false;
            // Se ha rank popolato dal worker v11+: usa quello
            if (typeof g.rk === 'number') {
              return g.rk === 0 || g.rk > NICHE_RANK_THRESHOLD;
            }
            // Fallback: usa rank dal catalogo Frogames (pochi giochi mainstream lì)
            const product = this.products.find(prod => prod.bgg === g.bggId);
            if (product && typeof product.rk === 'number' && product.rk > 0) {
              return product.rk > NICHE_RANK_THRESHOLD;
            }
            // Nessun dato di rank disponibile: skip (per non avere falsi positivi)
            return false;
          });
          // FIX 2026-06: badgeStats.hasNiche copre TUTTE le partite (anche oltre i top-30)
          const bsN = act.badgeStats;
          const isUnlocked = (bsN && typeof bsN.hasNiche === 'boolean') ? bsN.hasNiche : (niche.length > 0);
          return {
            unlocked: isUnlocked,
            progress: isUnlocked ? 100 : 0,
            triggeredBy: niche.slice(0, 12).map(g => ({
              bggId: g.bggId,
              name: g.name,
              plays: g.plays,
              img: g.img || null,
              rk: g.rk || 0
            }))
          };
        }
      });

      addAchievement({
        id: 'eclettico',
        icon: '🎨',
        name: 'Eclettico',
        desc: 'Giocato 5+ tipologie diverse',
        family: 'esplorazione',
        rarity: 18,
        check: (p, act) => {
          // FIX 2026-06-17: prima sommava topTypologies(+primary+secondary), ma quelle
          // sono cappate a 3 e primary/secondary non vengono mai popolate → max 3, MAI 5
          // (obiettivo impossibile). Ora conta le tipologie REALI da posseduti + giocati.
          const typSet = new Set();
          const addFrom = (obj) => {
            if (obj && FM.deriveTypologies) {
              for (const t of FM.deriveTypologies(obj)) typSet.add(t);
            }
          };
          // Posseduti BGG (metadati arricchiti) + catalogo Frogames
          for (const item of ((p.bggCollection && p.bggCollection.owned) || [])) {
            if (!item || typeof item !== 'object') continue;
            const prod = productsByBgg.get(item.id);
            if (prod) addFrom(prod);
            else addFrom({ mch: item.mch || [], cat: item.cat || [], w: item.w, f: {} });
          }
          // Acquisti Frogames (catalogo)
          for (const purch of (p.purchasedProducts || [])) {
            const prod = purch.bggId ? productsByBgg.get(purch.bggId) : null;
            if (prod) addFrom(prod);
          }
          // Giocati (anche non posseduti) — catalogo o metadati BGG enriched
          for (const g of (act.topPlayed || [])) {
            const prod = g.bggId ? productsByBgg.get(g.bggId) : null;
            if (prod) addFrom(prod);
            else addFrom({ mch: g.mch || [], cat: g.cat || [], w: g.w, f: { coop: !!g.isCoop, party: !!g.isParty } });
          }
          const unlocked = typSet.size >= 5;
          // Trigger: 1 gioco rappresentativo per tipologia (dai giocati)
          let triggeredBy = null;
          let triggerHeader = null;
          if (unlocked) {
            const TYPOLOGY_LABELS = FM.TYPOLOGY_LABELS || {};
            const seen = new Set();
            const list = [];
            for (const g of (act.topPlayed || [])) {
              const product = g.bggId ? productsByBgg.get(g.bggId) : null;
              const typs = FM.deriveTypologies
                ? FM.deriveTypologies(product || { mch: g.mch || [], cat: g.cat || [], w: g.w, f: {} })
                : [];
              for (const t of typs) {
                if (seen.has(t) || !typSet.has(t)) continue;
                seen.add(t);
                list.push({
                  bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null,
                  typologyLabel: TYPOLOGY_LABELS[t] || t
                });
                break;
              }
              if (list.length >= 8) break;
            }
            triggeredBy = list;
            triggerHeader = '🎨 Le tue ' + typSet.size + ' tipologie';
          }
          return {
            unlocked,
            progress: Math.min(100, (typSet.size / 5) * 100),
            label: typSet.size + '/5 tipologie',
            triggerHeader,
            triggeredBy
          };
        }
      });

      addAchievement({
        id: 'esploratore',
        icon: '🌍',
        name: 'Esploratore',
        desc: 'Giochi diversi loggati',
        family: 'esplorazione',
        tiers: [
          { value: 20, label: 'Bronzo', rarity: 55 },
          { value: 50, label: 'Argento', rarity: 28 },
          { value: 150, label: 'Oro', rarity: 10 },
          { value: 400, label: 'Diamante', rarity: 3 },
          { value: 1000, label: 'Leggendario', rarity: 0.3 }
        ],
        measure: (p, act) => act.uniqueGames || 0,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' giochi' : v + ' giochi unici',
        getTriggeredBy: (p, act) => {
          // Top 12 giochi diversi giocati (rappresentativi della varietà)
          return (act.topPlayed || []).slice(0, 12).map(g => ({
            bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null
          }));
        }
      });

      addAchievement({
        id: 'cinghiale',
        icon: '🧠',
        name: 'Cinghiale',
        desc: 'Sessione di 3+ ore di un gioco peso 4+',
        hint: 'Una serata epica con un gioco di peso',
        family: 'maestria',
        rarity: 9,
        check: (p, act) => {
          const heavy = (act.topPlayed || []).filter(g => {
            if ((g.minutes || 0) < 180) return false;
            const w = (typeof g.w === 'number') ? g.w : ((g.bggId ? (this.products.find(prod => prod.bgg === g.bggId) || {}).w : null) || null);
            return w && w >= 4;
          });
          // FIX 2026-06: badgeStats copre TUTTE le partite (anche oltre i top-30)
          const bsC = act.badgeStats;
          const isUnlocked = (bsC && typeof bsC.hasCinghiale === 'boolean') ? bsC.hasCinghiale : (heavy.length > 0);
          return {
            unlocked: isUnlocked,
            progress: isUnlocked ? 100 : 0,
            triggeredBy: heavy.slice(0, 8).map(g => ({
              bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null
            }))
          };
        }
      });

      addAchievement({
        id: 'diplomatico',
        icon: '🤝',
        name: 'Diplomatico',
        desc: '15+ partite cooperative',
        family: 'compagnia',
        rarity: 14,
        check: (p, act) => {
          const coopGames = (act.topPlayed || []).filter(g => {
            if (g.isCoop) return true; // metadati BGG già su topPlayed
            const product = g.bggId ? this.products.find(prod => prod.bgg === g.bggId) : null;
            return product && product.f && product.f.coop;
          });
          // FIX 2026-06: usa il totale su TUTTE le partite (badgeStats) se c'è; altrimenti i top-30
          const bs = act.badgeStats;
          const coopPlays = (bs && typeof bs.coopPlays === 'number')
            ? bs.coopPlays
            : coopGames.reduce((s, g) => s + (g.plays || 0), 0);
          return {
            unlocked: coopPlays >= 15,
            progress: (coopPlays / 15) * 100,
            label: coopPlays + '/15 partite coop',
            triggeredBy: coopGames.slice(0, 10).map(g => ({
              bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null
            }))
          };
        }
      });

      addAchievement({
        id: 'gladiatore',
        icon: '⚔️',
        name: 'Gladiatore',
        desc: '10+ partite di giochi conflittuali',
        family: 'compagnia',
        rarity: 11,
        check: (p, act) => {
          const CONFLICT_RE = /Combat|Take That|Player Elimination|Hidden Movement|Critical Hits/i;
          const directGames = (act.topPlayed || []).filter(g => {
            if (Array.isArray(g.mch) && g.mch.some(m => CONFLICT_RE.test(m))) return true;
            const product = g.bggId ? this.products.find(prod => prod.bgg === g.bggId) : null;
            if (!product || !FM.deriveInteraction) return false;
            return FM.deriveInteraction(product) === 3;
          });
          const bs = act.badgeStats;
          const directPlays = (bs && typeof bs.conflictPlays === 'number')
            ? bs.conflictPlays
            : directGames.reduce((s, g) => s + (g.plays || 0), 0);
          return {
            unlocked: directPlays >= 10,
            progress: (directPlays / 10) * 100,
            label: directPlays + '/10 partite conflittuali',
            triggeredBy: directGames.slice(0, 10).map(g => ({
              bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null
            }))
          };
        }
      });

      addAchievement({
        id: 'speed_runner',
        icon: '⚡',
        name: 'Speed Runner',
        desc: '5 giochi diversi nello stesso mese',
        family: 'maestria',
        rarity: 17,
        check: (p, act) => {
          const last30 = (act.topPlayed || []).filter(g => (g.plays30d || 0) > 0);
          // FIX 2026-06: uniqueGames30d è già calcolato dal worker su TUTTE le partite (non top-30)
          const n30 = (typeof act.uniqueGames30d === 'number') ? act.uniqueGames30d : last30.length;
          return {
            unlocked: n30 >= 5,
            progress: (n30 / 5) * 100,
            label: n30 + '/5 giochi questo mese',
            triggeredBy: last30.slice(0, 10).map(g => ({
              bggId: g.bggId, name: g.name, plays: g.plays30d || g.plays, img: g.img || null
            }))
          };
        }
      });

      // 🔥 STREAK MASTER (tiered)
      addAchievement({
        id: 'streak_master',
        icon: '🔥',
        name: 'Streak Master',
        desc: 'Giorni consecutivi con partite',
        hint: 'Non spezzare la catena!',
        family: 'maestria',
        tiers: [
          { value: 7, label: 'Bronzo', rarity: 25 },
          { value: 14, label: 'Argento', rarity: 10 },
          { value: 30, label: 'Oro', rarity: 4 },
          { value: 60, label: 'Diamante', rarity: 1 },
          { value: 100, label: 'Leggendario', rarity: 0.2 }
        ],
        measure: () => {
          const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
          const dates = Object.keys(playsByDate).sort();
          if (dates.length === 0) return 0;
          let bestStreak = 1, curStreak = 1;
          for (let i = 1; i < dates.length; i++) {
            const prev = new Date(dates[i - 1]);
            const cur = new Date(dates[i]);
            const diffDays = Math.round((cur - prev) / 86400000);
            if (diffDays === 1) {
              curStreak++;
              if (curStreak > bestStreak) bestStreak = curStreak;
            } else curStreak = 1;
          }
          return bestStreak;
        },
        formatLabel: (v, cur, next) => next ? 'Best: ' + v + 'gg / ' + next.value : 'Best: ' + v + 'gg',
        getTriggeredBy: () => this._streakMasterCompute().games,
        getTriggerHeader: () => this._streakMasterCompute().header
      });

      addAchievement({
        id: 'habitue',
        icon: '📅',
        name: 'Habitué',
        desc: '1+ partita ogni settimana di un mese intero',
        family: 'maestria',
        rarity: 12,
        check: () => {
          const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
          const dates = Object.keys(playsByDate);
          if (dates.length === 0) return { unlocked: false, progress: 0 };
          // Per ogni mese, conta settimane uniche con almeno 1 play
          const monthWeeks = {};
          const monthGames = {};
          for (const d of dates) {
            const dt = new Date(d);
            const monthKey = dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0');
            if (!monthWeeks[monthKey]) monthWeeks[monthKey] = new Set();
            if (!monthGames[monthKey]) monthGames[monthKey] = {};
            const weekKey = Math.floor(dt.getDate() / 7);
            monthWeeks[monthKey].add(weekKey);
            for (const g of (playsByDate[d] || [])) {
              const name = g.title || g.name || 'Gioco';
              if (!monthGames[monthKey][name]) {
                monthGames[monthKey][name] = { name, bggId: g.bggId, img: g.img || null, plays: 0 };
              }
              monthGames[monthKey][name].plays += g.plays || 1;
            }
          }
          const fullMonths = Object.entries(monthWeeks).filter(([, s]) => s.size >= 4).map(([k]) => k);
          const unlocked = fullMonths.length > 0;
          let triggerHeader = null, triggeredBy = null;
          if (unlocked) {
            // Prendi il mese più recente full
            fullMonths.sort();
            const bestMonth = fullMonths[fullMonths.length - 1];
            const months = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
            const [yr, mo] = bestMonth.split('-');
            const monthLabel = months[parseInt(mo, 10) - 1] + ' ' + yr;
            triggerHeader = '📅 ' + monthLabel + ' — hai giocato ogni settimana del mese';
            triggeredBy = Object.values(monthGames[bestMonth] || {}).sort((a, b) => b.plays - a.plays).slice(0, 8);
          }
          return {
            unlocked,
            progress: unlocked ? 100 : 50,
            triggerHeader,
            triggeredBy
          };
        }
      });

      addAchievement({
        id: 'maratona',
        icon: '🌅',
        name: 'Maratona',
        desc: '3+ partite stesso giorno',
        family: 'maestria',
        rarity: 28,
        check: () => {
          const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
          // Trova il giorno con il MAX numero di partite (giorno della maratona)
          let bestDate = null, bestCount = 0, bestGames = [];
          for (const [date, arr] of Object.entries(playsByDate)) {
            const count = arr.reduce((s, p) => s + (p.plays || 1), 0);
            if (count > bestCount) {
              bestCount = count;
              bestDate = date;
              bestGames = arr;
            }
          }
          const unlocked = bestCount >= 3;
          // Format data leggibile: es. "15 marzo 2026"
          let triggerHeader = null;
          let triggeredBy = null;
          if (unlocked && bestDate) {
            const months = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
            const d = new Date(bestDate + 'T00:00:00');
            const dateLabel = d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
            triggerHeader = '📅 Il ' + dateLabel + ' — ' + bestCount + (bestCount === 1 ? ' partita' : ' partite');
            // Lista giochi giocati quel giorno
            triggeredBy = bestGames.slice(0, 12).map(g => ({
              bggId: g.bggId,
              name: g.title || g.name,
              plays: g.plays || 1,
              img: g.img || null
            }));
          }
          return {
            unlocked,
            progress: (bestCount / 3) * 100,
            label: 'Massimo: ' + bestCount + ' partite/giorno',
            triggerHeader,
            triggeredBy
          };
        }
      });

      // 🌟 DISCOVERY
      addAchievement({
        id: 'versatile',
        icon: '🔮',
        name: 'Versatile',
        desc: 'Cooperativo + party + euro + american',
        family: 'esplorazione',
        rarity: 7,
        check: (p, act) => {
          const all = [...(p.topTypologies || []), ...(p.topTypologiesPrimary || []), ...(p.topTypologiesSecondary || [])];
          const need = ['coop', 'party', 'eurogame', 'american'];
          const matched = need.filter(n => all.includes(n));
          const unlocked = matched.length === 4;
          let triggeredBy = null;
          let triggerHeader = null;
          if (unlocked) {
            const TYPOLOGY_LABELS = FM.TYPOLOGY_LABELS || {};
            const list = [];
            for (const t of need) {
              for (const g of (act.topPlayed || [])) {
                const product = g.bggId ? this.products.find(prod => prod.bgg === g.bggId) : null;
                if (!product || !FM.deriveTypologies) continue;
                if (FM.deriveTypologies(product).includes(t)) {
                  list.push({
                    bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null,
                    typologyLabel: TYPOLOGY_LABELS[t] || t
                  });
                  break;
                }
              }
            }
            triggeredBy = list;
            triggerHeader = '🔮 Coop + Party + Euro + American: hai giocato a tutte e 4';
          }
          return {
            unlocked,
            progress: (matched.length / 4) * 100,
            label: matched.length + '/4 tipologie versatili',
            triggerHeader,
            triggeredBy
          };
        }
      });

      addAchievement({
        id: 'anteprima',
        icon: '✨',
        name: 'Anteprima',
        desc: 'Loggato un gioco pubblicato nell\'ultimo anno',
        family: 'esplorazione',
        rarity: 31,
        check: (p, act) => {
          const currentYear = new Date().getFullYear();
          const recents = (act.topPlayed || []).filter(g => {
            const yr = (typeof g.yr === 'number') ? g.yr : ((g.bggId ? (this.products.find(prod => prod.bgg === g.bggId) || {}).yr : null) || null);
            return yr && yr >= currentYear - 1;
          });
          // FIX 2026-06: badgeStats.hasRecentRelease copre TUTTE le partite
          const bsR = act.badgeStats;
          const isUnlocked = (bsR && typeof bsR.hasRecentRelease === 'boolean') ? bsR.hasRecentRelease : (recents.length > 0);
          return {
            unlocked: isUnlocked,
            progress: isUnlocked ? 100 : 0,
            triggeredBy: recents.slice(0, 8).map(g => {
              const product = this.products.find(prod => prod.bgg === g.bggId);
              return {
                bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null,
                yr: product && product.yr
              };
            })
          };
        }
      });

      // 💫 RARITY / STATUS
      addAchievement({
        id: 'solo_pro',
        icon: '🐉',
        name: 'Solo Pro',
        desc: '10+ partite in solitaria',
        family: 'compagnia',
        rarity: 6,
        check: (p, act) => {
          const soloGames = (act.topPlayed || []).filter(g => {
            if (g.isSolo) return true;
            const product = g.bggId ? this.products.find(prod => prod.bgg === g.bggId) : null;
            return product && product.f && product.f.solo;
          });
          const bs = act.badgeStats;
          const soloPlays = (bs && typeof bs.soloPlays === 'number')
            ? bs.soloPlays
            : soloGames.reduce((s, g) => s + (g.plays || 0), 0);
          return {
            unlocked: soloPlays >= 10,
            progress: (soloPlays / 10) * 100,
            label: soloPlays + '/10 partite solo',
            triggeredBy: soloGames.slice(0, 10).map(g => ({
              bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null
            }))
          };
        }
      });

      addAchievement({
        id: 'animatore',
        icon: '🎉',
        name: 'Animatore',
        desc: '10+ partite con 4+ giocatori',
        family: 'compagnia',
        rarity: 19,
        check: (p, act) => {
          const partyGames = (act.topPlayed || []).filter(g => {
            if ((g.pmax && g.pmax >= 4) || g.isParty) return true;
            const product = g.bggId ? this.products.find(prod => prod.bgg === g.bggId) : null;
            return product && product.pmax && product.pmax >= 4;
          });
          const bs = act.badgeStats;
          const partyPlays = (bs && typeof bs.groupPlays === 'number')
            ? bs.groupPlays
            : partyGames.reduce((s, g) => s + (g.plays || 0), 0);
          return {
            unlocked: partyPlays >= 10,
            progress: (partyPlays / 10) * 100,
            label: partyPlays + '/10 con tanti giocatori',
            triggeredBy: partyGames.slice(0, 10).map(g => ({
              bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null
            }))
          };
        }
      });

      addAchievement({
        id: 'pioniere',
        icon: '🌱',
        name: 'Pioniere',
        desc: 'Tra i primi 100 Frogger',
        hint: 'I padri fondatori della community',
        family: 'identita',
        rarity: 2,
        check: () => {
          // Per ora: chi si è registrato prima del 2026-09 (approssimazione)
          // In futuro: indice progressivo via worker
          const cutoff = new Date('2026-09-01').getTime();
          const created = p.createdAt || 0;
          return { unlocked: created > 0 && created < cutoff, progress: created > 0 && created < cutoff ? 100 : 0 };
        }
      });

      addAchievement({
        id: 'sincronizzato',
        icon: '🔄',
        name: 'Sincronizzato',
        desc: 'BGG collegato + community sharing attivo',
        family: 'identita',
        rarity: 33,
        check: (p) => {
          const a = !!(p.source === 'bgg' || p.bggUsername);
          const b = !!p.shareCommunityPlays;
          if (a && b) return { unlocked: true };
          if (a || b) return { unlocked: false, progress: 50 };
          return { unlocked: false, progress: 0 };
        }
      });

      addAchievement({
        id: 'padrone_di_casa',
        icon: '🏠',
        name: 'Padrone di Casa',
        desc: '5+ partite con almeno 2 stessi compagni',
        hint: 'Il tuo gruppo fisso del tavolo',
        family: 'compagnia',
        rarity: 16,
        check: (p, act) => {
          const companions = (act && act.companions) || [];
          const recurring = companions.filter(c => c.plays >= 5);
          const unlocked = recurring.length >= 2;
          if (unlocked) {
            return {
              unlocked: true,
              label: 'Hai ' + recurring.length + ' compagni fissi',
              triggerHeader: '🏠 Il tuo gruppo fisso: ' + recurring.length + ' Frogger',
              // Trasformiamo i companions in entries di tipo "compagno"
              // (la modal li renderizza con avatar iniziale + plays)
              triggeredBy: recurring.slice(0, 8).map(c => ({
                isCompanion: true,
                name: c.name,
                plays: c.plays,
                winRate: c.winRate,
                topGames: (c.topGames || []).slice(0, 3),
                bggId: null,
                img: null
              }))
            };
          }
          const top = companions[0];
          if (!top) return { unlocked: false, progress: 0 };
          const second = companions[1];
          const progress = second ? Math.min(100, (Math.min(top.plays, second.plays) / 5) * 100) : (top.plays / 5) * 50;
          return { unlocked: false, progress };
        }
      });

      // ════════════════════════════════════════════
      // V2 — 13 NUOVI ACHIEVEMENT (Step 1 — no metafield aggiuntivi)
      // ════════════════════════════════════════════

      // 🐸 IDENTITÀ NUOVI
      addAchievement({
        id: 'customizer',
        icon: '🎨',
        name: 'Customizer',
        desc: 'Hai personalizzato nome e motto',
        family: 'identita',
        rarity: 35,
        check: (p) => {
          const hasName = !!(p.displayName && p.displayName.trim().length > 0);
          const hasMotto = !!(p.motto && p.motto.trim().length > 0);
          if (hasName && hasMotto) return { unlocked: true };
          if (hasName || hasMotto) return { unlocked: false, progress: 50 };
          return { unlocked: false, progress: 0 };
        }
      });

      addAchievement({
        id: 'decennale',
        icon: '🌳',
        name: 'Decennale',
        desc: '10 anni nello stagno',
        hint: 'Per i Frogger di lunga data...',
        family: 'identita',
        rarity: 1,
        check: (p) => {
          if (!p.createdAt) return { unlocked: false, progress: 0 };
          const days = (Date.now() - p.createdAt) / 86400000;
          return { unlocked: days >= 3650, progress: Math.min(100, (days / 3650) * 100) };
        }
      });

      // 🎯 MAESTRIA NUOVI
      addAchievement({
        id: 'tour_de_force',
        icon: '⏳',
        name: 'Tour de Force',
        desc: '10 ore di gioco in un singolo giorno',
        hint: 'Una giornata epica al tavolo',
        family: 'maestria',
        rarity: 3,
        check: (p, act) => {
          const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
          if (!playsByDate || !act.totalMinutes || !act.totalPlays) return { unlocked: false, progress: 0 };
          const avgMinutesPerPlay = act.totalMinutes / act.totalPlays;
          let bestDay = null, bestDayMinutes = 0, bestDayPlays = 0;
          for (const d in playsByDate) {
            // Preferisci minuti reali se esposti dal worker (playsByDate v10+)
            const dayMinutesReal = (playsByDate[d] || []).reduce((s, pl) => s + (pl.minutes || 0), 0);
            const dayPlays = playsByDate[d].reduce((s, pl) => s + (pl.plays || 1), 0);
            const estMin = dayMinutesReal > 0 ? dayMinutesReal : dayPlays * avgMinutesPerPlay;
            if (estMin > bestDayMinutes) {
              bestDayMinutes = estMin;
              bestDay = d;
              bestDayPlays = dayPlays;
            }
          }
          const hours = bestDayMinutes / 60;
          const unlocked = hours >= 10;
          let triggerHeader = null, triggeredBy = null;
          if (unlocked && bestDay) {
            const months = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
            const dt = new Date(bestDay + 'T00:00:00');
            const dateLabel = dt.getDate() + ' ' + months[dt.getMonth()] + ' ' + dt.getFullYear();
            triggerHeader = '⏳ ' + dateLabel + ' — ' + hours.toFixed(1) + 'h, ' + bestDayPlays + ' partite';
            triggeredBy = (playsByDate[bestDay] || []).slice(0, 8).map(g => ({
              bggId: g.bggId, name: g.title || g.name, plays: g.plays || 1, img: g.img || null
            }));
          }
          return {
            unlocked,
            progress: Math.min(100, (hours / 10) * 100),
            label: 'Massimo stimato: ' + hours.toFixed(1) + 'h',
            triggerHeader,
            triggeredBy
          };
        }
      });

      addAchievement({
        id: 'comeback',
        icon: '🪞',
        name: 'Comeback',
        desc: 'Sei tornato dopo 90+ giorni di pausa',
        hint: 'Bentornato nello stagno',
        family: 'maestria',
        rarity: 12,
        check: () => {
          const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
          const dates = Object.keys(playsByDate).sort();
          if (dates.length < 2) return { unlocked: false, progress: 0 };
          for (let i = 1; i < dates.length; i++) {
            const gap = (new Date(dates[i]) - new Date(dates[i - 1])) / 86400000;
            if (gap >= 90) {
              const months = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
              const lastBefore = new Date(dates[i - 1] + 'T00:00:00');
              const firstBack = new Date(dates[i] + 'T00:00:00');
              const fmtDate = d => d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
              const triggerHeader = '🪞 Pausa di ' + Math.round(gap) + ' giorni: dal ' + fmtDate(lastBefore) + ' al ' + fmtDate(firstBack);
              const returnDay = playsByDate[dates[i]] || [];
              const triggeredBy = returnDay.slice(0, 6).map(g => ({
                bggId: g.bggId, name: g.title || g.name, plays: g.plays || 1, img: g.img || null
              }));
              return { unlocked: true, triggerHeader, triggeredBy };
            }
          }
          return { unlocked: false, progress: 0 };
        }
      });

      addAchievement({
        id: 'adattabile',
        icon: '⚖️',
        name: 'Adattabile',
        desc: '5+ partite peso leggero E 5+ peso medio-pesante',
        family: 'maestria',
        rarity: 13,
        check: (p, act) => {
          let lightPlays = 0, heavyPlays = 0;
          const lightGames = [], heavyGames = [];
          (act.topPlayed || []).forEach(g => {
            let w = (typeof g.w === 'number' && g.w > 0) ? g.w : null;
            if (w == null) { const product = g.bggId ? this.products.find(prod => prod.bgg === g.bggId) : null; w = (product && product.w) || null; }
            if (!w) return;
            if (w < 2) {
              lightPlays += (g.plays || 0);
              lightGames.push({ bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null, weight: w });
            } else if (w >= 3) {
              heavyPlays += (g.plays || 0);
              heavyGames.push({ bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null, weight: w });
            }
          });
          // FIX 2026-06: sblocco sui totali di TUTTE le partite (badgeStats); esempi dai top-30
          const bsA = act.badgeStats;
          if (bsA && typeof bsA.lightPlays === 'number') lightPlays = bsA.lightPlays;
          if (bsA && typeof bsA.heavyPlays === 'number') heavyPlays = bsA.heavyPlays;
          const unlocked = lightPlays >= 5 && heavyPlays >= 5;
          if (unlocked) {
            return {
              unlocked: true,
              triggerHeader: '⚖️ ' + lightPlays + ' partite leggere · ' + heavyPlays + ' pesanti',
              triggeredBy: [
                ...lightGames.sort((a, b) => b.plays - a.plays).slice(0, 4),
                ...heavyGames.sort((a, b) => b.plays - a.plays).slice(0, 4)
              ]
            };
          }
          const avg = (Math.min(5, lightPlays) + Math.min(5, heavyPlays)) / 10 * 100;
          return { unlocked: false, progress: avg, label: 'Leggeri: ' + lightPlays + ' · Pesanti: ' + heavyPlays };
        }
      });

      // 🌍 ESPLORAZIONE NUOVI
      addAchievement({
        id: 'viaggio_nel_tempo',
        icon: '⏰',
        name: 'Viaggio nel Tempo',
        desc: 'Giocato un titolo di ogni decennio: ’80, ’90, ’00, ’10',
        family: 'esplorazione',
        rarity: 7,
        check: (p, act) => {
          const decades = {};
          (act.topPlayed || []).forEach(g => {
            let yr = (typeof g.yr === 'number') ? g.yr : null;
            if (yr == null) { const product = g.bggId ? this.products.find(prod => prod.bgg === g.bggId) : null; yr = (product && product.yr) || null; }
            if (!yr) return;
            let key = null;
            if (yr >= 1980 && yr < 1990) key = '80';
            else if (yr >= 1990 && yr < 2000) key = '90';
            else if (yr >= 2000 && yr < 2010) key = '00';
            else if (yr >= 2010 && yr < 2020) key = '10';
            if (key && !decades[key]) {
              decades[key] = {
                bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null,
                yr: yr,
                decadeLabel: 'Anni \'' + key
              };
            }
          });
          // FIX 2026-06: conteggio decenni su TUTTE le partite (badgeStats) per lo sblocco
          const bsV = act.badgeStats;
          const count = (bsV && Array.isArray(bsV.decadesPlayed))
            ? [1980, 1990, 2000, 2010].filter(d => bsV.decadesPlayed.indexOf(d) !== -1).length
            : Object.keys(decades).length;
          const unlocked = count === 4;
          return {
            unlocked,
            progress: (count / 4) * 100,
            label: count + '/4 decenni',
            triggerHeader: unlocked ? '⏰ Un gioco da ognuno dei 4 decenni' : null,
            triggeredBy: unlocked
              ? ['80', '90', '00', '10'].map(k => decades[k]).filter(Boolean)
              : null
          };
        }
      });

      addAchievement({
        id: 'polyglot',
        icon: '🧬',
        name: 'Polyglot',
        desc: '5 meccaniche diverse con 5+ partite ognuna',
        family: 'esplorazione',
        rarity: 6,
        check: (p, act) => {
          const mechCount = {};
          const mechGames = {}; // mech → game più giocato per quella mech
          (act.topPlayed || []).forEach(g => {
            let mch = Array.isArray(g.mch) ? g.mch : null;
            if (!mch) { const product = g.bggId ? this.products.find(prod => prod.bgg === g.bggId) : null; mch = (product && product.mch) || null; }
            if (!mch) return;
            mch.forEach(m => {
              mechCount[m] = (mechCount[m] || 0) + (g.plays || 0);
              if (!mechGames[m] || mechGames[m].plays < g.plays) {
                mechGames[m] = { bggId: g.bggId, name: g.name, plays: g.plays, img: g.img || null, mech: m };
              }
            });
          });
          const passing = Object.entries(mechCount).filter(([, c]) => c >= 5).map(([m]) => m);
          // FIX 2026-06: conteggio meccaniche su TUTTE le partite (badgeStats) per lo sblocco
          const bsP = act.badgeStats;
          const passingCount = (bsP && typeof bsP.polyglotMechCount === 'number') ? bsP.polyglotMechCount : passing.length;
          const unlocked = passingCount >= 5;
          let triggeredBy = null;
          let triggerHeader = null;
          if (unlocked) {
            // Mostra 1 gioco rappresentativo per ognuna delle top 5 meccaniche padroneggiate
            const tMech = FM.tMech || (m => m);
            triggerHeader = '🧬 5 meccaniche padroneggiate';
            triggeredBy = passing
              .sort((a, b) => mechCount[b] - mechCount[a])
              .slice(0, 5)
              .map(m => {
                const g = mechGames[m];
                if (!g) return null;
                return Object.assign({}, g, { typologyLabel: tMech(m) });
              })
              .filter(Boolean);
          }
          return {
            unlocked,
            progress: (passingCount / 5) * 100,
            label: passingCount + '/5 meccaniche padroneggiate',
            triggerHeader,
            triggeredBy
          };
        }
      });

      // 🤝 COMPAGNIA NUOVI
      addAchievement({
        id: 'network',
        icon: '🌐',
        name: 'Network',
        desc: 'Giocato con 10+ compagni diversi',
        family: 'compagnia',
        rarity: 14,
        check: (p, act) => {
          const c = (act && act.companions) || [];
          const unlocked = c.length >= 10;
          let triggerHeader = null, triggeredBy = null;
          if (unlocked) {
            triggerHeader = '🌐 ' + c.length + ' compagni diversi al tavolo';
            triggeredBy = c.slice(0, 12).map(comp => ({
              isCompanion: true,
              name: comp.name,
              plays: comp.plays,
              winRate: comp.winRate,
              topGames: (comp.topGames || []).slice(0, 2),
              bggId: null,
              img: null
            }));
          }
          return {
            unlocked,
            progress: (c.length / 10) * 100,
            label: c.length + '/10 compagni diversi',
            triggerHeader,
            triggeredBy
          };
        }
      });

      addAchievement({
        id: 'amico_fidato',
        icon: '💚',
        name: 'Amico Fidato',
        desc: '10+ partite con lo stesso compagno',
        family: 'compagnia',
        rarity: 10,
        check: (p, act) => {
          const c = (act && act.companions) || [];
          const top = c[0];
          if (!top) return { unlocked: false, progress: 0 };
          const unlocked = top.plays >= 10;
          let triggerHeader = null;
          let triggeredBy = null;
          if (unlocked) {
            const winRateLabel = (top.winRate != null && (top.wins + top.losses) > 0)
              ? ' · ' + top.winRate + '% le vince lui'
              : '';
            triggerHeader = '👥 ' + top.name + ' — ' + top.plays + ' partite insieme' + winRateLabel;
            // Trasforma topGames del compagno in lista clickable
            const topGames = top.topGames || [];
            triggeredBy = topGames.slice(0, 8).map(name => {
              // Cerca nel catalogo Frogames per cover/url
              const product = this.products.find(prod => prod.t && prod.t.toLowerCase() === name.toLowerCase());
              return {
                bggId: product ? product.bgg : null,
                name,
                plays: 0, // BGG non espone breakdown plays-per-gioco-per-compagno
                img: product ? product.img : null
              };
            });
            // Se non ci sono topGames del compagno, almeno popoliamo placeholder per render modal
            if (triggeredBy.length === 0) {
              triggeredBy = [{ bggId: null, name: 'Top giochi non disponibili', plays: 0, img: null }];
            }
          }
          return {
            unlocked,
            progress: unlocked ? 100 : (top.plays / 10) * 100,
            label: unlocked ? (top.name + ' · ' + top.plays + ' partite insieme') : (top.name + ' · ' + top.plays + '/10'),
            triggerHeader,
            triggeredBy
          };
        }
      });

      // ════════════════════════════════════════════
      // 💎 COLLEZIONISMO V3 — basato su OWNED (BGG own=true)
      // ════════════════════════════════════════════

      // Helper per scorrere i giochi posseduti con dettagli.
      // Priorità fonti metadata:
      //   1. Catalogo Frogames (this.products) — più ricco (mch, cat, f, w, yr, tmin, tmax)
      //   2. BGG enriched topPlayed (act.topPlayed) — per giochi BGG-only giocati
      //      (popolato da fetchBggThingMetadata: w, yr, tmin, tmax, cat, mch, isSolo, isCoop, isParty)
      //   3. Stub minimal (solo bggId, name, img) — per giochi BGG-only mai giocati
      // Senza fix, i badge collezionismo sottostimavano quando l'utente aveva tanti giochi BGG fuori catalogo.
      //
      // PERFORMANCE FIX 2026-05-08: memoizzato. La funzione era chiamata 20+ volte
      // (ogni badge collezionismo: measure() + getTriggeredBy()), ora computa una
      // sola volta. Combinato con productsByBgg.get (O(1)) il costo crolla da
      // O(N×M) × 20 a O(N) × 1. Su profili 500+ owned: da 30s a <100ms.
      let _ownedCache = null;
      const getOwnedWithDetails = () => {
        if (_ownedCache) return _ownedCache;
        const topPlayedByBgg = {};
        if (act && Array.isArray(act.topPlayed)) {
          for (const tp of act.topPlayed) {
            if (tp.bggId) topPlayedByBgg[tp.bggId] = tp;
          }
        }
        // Deriva i flag solo/coop/party da categorie+meccaniche BGG.
        const deriveF = (cat, mch) => {
          const c = (Array.isArray(cat) ? cat : []).join(' ').toLowerCase();
          const m = (Array.isArray(mch) ? mch : []).join(' ').toLowerCase();
          return {
            coop: m.indexOf('cooperative') !== -1,
            party: c.indexOf('party') !== -1,
            solo: m.indexOf('solitaire') !== -1 || m.indexOf('solo') !== -1 || c.indexOf('solitaire') !== -1,
            t2p: false, team: false
          };
        };
        // Oggetto-dettaglio per un gioco posseduto. Priorità metadata:
        //   1. Catalogo Frogames → 2. Metadati BGG dell'item (enrichment worker:
        //      copre i posseduti FUORI catalogo) → 3. topPlayed → 4. stub (solo anno)
        const buildDetail = (bggId, name, thumb, meta) => {
          meta = meta || {};
          const collYr = meta.yr || meta.year || null;
          const product = bggId ? productsByBgg.get(bggId) : null;
          if (product) return (!product.yr && collYr) ? Object.assign({}, product, { yr: collYr }) : product;
          // Metadati BGG arricchiti sull'item (peso/durata/categorie/meccaniche).
          const hasMeta = (meta.w != null) || (Array.isArray(meta.mch) && meta.mch.length > 0) ||
                          (Array.isArray(meta.cat) && meta.cat.length > 0) || (meta.tmin != null) || (meta.tmax != null);
          if (hasMeta) {
            return {
              bgg: bggId, t: name || (bggId ? ('Gioco BGG ' + bggId) : 'Gioco'), img: thumb || null,
              w: (meta.w != null) ? meta.w : null, yr: collYr,
              tmin: (meta.tmin != null) ? meta.tmin : null, tmax: (meta.tmax != null) ? meta.tmax : null,
              mch: meta.mch || [], cat: meta.cat || [], f: deriveF(meta.cat, meta.mch),
              _fromBggMeta: true
            };
          }
          const tp = bggId ? topPlayedByBgg[bggId] : null;
          if (tp) {
            return {
              bgg: bggId, t: tp.name || name, img: tp.img || thumb || null,
              w: tp.w || null, yr: tp.yr || collYr || null, tmin: tp.tmin || null, tmax: tp.tmax || null,
              mch: tp.mch || [], cat: tp.cat || [],
              f: { coop: !!tp.isCoop, party: !!tp.isParty, solo: !!tp.isSolo, t2p: false, team: false },
              _fromBggEnriched: true
            };
          }
          return {
            bgg: bggId, t: name || (bggId ? ('Gioco BGG ' + bggId) : 'Gioco'), img: thumb || null,
            w: null, yr: collYr || null, tmin: null, tmax: null, mch: [], cat: [],
            f: { coop: false, party: false, solo: false, t2p: false, team: false },
            _fromBggStub: true
          };
        };

        // LUDOTECA COMPLETA = BGG owned + acquisti Frogames + aggiunti a mano
        // (stessa unione di collectCollection). PRIMA contava SOLO i BGG own=1, quindi
        // i giochi comprati da Frogames e non taggati su BGG erano invisibili a TUTTI
        // gli obiettivi-collezione (New Wave, Vintage, Big Box, ecc.). Dedup per bggId.
        const result = [];
        const seen = new Set();

        // 1. BGG owned
        const ownedBgg = (p.bggCollection && p.bggCollection.owned) || [];
        for (const item of ownedBgg) {
          const bggId = (typeof item === 'object') ? item.id : item;
          if (bggId && seen.has(bggId)) continue;
          if (bggId) seen.add(bggId);
          const name = (typeof item === 'object') ? item.name : null;
          const thumb = (typeof item === 'object') ? item.thumbnail : null;
          // L'item porta i metadati BGG arricchiti dal worker (yr/w/tmin/tmax/cat/mch).
          const meta = (typeof item === 'object') ? item : {};
          result.push(buildDetail(bggId, name, thumb, meta));
        }

        // 2. Acquisti Frogames (il catalogo porta anno/peso/durata/flag)
        if (Array.isArray(p.purchasedProducts)) {
          let productsById = null;
          for (const purch of p.purchasedProducts) {
            let product = purch.bggId ? productsByBgg.get(purch.bggId) : null;
            if (!product && purch.productId) {
              if (!productsById) {
                productsById = new Map();
                for (const pr of (this.products || [])) productsById.set(String(pr.id), pr);
              }
              product = productsById.get(String(purch.productId)) || null;
            }
            const bggId = (product && product.bgg) || purch.bggId || null;
            if (bggId && seen.has(bggId)) continue;
            if (bggId) seen.add(bggId);
            if (product) result.push(product);
            else result.push({
              bgg: bggId, t: purch.title || 'Gioco', img: purch.img || null,
              w: null, yr: null, tmin: null, tmax: null, mch: [], cat: [],
              f: { coop: false, party: false, solo: false, t2p: false, team: false },
              _fromPurchaseStub: true
            });
          }
        }

        // 3. Aggiunti a mano (ludoteca per chi non ha BGG sync)
        if (Array.isArray(p.manualOwned)) {
          for (const m of p.manualOwned) {
            const bggId = m.bggId || null;
            if (bggId && seen.has(bggId)) continue;
            if (bggId) seen.add(bggId);
            const product = bggId ? productsByBgg.get(bggId) : null;
            if (product) result.push(product);
            else result.push({
              bgg: bggId, t: m.name || 'Gioco', img: m.img || null,
              w: null, yr: m.yr || m.year || null, tmin: null, tmax: null, mch: [], cat: [],
              f: { coop: false, party: false, solo: false, t2p: false, team: false },
              _fromManualStub: true
            });
          }
        }

        _ownedCache = result;
        return _ownedCache;
      };

      addAchievement({
        id: 'possessore',
        icon: '📦',
        name: 'Possessore',
        desc: 'Giochi nella tua ludoteca',
        family: 'collezionismo',
        tiers: [
          { value: 10, label: 'Bronzo', rarity: 60 },
          { value: 50, label: 'Argento', rarity: 30 },
          { value: 200, label: 'Oro', rarity: 12 },
          { value: 500, label: 'Diamante', rarity: 3 },
          { value: 1000, label: 'Leggendario', rarity: 0.5 }
        ],
        measure: () => getOwnedWithDetails().length,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' giochi' : v + ' giochi posseduti',
        getTriggeredBy: () => {
          // Mostra fino a 12 giochi della ludoteca (con priorità: catalogo Frogames con cover)
          const owned = getOwnedWithDetails();
          return owned.slice(0, 12).map(prod => ({
            bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null
          }));
        }
      });

      addAchievement({
        id: 'curator',
        icon: '🎓',
        name: 'Curator',
        desc: 'Giochi peso 3+ posseduti',
        hint: 'Per chi predilige i pesi massimi',
        family: 'collezionismo',
        tiers: [
          { value: 5, label: 'Bronzo', rarity: 35 },
          { value: 20, label: 'Argento', rarity: 15 },
          { value: 50, label: 'Oro', rarity: 5 },
          { value: 100, label: 'Diamante', rarity: 1 }
        ],
        measure: () => getOwnedWithDetails().filter(prod => prod.w && prod.w >= 3).length,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' pesi 3+' : v + ' giochi peso 3+',
        getTriggeredBy: () => getOwnedWithDetails().filter(prod => prod.w && prod.w >= 3).slice(0, 12).map(prod => ({
          bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null
        }))
      });

      addAchievement({
        id: 'vintage_hunter',
        icon: '📼',
        name: 'Vintage Hunter',
        desc: 'Giochi anni ’90 posseduti',
        family: 'collezionismo',
        tiers: [
          { value: 1, label: 'Bronzo', rarity: 30 },
          { value: 3, label: 'Argento', rarity: 12 },
          { value: 8, label: 'Oro', rarity: 4 },
          { value: 15, label: 'Diamante', rarity: 1 }
        ],
        measure: () => getOwnedWithDetails().filter(prod => prod.yr >= 1990 && prod.yr < 2000).length,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' anni ’90' : v + ' titoli ’90',
        getTriggeredBy: () => getOwnedWithDetails().filter(prod => prod.yr >= 1990 && prod.yr < 2000).slice(0, 12).map(prod => ({
          bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null, yr: prod.yr
        }))
      });

      addAchievement({
        id: 'cult_master',
        icon: '👑',
        name: 'Cult Master',
        desc: 'Giochi anni ’80 o prima posseduti',
        hint: 'Pochi conoscono i veri classici',
        family: 'collezionismo',
        tiers: [
          { value: 1, label: 'Bronzo', rarity: 12 },
          { value: 3, label: 'Argento', rarity: 4 },
          { value: 8, label: 'Oro', rarity: 1 }
        ],
        measure: () => getOwnedWithDetails().filter(prod => prod.yr > 0 && prod.yr < 1990).length,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' classici' : v + ' classici',
        getTriggeredBy: () => getOwnedWithDetails().filter(prod => prod.yr > 0 && prod.yr < 1990).slice(0, 12).map(prod => ({
          bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null, yr: prod.yr
        }))
      });

      addAchievement({
        id: 'new_wave',
        icon: '🌊',
        name: 'New Wave',
        desc: 'Giochi che possiedi usciti negli ultimi 2 anni',
        family: 'collezionismo',
        tiers: [
          { value: 5, label: 'Bronzo', rarity: 40 },
          { value: 15, label: 'Argento', rarity: 18 },
          { value: 30, label: 'Oro', rarity: 6 },
          { value: 60, label: 'Diamante', rarity: 1.5 }
        ],
        measure: () => {
          const cur = new Date().getFullYear();
          return getOwnedWithDetails().filter(prod => prod.yr >= cur - 1).length;
        },
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' usciti di recente' : v + ' usciti negli ultimi 2 anni',
        getTriggeredBy: () => {
          const cur = new Date().getFullYear();
          return getOwnedWithDetails().filter(prod => prod.yr >= cur - 1).slice(0, 12).map(prod => ({
            bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null, yr: prod.yr
          }));
        }
      });

      addAchievement({
        id: 'big_box',
        icon: '🧱',
        name: 'Big Box',
        desc: 'Giochi peso 4+ posseduti (i pesi massimi veri)',
        family: 'collezionismo',
        tiers: [
          { value: 1, label: 'Bronzo', rarity: 25 },
          { value: 3, label: 'Argento', rarity: 10 },
          { value: 8, label: 'Oro', rarity: 3 },
          { value: 15, label: 'Diamante', rarity: 0.8 }
        ],
        measure: () => getOwnedWithDetails().filter(prod => prod.w && prod.w >= 4).length,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' big box' : v + ' big box',
        getTriggeredBy: () => getOwnedWithDetails().filter(prod => prod.w && prod.w >= 4).slice(0, 12).map(prod => ({
          bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null
        }))
      });

      addAchievement({
        id: 'filler_lover',
        icon: '⚡',
        name: 'Filler Lover',
        desc: 'Giochi <30 minuti posseduti',
        family: 'collezionismo',
        tiers: [
          { value: 5, label: 'Bronzo', rarity: 35 },
          { value: 20, label: 'Argento', rarity: 12 },
          { value: 50, label: 'Oro', rarity: 3 }
        ],
        measure: () => getOwnedWithDetails().filter(prod => prod.tmax > 0 && prod.tmax <= 30).length,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' filler' : v + ' filler',
        getTriggeredBy: () => getOwnedWithDetails().filter(prod => prod.tmax > 0 && prod.tmax <= 30).slice(0, 12).map(prod => ({
          bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null, durationMin: prod.tmax
        }))
      });

      addAchievement({
        id: 'marathon_owner',
        icon: '🏔',
        name: 'Marathon Owner',
        desc: 'Giochi 120+ minuti posseduti',
        family: 'collezionismo',
        tiers: [
          { value: 5, label: 'Bronzo', rarity: 30 },
          { value: 20, label: 'Argento', rarity: 10 },
          { value: 50, label: 'Oro', rarity: 2 }
        ],
        measure: () => getOwnedWithDetails().filter(prod => prod.tmin >= 120).length,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' lunghi' : v + ' giochi lunghi',
        getTriggeredBy: () => getOwnedWithDetails().filter(prod => prod.tmin >= 120).slice(0, 12).map(prod => ({
          bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null, durationMin: prod.tmin
        }))
      });

      addAchievement({
        id: 'solo_stash',
        icon: '🐺',
        name: 'Solo Stash',
        desc: 'Giochi solo-friendly posseduti',
        family: 'collezionismo',
        tiers: [
          { value: 5, label: 'Bronzo', rarity: 25 },
          { value: 15, label: 'Argento', rarity: 9 },
          { value: 30, label: 'Oro', rarity: 2 }
        ],
        measure: () => getOwnedWithDetails().filter(prod => prod.f && prod.f.solo).length,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' solo' : v + ' solo-friendly',
        getTriggeredBy: () => getOwnedWithDetails().filter(prod => prod.f && prod.f.solo).slice(0, 12).map(prod => ({
          bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null
        }))
      });

      addAchievement({
        id: 'coop_stash',
        icon: '🤜🤛',
        name: 'Coop Stash',
        desc: 'Giochi cooperativi posseduti',
        family: 'collezionismo',
        tiers: [
          { value: 5, label: 'Bronzo', rarity: 30 },
          { value: 15, label: 'Argento', rarity: 12 },
          { value: 30, label: 'Oro', rarity: 3 }
        ],
        measure: () => getOwnedWithDetails().filter(prod => prod.f && prod.f.coop).length,
        formatLabel: (v, cur, next) => next ? v + ' / ' + next.value + ' coop' : v + ' coop posseduti',
        getTriggeredBy: () => getOwnedWithDetails().filter(prod => prod.f && prod.f.coop).slice(0, 12).map(prod => ({
          bggId: prod.bgg, name: prod.t, plays: 0, img: prod.img || null
        }))
      });

      // ── Override rarity con dati reali se sample sufficient ──
      if (this.badgeStats && this.badgeStats.sampleSufficient && this.badgeStats.badges) {
        out.forEach(a => {
          const stat = this.badgeStats.badges[a.id];
          if (!stat) return;
          // Se tiered, prova prima il valore del tier corrente
          if (a.isTiered && a.currentTier >= 0 && stat.tiers && stat.tiers[a.currentTier]) {
            a.rarity = stat.tiers[a.currentTier].pct;
          } else if (typeof stat.pct === 'number') {
            a.rarity = stat.pct;
          }
          a.rarityLive = true;
          a.raritySampleSize = this.badgeStats.total;
        });
      }

      // ── Aggiorna sistema "Recently Earned": traccia timestamp unlock ──
      this.updateUnlockedTimestamps(out);

      return out;
    }

    /**
     * Personal Records: i tuoi best personali (Duolingo "Personal Records" pattern)
     */
    computeRecords() {
      const p = this.profile;
      const act = p.playsActivity || {};
      const out = [];

      if (act.totalPlays > 0) {
        out.push({ icon: '🎲', label: 'Partite totali loggate', value: String(act.totalPlays) });
      }
      if (act.totalMinutes > 0) {
        const hrs = Math.round(act.totalMinutes / 60);
        out.push({ icon: '⏱', label: 'Ore al tavolo', value: hrs + 'h' });
      }
      if (act.uniqueGames > 0) {
        out.push({ icon: '🌍', label: 'Giochi diversi giocati', value: String(act.uniqueGames) });
      }

      // Gioco più giocato REALE (BGG + manuali, deduplicato) — non act.topPlayed[0]
      // che dopo un re-sync BGG perde le manuali (mostrava Maquis invece del reale).
      const top = this.getMostPlayed();
      if (top) {
        out.push({ icon: '🏆', label: 'Più giocato in assoluto', value: top.name + ' (' + top.plays + ' partite)' });
      }

      // Sessione più lunga
      const longest = (act.topPlayed || []).reduce((max, g) => {
        if (!g.minutes || !g.plays || g.plays === 0) return max;
        const avgMin = g.minutes / g.plays;
        return avgMin > max.min ? { min: avgMin, name: g.name } : max;
      }, { min: 0, name: '' });
      if (longest.min > 0) {
        const hrs = (longest.min / 60).toFixed(1);
        out.push({ icon: '🕰', label: 'Sessione media più lunga', value: longest.name + ' · ' + (longest.min >= 60 ? hrs + 'h' : Math.round(longest.min) + ' min') });
      }

      // Tipologia dominante
      const primTyp = (p.topTypologiesPrimary || p.topTypologies || [])[0];
      if (primTyp && FM.TYPOLOGY_LABELS) {
        out.push({ icon: '🎯', label: 'Tipologia dominante', value: FM.TYPOLOGY_LABELS[primTyp] || primTyp });
      }

      // Streak corrente (calcolata "ad oggi")
      const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
      const dates = Object.keys(playsByDate).sort().reverse();
      if (dates.length > 0) {
        let streak = 0;
        let cur = new Date();
        cur.setHours(0, 0, 0, 0);
        for (const d of dates) {
          const dt = new Date(d);
          dt.setHours(0, 0, 0, 0);
          const diff = Math.round((cur - dt) / 86400000);
          if (diff === 0 || diff === streak + 1 || (streak === 0 && diff <= 1)) {
            if (streak === 0 && diff <= 1) streak = 1;
            else if (diff === streak + 1) streak++;
            cur = dt;
          } else break;
        }
        if (streak > 0) {
          out.push({ icon: '🔥', label: 'Streak corrente', value: streak + (streak === 1 ? ' giorno' : ' giorni') });
        }
      }

      // Mese più attivo
      if (Object.keys(playsByDate).length > 0) {
        const monthCount = {};
        for (const d in playsByDate) {
          const m = d.slice(0, 7);
          monthCount[m] = (monthCount[m] || 0) + playsByDate[d].length;
        }
        const topMonth = Object.entries(monthCount).sort((a, b) => b[1] - a[1])[0];
        if (topMonth) {
          const [ym, count] = topMonth;
          const [year, month] = ym.split('-').map(Number);
          const monthNames = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
          out.push({ icon: '📈', label: 'Mese più attivo', value: monthNames[month - 1] + ' ' + year + ' (' + count + ' partite)' });
        }
      }

      return out;
    }

    // ────────────────────────────────────────
    // DRILL-DOWN: mostra solo quelli con dati reali, popola body
    // ────────────────────────────────────────
    renderDrillDown() {
      const act = this.profile.playsActivity;

      // ── Drill PARTITE RECENTI (BGG topPlayed + manualPlays merged) ──
      // SEMPRE visibile: con 0 partite mostra empty state + CTA registra
      const playsDrill = this.root.querySelector('[data-fp-drill="plays"]');
      const playsBody = this.root.querySelector('[data-fp-drill-plays]');
      const playsCount = this.root.querySelector('[data-fp-drill-plays-count]');
      const recentPlays = this.collectRecentPlays();
      if (playsDrill && playsBody) {
        playsDrill.hidden = false;
        if (playsCount) playsCount.textContent = recentPlays.length === 0
          ? 'nessuna ancora'
          : recentPlays.length + (recentPlays.length === 1 ? ' partita' : ' partite');
        if (recentPlays.length > 0) {
          playsBody.innerHTML = this.renderPlaysList(recentPlays);
          this.bindPlaysListActions(playsBody);
        } else {
          playsBody.innerHTML =
            '<div class="fp-section-cta fp-section-cta--inline">' +
              '<p class="fp-section-cta__text">📜 Nessuna partita registrata. <strong>Registra la prossima</strong> e inizia il tuo diario al tavolo.</p>' +
              '<button type="button" class="fp-section-cta__btn" data-fm-log-play>🎲 Registra una partita</button>' +
            '</div>';
        }
      }

      // ── Drill COLLEZIONE (BGG owned + acquisti Frogames + manualOwned + favorites) ──
      // Mostriamo SEMPRE il drill (anche con 0 giochi) per dare CTA "Aggiungi gioco"
      const collDrill = this.root.querySelector('[data-fp-drill="collection"]');
      const collBody = this.root.querySelector('[data-fp-drill-collection]');
      const collCount = this.root.querySelector('[data-fp-drill-collection-count]');
      const collGames = this.collectCollection();
      if (collDrill && collBody) {
        collDrill.hidden = false;
        if (collCount) collCount.textContent = collGames.length === 0
          ? 'vuota'
          : collGames.length + (collGames.length === 1 ? ' gioco' : ' giochi');
        if (collGames.length > 0) {
          collBody.innerHTML = this.renderCollectionGrid(collGames);
          this.bindCollectionControls(collGames);
        } else {
          collBody.innerHTML = this.renderCollectionEmpty();
        }
      }

      // ── Drill "Il tuo viaggio Frogger" — SEMPRE visibile per chi ha un profilo ──
      // FIX 2026-05-11: il check hasDnaData precedente richiedeva almeno UNO tra
      // topMechanics/Categories/Designers/interactionPreference/aleaPreference.
      // Per onboarder manuali che saltavano gli step opzionali del quiz (meccaniche
      // e categorie sono optional), tutti falsi → sezione nascosta → manca tutto
      // il "Viaggio Frogger" incluso il diff Genesi vs Oggi (utile a tutti).
      // Ora la sezione è sempre visibile: renderJourney gestisce internamente
      // i blocchi vuoti (skip "Meccaniche preferite" se vuoto, ecc.).
      const dnaDrill = this.root.querySelector('[data-fp-drill="dna"]');
      const dnaBody = this.root.querySelector('[data-fp-drill-dna]');
      if (dnaDrill && dnaBody) {
        dnaDrill.hidden = false;
        dnaBody.innerHTML = this.renderDnaContent();
      }

      // ── Drill COMPAGNI DI TAVOLO (BGG + partite manuali, fusi) ──
      const compDrill = this.root.querySelector('[data-fp-drill="companions"]');
      const compBody = this.root.querySelector('[data-fp-drill-companions]');
      const compCount = this.root.querySelector('[data-fp-drill-companions-count]');
      const companions = this.getMergedCompanions();
      if (companions.length > 0 && compDrill && compBody) {
        compDrill.hidden = false;
        if (compCount) compCount.textContent = companions.length + ' persone';
        compBody.innerHTML = this.renderCompanionsList(companions);
      }
    }

    renderCompanionsList(companions) {
      return '<ul class="fp-companions">' + companions.map(c => {
        const winRateLabel = (c.winRate != null && (c.wins + c.losses) > 0) ?
          '<span class="fp-companions__winrate">Win rate: ' + c.winRate + '%</span>' : '';
        const topGames = c.topGames && c.topGames.length > 0 ?
          '<span class="fp-companions__games">Top: ' + c.topGames.slice(0, 2).map(escapeHtml).join(' · ') + '</span>' : '';
        // Tag ✋ per chi appare SOLO dalle partite registrate a mano (non da BGG)
        const manualTag = (c.fromBgg === false)
          ? ' <span class="fp-companions__tag" title="Dalle partite che hai registrato a mano">✋</span>' : '';
        return '<li class="fp-companions__item">' +
          '<span class="fp-companions__avatar">' + escapeHtml((c.name || '?').slice(0, 1).toUpperCase()) + '</span>' +
          '<div class="fp-companions__body">' +
            '<span class="fp-companions__name">' + escapeHtml((this && this.companionLabel ? this.companionLabel(c.name) : c.name) || '—') + manualTag + '</span>' +
            '<span class="fp-companions__plays">' + c.plays + (c.plays === 1 ? ' partita' : ' partite') + ' insieme</span>' +
            (topGames ? '<span class="fp-companions__games-row">' + topGames + '</span>' : '') +
          '</div>' +
          winRateLabel +
        '</li>';
      }).join('') + '</ul>';
    }

    // Helpers per drill-down

    collectRecentPlays() {
      const out = [];
      const act = this.profile.playsActivity;

      // Fingerprint delle manualPlays per dedup: una manualPlay e la sua
      // entry "ombra" in topPlayed (creata da mergeManualPlayIntoActivity)
      // sono la STESSA partita — vanno mostrate UNA volta sola, con la
      // versione manual (ha edit/delete + dati di durata/giocatori precisi).
      // Bug 2026-05-16: Martina vedeva ogni partita registrata DOPPIA per
      // questa duplicazione di rendering.
      const manualKeys = new Set();
      if (this.profile.manualPlays) {
        for (const p of this.profile.manualPlays) {
          const id = (p.bggId || p.productId || p.title || '').toString().toLowerCase();
          if (id) manualKeys.add(id + '|' + p.date);
        }
      }

      // BGG/aggregato topPlayed: includi solo se NON c'è una manualPlay
      // corrispondente per stesso gioco + stessa data.
      if (act && act.topPlayed) {
        for (const g of act.topPlayed) {
          if (!g.lastPlayed) continue;
          const id = (g.bggId || g.productId || g.name || '').toString().toLowerCase();
          const key = id + '|' + g.lastPlayed;
          if (manualKeys.has(key)) continue; // shadow di una manualPlay → skip
          out.push({
            date: g.lastPlayed,
            title: g.name,
            bggId: g.bggId,
            plays: g.plays,
            minutes: g.minutes,
            source: g.source || 'bgg'
          });
        }
      }

      // Manual plays: tutte (include playId per edit/delete UI)
      if (this.profile.manualPlays) {
        for (const p of this.profile.manualPlays) {
          out.push({
            playId: p.id,
            date: p.date,
            title: p.title,
            bggId: p.bggId,
            productId: p.productId,
            plays: 1,
            minutes: p.minutes || 0,
            rating: p.rating,
            players: p.players,
            extras: Array.isArray(p.extras) ? p.extras : [], // espansioni/set usati
            context: p.context || 'tavolo', // dove: tavolo | bga | online
            companions: Array.isArray(p.playersList)
              ? p.playersList.filter(x => x && !x.isBot && x.name && x.name.trim()).map(x => x.name.trim())
              : [],
            source: 'manual'
          });
        }
      }
      out.sort((a, b) => (b.date || '').localeCompare(a.date || ''));
      return out.slice(0, 15);
    }

    renderPlaysList(plays) {
      // Statistica "dal vivo vs online" su TUTTE le partite manuali (non solo le 15 recenti).
      // Mostrata solo se c'è almeno una partita online, altrimenti è rumore inutile.
      let ctxStat = '';
      const allManual = Array.isArray(this.profile.manualPlays) ? this.profile.manualPlays : [];
      if (allManual.length > 0) {
        let live = 0, online = 0;
        for (const mp of allManual) {
          const ctx = mp.context || 'tavolo';
          if (ctx === 'bga' || ctx === 'online') online++; else live++;
        }
        if (online > 0) {
          ctxStat = '<li class="fp-plays-list__ctxstat">📍 <strong>' + live + '</strong> dal vivo · <strong>' +
            online + '</strong> online <span class="fp-plays-list__ctxstat-hint">(BGA/app)</span></li>';
        }
      }
      return '<ul class="fp-plays-list">' + ctxStat + plays.map(p => {
        const dateLabel = this.formatDate(p.date);
        const detail = [];
        if (p.minutes && p.minutes > 0) {
          const hrs = (p.minutes / 60).toFixed(1);
          detail.push(p.minutes >= 60 ? hrs + 'h' : p.minutes + ' min');
        }
        if (p.plays > 1) detail.push(p.plays + ' partite');
        if (p.players) detail.push(p.players + (p.players === 1 ? ' giocatore' : ' giocatori'));
        if (p.rating) detail.push('⭐ ' + p.rating);
        const sourceIcon = p.source === 'manual' ? '🎲' : '📥';
        // Riga meta full-width sotto la partita: chi c'era + dove (badge online).
        // Tavolo è il default → nessun badge (niente rumore). Solo BGA/Online lo segnalano.
        const metaParts = [];
        if (Array.isArray(p.companions) && p.companions.length > 0) {
          const shown = p.companions.slice(0, 4).map(escapeHtml).join(', ');
          const extra = p.companions.length > 4 ? ' +' + (p.companions.length - 4) : '';
          metaParts.push('<span class="fp-plays-list__meta-companions">👥 ' + shown + extra + '</span>');
        }
        if (p.context === 'bga') metaParts.push('<span class="fp-plays-list__meta-ctx">🌐 BGA</span>');
        else if (p.context === 'online') metaParts.push('<span class="fp-plays-list__meta-ctx">💻 Online</span>');
        const metaRow = metaParts.length > 0
          ? '<span class="fp-plays-list__meta">' + metaParts.join('') + '</span>'
          : '';
        // Edit/Delete buttons SOLO per partite manuali (le BGG sono read-only, vengono da BGG)
        const actions = (p.source === 'manual' && p.playId)
          ? '<span class="fp-plays-list__actions">' +
              '<button type="button" class="fp-plays-list__btn" data-fp-play-edit="' + escapeHtml(p.playId) + '" aria-label="Modifica partita" title="Modifica">✏️</button>' +
              '<button type="button" class="fp-plays-list__btn fp-plays-list__btn--danger" data-fp-play-delete="' + escapeHtml(p.playId) + '" aria-label="Elimina partita" title="Elimina">🗑</button>' +
            '</span>'
          : '';
        // Extras differenziati per type:
        //   - expansion → "🃏 + Wicked to the Core"  (espansione del gioco base)
        //   - standalone → "🎁 Set combinato: Marvel Villainous"  (set autonomo mescolato)
        let extrasRow = '';
        if (Array.isArray(p.extras) && p.extras.length > 0) {
          const exps = p.extras.filter(e => (e.type || 'expansion') === 'expansion');
          const stds = p.extras.filter(e => e.type === 'standalone');
          const parts = [];
          if (exps.length > 0) {
            parts.push('<span class="fp-plays-list__extra fp-plays-list__extra--exp">🃏 + ' +
              exps.map(e => escapeHtml(e.name)).join(' · ') + '</span>');
          }
          if (stds.length > 0) {
            parts.push('<span class="fp-plays-list__extra fp-plays-list__extra--std">🎁 Set combinato: ' +
              stds.map(e => escapeHtml(e.name)).join(' + ') + '</span>');
          }
          extrasRow = '<span class="fp-plays-list__extras">' + parts.join('') + '</span>';
        }
        return '<li class="fp-plays-list__item">' +
          '<span class="fp-plays-list__date">' + escapeHtml(dateLabel) + '</span>' +
          '<span class="fp-plays-list__title">' + escapeHtml(p.title || 'Gioco') + '</span>' +
          '<span class="fp-plays-list__detail">' + detail.join(' · ') + '</span>' +
          '<span class="fp-plays-list__src" title="' + (p.source === 'manual' ? 'Registrata da te' : 'Da BGG') + '">' + sourceIcon + '</span>' +
          actions +
          metaRow +
          extrasRow +
          '</li>';
      }).join('') + '</ul>';
    }

    /**
     * Bind edit/delete sui pulsanti accanto alle partite manuali in "Le tue partite recenti".
     */
    bindPlaysListActions(container) {
      // Delete: conferma + rimozione + re-render
      container.querySelectorAll('[data-fp-play-delete]').forEach(btn => {
        if (btn.__fpBound) return;
        btn.__fpBound = true;
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const playId = btn.dataset.fpPlayDelete;
          if (!confirm('Eliminare questa partita registrata? L\'azione non è reversibile.')) return;
          const result = FM.deleteManualPlay(playId);
          if (!result.ok) {
            alert('Errore: ' + (result.error || 'eliminazione fallita'));
            return;
          }
          this.profile = FM.loadProfile();
          this._rerenderAllAfterPlaysChange();
        });
      });

      // Edit: apre modal pre-popolato con i valori esistenti
      container.querySelectorAll('[data-fp-play-edit]').forEach(btn => {
        if (btn.__fpBound) return;
        btn.__fpBound = true;
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const playId = btn.dataset.fpPlayEdit;
          this.openEditPlayModal(playId);
        });
      });
    }

    /**
     * Apre modal per modificare i campi di una partita registrata.
     * Riusa lo stile del modal log play per consistency.
     */
    openEditPlayModal(playId) {
      const play = (this.profile.manualPlays || []).find(p => p.id === playId);
      if (!play) {
        alert('Partita non trovata.');
        return;
      }
      // Lo stesso modulo della partita nuova, già riempito: si può correggere tutto, non solo la data.
      if (this.openLogEdit) { this.openLogEdit(play); return; }

      const escapeHtmlFn = (typeof escapeHtml === 'function') ? escapeHtml : (s => String(s || ''));
      const dateVal = play.date || new Date().toISOString().slice(0, 10);
      const minutesVal = play.minutes || 0;
      const playersVal = play.players || '';
      const ratingVal = play.rating || '';
      const whereVal = (play.context === 'bga' || play.context === 'online') ? play.context : 'tavolo';

      const chip = (val, label, current) => {
        const active = (String(val) === String(current)) ? ' is-active' : '';
        return '<button type="button" class="fm-chip' + active + '" data-value="' + val + '">' + label + '</button>';
      };

      const existing = document.querySelector('[data-fp-edit-modal-overlay]');
      if (existing) existing.remove();
      const overlay = document.createElement('div');
      overlay.setAttribute('data-fp-edit-modal-overlay', '1');
      overlay.className = 'fp-cal-modal-overlay';
      overlay.innerHTML =
        '<div class="fp-cal-modal" role="dialog" style="max-width:480px">' +
        '<button class="fp-cal-modal__close" aria-label="Chiudi">×</button>' +
        '<div class="fp-cal-modal__head">' +
          '<div class="fp-cal-modal__date">✏️ Modifica partita</div>' +
          '<div class="fp-cal-modal__total">' + escapeHtmlFn(play.title || 'Gioco') + '</div>' +
        '</div>' +
        '<div class="fp-cal-modal__games" style="padding:20px 24px 24px">' +
          '<div class="fm-log-field" style="margin-bottom:14px">' +
            '<label style="display:block;font-weight:600;margin-bottom:6px">Quando</label>' +
            '<input type="date" data-fp-edit-date class="fm-log-input" value="' + escapeHtmlFn(dateVal) + '" style="width:100%;padding:10px;border:1px solid #ddd;border-radius:8px">' +
          '</div>' +
          '<div class="fm-log-field" style="margin-bottom:14px">' +
            '<label style="display:block;font-weight:600;margin-bottom:6px">Quanto è durata</label>' +
            '<div class="fm-chips fm-chips--single" data-fp-edit-duration>' +
              chip(20, '20 min', minutesVal) + chip(45, '45 min', minutesVal) + chip(75, '1h 15', minutesVal) +
              chip(120, '2h', minutesVal) + chip(180, '3h', minutesVal) + chip(240, '4h+', minutesVal) +
              chip(0, 'Non so', minutesVal) +
            '</div>' +
          '</div>' +
          '<div class="fm-log-field" style="margin-bottom:14px">' +
            '<label style="display:block;font-weight:600;margin-bottom:6px">In quanti</label>' +
            '<div class="fm-chips fm-chips--single" data-fp-edit-players>' +
              chip(1, 'Solo', playersVal) + chip(2, '2', playersVal) + chip(3, '3', playersVal) +
              chip(4, '4', playersVal) + chip(5, '5', playersVal) + chip(6, '6', playersVal) + chip(7, '7+', playersVal) +
            '</div>' +
          '</div>' +
          '<div class="fm-log-field" style="margin-bottom:14px">' +
            '<label style="display:block;font-weight:600;margin-bottom:6px">📍 Dove</label>' +
            '<div class="fm-chips fm-chips--single" data-fp-edit-where>' +
              chip('tavolo', '🎲 Al tavolo', whereVal) + chip('bga', '🌐 BGA', whereVal) + chip('online', '💻 Online', whereVal) +
            '</div>' +
          '</div>' +
          '<div class="fm-log-field" style="margin-bottom:18px">' +
            '<label style="display:block;font-weight:600;margin-bottom:6px">Voto</label>' +
            '<div class="fm-chips fm-chips--single" data-fp-edit-rating>' +
              chip('', '—', ratingVal) +
              [1,2,3,4,5,6,7,8,9,10].map(v => chip(v, String(v), ratingVal)).join('') +
            '</div>' +
          '</div>' +
          '<div class="fm-log-actions">' +
            '<button type="button" class="fm-btn-primary" data-fp-edit-save>💾 Salva modifiche</button>' +
            '<button type="button" class="fm-btn-secondary" data-fp-edit-cancel>Annulla</button>' +
          '</div>' +
        '</div>' +
        '</div>';
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';

      const close = () => {
        overlay.remove();
        document.body.style.overflow = '';
      };
      overlay.querySelector('.fp-cal-modal__close').addEventListener('click', close);
      overlay.querySelector('[data-fp-edit-cancel]').addEventListener('click', close);
      overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

      // Chip selection state
      const state = { minutes: minutesVal, players: playersVal === '' ? null : parseInt(playersVal, 10), rating: ratingVal === '' ? null : parseInt(ratingVal, 10), context: whereVal };
      const bindChips = (selector, key, parser) => {
        const group = overlay.querySelector('[' + selector + ']');
        if (!group) return;
        group.addEventListener('click', (e) => {
          const btn = e.target.closest('button.fm-chip');
          if (!btn) return;
          group.querySelectorAll('.fm-chip').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const v = btn.dataset.value;
          state[key] = (v === '' || v == null) ? null : parser(v);
        });
      };
      bindChips('data-fp-edit-duration', 'minutes', v => parseInt(v, 10));
      bindChips('data-fp-edit-players', 'players', v => parseInt(v, 10));
      bindChips('data-fp-edit-rating', 'rating', v => parseInt(v, 10));
      bindChips('data-fp-edit-where', 'context', v => v);

      overlay.querySelector('[data-fp-edit-save]').addEventListener('click', () => {
        const dateInput = overlay.querySelector('[data-fp-edit-date]');
        const newDate = dateInput ? dateInput.value : dateVal;
        const result = FM.editManualPlay(playId, {
          date: newDate,
          minutes: state.minutes || 0,
          rating: state.rating,
          players: state.players,
          context: state.context
        });
        if (!result.ok) {
          alert('Errore: ' + (result.error || 'modifica fallita'));
          return;
        }
        this.profile = result.profile;
        close();
        this._rerenderAllAfterPlaysChange();
      });
    }

    formatDate(iso) {
      if (!iso) return '';
      const d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      const day = d.getDate();
      const monthNames = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
      const month = monthNames[d.getMonth()];
      const year = d.getFullYear();
      return day + ' ' + month + ' ' + year;
    }

    /**
     * Rubrica compagni abituali — DERIVATA, nessun campo dedicato da mantenere.
     * Fonde i nomi delle partite manuali (playersList) con i compagni BGG
     * (playsActivity.companions), normalizza per nome, somma le frequenze e
     * ordina per frequenza poi recenza. Esclude bot, se stessi, segnaposto e
     * i nomi in profile.hiddenCompanions. Ritorna [{ name, plays, lastPlayed }].
     */
    getCompanionRoster(opts) {
      const includeHidden = !!(opts && opts.includeHidden);
      const p = this.profile || {};
      const PLACEHOLDER = new Set(['sfidante', 'automa', 'bot', 'tu', 'io', 'me', '']);
      const hidden = new Set(
        (Array.isArray(p.hiddenCompanions) ? p.hiddenCompanions : [])
          .map(n => String(n || '').trim().toLowerCase())
      );
      const map = new Map(); // normName -> { name, plays, lastPlayed }
      const add = (rawName, plays, dateStr, atTable) => {
        const name = String(rawName || '').trim();
        const norm = name.toLowerCase();
        if (!name || PLACEHOLDER.has(norm) || (!includeHidden && hidden.has(norm))) return;
        let e = map.get(norm);
        if (!e) { e = { name: name, plays: 0, table: 0, lastPlayed: null }; map.set(norm, e); }
        e.plays += (plays > 0 ? plays : 1);
        if (atTable) e.table += (plays > 0 ? plays : 1);
        if (dateStr && (!e.lastPlayed || dateStr > e.lastPlayed)) e.lastPlayed = dateStr;
        // Preferisci la grafia con iniziale maiuscola (es. "Marco" > "marco")
        if (name && name.charAt(0) === name.charAt(0).toUpperCase()
            && e.name.charAt(0) !== e.name.charAt(0).toUpperCase()) {
          e.name = name;
        }
      };
      // 1) Partite manuali loggate qui
      if (Array.isArray(p.manualPlays)) {
        for (const mp of p.manualPlays) {
          if (!mp || !Array.isArray(mp.playersList)) continue;
          const live = (!mp.context || mp.context === 'tavolo') && String(mp.tableId || '').indexOf('bga:') !== 0;
          for (const pl of mp.playersList) {
            if (!pl || pl.isBot || pl.isMe) continue;
            add(pl.name, 1, mp.date || null, live);
          }
        }
      }
      // 2) Compagni dalle partite BGG sincronizzate
      const bggComp = (p.playsActivity && Array.isArray(p.playsActivity.companions))
        ? p.playsActivity.companions : [];
      for (const c of bggComp) {
        if (!c) continue;
        add(c.name, c.plays || 1, null, true);
      }
      // 3) Aggiunti a mano, anche senza partite. Preferiti in testa.
      const prefs = p.companionPrefs || {};
      Object.keys(prefs).forEach(k => {
        const e = prefs[k];
        if (e && e.name && !map.has(k) && (includeHidden || !hidden.has(k))) map.set(k, { name: e.name, plays: 0, table: 0, lastPlayed: null });
      });
      let arr = Array.from(map.values());
      arr.forEach(c => {
        const k = c.name.toLowerCase(), e = prefs[k] || {};
        c.fav = !!e.fav;
        c.nick = e.nick || '';
        c.hidden = hidden.has(k);
        c.added = !!e.name;
      });
      // Al tavolo non propone chi conosci solo da una partita online.
      const tableOnly = !!(opts && opts.tableOnly);
      if (tableOnly) arr = arr.filter(c => c.table > 0 || c.fav || c.nick || c.added);
      arr.sort((a, b) => {
        if (a.fav !== b.fav) return a.fav ? -1 : 1;
        if (tableOnly && b.table !== a.table) return b.table - a.table;
        if (b.plays !== a.plays) return b.plays - a.plays;
        return (b.lastPlayed || '').localeCompare(a.lastPlayed || '');
      });
      return arr;
    }

    /** Il soprannome si vede soltanto: nelle partite e nelle statistiche resta il nome vero. */
    companionLabel(name) {
      const e = ((this.profile && this.profile.companionPrefs) || {})[String(name || '').trim().toLowerCase()];
      return (e && e.nick) || name;
    }

    /** Preferito e soprannome di un compagno (profile.companionPrefs, chiave = nome minuscolo). */
    setCompanionPref(name, patch) {
      const norm = String(name || '').trim().toLowerCase();
      if (!norm || !this.profile) return;
      const all = this.profile.companionPrefs || (this.profile.companionPrefs = {});
      const e = Object.assign({}, all[norm], patch);
      if (!e.fav) delete e.fav;
      if (!e.nick) delete e.nick;
      if (!e.name) delete e.name;
      if (Object.keys(e).length) all[norm] = e; else delete all[norm];
      FM.saveProfile(this.profile);
    }

    /** Salva un compagno prima ancora di averci giocato. Se era nascosto, torna visibile. */
    addCompanion(name) {
      const clean = String(name || '').trim().slice(0, 30);
      const norm = clean.toLowerCase();
      if (!clean || ['sfidante', 'automa', 'bot', 'tu', 'io', 'me'].indexOf(norm) >= 0) return false;
      this.unhideCompanion(clean);
      const known = this.getCompanionRoster({ includeHidden: true }).some(c => c.name.toLowerCase() === norm);
      if (!known) this.setCompanionPref(clean, { name: clean });
      return true;
    }

    /** Nasconde un compagno dalla rubrica (persistente in profile.hiddenCompanions). */
    hideCompanion(name) {
      const norm = String(name || '').trim().toLowerCase();
      if (!norm || !this.profile) return;
      this.profile = FM.loadProfile() || this.profile;
      if (!Array.isArray(this.profile.hiddenCompanions)) this.profile.hiddenCompanions = [];
      const already = this.profile.hiddenCompanions
        .some(n => String(n || '').trim().toLowerCase() === norm);
      if (!already) {
        this.profile.hiddenCompanions.push(norm);
        FM.saveProfile(this.profile);
      }
    }

    /** Ripristina un compagno nascosto (undo della ×). */
    unhideCompanion(name) {
      const norm = String(name || '').trim().toLowerCase();
      if (!norm || !this.profile) return;
      this.profile = FM.loadProfile() || this.profile;
      if (!Array.isArray(this.profile.hiddenCompanions)) return;
      this.profile.hiddenCompanions = this.profile.hiddenCompanions
        .filter(n => String(n || '').trim().toLowerCase() !== norm);
      FM.saveProfile(this.profile);
    }

    /**
     * Lista compagni per il drill "Compagni di tavolo": FONDE i compagni BGG
     * (ricchi: winRate, topGames) con quelli delle partite registrate a mano.
     * Dedup per nome normalizzato, somma le partite. `fromBgg=false` marca chi
     * esiste solo grazie al log manuale (mostra tag ✋). Esclude bot/se stessi/
     * segnaposto e i nomi in hiddenCompanions. Ordina per partite totali.
     */
    getMergedCompanions() {
      const p = this.profile || {};
      const act = p.playsActivity || {};
      const PLACEHOLDER = new Set(['sfidante', 'automa', 'bot', 'tu', 'io', 'me', '']);
      const hidden = new Set(
        (Array.isArray(p.hiddenCompanions) ? p.hiddenCompanions : [])
          .map(n => String(n || '').trim().toLowerCase())
      );
      const map = new Map();
      // 1) Seed dai compagni BGG (fields ricchi)
      const bgg = Array.isArray(act.companions) ? act.companions : [];
      for (const c of bgg) {
        if (!c || !c.name) continue;
        const norm = String(c.name).trim().toLowerCase();
        if (PLACEHOLDER.has(norm) || hidden.has(norm)) continue;
        map.set(norm, {
          name: c.name, plays: c.plays || 0, winRate: c.winRate,
          wins: c.wins, losses: c.losses, topGames: c.topGames || [],
          lastPlayed: null, fromBgg: true
        });
      }
      // 2) Aggiungi i compagni dalle partite manuali
      if (Array.isArray(p.manualPlays)) {
        for (const mp of p.manualPlays) {
          if (!Array.isArray(mp.playersList)) continue;
          for (const pl of mp.playersList) {
            if (!pl || pl.isBot || pl.isMe || !pl.name) continue;
            const name = String(pl.name).trim();
            const norm = name.toLowerCase();
            if (PLACEHOLDER.has(norm) || hidden.has(norm)) continue;
            let e = map.get(norm);
            if (!e) {
              e = { name: name, plays: 0, winRate: null, wins: 0, losses: 0, topGames: [], lastPlayed: null, fromBgg: false };
              map.set(norm, e);
            }
            e.plays += 1;
            if (mp.date && (!e.lastPlayed || mp.date > e.lastPlayed)) e.lastPlayed = mp.date;
          }
        }
      }
      return Array.from(map.values()).sort((a, b) => b.plays - a.plays);
    }

    collectCollection() {
      // LUDOTECA = solo ciò che POSSIEDI (BGG owned + acquisti Frogames).
      // I giocati con amici NON entrano qui: stanno nel drill-down "Le tue partite".
      // Per ogni posseduto, mostra anche il count plays se esiste in topPlayed.
      const out = [];
      const seen = new Set();
      const act = this.profile.playsActivity || {};
      const playsByBgg = {};
      const lastPlayedByBgg = {};
      const playsImgByBgg = {};
      // FIX 2026-05-25: extrasUsageByBgg conta le volte che un'espansione/set è
      // stata USATA in una partita (registrata in manualPlay.extras). Le espansioni
      // per design NON ricevono +1 ai plays (solo il gioco base), ma "MAI GIOCATO"
      // è ingannevole se l'utente le ha effettivamente usate al tavolo.
      const extrasUsageByBgg = {};
      const lastExtrasUsedByBgg = {};
      if (Array.isArray(this.profile.manualPlays)) {
        for (const mp of this.profile.manualPlays) {
          if (!Array.isArray(mp.extras)) continue;
          for (const ex of mp.extras) {
            if (!ex || !ex.bggId) continue;
            extrasUsageByBgg[ex.bggId] = (extrasUsageByBgg[ex.bggId] || 0) + 1;
            if (mp.date && (!lastExtrasUsedByBgg[ex.bggId] || mp.date > lastExtrasUsedByBgg[ex.bggId])) {
              lastExtrasUsedByBgg[ex.bggId] = mp.date;
            }
          }
        }
      }

      // Build lookup: per ogni bggId in topPlayed, plays/lastPlayed/img enrichment
      if (act.topPlayed) {
        for (const g of act.topPlayed) {
          if (!g.bggId) continue;
          playsByBgg[g.bggId] = g.plays;
          if (g.lastPlayed) lastPlayedByBgg[g.bggId] = g.lastPlayed;
          if (g.img) playsImgByBgg[g.bggId] = g.img;
        }
      }

      // FIX 2026-06-01: conta anche le partite MANUALI nella ludoteca.
      // Bug Andrea: Minikin City con 2 partite manuali appariva come
      // "MAI GIOCATO" perché playsByBgg leggeva solo da act.topPlayed
      // (BGG sync). manualPlays viveva in profile.manualPlays e veniva
      // visto solo dal Wrapped/Volume, non dalla ludoteca.
      //
      // Dedup vs BGG: stessa logica di computeMomentCards — se la stessa
      // partita risulta già in playsByDate per quella data, NON contiamo
      // (caso utente che logga a mano + sincronizza BGG).
      // Match per bggId (preciso) + per nome normalizzato (fallback per
      // manualPlay senza bggId, es. digitato a mano).
      const playsByName = {}; // norm name → count
      const playsByBggManual = {}; // bggId → count manuali
      const playsByDateMap = act.playsByDate || {};
      const normPlayName = (s) => (s || '').toLowerCase().trim();
      if (Array.isArray(this.profile.manualPlays)) {
        for (const mp of this.profile.manualPlays) {
          if (!mp || !mp.date) continue;
          // Dedup contro BGG playsByDate per la stessa data
          const bggDay = playsByDateMap[mp.date];
          if (bggDay && Array.isArray(bggDay.games)) {
            const dup = bggDay.games.some(g =>
              (mp.bggId && g.bggId && g.bggId === mp.bggId) ||
              (g.name && normPlayName(g.name) === normPlayName(mp.title))
            );
            if (dup) continue;
          }
          if (mp.bggId) {
            playsByBggManual[mp.bggId] = (playsByBggManual[mp.bggId] || 0) + 1;
            if (mp.date && (!lastPlayedByBgg[mp.bggId] || mp.date > lastPlayedByBgg[mp.bggId])) {
              lastPlayedByBgg[mp.bggId] = mp.date;
            }
          }
          if (mp.title) {
            const k = normPlayName(mp.title);
            playsByName[k] = (playsByName[k] || 0) + 1;
          }
        }
      }
      // Helper: count effettivo per un gioco della ludoteca (BGG sync + manual)
      // Match prima per bggId (preciso), fallback per nome normalizzato (per
      // manualPlays senza bggId o ludoteca con nome scritto diverso).
      const getTotalPlays = (bggId, name) => {
        let n = 0;
        // FIX 2026-06 (bug "4 partite → 8"): topPlayed (playsByBgg) INCLUDE GIÀ le manuali
        // fuse da mergeManualPlayIntoActivity. Sommare playsByBggManual sopra le contava 2 volte.
        // Ora: si usa topPlayed se presente; le manuali solo come FALLBACK per giochi non ancora lì.
        if (bggId) n = (playsByBgg[bggId] > 0) ? playsByBgg[bggId] : (playsByBggManual[bggId] || 0);
        if (n === 0 && name) {
          const k = normPlayName(name);
          if (k && playsByName[k]) n = playsByName[k];
        }
        return n;
      };

      // 1. BGG owned (fonte primaria — ciò che hai marcato own=1 su BGG)
      if (this.profile.bggCollection && Array.isArray(this.profile.bggCollection.owned)) {
        for (const item of this.profile.bggCollection.owned) {
          const id = (typeof item === 'object') ? item.id : item;
          const name = (typeof item === 'object') ? item.name : null;
          const thumb = (typeof item === 'object') ? item.thumbnail : null;
          const fullImage = (typeof item === 'object') ? item.image : null; // HD per srcset 2x
          if (!id || seen.has(id)) continue;
          seen.add(id);
          const product = this.products.find(p => p.bgg === id);
          const resolvedName = name || (product ? product.t : 'Gioco BGG ' + id);
          out.push({
            name: resolvedName,
            bggId: id,
            img: (product && product.img) || playsImgByBgg[id] || thumb || null,
            imgFull: fullImage || null,
            url: product ? product.u : null,
            plays: getTotalPlays(id, resolvedName),
            extrasPlays: extrasUsageByBgg[id] || 0,
            lastPlayed: lastPlayedByBgg[id] || null,
            lastExtrasUsed: lastExtrasUsedByBgg[id] || null,
            source: 'bgg',
            inFrogamesCatalog: !!product,
            isOwned: true
          });
        }
      }

      // 2. Acquistati Frogames non già visti.
      // FIX 2026-05-11: cascata fallback img più aggressiva. Prima per Formosa Tea
      // ed Emerald Echoes (acquisti senza img nel backfill) si vedeva solo l'icona
      // dado. Ora aggiungiamo lookup da playsImgByBgg (BGG thumb se l'utente l'ha
      // mai loggato).
      if (this.profile.purchasedProducts) {
        for (const purch of this.profile.purchasedProducts) {
          if (!purch.productId) continue;
          const product = this.products.find(p => String(p.id) === String(purch.productId));
          const bggId = (product && product.bgg) || purch.bggId || null;
          if (bggId && seen.has(bggId)) continue;
          if (bggId) seen.add(bggId);
          const resolvedNameP = purch.title || (product && product.t) || 'Gioco';
          out.push({
            name: resolvedNameP,
            bggId: bggId,
            // Cascata img: catalog → purch saved → BGG plays thumb (se loggato)
            img: (product && product.img) || purch.img || (bggId ? playsImgByBgg[bggId] : null) || null,
            imgFull: purch.imgFull || null,
            url: (product && product.u) || purch.url || null,
            plays: getTotalPlays(bggId, resolvedNameP),
            extrasPlays: bggId ? (extrasUsageByBgg[bggId] || 0) : 0,
            lastPlayed: bggId ? (lastPlayedByBgg[bggId] || null) : null,
            lastExtrasUsed: bggId ? (lastExtrasUsedByBgg[bggId] || null) : null,
            source: 'frogames',
            inFrogamesCatalog: !!product,
            isOwned: true
          });
        }
      }

      // 3. Manual owned (ludoteca aggiunta a mano da chi non ha BGG sync)
      if (this.profile.manualOwned) {
        for (const m of this.profile.manualOwned) {
          if (m.bggId && seen.has(m.bggId)) continue;
          if (m.bggId) seen.add(m.bggId);
          const product = m.productId
            ? this.products.find(p => String(p.id) === String(m.productId))
            : (m.bggId ? this.products.find(p => p.bgg === m.bggId) : null);
          const resolvedNameM = m.title || (product ? product.t : 'Gioco');
          out.push({
            name: resolvedNameM,
            bggId: m.bggId || null,
            img: (product && product.img) || (m.bggId ? playsImgByBgg[m.bggId] : null) || m.img || null,
            imgFull: m.imgFull || null,
            url: product ? product.u : null,
            // FIX 2026-06-01: usa getTotalPlays per leggere anche partite manuali.
            plays: getTotalPlays(m.bggId, resolvedNameM),
            extrasPlays: m.bggId ? (extrasUsageByBgg[m.bggId] || 0) : 0,
            lastPlayed: m.bggId ? (lastPlayedByBgg[m.bggId] || null) : null,
            lastExtrasUsed: m.bggId ? (lastExtrasUsedByBgg[m.bggId] || null) : null,
            source: 'manual',
            inFrogamesCatalog: !!product,
            isOwned: true,
            manualOwnedId: m.id
          });
        }
      }

      // 4. Four favorites del cuore — sempre considerati posseduti se non già presenti
      // (chi sceglie un gioco "del cuore" ce l'ha quasi certamente)
      if (this.profile.fourFavorites) {
        for (const fav of this.profile.fourFavorites) {
          if (!fav) continue;
          if (fav.bggId && seen.has(fav.bggId)) continue;
          if (fav.bggId) seen.add(fav.bggId);
          const product = fav.bggId ? this.products.find(p => p.bgg === fav.bggId) : null;
          const resolvedNameF = fav.name || (product ? product.t : 'Gioco');
          out.push({
            name: resolvedNameF,
            bggId: fav.bggId || null,
            img: (product && product.img) || (fav.bggId ? playsImgByBgg[fav.bggId] : null) || fav.img || null,
            url: product ? product.u : null,
            plays: getTotalPlays(fav.bggId, resolvedNameF),
            extrasPlays: fav.bggId ? (extrasUsageByBgg[fav.bggId] || 0) : 0,
            lastPlayed: fav.bggId ? (lastPlayedByBgg[fav.bggId] || null) : null,
            lastExtrasUsed: fav.bggId ? (lastExtrasUsedByBgg[fav.bggId] || null) : null,
            source: 'favorite',
            inFrogamesCatalog: !!product,
            isOwned: true,
            isFavorite: true
          });
        }
      }
      return out;
    }

    renderCollectionEmpty() {
      const hasBgg = !!(this.profile && this.profile.bggUsername);
      return '<div class="fp-collection__empty-cta">' +
        '<h4>📚 La tua ludoteca è ancora vuota</h4>' +
        '<p>' + (hasBgg
          ? 'Su BGG non hai ancora marcato giochi come <em>own=1</em>. Aggiungili a mano qui sotto per usarli nel match.'
          : 'Aggiungi i tuoi giochi a mano: bastano pochi click. Servono al sistema per migliorare i match.') + '</p>' +
        '<button type="button" class="fp-collection__add" data-fp-add-owned>📚 Aggiungi un gioco alla ludoteca</button>' +
      '</div>';
    }

    renderCollectionGrid(games) {
      // Stato filtri/search persistito durante la sessione
      if (!this.collectionState) {
        this.collectionState = {
          search: '',
          filter: 'all',
          sort: 'recent',
          limit: 24
        };
      }

      // Wrapper completo con controlli
      return '<div class="fp-collection">' +
        '<div class="fp-collection__controls">' +
          '<input type="text" class="fp-collection__search" data-fp-coll-search placeholder="🔍 Cerca nei tuoi giochi..." value="' + escapeHtml(this.collectionState.search) + '">' +
          '<div class="fp-collection__filter-row">' +
            this.renderCollectionFilters() +
          '</div>' +
          '<div class="fp-collection__sort-row">' +
            '<label>Ordina per:</label>' +
            '<select class="fp-collection__sort" data-fp-coll-sort>' +
              '<option value="recent"' + (this.collectionState.sort === 'recent' ? ' selected' : '') + '>Più recente</option>' +
              '<option value="plays"' + (this.collectionState.sort === 'plays' ? ' selected' : '') + '>Più giocati</option>' +
              '<option value="alpha"' + (this.collectionState.sort === 'alpha' ? ' selected' : '') + '>A → Z</option>' +
              '<option value="never"' + (this.collectionState.sort === 'never' ? ' selected' : '') + '>Mai giocati</option>' +
            '</select>' +
          '</div>' +
          '<button type="button" class="fp-collection__add" data-fp-add-owned>+ Aggiungi gioco</button>' +
        '</div>' +
        '<div class="fp-collection__grid-wrap" data-fp-coll-grid-wrap>' +
          this.renderFilteredCollection(games) +
        '</div>' +
      '</div>';
    }

    renderCollectionFilters() {
      const filters = [
        { id: 'all', label: 'Tutti' },
        { id: 'played', label: 'Giocati' },
        { id: 'never', label: 'Mai giocati' },
        { id: 'frogames', label: 'Da Frogames' }
      ];
      return filters.map(f =>
        '<button type="button" class="fp-coll-filter' + (this.collectionState.filter === f.id ? ' is-active' : '') + '" data-fp-coll-filter="' + f.id + '">' +
        f.label + '</button>'
      ).join('');
    }

    renderFilteredCollection(allGames) {
      const s = this.collectionState;
      const qLow = s.search.toLowerCase().trim();

      let filtered = allGames;
      if (qLow) filtered = filtered.filter(g => (g.name || '').toLowerCase().includes(qLow));

      switch (s.filter) {
        case 'played': filtered = filtered.filter(g => g.plays > 0); break;
        case 'never': filtered = filtered.filter(g => !g.plays); break;
        case 'frogames': filtered = filtered.filter(g => g.source === 'frogames'); break;
      }

      switch (s.sort) {
        case 'plays': filtered = filtered.sort((a, b) => b.plays - a.plays); break;
        case 'alpha': filtered = filtered.sort((a, b) => (a.name || '').localeCompare(b.name || '')); break;
        case 'never': filtered = filtered.sort((a, b) => a.plays - b.plays); break;
        default: filtered = filtered.sort((a, b) => (b.lastPlayed || '').localeCompare(a.lastPlayed || '')); break;
      }

      if (filtered.length === 0) {
        return '<p class="fp-collection__empty">Niente trovato con questi filtri.</p>';
      }

      const visible = filtered.slice(0, s.limit);
      const remaining = filtered.length - visible.length;

      let html = '<p class="fp-collection__count">' + filtered.length + (filtered.length === 1 ? ' gioco posseduto' : ' giochi posseduti') + ' <span class="fp-collection__hint">· i giochi giocati con amici li trovi in <strong>Le tue partite</strong></span></p>';
      // FIX 2026-05-12: fallback iniziale al posto del dado generico. Più aesthetic
      // e dà subito identità (la "F" gialla di "Formosa Tea" è riconoscibile).
      const colorForName = (name) => {
        const colors = ['#2D7A4F', '#F4A100', '#6B5B95', '#D64545', '#5B8FB9', '#B8480B', '#8B5A2B', '#4A7C7E'];
        let h = 0;
        for (let i = 0; i < (name || '').length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
        return colors[Math.abs(h) % colors.length];
      };
      html += '<div class="fp-collection-grid">' + visible.map(g => {
        const sourceBadge = g.isFavorite
          ? '<span class="fp-collection-grid__badge fp-collection-grid__badge--fav" title="Tra i tuoi 4 del cuore">❤️</span>'
          : (g.source === 'manual'
              ? '<span class="fp-collection-grid__badge fp-collection-grid__badge--manual" title="Aggiunto a mano">✏️</span>'
              : (g.source === 'frogames'
                  ? '<span class="fp-collection-grid__badge fp-collection-grid__badge--frog" title="Acquistato da Frogames">🐸</span>'
                  : ''));
        const initial = (g.name || '?').charAt(0).toUpperCase();
        const fallbackColor = colorForName(g.name);
        const inner = (g.img ?
          // src HD priority: imgFull se disponibile (BGG image originale) altrimenti
          // img (thumbnail 200x150 sgranato su retina). srcset rimosso perché mobile
          // browser non sempre lo rispetta. Più affidabile setare src direttamente.
          '<img class="fp-collection-grid__img" src="' + escapeHtml(g.imgFull || g.img) + '"' +
          ' alt="' + escapeHtml(g.name) + '" loading="lazy" onerror="this.style.display=\'none\';this.nextElementSibling&&(this.nextElementSibling.style.display=\'flex\')">' +
          '<span class="fp-collection-grid__noimg fp-collection-grid__noimg--hidden" style="background:' + fallbackColor + ';color:#fff">' + escapeHtml(initial) + '</span>' :
          '<span class="fp-collection-grid__noimg" style="background:' + fallbackColor + ';color:#fff">' + escapeHtml(initial) + '</span>') +
          sourceBadge +
          '<span class="fp-collection-grid__name">' + escapeHtml(g.name) + '</span>' +
          (g.plays > 0
            ? '<span class="fp-collection-grid__plays">' + g.plays + (g.plays === 1 ? ' partita' : ' partite') + '</span>'
            : (g.extrasPlays > 0
                ? '<span class="fp-collection-grid__plays fp-collection-grid__plays--extra">🃏 Usato ' + g.extrasPlays + (g.extrasPlays === 1 ? ' volta' : ' volte') + '</span>'
                : '<span class="fp-collection-grid__plays fp-collection-grid__plays--none">Mai giocato</span>')) +
          (g.manualOwnedId
            ? '<button type="button" class="fp-collection-grid__rm" data-fp-rm-owned="' + escapeHtml(g.manualOwnedId) + '" title="Rimuovi dalla ludoteca" aria-label="Rimuovi">×</button>'
            : '');
        return g.url ?
          '<a class="fp-collection-grid__item" href="' + escapeHtml(g.url) + '">' + inner + '</a>' :
          '<div class="fp-collection-grid__item">' + inner + '</div>';
      }).join('') + '</div>';

      if (remaining > 0) {
        // Progressiva: 24 → +24 → +48 → +100 → +100...
        const next = s.limit < 48 ? 24 : (s.limit < 96 ? 48 : 100);
        const showNext = Math.min(remaining, next);
        html += '<button type="button" class="fp-collection__more" data-fp-coll-more>📦 Mostra altri ' + showNext + ' (di ' + remaining + ')</button>';
      }
      return html;
    }

    bindCollectionControls(allGames) {
      const search = this.root.querySelector('[data-fp-coll-search]');
      const sort = this.root.querySelector('[data-fp-coll-sort]');
      const gridWrap = this.root.querySelector('[data-fp-coll-grid-wrap]');
      if (!gridWrap) return;

      const refresh = () => {
        gridWrap.innerHTML = this.renderFilteredCollection(allGames);
        this.bindCollectionControls(allGames);
      };

      if (search && !search.__fpBound) {
        search.__fpBound = true;
        let timer = null;
        search.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            this.collectionState.search = search.value;
            this.collectionState.limit = 24;
            refresh();
          }, 200);
        });
      }
      if (sort && !sort.__fpBound) {
        sort.__fpBound = true;
        sort.addEventListener('change', () => {
          this.collectionState.sort = sort.value;
          this.collectionState.limit = 24;
          refresh();
        });
      }
      this.root.querySelectorAll('[data-fp-coll-filter]').forEach(btn => {
        if (btn.__fpBound) return;
        btn.__fpBound = true;
        btn.addEventListener('click', () => {
          this.collectionState.filter = btn.dataset.fpCollFilter;
          this.collectionState.limit = 24;
          refresh();
        });
      });
      const moreBtn = this.root.querySelector('[data-fp-coll-more]');
      if (moreBtn && !moreBtn.__fpBound) {
        moreBtn.__fpBound = true;
        moreBtn.addEventListener('click', () => {
          // Step progressivo: 24 → +24 → +48 → +100
          const cur = this.collectionState.limit;
          const step = cur < 48 ? 24 : (cur < 96 ? 48 : 100);
          this.collectionState.limit = cur + step;
          refresh();
        });
      }
      // Rimozione singola di un gioco manualOwned (delegate via gridWrap)
      this.root.querySelectorAll('[data-fp-rm-owned]').forEach(btn => {
        if (btn.__fpBound) return;
        btn.__fpBound = true;
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const id = btn.dataset.fpRmOwned;
          if (!id) return;
          if (!confirm('Rimuovere questo gioco dalla tua ludoteca?')) return;
          const result = FM.removeManualOwned(id);
          if (result.ok) {
            this.profile = result.profile;
            this.renderHero();
            this.renderDrillDown();
          }
        });
      });
    }

    renderDnaContent() {
      // Sostituito da renderJourney: la "DNA" diventa "Il tuo viaggio Frogger"
      return this.renderJourney();
    }

    /**
     * Il tuo viaggio Frogger — timeline narrativa verticale + snapshot live oggi + diff.
     * Eventi reali dai dati, raggruppati per anno, con respiro visivo.
     */
    renderJourney() {
      const p = this.profile;

      let html = '';

      // ── TIMELINE NARRATIVA verticale (con eventi reali) ──
      html += this.renderJourneyTimeline();

      // ── DIFF narrativo Genesi vs Oggi ──
      try {
        const events = this._computeJourneyEvents();
        const genesis = events.find(e => e.kind === 'genesis');
        const liveSnap = this._buildLiveSnapshot();
        if (genesis && liveSnap && (liveSnap.uniqueGames > 0 || liveSnap.totalPlays > 0)) {
          // Costruisci pseudo-snapshot Genesi per il diff (stato iniziale = vuoto)
          const genesisSnap = {
            ts: genesis.ts, archetype: 'Girino', typology: null, weightAvg: null,
            uniqueGames: 0, totalPlays: 0, topDesigner: null
          };
          html += this._renderJourneyDiff(genesisSnap, liveSnap);
        }
      } catch (e) { /* silenzioso */ }

      // ── DETTAGLI GUSTO (chips compatte sotto, non più al centro) ──
      // FIX 2026-05-11: aggiunti blocchi sempre disponibili (peso, durata, giocatori,
      // interazione, alea) anche per onboarder manuali che non hanno popolato meccaniche.
      // Prima il body restava vuoto e l'utente vedeva la freccia ruotare senza contenuto.
      html += '<details class="fp-journey__details">' +
        '<summary class="fp-journey__details-summary">🧬 I tuoi gusti nel dettaglio</summary>' +
        '<div class="fp-journey__details-body">';

      let dettagliRows = 0;

      // FIX 2026-05-11: per BGG users con topMechanics/topCategories vuoti
      // (es. Danilo, profili pre-calc o onboarding parziale), deriviamo on-the-fly
      // dalle meccaniche/categorie dei giochi più giocati (topPlayed).
      // Aggrega per frequenza pesata sulle partite — il segnale è onesto: ciò che
      // gioca davvero conta più di un click in più nel quiz.
      const _actDettagli = p.playsActivity || {};
      const deriveTopFromPlays = (field, limit) => {
        if (!Array.isArray(_actDettagli.topPlayed)) return [];
        const counts = {};
        for (const tp of _actDettagli.topPlayed) {
          const arr = tp && tp[field];
          if (!Array.isArray(arr)) continue;
          const weight = tp.plays || 1;
          for (const item of arr) {
            counts[item] = (counts[item] || 0) + weight;
          }
        }
        let entries = Object.entries(counts);
        // Fix 2026-05-15: per "cat" filtra meta-tag BGG (Card Game, Party Game,
        // Bluffing, Memory, ecc.) PRIMA dello slice → preserva temi reali anche
        // se minoritari. Esempio: profilo party-heavy con Bluffing 21 + Memory 20
        // + Medical 19 → prima del fix top-3 erano tutti meta → sezione vuota.
        // Dopo: meta filtrati → "Medical, Mafia, Medieval" risalgono al top-3.
        if (field === 'cat' && typeof FM.isThemeCategory === 'function') {
          entries = entries.filter(([name]) => FM.isThemeCategory(name));
        }
        return entries
          .sort((a, b) => b[1] - a[1])
          .slice(0, limit)
          .map(([name]) => name);
      };

      const mechanicsToShow = (p.topMechanics && p.topMechanics.length > 0)
        ? p.topMechanics
        : deriveTopFromPlays('mch', 5);
      if (mechanicsToShow.length > 0) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Meccaniche preferite</span>' +
          '<div class="fp-dna-row__chips">' +
          mechanicsToShow.map(m => '<span class="fp-chip">' + escapeHtml(FM.tMech ? FM.tMech(m) : m) + '</span>').join('') +
          '</div></div>';
      }
      // Filter via isThemeCategory: scarta categorie BGG meta (Strategy Games,
      // Expansion for Base-game, ecc.) che hanno label null e renderebbero "null"
      // come testo nelle chip. Bug 2026-05-12 segnalato da cliente.
      const isTheme = FM.isThemeCategory || (() => true);
      const categoriesToShow = ((p.topCategories && p.topCategories.length > 0)
        ? p.topCategories
        : deriveTopFromPlays('cat', 3)).filter(isTheme);
      if (categoriesToShow.length > 0) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Ambientazioni</span>' +
          '<div class="fp-dna-row__chips">' +
          categoriesToShow.map(c => {
            const label = FM.tCat ? FM.tCat(c) : c;
            // Doppia safety: anche se isThemeCategory ha lasciato passare qualcosa
            // di non tradotto, ritornare la stringa originale (mai "null")
            return '<span class="fp-chip">' + escapeHtml(label || c || '?') + '</span>';
          }).join('') +
          '</div></div>';
      }
      if (p.topDesigners && p.topDesigners.length > 0) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Autori amati</span>' +
          '<div class="fp-dna-row__chips">' +
          p.topDesigners.map(d => '<span class="fp-chip fp-chip--designer">' + escapeHtml(d) + '</span>').join('') +
          '</div></div>';
      }
      if (p.avoidedMechanics && p.avoidedMechanics.length > 0) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Eviti</span>' +
          '<div class="fp-dna-row__chips">' +
          p.avoidedMechanics.map(a => '<span class="fp-chip fp-chip--avoid">' + escapeHtml(FM.tMech ? FM.tMech(a) : a) + '</span>').join('') +
          '</div></div>';
      }

      // ── Sempre disponibili da profilo (anche manual onboarder) ──
      if (p.weightTarget != null && p.weightTarget > 0) {
        dettagliRows++;
        const wLabel = p.weightTarget.toFixed(1);
        const wRange = (p.weightRange && p.weightRange.length === 2)
          ? p.weightRange[0].toFixed(1) + '–' + p.weightRange[1].toFixed(1)
          : null;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Peso ideale</span>' +
          '<div class="fp-dna-row__chips">' +
          '<span class="fp-chip">' + wLabel + '/5' + (wRange ? ' <span style="opacity:0.6">(range ' + wRange + ')</span>' : '') + '</span>' +
          '</div></div>';
      }
      if (p.playtimeTarget && p.playtimeTarget.length === 2) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Durata preferita</span>' +
          '<div class="fp-dna-row__chips">' +
          '<span class="fp-chip">' + p.playtimeTarget[0] + '–' + p.playtimeTarget[1] + ' min</span>' +
          '</div></div>';
      }
      const PLAYER_LABELS = { '1': 'Solo', '2': '2', '3': '3-4', '5': '5+' };
      if (p.playerCounts && p.playerCounts.length > 0) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Tavolo abituale</span>' +
          '<div class="fp-dna-row__chips">' +
          p.playerCounts.map(c => '<span class="fp-chip">' + escapeHtml(PLAYER_LABELS[c] || c) + ' giocatori</span>').join('') +
          '</div></div>';
      } else if (p.playerCountIdeal) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Tavolo abituale</span>' +
          '<div class="fp-dna-row__chips">' +
          '<span class="fp-chip">' + p.playerCountIdeal + ' giocatori</span>' +
          '</div></div>';
      }
      const INTERACTION_LABELS = { 0: 'Mio mondo', 1: 'Misto', 2: 'Conflitto', 3: 'Caos' };
      if (p.interactionPreference != null && INTERACTION_LABELS[p.interactionPreference]) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Interazione</span>' +
          '<div class="fp-dna-row__chips">' +
          '<span class="fp-chip">' + escapeHtml(INTERACTION_LABELS[p.interactionPreference]) + '</span>' +
          '</div></div>';
      }
      const ALEA_LABELS = { 0: 'Niente caso', 1: 'Poco caso', 2: 'Misto', 3: 'Tanto caso' };
      if (p.aleaPreference != null && ALEA_LABELS[p.aleaPreference]) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Caso/Fortuna</span>' +
          '<div class="fp-dna-row__chips">' +
          '<span class="fp-chip">' + escapeHtml(ALEA_LABELS[p.aleaPreference]) + '</span>' +
          '</div></div>';
      }

      // ── Fallback da playsActivity per BGG users con topMechanics/Categories vuoti ──
      // (es. profili creati prima dei calc o con onboarding parziale): mostra dati
      // sempre certi (totale partite, ore al tavolo, ecc.) così la sezione non è quasi vuota.
      const act = p.playsActivity || {};
      if (act.totalPlays && act.totalPlays > 0) {
        dettagliRows++;
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Partite registrate</span>' +
          '<div class="fp-dna-row__chips">' +
          '<span class="fp-chip">' + act.totalPlays + (act.totalPlays === 1 ? ' partita' : ' partite') + '</span>' +
          (act.uniqueGames ? '<span class="fp-chip">' + act.uniqueGames + ' giochi unici</span>' : '') +
          '</div></div>';
      }
      if (act.totalMinutes && act.totalMinutes > 0) {
        dettagliRows++;
        const ore = Math.round(act.totalMinutes / 60);
        html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Ore al tavolo</span>' +
          '<div class="fp-dna-row__chips">' +
          '<span class="fp-chip">' + ore + ' ore totali</span>' +
          '</div></div>';
      }
      // Top 3 giochi più giocati (sempre disponibili da topPlayed se BGG sync)
      if (Array.isArray(act.topPlayed) && act.topPlayed.length > 0) {
        const top3 = act.topPlayed.slice(0, 3);
        if (top3.length > 0) {
          dettagliRows++;
          html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Top giochi</span>' +
            '<div class="fp-dna-row__chips">' +
            top3.map(g => '<span class="fp-chip">' + escapeHtml(g.name || 'Gioco') + ' · ' + (g.plays || 1) + 'x</span>').join('') +
            '</div></div>';
        }
      }
      // Anni come Frogger (da createdAt)
      if (p.createdAt) {
        const days = Math.floor((Date.now() - p.createdAt) / 86400000);
        if (days >= 0) {
          dettagliRows++;
          let label;
          if (days <= 1) label = 'Oggi';
          else if (days < 7) label = days + ' giorni';
          else if (days < 30) { const w = Math.floor(days / 7); label = w + (w === 1 ? ' settimana' : ' settimane'); }
          else if (days < 365) { const m = Math.floor(days / 30); label = m + (m === 1 ? ' mese' : ' mesi'); }
          else { const y = (days / 365).toFixed(1); label = y + ' anni'; }
          html += '<div class="fp-dna-row"><span class="fp-dna-row__label">Frogger da</span>' +
            '<div class="fp-dna-row__chips">' +
            '<span class="fp-chip">' + label + '</span>' +
            '</div></div>';
        }
      }

      // Empty state se proprio non c'è nulla (caso rarissimo: profilo molto incompleto)
      if (dettagliRows === 0) {
        html += '<div class="fp-dna-row" style="text-align:center;padding:12px;color:var(--fp-fg-mute);font-size:0.9rem">' +
          '<p style="margin:0 0 6px">Nessun dettaglio ancora disponibile.</p>' +
          '<p style="margin:0;font-size:0.82rem">Logga qualche partita o rifai l\'onboarding strutturato per popolare i tuoi gusti.</p>' +
          '</div>';
      }

      html += '</div></details>';

      return html;
    }

    /**
     * Compute degli eventi narrativi della vita boardgamer.
     * Solo eventi REALI dai dati, niente fake.
     */
    _computeJourneyEvents() {
      const p = this.profile;
      const act = p.playsActivity || {};
      const events = [];

      // 🌱 Genesi: la prima cosa accaduta (prima play BGG o iscrizione, quale è prima)
      let genesisTs = p.createdAt || Date.now();
      let genesisLabel = 'Iscritto a Frogames';
      let genesisDesc = 'Il tuo viaggio è cominciato qui.';
      if (act.fromDate) {
        const firstPlayTs = new Date(act.fromDate).getTime();
        if (firstPlayTs > 0 && firstPlayTs < genesisTs) {
          genesisTs = firstPlayTs;
          genesisLabel = 'La prima partita';
          // Trova il primo gioco
          const sorted = (act.topPlayed || []).filter(g => g.lastPlayed).slice()
            .sort((a, b) => new Date(a.lastPlayed).getTime() - new Date(b.lastPlayed).getTime());
          if (sorted[0]) genesisDesc = 'Hai iniziato giocando a <strong>' + sorted[0].name + '</strong>';
        }
      }
      events.push({ ts: genesisTs, kind: 'genesis', icon: '🌱', label: genesisLabel, desc: genesisDesc });

      // ✨ Iscrizione Frogames (se più recente di prima play BGG)
      if (act.fromDate && p.createdAt && new Date(act.fromDate).getTime() < p.createdAt) {
        events.push({
          ts: p.createdAt, kind: 'frogames-join', icon: '🐸',
          label: 'Sei entrato nello stagno',
          desc: 'Hai creato il tuo profilo Frogger'
        });
      }

      // 🏆 Achievement (tutti quelli con timestamp reale, max 6 più importanti per data)
      const ub = p.unlockedBadges || {};
      const achList = Object.entries(ub)
        .filter(([id, data]) => data && data.unlockedAt && data.unlockedAt > 1)
        .sort((a, b) => a[1].unlockedAt - b[1].unlockedAt)
        .slice(0, 6);
      const ACH_LABELS = {
        specialista: { icon: '💎', label: 'Specialista', desc: 'Sei diventato esperto di un gioco' },
        cinghiale: { icon: '🧠', label: 'Cinghiale', desc: 'Una serata epica con un peso massimo' },
        eclettico: { icon: '🎨', label: 'Eclettico', desc: 'Hai esplorato 5 tipologie diverse' },
        esploratore: { icon: '🌍', label: 'Esploratore', desc: 'Hai loggato 20+ giochi diversi' },
        mondo_aperto: { icon: '🗺', label: 'Mondo Aperto', desc: '100 giochi diversi giocati' },
        diplomatico: { icon: '🤝', label: 'Diplomatico', desc: '15+ partite cooperative' },
        gladiatore: { icon: '⚔️', label: 'Gladiatore', desc: '10 partite di pura competizione' },
        speed_runner: { icon: '⚡', label: 'Speed Runner', desc: '5 giochi diversi in un mese' },
        animatore: { icon: '🎉', label: 'Animatore', desc: '10+ partite con tanti giocatori' },
        streak_master: { icon: '🔥', label: 'Streak Master', desc: 'Giorni consecutivi al tavolo' },
        habitue: { icon: '📅', label: 'Habitué', desc: 'Una partita ogni settimana' },
        maratona: { icon: '🌅', label: 'Maratona', desc: 'Tre partite in un giorno solo' },
        tour_de_force: { icon: '⏳', label: 'Tour de Force', desc: '10 ore di gioco in un giorno' },
        comeback: { icon: '🪞', label: 'Comeback', desc: 'Sei tornato dopo una pausa lunga' },
        adattabile: { icon: '⚖️', label: 'Adattabile', desc: 'Spazi tra leggeri e pesanti' },
        versatile: { icon: '🔮', label: 'Versatile', desc: 'Coop, party, euro e american' },
        anteprima: { icon: '✨', label: 'Anteprima', desc: 'Un titolo dell\'ultimo anno' },
        viaggio_nel_tempo: { icon: '⏰', label: 'Viaggio nel Tempo', desc: 'Un gioco per decennio' },
        polyglot: { icon: '🧬', label: 'Polyglot', desc: '5 meccaniche padroneggiate' },
        padrone_di_casa: { icon: '🏠', label: 'Padrone di Casa', desc: 'Hai trovato i tuoi compagni fissi' },
        amico_fidato: { icon: '💚', label: 'Amico Fidato', desc: 'Tante partite con lo stesso compagno' },
        network: { icon: '🌐', label: 'Network', desc: '10+ Froggers diversi al tuo tavolo' },
        solo_pro: { icon: '🐺', label: 'Solo Pro', desc: '10 partite in solitario' },
        possessore: { icon: '📦', label: 'Possessore', desc: 'La tua collezione cresce' },
        curator: { icon: '🎓', label: 'Curator', desc: 'Pesi 3+ nella ludoteca' },
        vintage_hunter: { icon: '📼', label: 'Vintage Hunter', desc: 'Un classico anni \'90' },
        cult_master: { icon: '👑', label: 'Cult Master', desc: 'Un classico anni \'80' },
        new_wave: { icon: '🌊', label: 'New Wave', desc: 'Giochi che possiedi usciti negli ultimi 2 anni' },
        big_box: { icon: '🧱', label: 'Big Box', desc: 'Un peso massimo nella ludoteca' },
        filler_lover: { icon: '⚡', label: 'Filler Lover', desc: 'Filler nello scaffale' },
        marathon_owner: { icon: '🏔', label: 'Marathon Owner', desc: 'Giochi lunghi posseduti' },
        solo_stash: { icon: '🐺', label: 'Solo Stash', desc: 'Solo-friendly nello scaffale' },
        coop_stash: { icon: '🤜🤛', label: 'Coop Stash', desc: 'Coop nello scaffale' },
        customizer: { icon: '🎨', label: 'Customizer', desc: 'Hai personalizzato il tuo profilo' },
        sincronizzato: { icon: '🔄', label: 'Sincronizzato', desc: 'BGG e community attivi' },
        trovatore: { icon: '🌌', label: 'Trovatore di Nicchie', desc: 'Hai trovato una rarità' },
        pioniere: { icon: '🌱', label: 'Pioniere', desc: 'Tra i primi 100 Frogger' },
        frogger_veterano: { icon: '🐸', label: 'Frogger Veterano', desc: 'Un anno nello stagno' },
        decennale: { icon: '🌳', label: 'Decennale', desc: 'Dieci anni di gioco' },
        dedicato: { icon: '🎲', label: 'Dedicato', desc: 'Una soglia di partite raggiunta' },
        frog_marathon: { icon: '⏱', label: 'Frog Marathon', desc: 'Ore al tavolo' }
      };
      achList.forEach(([id, data]) => {
        const meta = ACH_LABELS[id] || { icon: '🏆', label: id.replace(/_/g, ' '), desc: 'Sblocco' };
        events.push({ ts: data.unlockedAt, kind: 'achievement', icon: meta.icon, label: meta.label, desc: meta.desc });
      });

      // 🎂 Anniversario 1 anno (se è già passato)
      const oneYearTs = genesisTs + 365 * 86400000;
      if (oneYearTs < Date.now()) {
        events.push({ ts: oneYearTs, kind: 'anniv', icon: '🎂', label: '1 anno di gioco', desc: 'Un anno tondo da quando è iniziato il viaggio' });
      }
      const twoYearTs = genesisTs + 2 * 365 * 86400000;
      if (twoYearTs < Date.now()) {
        events.push({ ts: twoYearTs, kind: 'anniv', icon: '🎂', label: '2 anni di gioco', desc: 'Due anni dentro il pond — ehm, lo stagno' });
      }

      // 🌅 Prima maratona (3+ partite stesso giorno)
      const playsByDate = this.calPlaysByDate || this.collectPlaysByDate();
      const dates = Object.keys(playsByDate).sort();
      for (const d of dates) {
        const tot = playsByDate[d].reduce((s, p) => s + (p.plays || 1), 0);
        if (tot >= 3) {
          events.push({
            ts: new Date(d + 'T00:00:00').getTime(), kind: 'first-marathon',
            icon: '🌅', label: 'La tua prima maratona',
            desc: tot + ' partite in un giorno solo. Una di quelle giornate che ricordi.'
          });
          break;
        }
      }

      // 👥 Primo Frogger compagno (più antica partita con un companion)
      const allCompanions = act.companions || [];
      if (allCompanions.length > 0) {
        const oldestCompanion = allCompanions.slice().sort((a, b) =>
          (a.lastPlayedDate || '').localeCompare(b.lastPlayedDate || '')
        )[0];
        if (oldestCompanion && oldestCompanion.lastPlayedDate) {
          events.push({
            ts: new Date(oldestCompanion.lastPlayedDate + 'T00:00:00').getTime(),
            kind: 'first-companion', icon: '👥', label: 'Il primo Frogger al tavolo',
            desc: '<strong>' + escapeHtml(oldestCompanion.name) + '</strong>, prima persona a giocare con te'
          });
        }
      }

      // 📸 Snapshot trimestrali (calcolati da playsByQuarter o persistiti).
      // DEDUP: salto snapshot identici al precedente (stessi numeri = niente da raccontare).
      try {
        const snaps = FM.generateRetroSnapshots(p, this.products) || [];
        let lastShown = null;
        snaps.forEach(s => {
          if (!s.ts || s.isGenesis) return;
          // Skip se ts > now (no snapshot futuri)
          if (s.ts > Date.now()) return;
          // Dedup: stessi numeri E stessa typology = no nuovo snapshot
          if (lastShown
            && lastShown.uniqueGames === s.uniqueGames
            && lastShown.totalPlays === s.totalPlays
            && lastShown.weightAvg === s.weightAvg
            && lastShown.typology === s.typology) {
            return;
          }
          // Costruisci descrizione narrativa con delta visibili
          let desc = '<strong>' + escapeHtml(s.archetype || 'Frogger') + '</strong>';
          const bits = [];
          if (s.weightAvg != null) {
            const arrow = (lastShown && lastShown.weightAvg != null && s.weightAvg !== lastShown.weightAvg)
              ? (s.weightAvg > lastShown.weightAvg ? ' ↑' : ' ↓') : '';
            bits.push('peso ' + s.weightAvg + arrow);
          }
          if (s.uniqueGames > 0) bits.push(s.uniqueGames + ' giochi');
          if (s.totalPlays > 0) bits.push(s.totalPlays + ' partite');
          if (bits.length > 0) desc += ' · ' + bits.join(' · ');
          if (s.topGame && s.topGame.name) {
            desc += '<br>Top del periodo: <strong>' + escapeHtml(s.topGame.name) + '</strong>';
          }
          events.push({
            ts: s.ts, kind: 'snapshot', icon: '📸',
            label: s.label || 'Snapshot',
            desc
          });
          lastShown = s;
        });
      } catch (e) { /* silenzioso */ }

      // ── 🎯 MILESTONE PROGRESSIVE (calcolate da playsByQuarter) ──
      this._computeMilestoneEvents(events);

      // ★ Oggi (sempre l'ultima)
      const liveTop = ((act.topPlayed || [])[0]);
      events.push({
        ts: Date.now(), kind: 'today', icon: '★', label: 'Oggi',
        desc: '<strong>' + (p.archetypeName || 'Frogger') + '</strong>' +
          (act.uniqueGames ? ' · ' + act.uniqueGames + ' giochi' : '') +
          (act.totalPlays ? ' · ' + act.totalPlays + ' partite' : '') +
          (liveTop ? '<br>Ultimamente giochi a <strong>' + escapeHtml(liveTop.name) + '</strong>' : '')
      });

      // Ordina cronologicamente
      events.sort((a, b) => a.ts - b.ts);
      return events;
    }

    /**
     * Aggiunge eventi milestone PROGRESSIVE (10/25/50 partite, 5/10/20 giochi diversi,
     * primo coop, primo solo, primo peso 3+ ecc) basate su playsByQuarter REALE.
     */
    _computeMilestoneEvents(events) {
      const p = this.profile;
      const act = p.playsActivity || {};
      const topPlayed = act.topPlayed || [];
      if (topPlayed.length === 0) return;

      // Costruisci timeline plays-by-quarter unificata: ordina trimestri cronologicamente
      const quarterPlays = {}; // { '2024-Q3': [{game, plays}, ...] }
      topPlayed.forEach(g => {
        if (!g.playsByQuarter) return;
        Object.entries(g.playsByQuarter).forEach(([qKey, count]) => {
          if (!quarterPlays[qKey]) quarterPlays[qKey] = [];
          quarterPlays[qKey].push({ game: g, plays: count });
        });
      });
      const sortedQuarters = Object.keys(quarterPlays).sort();
      if (sortedQuarters.length === 0) return;

      const tsForQuarter = (qKey) => {
        const [y, qStr] = qKey.split('-Q');
        const q = parseInt(qStr, 10);
        // Mese centrale del trimestre: feb(1), mag(4), ago(7), nov(10)
        return new Date(parseInt(y, 10), (q - 1) * 3 + 1, 15).getTime();
      };
      const quarterLabel = (qKey) => {
        const [y, qStr] = qKey.split('-Q');
        const monthNames = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
        return monthNames[(parseInt(qStr, 10) - 1) * 3 + 1] + ' ’' + y.slice(2);
      };

      // Soglie milestone
      const playsMilestones = [10, 25, 50, 100, 200, 500];
      const uniqueMilestones = [5, 10, 20, 50, 100];
      // Microcopy Frogames-vibe per soglie partite (caldo, no corporate)
      const PLAY_COPY = {
        10: 'Hai messo <strong>10 partite</strong> nel registro. Sei dentro per davvero.',
        25: '<strong>25 partite</strong> alle spalle. Lo stagno comincia a riconoscerti.',
        50: 'Cinquanta. Una bella mezza-cinquantina di serate al tavolo.',
        100: 'Cento partite. Sei diventato un Frogger come si deve.',
        200: 'Duecento partite. Pochi arrivano qua.',
        500: 'Cinquecento partite. Sei una leggenda dello stagno.'
      };
      const UNIQUE_COPY = {
        5: 'Cinque giochi diversi nel registro. <strong>__G__</strong> è il quinto a passare dallo stagno.',
        10: 'Dieci titoli diversi. Lo scaffale prende forma. <strong>__G__</strong> è il decimo.',
        20: 'Venti giochi diversi. Sei un esploratore. <strong>__G__</strong> ti porta a quota venti.',
        50: 'Cinquanta giochi diversi. Una collezione che si vede. <strong>__G__</strong> chiude il quadro.',
        100: 'Cento titoli diversi giocati. Pochi ci arrivano. <strong>__G__</strong> è il centesimo.'
      };

      let cumPlays = 0;
      const seenGames = new Set();
      const milestoneFlags = {
        plays: new Set(),
        unique: new Set(),
        firstCoop: false,
        firstSolo: false,
        firstParty: false,
        firstHeavy3: false,
        firstHeavy4: false,
        firstVintage: false,
        firstCult: false,
        firstByTypology: {} // 'eurogame' → true se già emesso
      };
      // Game adoption tracking: cumulative plays per gioco
      const gameCumPlays = {}; // bggId → cumulative
      const gameAdopted5 = new Set();
      const gameSpecialist10 = new Set();
      let bestQuarter = { qKey: null, plays: 0 };

      sortedQuarters.forEach(qKey => {
        const arr = quarterPlays[qKey];
        let qTotalPlays = 0;
        arr.forEach(({ game, plays }) => {
          qTotalPlays += plays;
          cumPlays += plays;
          // Cumulative per gioco
          gameCumPlays[game.bggId] = (gameCumPlays[game.bggId] || 0) + plays;

          // Trigger milestone partite totali
          playsMilestones.forEach(m => {
            if (cumPlays >= m && !milestoneFlags.plays.has(m)) {
              milestoneFlags.plays.add(m);
              events.push({
                ts: tsForQuarter(qKey), kind: 'milestone', icon: '🎯',
                label: m + ' partite',
                desc: PLAY_COPY[m] || (m + ' partite raggiunte.')
              });
            }
          });
          // Unique games
          if (!seenGames.has(game.bggId)) {
            seenGames.add(game.bggId);
            uniqueMilestones.forEach(m => {
              if (seenGames.size === m && !milestoneFlags.unique.has(m)) {
                milestoneFlags.unique.add(m);
                const tmpl = UNIQUE_COPY[m] || ('Ora hai ' + m + ' giochi nel registro.');
                events.push({
                  ts: tsForQuarter(qKey), kind: 'milestone', icon: '🌍',
                  label: m + ' giochi diversi',
                  desc: tmpl.replace('__G__', escapeHtml(game.name))
                });
              }
            });
          }
          // Game adoption (5+ partite stesso gioco)
          if (gameCumPlays[game.bggId] >= 5 && !gameAdopted5.has(game.bggId)) {
            gameAdopted5.add(game.bggId);
            events.push({
              ts: tsForQuarter(qKey), kind: 'milestone', icon: '🎲',
              label: 'Fan di ' + (game.name || 'un gioco'),
              desc: 'Cinque partite a <strong>' + escapeHtml(game.name) + '</strong>. Inizia a essere uno dei tuoi.'
            });
          }
          // Specialista (10+ partite stesso gioco)
          if (gameCumPlays[game.bggId] >= 10 && !gameSpecialist10.has(game.bggId)) {
            gameSpecialist10.add(game.bggId);
            events.push({
              ts: tsForQuarter(qKey), kind: 'milestone', icon: '💎',
              label: 'Specialista di ' + (game.name || 'un gioco'),
              desc: 'Dieci partite a <strong>' + escapeHtml(game.name) + '</strong>. Lo conosci dentro e fuori.'
            });
          }
          // Lookup product Frogames + fallback su metadata BGG (worker enrichment)
          const product = this.products.find(pr => pr.bgg === game.bggId);
          // Helper: prendi attributo da product Frogames o fallback BGG meta in topPlayed
          const isCoop = (product && product.f && product.f.coop) || game.isCoop;
          // PURE SOLO: solo giochi nati per il solo (pmin=1 AND pmax=1).
          // NON usiamo f.solo (sarebbe "supporta solo", troppo permissivo: Harmonies 1-4 ne sarebbe taggato).
          const pmin = (product && product.pmin) || game.pmin;
          const pmax = (product && product.pmax) || game.pmax;
          const isSolo = (pmin === 1 && pmax === 1);
          const isParty = (product && product.f && product.f.party) || game.isParty;
          const weight = (product && product.w) || game.w || null;
          const year = (product && product.yr) || game.yr || null;

          if (isCoop && !milestoneFlags.firstCoop) {
            milestoneFlags.firstCoop = true;
            events.push({
              ts: tsForQuarter(qKey), kind: 'milestone', icon: '🤝',
              label: 'Prima cooperativa',
              desc: 'Hai scoperto il <strong>cooperativo</strong> con ' + escapeHtml(game.name) + '.'
            });
          }
          if (isSolo && !milestoneFlags.firstSolo) {
            milestoneFlags.firstSolo = true;
            events.push({
              ts: tsForQuarter(qKey), kind: 'milestone', icon: '🐺',
              label: 'Primo solo',
              desc: 'In silenzio, contro il sistema: <strong>' + escapeHtml(game.name) + '</strong>.'
            });
          }
          if (isParty && !milestoneFlags.firstParty) {
            milestoneFlags.firstParty = true;
            events.push({
              ts: tsForQuarter(qKey), kind: 'milestone', icon: '🎉',
              label: 'Primo party',
              desc: 'Risate al tavolo con <strong>' + escapeHtml(game.name) + '</strong>.'
            });
          }
          if (weight && weight >= 3 && weight < 4 && !milestoneFlags.firstHeavy3) {
            milestoneFlags.firstHeavy3 = true;
            events.push({
              ts: tsForQuarter(qKey), kind: 'milestone', icon: '🧠',
              label: 'Primo peso 3+',
              desc: 'Sei salito di livello: <strong>' + escapeHtml(game.name) + '</strong> (peso ' + (+weight).toFixed(1) + ').'
            });
          }
          if (weight && weight >= 4 && !milestoneFlags.firstHeavy4) {
            milestoneFlags.firstHeavy4 = true;
            events.push({
              ts: tsForQuarter(qKey), kind: 'milestone', icon: '🧠',
              label: 'Primo Cinghiale',
              desc: 'Un peso massimo al tavolo: <strong>' + escapeHtml(game.name) + '</strong> (peso ' + (+weight).toFixed(1) + ').'
            });
          }
          if (year && year >= 1990 && year < 2000 && !milestoneFlags.firstVintage) {
            milestoneFlags.firstVintage = true;
            events.push({
              ts: tsForQuarter(qKey), kind: 'milestone', icon: '📼',
              label: 'Primo vintage',
              desc: 'Sei tornato agli anni \'90 con <strong>' + escapeHtml(game.name) + '</strong>.'
            });
          }
          if (year && year > 0 && year < 1990 && !milestoneFlags.firstCult) {
            milestoneFlags.firstCult = true;
            events.push({
              ts: tsForQuarter(qKey), kind: 'milestone', icon: '👑',
              label: 'Primo cult',
              desc: 'Un pezzo di storia: <strong>' + escapeHtml(game.name) + '</strong> (' + year + ').'
            });
          }

          // Prima volta per ogni tipologia (eurogame/american/family/filler/...) — usa deriveTypologies
          // Fallback: se product Frogames non esiste, costruisce pseudo-product da metadata BGG enrichment
          if (FM.deriveTypologies) {
            const pseudoProduct = product || {
              mch: game.mch || [],
              cat: game.cat || [],
              f: { coop: !!game.isCoop, solo: !!game.isSolo, party: !!game.isParty },
              w: game.w || null,
              yr: game.yr || null,
              tmin: game.bggAvgDuration || null,
              tmax: game.bggAvgDuration || null,
              pmin: game.pmin || null,
              pmax: game.pmax || null,
              rt: null
            };
            const typs = FM.deriveTypologies(pseudoProduct);
            const TYP_COPY = {
              eurogame: { icon: '⚙️', label: 'Primo eurogame', desc: 'Hai messo le mani su un <strong>eurogame</strong>: ' },
              american: { icon: '🎭', label: 'Primo american', desc: 'Tema, scontri, narrazione: ' },
              ibrido: { icon: '⚖️', label: 'Primo ibrido', desc: 'Strategia con un\'anima tematica: ' },
              family: { icon: '👨‍👩‍👧', label: 'Primo family', desc: 'Tutti dentro al tavolo con ' },
              filler: { icon: '⚡', label: 'Primo filler', desc: 'Veloce e affilato: ' },
              astratto: { icon: '◾', label: 'Primo astratto', desc: 'Solo skill, niente rumore: ' },
              wargame: { icon: '⚔️', label: 'Primo wargame', desc: 'Tattica e controllo con ' },
              dexterity: { icon: '🎯', label: 'Primo dexterity', desc: 'Mira e mani ferme con ' },
              gateway: { icon: '🚪', label: 'Primo gateway', desc: 'Il tuo primo passo serio nei giochi moderni: ' },
              dungeon: { icon: '🐉', label: 'Primo dungeon crawler', desc: 'Esplora, combatti, racconta con ' },
              legacy: { icon: '📖', label: 'Primo legacy', desc: 'Una storia che cresce con te: ' },
              narrativo: { icon: '📜', label: 'Primo narrativo', desc: 'Lascia che il gioco ti racconti con ' },
              asimmetrico: { icon: '♟', label: 'Primo asimmetrico', desc: 'Ogni giocatore ha il suo gioco: ' },
              deckbuilder: { icon: '🃏', label: 'Primo deckbuilder', desc: 'Costruisci il motore di carte: ' },
              tricktaking: { icon: '♣️', label: 'Primo trick-taking', desc: 'Bid e prese con ' },
              rollwrite: { icon: '✏️', label: 'Primo roll & write', desc: 'Carta, matita, scelte: ' },
              escape: { icon: '🗝', label: 'Primo escape', desc: 'Risolvere insieme con ' }
            };
            typs.forEach(t => {
              if (TYP_COPY[t] && !milestoneFlags.firstByTypology[t]) {
                milestoneFlags.firstByTypology[t] = true;
                events.push({
                  ts: tsForQuarter(qKey), kind: 'milestone', icon: TYP_COPY[t].icon,
                  label: TYP_COPY[t].label,
                  desc: TYP_COPY[t].desc + '<strong>' + escapeHtml(game.name) + '</strong>.'
                });
              }
            });
          }
        });
        if (qTotalPlays > bestQuarter.plays) bestQuarter = { qKey, plays: qTotalPlays };
      });

      // 📈 Trimestre più intenso
      if (bestQuarter.qKey && bestQuarter.plays >= 5) {
        events.push({
          ts: tsForQuarter(bestQuarter.qKey), kind: 'milestone', icon: '📈',
          label: 'Trimestre di fuoco',
          desc: bestQuarter.plays + ' partite in 3 mesi. Il tuo periodo più caldo.'
        });
      }

      // 👥 Compagni fissi (5+ partite con stesso companion)
      const companions = (act.companions || []).slice().sort((a, b) => b.plays - a.plays);
      const fixedCompanions = companions.filter(c => c.plays >= 5).slice(0, 4);
      fixedCompanions.forEach(c => {
        // Usa la lastPlayedDate come proxy di "quando è diventato fisso"
        if (!c.lastPlayedDate) return;
        events.push({
          ts: new Date(c.lastPlayedDate + 'T00:00:00').getTime(),
          kind: 'milestone', icon: '🤝',
          label: c.name + ' è fisso al tavolo',
          desc: '<strong>' + escapeHtml(c.name) + '</strong> con ' + c.plays + ' partite insieme. Uno dei tuoi.'
        });
      });
    }

    renderJourneyTimeline() {
      const events = this._computeJourneyEvents();
      const monthNames = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
      const fmtDate = (ts) => {
        const d = new Date(ts);
        return d.getDate() + ' ' + monthNames[d.getMonth()];
      };

      // Raggruppa per anno
      const groups = {};
      events.forEach(e => {
        const year = new Date(e.ts).getFullYear();
        if (!groups[year]) groups[year] = [];
        groups[year].push(e);
      });
      const years = Object.keys(groups).sort();

      let html = '<div class="fp-journey__timeline">' +
        '<h3 class="fp-journey__h3">⏱ Il tuo percorso</h3>' +
        '<p class="fp-journey__sub">Le tappe della tua vita da boardgamer</p>';

      years.forEach(year => {
        html += '<div class="fp-tl-year">' +
          '<div class="fp-tl-year-label">' + year + '</div>' +
          '<ol class="fp-tl-events">';
        groups[year].forEach((e, idx) => {
          const isLast = (year === years[years.length - 1]) && (idx === groups[year].length - 1);
          const kindCls = e.kind === 'today' ? ' fp-tl-event--today'
            : e.kind === 'genesis' ? ' fp-tl-event--genesis'
            : e.kind === 'snapshot' ? ' fp-tl-event--snapshot'
            : '';
          html += '<li class="fp-tl-event' + kindCls + '" data-kind="' + e.kind + '">' +
            '<span class="fp-tl-event__dot">' + e.icon + '</span>' +
            '<div class="fp-tl-event__body">' +
              '<div class="fp-tl-event__head">' +
                '<span class="fp-tl-event__label">' + escapeHtml(e.label) + '</span>' +
                '<span class="fp-tl-event__date">' + fmtDate(e.ts) + '</span>' +
              '</div>' +
              '<div class="fp-tl-event__desc">' + e.desc + '</div>' +
            '</div>' +
          '</li>';
        });
        html += '</ol></div>';
      });

      html += '</div>';
      return html;
    }

    _buildLiveSnapshot() {
      const p = this.profile;
      const act = p.playsActivity || {};
      const labels = FM.TYPOLOGY_LABELS || {};
      const top = (p.topTypologies || [])[0];
      const mostP = this.getMostPlayed();
      return {
        ts: Date.now(),
        label: '★ Oggi',
        season: 'live',
        isGenesis: false,
        isLive: true,
        typology: top || null,
        typologyLabel: top ? (labels[top] || top) : null,
        archetype: p.archetypeName || 'Frogger',
        weightAvg: p.weightTarget || null,
        uniqueGames: act.uniqueGames || 0,
        totalPlays: act.totalPlays || 0,
        topGame: mostP ? { name: mostP.name, img: mostP.img, plays: mostP.plays } : null,
        topDesigner: (p.topDesigners || [])[0] || null
      };
    }

    _renderSnapshotCard(s, prev, isLast) {
      const labels = FM.TYPOLOGY_LABELS || {};
      const monthNames = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
      const date = new Date(s.ts);
      const dateStr = monthNames[date.getMonth()] + ' ’' + String(date.getFullYear()).slice(2);

      const arrow = (cur, old, format) => {
        if (cur == null || old == null || cur === old) return '';
        const f = format || ((v) => v);
        const sym = cur > old ? '↑' : '↓';
        return '<span class="fp-snap__arrow">' + sym + '</span>';
      };
      const newStar = (cur, old) => {
        if (!cur) return '';
        if (!old || cur !== old) return '<span class="fp-snap__new">★</span>';
        return '';
      };

      let body;
      if (s.isGenesis) {
        body =
          '<div class="fp-snap__girino">🐸</div>' +
          '<div class="fp-snap__archetype">Girino</div>' +
          (s.topGame
            ? '<div class="fp-snap__line fp-snap__line--small">Hai iniziato con<br><strong>' + escapeHtml(s.topGame.name) + '</strong></div>'
            : '<div class="fp-snap__caption">Il punto zero del tuo viaggio</div>');
      } else {
        const typLabel = s.typology ? (labels[s.typology] || s.typology) : '—';
        const prevTyp = prev && prev.typology;
        body =
          '<div class="fp-snap__archetype">' + escapeHtml(s.archetype) + '</div>' +
          '<div class="fp-snap__chip">' + escapeHtml(typLabel) + (s.typology !== prevTyp ? newStar(s.typology, prevTyp) : '') + '</div>' +
          (s.weightAvg != null ? '<div class="fp-snap__line">Peso medio <strong>' + s.weightAvg + '</strong>' + (prev && prev.weightAvg != null ? arrow(s.weightAvg, prev.weightAvg) : '') + '</div>' : '') +
          '<div class="fp-snap__line"><strong>' + s.uniqueGames + '</strong> giochi · <strong>' + s.totalPlays + '</strong> partite</div>' +
          (s.topGame ? '<div class="fp-snap__line fp-snap__line--small">Top: ' + escapeHtml(s.topGame.name) + '</div>' : '') +
          (s.topDesigner ? '<div class="fp-snap__line fp-snap__line--small">Designer: ' + escapeHtml(s.topDesigner) + (prev && prev.topDesigner !== s.topDesigner ? newStar(s.topDesigner, prev && prev.topDesigner) : '') + '</div>' : '');
      }

      const seasonCls = s.isGenesis ? 'fp-snap--genesis' : (s.isLive ? 'fp-snap--live' : 'fp-snap--' + (s.season || 'std'));
      return '<div class="fp-snap ' + seasonCls + (isLast ? ' is-last' : '') + '">' +
        '<div class="fp-snap__head">' +
          '<span class="fp-snap__label">' + escapeHtml(s.label) + '</span>' +
          '<span class="fp-snap__date">' + dateStr + '</span>' +
        '</div>' +
        body +
      '</div>';
    }

    _renderJourneyDiff(first, last) {
      const labels = FM.TYPOLOGY_LABELS || {};
      const lines = [];

      // Peso evoluzione
      if (first.weightAvg != null && last.weightAvg != null && first.weightAvg !== last.weightAvg) {
        const direction = last.weightAvg > first.weightAvg ? 'cresciuto' : 'diminuito';
        lines.push('Il tuo peso medio è <strong>' + direction + ' da ' + first.weightAvg + ' a ' + last.weightAvg + '</strong>');
      }

      // Tipologia evoluzione
      if (first.typology !== last.typology && last.typology) {
        const fLabel = first.typology ? (labels[first.typology] || first.typology) : 'Girino';
        const lLabel = labels[last.typology] || last.typology;
        lines.push('Sei evoluto da <strong>' + fLabel + '</strong> a <strong>' + lLabel + '</strong>');
      }

      // Crescita giochi
      if (last.uniqueGames > first.uniqueGames) {
        lines.push('Hai scoperto <strong>' + (last.uniqueGames - first.uniqueGames) + ' nuovi giochi</strong>');
      }
      if (last.totalPlays > first.totalPlays) {
        lines.push('Hai giocato <strong>' + (last.totalPlays - first.totalPlays) + ' partite in più</strong>');
      }

      // Designer
      if (first.topDesigner !== last.topDesigner && last.topDesigner) {
        if (first.topDesigner) {
          lines.push('Il tuo designer top è cambiato: <strong>' + first.topDesigner + ' → ' + last.topDesigner + '</strong>');
        }
      }

      if (lines.length === 0) return '';

      return '<div class="fp-journey__diff">' +
        '<h3 class="fp-journey__h3">📈 Cosa è cambiato dal punto zero</h3>' +
        '<ul class="fp-journey__diff-list">' +
          lines.map(l => '<li>' + l + '</li>').join('') +
        '</ul>' +
      '</div>';
    }

    bindSettings() {
      const refreshBtn = this.root.querySelector('[data-fp-settings-bgg-refresh]');
      if (refreshBtn && this.profile && this.profile.bggUsername) {
        refreshBtn.hidden = false;
        refreshBtn.addEventListener('click', () => this.refreshBggData(refreshBtn));
      }

      // Pulsante "Aggiorna da BGG" nell'hero (in alto, con tooltip) — più accessibile
      // del pulsante sepolto in Impostazioni. Stesso comportamento/handler.
      const heroRefreshBtn = this.root.querySelector('[data-fp-hero-bgg-refresh]');
      if (heroRefreshBtn && this.profile && this.profile.bggUsername && !heroRefreshBtn.__fpBound) {
        heroRefreshBtn.__fpBound = true;
        heroRefreshBtn.hidden = false;
        heroRefreshBtn.addEventListener('click', () => this.refreshBggData(heroRefreshBtn));
      }

      const redoBtn = this.root.querySelector('[data-fp-settings-redo]');
      if (redoBtn) {
        redoBtn.addEventListener('click', () => {
          if (confirm('Vuoi rifare la carta da capo? Il tuo profilo attuale verrà sostituito.')) {
            FM.clearAll();
            window.location.href = this.quizUrl;
          }
        });
      }

      // Toggle Condivisione community (UI switch + status + conferma)
      const shareInput = this.root.querySelector('[data-fp-settings-share-input]');
      const shareStatus = this.root.querySelector('[data-fp-settings-share-status]');
      const updateShareStatus = (val) => {
        if (!shareStatus) return;
        if (val) {
          shareStatus.textContent = '✅ Attiva — grazie, le tue partite contribuiscono allo stagno.';
          shareStatus.className = 'fp-settings-card__status fp-settings-card__status--on';
        } else {
          shareStatus.textContent = '○ Disattivata — le tue partite restano private.';
          shareStatus.className = 'fp-settings-card__status fp-settings-card__status--off';
        }
      };
      if (shareInput) {
        // Stato iniziale (default true se mai impostato)
        const cur = this.profile.shareCommunityPlays !== false;
        shareInput.checked = cur;
        updateShareStatus(cur);

        shareInput.addEventListener('change', () => {
          const newVal = shareInput.checked;
          // Conferma solo per disattivare (azione "negativa", non per attivare)
          if (!newVal && this.profile.shareCommunityPlays !== false) {
            const ok = confirm('Sicuro di disattivare? Le tue partite non contribuiranno più alle classifiche e ai suggerimenti community.');
            if (!ok) {
              shareInput.checked = true;
              return;
            }
          }
          this.profile.shareCommunityPlays = newVal;
          this.profile.shareCommunityPlaysSetAt = Date.now();
          FM.saveProfile(this.profile);
          updateShareStatus(newVal);
        });
      }

      // Legacy bottone (se ancora presente in vecchi liquid)
      const shareBtn = this.root.querySelector('[data-fp-settings-share-toggle]');
      if (shareBtn && !shareBtn.__fpBound) {
        shareBtn.__fpBound = true;
        shareBtn.addEventListener('click', () => {
          const current = !!this.profile.shareCommunityPlays;
          this.profile.shareCommunityPlays = !current;
          this.profile.shareCommunityPlaysSetAt = Date.now();
          FM.saveProfile(this.profile);
          alert(!current ? '✅ Attivata' : 'ℹ️ Disattivata');
        });
      }

      // ── Self-aliases BGG: salva soprannomi con cui l'utente si elenca nei plays.
      // Il check skip-self del worker confronta player.name/username SOLO contro BGG username.
      // Se l'utente nei plays si elenca come "Janjo" (nick) invece di "Sasso984",
      // finisce come proprio "compagno fisso". Questi alias risolvono il caso.
      const aliasInput = this.root.querySelector('[data-fp-settings-aliases]');
      const aliasSaveBtn = this.root.querySelector('[data-fp-settings-aliases-save]');
      const aliasStatus = this.root.querySelector('[data-fp-settings-aliases-status]');
      if (aliasInput) {
        // Pre-popola con aliases già salvati nel profilo
        const saved = (this.profile.bggSelfAliases || []).join(', ');
        aliasInput.value = saved;
      }
      if (aliasSaveBtn && !aliasSaveBtn.__fpBound) {
        aliasSaveBtn.__fpBound = true;
        aliasSaveBtn.addEventListener('click', async () => {
          const raw = (aliasInput && aliasInput.value || '').trim();
          const aliases = raw
            ? raw.split(',').map(s => s.trim()).filter(s => s.length >= 2)
            : [];
          this.profile.bggSelfAliases = aliases;
          this.profile.updatedAt = Date.now();
          FM.saveProfile(this.profile);

          if (aliasStatus) {
            aliasStatus.textContent = aliases.length > 0
              ? '✅ Salvati ' + aliases.length + ' alias. Sincronizzo BGG...'
              : '✅ Alias rimossi. Sincronizzo BGG...';
            aliasStatus.className = 'fp-settings-card__status fp-settings-card__status--on';
          }

          // Se ha BGG username, lancia un refresh BGG così i compagni vengono ricalcolati
          if (this.profile.bggUsername) {
            try {
              await this.refreshBggData(null);
              if (aliasStatus) {
                aliasStatus.textContent = '✅ Sincronizzato. Ricarica la pagina per vedere i nuovi compagni di tavolo.';
              }
            } catch (e) {
              if (aliasStatus) {
                aliasStatus.textContent = '⚠️ Alias salvati ma sync BGG fallito. Clicca "🔄 Aggiorna da BGG" manualmente.';
              }
            }
          } else {
            if (aliasStatus) {
              aliasStatus.textContent = '✅ Alias salvati. (Verranno usati al prossimo sync BGG)';
            }
          }
        });
      }
    }

    // ────────────────────────────────────────
    // REFRESH BGG DATA — soft refresh in place (no redirect)
    // Fetcha plays + collection con username già salvato, aggiorna profile, re-render
    // ────────────────────────────────────────
    async refreshBggData(button) {
      if (!this.profile.bggUsername) {
        if (button) alert('Nessun username BGG salvato.');
        return;
      }
      const workerUrl = this.workerUrl || (this.customer && this.customer.workerUrl) || '';
      if (!workerUrl) {
        if (button) alert('⚙️ Worker URL non configurato. Contatta lo store admin.');
        return;
      }

      // Button-icona (refresh Wrapped + nuovo refresh hero): usano animazione
      // is-spinning, MAI toccare textContent (hanno struttura interna con <span>
      // icona + tooltip che si distruggerebbe). I button testuali invece cambiano label.
      const isIconButton = !!(button && (button.classList.contains('fp-moment__refresh') || button.classList.contains('fp-hero__bgg-refresh')));
      const originalLabel = (button && !isIconButton) ? button.textContent : '';
      if (button) {
        button.disabled = true;
        if (isIconButton || button.textContent === '🔄') {
          button.classList.add('is-spinning');
        } else {
          button.textContent = '🔄 Aggiornamento in corso...';
        }
      }

      try {
        const username = encodeURIComponent(this.profile.bggUsername);
        const base = workerUrl.replace(/\/$/, '');

        // selfAliases: combina firstName del customer Shopify + alias custom salvati
        // dal profilo (Settings → "I tuoi nomi nei plays BGG"). Il worker li userà tutti
        // per identificare l'utente come "se stesso" anche quando si elenca con soprannomi.
        const aliasesSet = new Set();
        if (this.customer && this.customer.firstName) {
          aliasesSet.add(this.customer.firstName);
        }
        if (Array.isArray(this.profile.bggSelfAliases)) {
          for (const a of this.profile.bggSelfAliases) {
            if (a && a.length >= 2) aliasesSet.add(a);
          }
        }
        let selfAliasParam = '';
        if (aliasesSet.size > 0) {
          selfAliasParam = '&selfAliases=' + encodeURIComponent([...aliasesSet].join(','));
        }

        // Timeout duro 25s per evitare che la pagina resti impallata se BGG è lento.
        // AbortController interrompe le fetch e fa scattare il catch → bottone si sblocca.
        const ac = new AbortController();
        const timeoutId = setTimeout(() => ac.abort(), 25000);

        // Fetch plays + collection in parallelo (no cache per dati freschi)
        let collRes, playsRes;
        try {
          [collRes, playsRes] = await Promise.all([
            fetch(base + '/api/bgg-collection?username=' + username, { signal: ac.signal }),
            fetch(base + '/api/bgg-plays?username=' + username + '&nocache=1' + selfAliasParam, { signal: ac.signal })
          ]);
        } finally {
          clearTimeout(timeoutId);
        }

        if (!playsRes.ok) {
          throw new Error('BGG plays non risponde (HTTP ' + playsRes.status + ')');
        }

        const playsData = await playsRes.json();
        if (playsData.totalPlays != null) {
          // Mantieni TUTTI i campi nuovi (playsByDate, uniqueGamesXd, totalPlaysXd,
          // hasMoreToImport, etc) altrimenti il calendario torna ai dati rolling sbagliati.
          this.profile.playsActivity = {
            fetchedAt: playsData.fetchedAt || Date.now(),
            fromDate: playsData.fromDate,
            toDate: playsData.toDate,
            totalPlays: playsData.totalPlays,
            totalMinutes: playsData.totalMinutes,
            last30DaysPlays: playsData.last30DaysPlays,
            last30DaysMinutes: playsData.last30DaysMinutes,
            last90DaysMinutes: playsData.last90DaysMinutes,
            mostRecentPlay: playsData.mostRecentPlay,
            uniqueGames: playsData.uniqueGames,
            // Count veri per periodo (worker v8+) — NON limitati a top 30
            uniqueGames30d: playsData.uniqueGames30d,
            uniqueGames90d: playsData.uniqueGames90d,
            uniqueGames180d: playsData.uniqueGames180d,
            uniqueGames365d: playsData.uniqueGames365d,
            totalPlays30d: playsData.totalPlays30d,
            totalPlays90d: playsData.totalPlays90d,
            totalPlays180d: playsData.totalPlays180d,
            totalPlays365d: playsData.totalPlays365d,
            activityStatus: playsData.activityStatus,
            companions: (playsData.companions || []).slice(0, 12),
            badgeStats: playsData.badgeStats || null,
            topPlayed: (playsData.topPlayed || []).slice(0, 30),
            // playsByDate (worker v10+): mese/anno di calendario corretti
            playsByDate: playsData.playsByDate || null,
            // Continuation backlog (worker v10+): per utenti con >1000 partite
            archivedTotal: playsData.archivedTotal || 0,
            bggTotalDeclared: playsData.bggTotalDeclared || null,
            hasMoreToImport: !!playsData.hasMoreToImport,
            nextPageToFetch: playsData.nextPageToFetch || null
          };
        }

        // Aggiorna bggOwnedCount + array bggCollection per achievement collezionismo + UI ludoteca
        if (collRes.ok) {
          try {
            const collData = await collRes.json();
            if (collData.games && Array.isArray(collData.games)) {
              const owned = [];
              const prevowned = [];
              const wishlist = [];
              for (const g of collData.games) {
                if (!g.id) continue;
                // Conserva i metadati BGG arricchiti dal worker (peso/durata/categorie/
                // meccaniche oltre all'anno) → tutti gli obiettivi-collezione leggono da BGG.
                const lite = {
                  id: g.id, name: g.name, thumbnail: g.thumbnail || g.image || '',
                  yr: g.year || null,
                  w: (g.w != null) ? g.w : null,
                  tmin: (g.tmin != null) ? g.tmin : null,
                  tmax: (g.tmax != null) ? g.tmax : null,
                  cat: Array.isArray(g.cat) ? g.cat : [],
                  mch: Array.isArray(g.mch) ? g.mch : []
                };
                if (g.owned) owned.push(lite);
                else if (g.prevowned) prevowned.push(lite);
                if (g.wishlist) wishlist.push(lite);
              }
              this.profile.bggOwnedCount = owned.length;
              this.profile.bggCollection = {
                owned: owned,
                prevowned: prevowned,
                wishlist: wishlist,
                fetchedAt: Date.now()
              };
            }
          } catch (e) { /* non bloccare se collection non parse */ }
        }

        this.profile.updatedAt = Date.now();
        // Ri-deriva mecc./cat./tipologia/durata dalla collezione ora arricchita
        // (non solo il peso): senza questo il refresh aggiornava metà profilo.
        try { FM.recomputeProfileFromCollection(this.profile, this.products); } catch (e) { /* silenzioso */ }
        // Riapplica il tag 'solo' + ricalcola peso/archetipo con i nuovi dati BGG (plays + collection)
        try { FM.applySoloGamerTag(this.profile, this.products); } catch (e) { /* silenzioso */ }
        this.profile.tasteRederivedV1 = true;
        FM.saveProfile(this.profile);

        if (button) {
          if (button.classList.contains('is-spinning')) {
            button.classList.remove('is-spinning');
            button.classList.add('is-success');
          } else {
            button.textContent = '✓ Aggiornato!';
            button.style.background = 'rgba(45, 122, 79, 0.15)';
          }
        }

        // Re-render tutto in place
        setTimeout(() => {
          this.renderHero();
          this.renderFavorites();
          this.renderMoment();
          this.renderCalendar();
          this.renderChallenges();
          this.renderGems();
          this.renderDrillDown();
          if (button) {
            button.disabled = false;
            button.classList.remove('is-success');
            // Icon button: niente textContent (distruggerebbe le <span> interne)
            if (!isIconButton) {
              if (originalLabel) button.textContent = originalLabel;
              else button.textContent = '🔄 Aggiorna da BGG';
              button.style.background = '';
            }
          }
        }, 1200);
      } catch (e) {
        console.error('[FroggerProfile] refresh BGG failed:', e);
        if (button) {
          button.disabled = false;
          button.classList.remove('is-spinning');
          if (!isIconButton) button.textContent = originalLabel || '🔄 Aggiorna da BGG';
        }
        if (button) alert('⚠️ Aggiornamento fallito: ' + e.message + '\n\nRiprova fra qualche secondo.');
      }
    }

    // ────────────────────────────────────────
    // LOG PLAY — riusa la stessa modal logic di WrappedController
    // (delegated listener, resilient a tutto)
    // ────────────────────────────────────────
    bindLogPlay() {
      if (this.root.__fpLogPlayBound) return;
      this.root.__fpLogPlayBound = true;

      // Le modal sono renderizzate FUORI dal section (per z-index/stacking),
      // quindi serve un fallback a document quando this.root.querySelector ritorna null.
      const q = (sel) => this.root.querySelector(sel) || document.querySelector(sel);
      const qa = (sel) => {
        const local = this.root.querySelectorAll(sel);
        return local.length ? local : document.querySelectorAll(sel);
      };

      const modal = q('[data-fm-log-modal]');
      const closes = qa('[data-fm-log-close]');
      const dateInput = q('[data-fm-log-date]');
      const gameInput = q('[data-fm-log-game]');
      const suggest = q('[data-fm-log-suggest]');
      const durationGroup = q('[data-fm-log-duration]');
      const ratingGroup = q('[data-fm-log-rating]');
      const playersGroup = q('[data-fm-log-players]');
      const saveBtn = q('[data-fm-log-save]');
      const onlyAddBtn = q('[data-fm-log-only-add]');
      const status = q('[data-fm-log-status]');
      if (!modal || !saveBtn) {
        console.warn('[FroggerProfile] Modal log play non in pagina');
        return;
      }

      const state = {
        product: null, bggOnly: null, customTitle: '', date: '',
        minutes: null, rating: null, players: null,
        outcome: null, // 'win' | 'loss' | 'coop_win' | 'coop_loss'
        // context: dove si è giocato. 'tavolo' (dal vivo) | 'bga' | 'online'.
        // Default 'tavolo'. Solo 'tavolo' qualifica i compagni come compagni veri
        // (gating medaglie social, da collegare in un secondo step).
        context: 'tavolo',
        playersList: [],
        // extras: espansioni / set compatibili usati in questa partita
        // Shape: [{ bggId, name }]. Default vuoto = opzionale, non blocca save.
        extras: [],
        // 2026-11-01: i miei punti (io non sto in playersList) e chi ha iniziato.
        myScore: null,
        firstPlayer: null,
        // Da dove viene la durata: 'timer' | 'mine' (tua media) | 'bgg' (media BGG) | null (a mano).
        minutesSource: null,
        solo: false,
        soloMode: null,
        soloTouched: false,
        soloFor: null,
        keptPlayers: null,
        // Scheda del gioco: come si vince e voci dei punti, se le conosciamo.
        sheet: null, sheetKey: null, sheetOpen: false, sheetVals: {}, sheetExp: {}, winWay: null,
        // Modulo a una schermata (2026-11-03).
        coopMode: false, whoTouched: false, titleLocked: false, whoAdding: false, editId: null
      };

      modal.hidden = true;
      modal.style.display = 'none';

      // ── Hero (cover gioco) — appare dopo selezione ──
      const heroEl = q('[data-fm-log-hero]');
      const heroCover = q('[data-fm-log-hero-cover]');
      const heroTitle = q('[data-fm-log-hero-title]');
      const heroSub = q('[data-fm-log-hero-sub]');
      const titleBlock = q('[data-fm-log-title-block]');
      const subtitleBlock = q('[data-fm-log-subtitle]');

      // Quando, durata e dove: sempre in vista, ognuno col suo nome. Si apre solo quello che tocchi.
      const factValues = () => {
        const iso = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
        const now = new Date(), yest = new Date(now.getTime() - 86400000), d = String(state.date || '');
        return {
          when: d === iso(now) ? 'Oggi' : d === iso(yest) ? 'Ieri' : d.slice(8, 10) + '/' + d.slice(5, 7),
          time: state.minutes > 0 ? (state.minutesSource === 'mine' || state.minutesSource === 'bgg' ? 'circa ' : '') + minutesToLabel(state.minutes) : (state.minutes === 0 ? 'Non so' : 'Da segnare'),
          where: state.context === 'bga' ? 'BGA' : state.context === 'online' ? 'Online' : 'Al tavolo'
        };
      };
      const updateHero = () => {
        if (!heroEl) return;
        // Il titolo del modulo sparisce a gioco scelto: la riga sotto deve dire cosa sta succedendo.
        let title = null, img = null;
        const facts = factValues();
        factsEl.querySelectorAll('[data-fm-fact]').forEach(b => { b.querySelector('b').textContent = facts[b.getAttribute('data-fm-fact')]; });
        if (state.product) {
          title = state.product.t;
          img = state.product.img;
        } else if (state.bggOnly) {
          title = state.bggOnly.name;
          img = state.bggOnly.img;
        } else if (state.customTitle && state.customTitle.length > 1) {
          title = state.customTitle;
        }
        if (title) {
          heroEl.hidden = false;
          if (heroTitle) heroTitle.textContent = title;
          if (heroSub) heroSub.textContent = state.editId ? 'Voto, espansioni e altro' : 'Espansioni, chi inizia e altro';
          if (heroCover) {
            if (img) {
              heroCover.src = img;
              heroCover.style.display = '';
            } else {
              heroCover.style.display = 'none';
            }
          }
          // Nascondi titolo modal generico quando hero è visibile (ridondanza)
          if (titleBlock) titleBlock.style.display = 'none';
          if (subtitleBlock) subtitleBlock.style.display = 'none';
        } else {
          heroEl.hidden = true;
          if (titleBlock) titleBlock.style.display = '';
          if (subtitleBlock) subtitleBlock.style.display = '';
        }
      };

      // ── Outcome toggle (HAI VINTO / HAI PERSO / COOP) ──
      const outcomeGroup = q('[data-fm-log-outcome]');
      const coopSub = q('[data-fm-log-coop-sub]');
      const coopWinGroup = q('[data-fm-log-coop-win]');

      const setOutcome = (outcome) => {
        // outcome: 'win' | 'loss' | 'coop' | null
        if (outcomeGroup) {
          outcomeGroup.querySelectorAll('.fm-result-btn').forEach(b => b.classList.remove('is-active'));
          if (outcome) {
            const btn = outcomeGroup.querySelector('.fm-result-btn[data-outcome="' + outcome + '"]');
            if (btn) btn.classList.add('is-active');
          }
        }
        if (coopSub) coopSub.hidden = (outcome !== 'coop');
        if (outcome === 'win') state.outcome = 'win';
        else if (outcome === 'loss') state.outcome = 'loss';
        else if (outcome === 'coop') {
          // resta in attesa di coop_win/coop_loss; default null finché user non sceglie
          state.outcome = state.outcome === 'coop_win' || state.outcome === 'coop_loss' ? state.outcome : 'coop_pending';
        } else state.outcome = null;
      };

      if (outcomeGroup) {
        outcomeGroup.addEventListener('click', (e) => {
          const btn = e.target.closest('.fm-result-btn');
          if (!btn) return;
          setOutcome(btn.dataset.outcome);
        });
      }
      if (coopWinGroup) {
        coopWinGroup.addEventListener('click', (e) => {
          const btn = e.target.closest('.fm-result-coop-opt');
          if (!btn) return;
          coopWinGroup.querySelectorAll('.fm-result-coop-opt').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          state.outcome = btn.dataset.coopWin === 'true' ? 'coop_win' : 'coop_loss';
        });
      }

      // ── Players grid: avatar tap-to-toggle vincitore ──
      const playersGridEl = q('[data-fm-log-players-grid]');
      const colorForName = (name) => {
        const colors = ['#2D7A4F', '#F4A100', '#6B5B95', '#D64545', '#5B8FB9', '#B8480B', '#8B5A2B', '#4A7C7E'];
        let h = 0;
        for (let i = 0; i < (name || '').length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
        return colors[Math.abs(h) % colors.length];
      };

      const renderPlayersGrid = (opts) => {
        if (!playersGridEl) return;
        const items = state.playersList.map((p, i) => {
          const name = p.name || (p.isBot ? 'Bot' : 'Sfidante');
          const initial = (name || '?').charAt(0).toUpperCase();
          const color = p.isBot ? '#6B5B95' : colorForName(name);
          const winCls = p.isWin ? ' is-winner' : '';
          const botCls = p.isBot ? ' is-bot' : '';
          return '<div class="fm-player-avatar' + winCls + botCls + '" data-fm-player-idx="' + i + '" style="background:' + color + '">' +
            (p.isBot ? '<span class="fm-player-avatar__bot-icon">🤖</span>' : '<span class="fm-player-avatar__initial">' + escapeHtml(initial) + '</span>') +
            (p.isWin ? '<span class="fm-player-avatar__crown">🏆</span>' : '') +
            '<input type="text" class="fm-player-avatar__name" data-fm-player-name list="fm-log-roster-datalist" placeholder="Nome" value="' + escapeHtml(p.name || '') + '" maxlength="20">' +
            '<button type="button" class="fm-player-avatar__del" data-fm-player-del aria-label="Rimuovi">×</button>' +
          '</div>';
        }).join('');
        playersGridEl.innerHTML = items +
          '<button type="button" class="fm-player-add" data-fm-log-add-player>+</button>' +
          '<button type="button" class="fm-player-add fm-player-add--bot" data-fm-log-add-bot>🤖+</button>';

        playersGridEl.querySelectorAll('[data-fm-player-idx]').forEach(av => {
          const idx = parseInt(av.dataset.fmPlayerIdx, 10);
          // Tap su avatar (non sul nome o del) → toggle winner
          av.addEventListener('click', (e) => {
            if (e.target.closest('[data-fm-player-name]') || e.target.closest('[data-fm-player-del]')) return;
            state.playersList[idx].isWin = !state.playersList[idx].isWin;
            renderPlayersGrid();
          });
          const nameInput = av.querySelector('[data-fm-player-name]');
          if (nameInput) {
            nameInput.addEventListener('input', () => { state.playersList[idx].name = nameInput.value; scheduleScoreBlock(); });
            nameInput.addEventListener('click', (e) => e.stopPropagation());
          }
          const delBtn = av.querySelector('[data-fm-player-del]');
          if (delBtn) {
            delBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              state.playersList.splice(idx, 1);
              renderPlayersGrid();
            });
          }
        });
        const addBtn = playersGridEl.querySelector('[data-fm-log-add-player]');
        const addBotBtn2 = playersGridEl.querySelector('[data-fm-log-add-bot]');
        if (addBtn) addBtn.addEventListener('click', () => {
          state.playersList.push({ name: '', isMe: false, isBot: false, isWin: false, score: null });
          renderPlayersGrid();
          setTimeout(() => {
            const inputs = playersGridEl.querySelectorAll('[data-fm-player-name]');
            if (inputs.length > 0) inputs[inputs.length - 1].focus();
          }, 50);
        });
        if (addBotBtn2) addBotBtn2.addEventListener('click', () => {
          state.playersList.push({ name: 'Automa', isMe: false, isBot: true, isWin: false, score: null });
          renderPlayersGrid();
        });
        renderRoster(); // tiene sincronizzata la rubrica (stato "già al tavolo")
        if (!(opts && opts.keepScores)) renderScoreBlock();
      };

      // ── Rubrica compagni: derivata da partite manuali + compagni BGG. ──
      // Tap su un compagno = aggiungilo (o toglilo) dal tavolo. La × lo nasconde.
      // Il datalist alimenta anche il type-ahead dei campi nome.
      const rosterEl = q('[data-fm-log-roster]');
      const rosterDatalist = q('[data-fm-log-roster-datalist]');
      const normName = (s) => String(s || '').trim().toLowerCase();
      const isInTable = (name) => state.playersList.some(p => p && !p.isBot && normName(p.name) === normName(name));
      const renderRoster = () => {
        const all = (typeof this.getCompanionRoster === 'function') ? this.getCompanionRoster() : [];
        const roster = state.context === 'tavolo' ? this.getCompanionRoster({ tableOnly: true }) : all;
        // Type-ahead: datalist sempre aggiornato, anche se la riga è nascosta.
        if (rosterDatalist) {
          rosterDatalist.innerHTML = all.map(c => '<option value="' + escapeHtml(c.name) + '"></option>').join('');
        }
        if (!rosterEl) return;
        rosterEl.hidden = false;
        // Prima chi è già al tavolo, poi gli altri compagni.
        const here = state.solo ? [] : state.playersList.filter(p => p && !p.isBot && p.name && p.name.trim()).map(p => p.name.trim());
        const others = roster.map(c => c.name).filter(n => !here.some(h => normName(h) === normName(n))).slice(0, Math.max(0, 8 - here.length));
        const hasBot = state.playersList.some(p => p && p.isBot);
        const chip = (attr, label, on) => '<button type="button" class="fm-who__chip" ' + attr + ' aria-pressed="' + !!on + '">' + (on ? '✓ ' : '') + escapeHtml(label) + '</button>';
        if (state.whoManaging) {
          const names = roster.map(c => c.name);
          const undo = state.whoRemoved ? '<p class="fm-who__note">Hai tolto ' + escapeHtml(state.whoRemoved) + '. <button type="button" data-fm-who-undo>Rimetti</button></p>' : '';
          rosterEl.innerHTML = '<div class="fm-who">' +
            names.slice(0, 12).map(n => '<button type="button" class="fm-who__chip fm-who__chip--del" data-fm-who-del="' + escapeHtml(n) + '" aria-label="Togli ' + escapeHtml(this.companionLabel(n)) + '">' + escapeHtml(this.companionLabel(n)) + ' ✕</button>').join('') +
            '<button type="button" class="fm-who__chip fm-who__chip--done" data-fm-who-done>Fatto</button></div>' +
            (undo || '<p class="fm-who__note">Tocca chi non vuoi più vedere qui. Le vostre partite restano.</p>');
          rosterEl.querySelectorAll('[data-fm-who-del]').forEach(b => b.addEventListener('click', () => {
            const name = b.getAttribute('data-fm-who-del');
            this.hideCompanion(name);
            const i = state.playersList.findIndex(p => p && !p.isBot && normName(p.name) === normName(name));
            if (i >= 0) state.playersList.splice(i, 1);
            state.whoRemoved = name;
            renderPlayersGrid();
          }));
          const undoBtn = rosterEl.querySelector('[data-fm-who-undo]');
          if (undoBtn) undoBtn.addEventListener('click', () => { this.unhideCompanion(state.whoRemoved); state.whoRemoved = ''; renderRoster(); });
          rosterEl.querySelector('[data-fm-who-done]').addEventListener('click', () => { state.whoManaging = false; state.whoRemoved = ''; renderRoster(); });
          return;
        }
        rosterEl.innerHTML = '<div class="fm-who">' +
          here.concat(others).map(n => chip('data-fm-who="' + escapeHtml(n) + '"', this.companionLabel(n), here.indexOf(n) >= 0)).join('') +
          chip('data-fm-who-bot', 'Automa', hasBot) +
          chip('data-fm-who-solo', 'Da solo', state.solo && state.soloMode !== 'automa') +
          (state.whoAdding
            ? '<form class="fm-who__add" data-fm-who-form><input type="text" list="fm-log-roster-datalist" maxlength="20" placeholder="Nome" aria-label="Nome del giocatore" data-fm-who-input><button type="submit">Aggiungi</button></form>'
            : '<button type="button" class="fm-who__chip fm-who__chip--add" data-fm-who-add>+ Altro</button>') +
          (roster.length ? '<button type="button" class="fm-who__manage" data-fm-who-manage>Togli nomi</button>' : '') +
          '</div>';
        const manageBtn = rosterEl.querySelector('[data-fm-who-manage]');
        if (manageBtn) manageBtn.addEventListener('click', () => { state.whoManaging = true; state.whoRemoved = ''; renderRoster(); });
        const touch = () => { state.whoTouched = true; state.soloTouched = true; };
        rosterEl.querySelectorAll('[data-fm-who]').forEach(b => b.addEventListener('click', () => {
          const name = b.getAttribute('data-fm-who');
          touch();
          if (state.solo) setSolo(false);
          if (isInTable(name)) {
            const i = state.playersList.findIndex(p => p && !p.isBot && normName(p.name) === normName(name));
            if (i >= 0) state.playersList.splice(i, 1);
          } else {
            state.playersList.push({ name: name, isMe: false, isBot: false, isWin: false, score: null });
          }
          renderPlayersGrid();
        }));
        const botBtn = rosterEl.querySelector('[data-fm-who-bot]');
        if (botBtn) botBtn.addEventListener('click', () => {
          touch();
          // Con delle persone al tavolo l'automa è un posto in più. Senza nessuno, è una partita da solo contro di lui.
          const i = state.playersList.findIndex(p => p && p.isBot);
          const people = state.playersList.some(p => p && !p.isBot);
          if (state.solo && state.soloMode === 'automa') setSolo(false);
          else if (!state.solo && i >= 0) state.playersList.splice(i, 1);
          else if (state.solo || !people) { state.outcome = null; setSolo(true, 'automa'); }
          else state.playersList.push({ name: 'Automa', isMe: false, isBot: true, isWin: false, score: null });
          renderPlayersGrid();
        });
        const soloBtn = rosterEl.querySelector('[data-fm-who-solo]');
        if (soloBtn) soloBtn.addEventListener('click', () => {
          touch();
          if (state.solo && state.soloMode !== 'automa') setSolo(false);
          else { if (state.solo) state.outcome = null; setSolo(true, 'game'); }
          renderPlayersGrid();
        });
        const addBtn = rosterEl.querySelector('[data-fm-who-add]');
        if (addBtn) addBtn.addEventListener('click', () => {
          state.whoAdding = true;
          renderRoster();
          const inp = rosterEl.querySelector('[data-fm-who-input]');
          if (inp) inp.focus();
        });
        const addForm = rosterEl.querySelector('[data-fm-who-form]');
        if (addForm) addForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const name = addForm.querySelector('[data-fm-who-input]').value.trim();
          state.whoAdding = false;
          if (name) {
            touch();
            if (state.solo) setSolo(false);
            if (!isInTable(name)) state.playersList.push({ name: name, isMe: false, isBot: false, isWin: false, score: null });
          }
          renderPlayersGrid();
        });
      };

      // ── Chi inizia + punti per giocatore (2026-11-01) ──
      // I punti sono facoltativi. Quando ci sono i miei e quelli di tutti gli altri,
      // vincitore e risultato si calcolano da soli (resta possibile il tocco a mano).
      const scoresEl = q('[data-fm-log-scores]');
      const starterEl = q('[data-fm-log-starter]');
      const atTable = () => state.playersList.filter(p => p && (p.isBot || (p.name && p.name.trim())));

      // ── Scheda del gioco (2026-11-03): modi di vincere e voci dei punti, se li conosciamo ──
      // Chi non vuole scrive il totale come sempre. Un gioco che non conosciamo resta col modulo di oggi.
      const moreEl = document.createElement('div');
      moreEl.className = 'fm-log-more';
      moreEl.hidden = true;
      const factsEl = document.createElement('div');
      factsEl.className = 'fm-log-facts';
      factsEl.innerHTML = [['when', 'Quando'], ['time', 'Durata'], ['where', 'Dove']].map(f => '<button type="button" class="fm-fact" data-fm-fact="' + f[0] + '" aria-expanded="false"><small>' + f[1] + '</small><span><b></b><i aria-hidden="true">▾</i></span></button>').join('');
      const syncMore = () => {
        const on = moreEl.hidden ? '' : moreEl.getAttribute('data-show');
        factsEl.querySelectorAll('[data-fm-fact]').forEach(b => b.setAttribute('aria-expanded', String(b.getAttribute('data-fm-fact') === on)));
        if (heroSub) heroSub.setAttribute('aria-expanded', String(on === 'other'));
      };
      const showPart = (k) => {
        moreEl.hidden = !moreEl.hidden && moreEl.getAttribute('data-show') === k;
        moreEl.setAttribute('data-show', k);
        syncMore();
      };
      const closeMore = () => { moreEl.hidden = true; syncMore(); };
      factsEl.addEventListener('click', (e) => { const b = e.target.closest('[data-fm-fact]'); if (b) showPart(b.getAttribute('data-fm-fact')); });
      const expsEl = document.createElement('div');
      expsEl.className = 'fm-log-field fm-log-exps';
      expsEl.hidden = true;
      const sheetEl = document.createElement('div');
      sheetEl.className = 'fm-sheet';
      sheetEl.hidden = true;
      if (outcomeGroup && outcomeGroup.parentNode) outcomeGroup.parentNode.insertBefore(sheetEl, outcomeGroup);
      const sheetExpOn = (e) => !e || !!state.sheetExp[e];
      const sheetWays = () => (state.sheet ? state.sheet.ways.filter(w => sheetExpOn(w.e)) : []);
      const sheetVoci = () => (state.sheet ? state.sheet.voci.filter(v => sheetExpOn(v.e)) : []);
      const pointsCount = () => { const w = sheetWays().find(x => x.it === state.winWay); return !w || w.p !== false; };
      const sheetKeys = () => ['me'].concat(state.playersList.map((p, i) => (p && (p.isBot || (p.name && p.name.trim())) ? String(i) : null)).filter(k => k !== null));
      const sheetSums = () => {
        if (!state.sheet || !state.sheet.sum) return;
        sheetKeys().forEach(k => {
          let any = false, tot = 0;
          sheetVoci().forEach(v => { const x = (state.sheetVals[v.it] || {})[k]; if (typeof x === 'number') { any = true; tot += x; } });
          if (!any) return;
          if (k === 'me') state.myScore = tot; else if (state.playersList[+k]) state.playersList[+k].score = tot;
          const inp = scoresEl && scoresEl.querySelector('[data-fm-score="' + k + '"]');
          if (inp) inp.value = tot;
        });
        autoWinner();
      };
      const renderSheetVoci = () => {
        if (!scoresEl) return;
        const old = scoresEl.querySelector('.fm-sv');
        if (old) old.remove();
        scoresEl.classList.toggle('fm-scores--nopts', !pointsCount());
        if (!pointsCount()) return;
        const voci = sheetVoci();
        if (!voci.length || scoresEl.hidden) return;
        const keys = sheetKeys(), box = document.createElement('div');
        box.className = 'fm-sv';
        const who = (k) => (k === 'me' ? 'Tu' : (((state.playersList[+k] || {}).name || '').trim() || 'Automa'));
        let inner = '<button type="button" class="fm-sv__more" data-fm-sv-toggle>' + (state.sheetOpen ? 'Solo il totale' : 'Aggiungi le voci di ' + escapeHtml(state.customTitle || 'questo gioco')) + '</button>';
        if (state.sheetOpen) {
          inner += '<div class="fm-sv__grid" style="--n:' + keys.length + '"><span></span>' + keys.map(k => '<span class="fm-sv__h">' + escapeHtml(who(k)) + '</span>').join('');
          voci.forEach((v, r) => {
            inner += '<span class="fm-sv__l">' + escapeHtml(v.it) + '</span>' + keys.map(k => {
              const x = (state.sheetVals[v.it] || {})[k];
              return '<input class="fm-scores__in" type="number" inputmode="numeric" step="1" data-fm-sv-r="' + r + '" data-fm-sv-k="' + k + '" value="' + (typeof x === 'number' ? x : '') + '" placeholder="—" aria-label="' + escapeHtml(v.it + ', ' + who(k)) + '">';
            }).join('');
          });
          inner += '</div>';
          if (!state.sheet.sum) inner += '<p class="fm-sv__note">In questo gioco il totale non è la somma delle voci: scrivilo qui sopra.</p>';
          inner += '<button type="button" class="fm-sv__rep" data-fm-sv-report>Una voce è sbagliata?</button>';
        }
        box.innerHTML = inner;
        scoresEl.appendChild(box);
        box.querySelector('[data-fm-sv-toggle]').addEventListener('click', () => { state.sheetOpen = !state.sheetOpen; renderSheetVoci(); });
        box.querySelectorAll('[data-fm-sv-r]').forEach(inp => {
          inp.addEventListener('input', () => {
            const v = voci[+inp.getAttribute('data-fm-sv-r')], k = inp.getAttribute('data-fm-sv-k'), raw = inp.value.trim(), n = raw === '' ? null : Number(raw);
            if (!state.sheetVals[v.it]) state.sheetVals[v.it] = {};
            state.sheetVals[v.it][k] = (n === null || !isFinite(n)) ? null : n;
            sheetSums();
          });
        });
        const rep = box.querySelector('[data-fm-sv-report]');
        if (rep) rep.addEventListener('click', () => {
          const row = document.createElement('div');
          row.className = 'fm-sv__form';
          row.innerHTML = '<input type="text" maxlength="300" placeholder="Cosa non torna?" aria-label="Cosa non torna"><button type="button">Invia</button>';
          rep.replaceWith(row);
          row.querySelector('button').addEventListener('click', () => {
            const text = row.querySelector('input').value.trim(), api = window.FrogMatchOggi && window.FrogMatchOggi.gameSheetReport;
            if (!text || !api) return;
            api(state.sheet.slug, text, state.customTitle);
            row.innerHTML = '<p class="fm-sv__note">Ricevuto, grazie: la controlliamo.</p>';
          });
        });
      };
      const renderSheet = () => {
        if (!state.sheet || state.solo) { sheetEl.hidden = true; sheetEl.innerHTML = ''; return; }
        const exps = [];
        state.sheet.ways.concat(state.sheet.voci).forEach(x => { if (x.e && exps.indexOf(x.e) < 0) exps.push(x.e); });
        const ways = sheetWays();
        if (state.winWay && !ways.some(w => w.it === state.winWay)) state.winWay = null;
        let html = '';
        if (exps.length) html += '<span class="fm-sheet__lab">Con quali espansioni?</span><div class="fm-sheet__chips">' + exps.map(e => '<button type="button" class="fm-sheet__chip" data-fm-sheet-exp="' + escapeHtml(e) + '" aria-pressed="' + !!state.sheetExp[e] + '">' + escapeHtml(e) + '</button>').join('') + '</div>';
        if (ways.length >= 2) {
          html += '<span class="fm-sheet__lab">Com\'è finita?</span><div class="fm-sheet__chips">' + ways.map(w => '<button type="button" class="fm-sheet__chip" data-fm-sheet-way="' + escapeHtml(w.it) + '" aria-pressed="' + (state.winWay === w.it) + '">' + escapeHtml(w.it) + '</button>').join('') + '</div>';
          if (!pointsCount()) html += '<p class="fm-sheet__note">Con questa vittoria i punti non contano: basta dire chi ha vinto.</p>';
        }
        sheetEl.hidden = !html;
        sheetEl.innerHTML = html;
        sheetEl.querySelectorAll('[data-fm-sheet-way]').forEach(b => b.addEventListener('click', () => {
          const it = b.getAttribute('data-fm-sheet-way');
          state.winWay = state.winWay === it ? null : it;
          renderSheet();
          renderScoreBlock();
        }));
        sheetEl.querySelectorAll('[data-fm-sheet-exp]').forEach(b => b.addEventListener('click', () => {
          const e = b.getAttribute('data-fm-sheet-exp');
          state.sheetExp[e] = !state.sheetExp[e];
          renderSheet();
          renderScoreBlock();
          sheetSums();
        }));
      };
      const syncSheet = () => {
        const bgg = state.bggOnly ? state.bggOnly.bggId : (state.product ? state.product.bgg : null), key = bgg ? String(bgg) : null;
        if (key === state.sheetKey) return;
        state.sheetKey = key; state.sheet = null; state.winWay = null; state.sheetVals = {}; state.sheetExp = {}; state.sheetOpen = false;
        renderSheet();
        const api = window.FrogMatchOggi && window.FrogMatchOggi.gameSheet;
        if (!key || !api) return;
        api(bgg, state.customTitle).then(sh => {
          if (state.sheetKey !== key) return;
          state.sheet = sh || null;
          if (sh && sh.coop && !state.solo && !state.coopMode && !state.editId) setCoop(true);
          renderSheet();
          renderScoreBlock();
        }).catch(() => {});
      };
      const sheetVociToSave = () => {
        if (!state.sheet || !pointsCount()) return null;
        const keys = sheetKeys(), rows = [];
        sheetVoci().forEach(v => {
          const vals = keys.map(k => { const x = (state.sheetVals[v.it] || {})[k]; return typeof x === 'number' ? x : null; });
          if (vals.some(x => x !== null)) rows.push({ l: v.it, v: vals });
        });
        return rows.length ? rows : null;
      };
      const renderStarter = () => {
        if (!starterEl) return;
        const ps = atTable();
        if (!ps.length) { starterEl.hidden = true; starterEl.innerHTML = ''; return; }
        starterEl.hidden = false;
        const who = state.firstPlayer;
        starterEl.innerHTML = '<span>' + (who ? 'Inizia <b>' + escapeHtml(who === 'Tu' ? 'tu' : who) + '</b>' : 'Chi inizia?') + '</span>' +
          '<button type="button" data-fm-starter-spin>🎲 ' + (who ? 'Di nuovo' : 'Estrai') + '</button>';
        starterEl.querySelector('[data-fm-starter-spin]').addEventListener('click', () => {
          const names = ['Tu'].concat(atTable().map(p => (p.name && p.name.trim()) || 'Automa'));
          state.firstPlayer = names[Math.floor(Math.random() * names.length)];
          renderStarter();
        });
      };
      // Le corone seguono lo stato; sotto, in una riga, com'è finita.
      const markLeaders = () => {
        if (!scoresEl) return;
        scoresEl.querySelectorAll('[data-fm-crown]').forEach(b => {
          const k = b.getAttribute('data-fm-crown');
          b.setAttribute('aria-pressed', String(k === 'me' ? state.outcome === 'win' : !!(state.playersList[+k] || {}).isWin));
        });
        const line = scoresEl.querySelector('[data-fm-win-line]');
        if (!line) return;
        const ps = atTable(), won = ps.filter(p => p.isWin), mine = state.myScore;
        const rival = state.outcome === 'win' ? ps.filter(p => typeof p.score === 'number').sort((a, b) => b.score - a.score)[0] : won[0];
        const gap = rival && typeof rival.score === 'number' && typeof mine === 'number' ? Math.abs(mine - rival.score) : 0;
        const by = gap && pointsCount() ? ' di ' + (gap === 1 ? '1 punto' : gap + ' punti') : '';
        const way = state.winWay ? ' · ' + state.winWay : '';
        line.textContent = state.outcome === 'win' ? '✓ Hai vinto' + by + way
          : (state.outcome === 'loss' && won.length ? '✕ Ha vinto ' + ((won[0].name && won[0].name.trim()) || 'Automa') + by + way : '');
      };
      // Tre modi di dire com'è finita, uno solo alla volta.
      const syncResultUi = () => {
        const noOne = !atTable().length;
        if (outcomeGroup) outcomeGroup.style.display = (!state.solo && !state.coopMode && noOne) ? '' : 'none';
        if (coopSub) coopSub.hidden = !state.coopMode || state.solo;
        if (scoresEl) {
          scoresEl.classList.toggle('fm-scores--coop', !!state.coopMode);
          if (!noOne && !state.solo) scoresEl.hidden = false;
        }
        const co = moreEl && moreEl.querySelector('[data-fm-coop]');
        if (co) co.checked = !!state.coopMode;
      };
      const setCoop = (on) => {
        state.coopMode = !!on;
        if (on) {
          state.playersList.forEach(p => { if (p) p.isWin = false; });
          setOutcome('coop');
        } else if (/^coop_|coop_pending/.test(state.outcome || '')) {
          setOutcome(null);
          if (coopWinGroup) coopWinGroup.querySelectorAll('.fm-result-coop-opt').forEach(b => b.classList.remove('is-active'));
        }
        syncResultUi();
        markLeaders();
      };
      const autoWinner = () => {
        const ps = atTable();
        const coop = state.outcome === 'coop_win' || state.outcome === 'coop_loss' || state.outcome === 'coop_pending';
        if (coop || typeof state.myScore !== 'number' || !ps.length || ps.some(p => typeof p.score !== 'number')) { markLeaders(); return; }
        const best = Math.max.apply(null, [state.myScore].concat(ps.map(p => p.score)));
        ps.forEach(p => { p.isWin = p.score === best; });
        setOutcome(state.myScore === best ? 'win' : 'loss');
        renderPlayersGrid({ keepScores: true });
        markLeaders();
      };
      const renderScoreBlock = () => {
        renderStarter();
        if (!scoresEl) return;
        const ps = state.playersList;
        syncResultUi();
        if (state.solo || !atTable().length) { scoresEl.hidden = true; scoresEl.innerHTML = ''; return; }
        scoresEl.hidden = false;
        const crown = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M3 8l4.500 4L12 5l4.500 7L21 8l-2 11H5z" fill="currentColor" stroke="currentColor" stroke-width="1.500" stroke-linejoin="round"/></svg>';
        const row = (key, name, color, val) =>
          '<div class="fm-scores__row fm-win-row">' +
            '<span class="fm-scores__av" style="background:' + color + '">' + escapeHtml((name || '?').charAt(0).toUpperCase()) + '</span>' +
            '<span class="fm-scores__name" data-fm-score-name="' + key + '">' + escapeHtml(name) + '</span>' +
            '<button type="button" class="fm-win-row__crown" data-fm-crown="' + key + '" aria-pressed="false" aria-label="Ha vinto ' + escapeHtml(name) + '">' + crown + '</button>' +
            '<input class="fm-scores__in" type="number" inputmode="numeric" step="1" data-fm-score="' + key + '" value="' + (typeof val === 'number' ? val : '') + '" placeholder="punti" aria-label="Punti di ' + escapeHtml(name) + '">' +
          '</div>';
        let html = state.coopMode
          ? '<div class="fm-scores__head"><span>I punti</span><span>facoltativi</span></div>'
          : '<div class="fm-scores__head"><span>Chi ha vinto?</span><span>tocca la corona o scrivi i punti</span></div>';
        html += row('me', 'Tu', '#1d7a43', state.myScore);
        ps.forEach((p, i) => {
          if (!p || !(p.isBot || (p.name && p.name.trim()))) return;
          const nm = (p.name && p.name.trim()) || 'Automa';
          html += row(String(i), nm, p.isBot ? '#6B5B95' : colorForName(nm), p.score);
        });
        html += '<div class="fm-win-line" data-fm-win-line></div>';
        scoresEl.innerHTML = html;
        scoresEl.querySelectorAll('[data-fm-crown]').forEach(b => b.addEventListener('click', () => {
          const k = b.getAttribute('data-fm-crown'), on = b.getAttribute('aria-pressed') === 'true';
          state.playersList.forEach(p => { if (p) p.isWin = false; });
          if (on) setOutcome(null);
          else if (k === 'me') setOutcome('win');
          else { state.playersList[+k].isWin = true; setOutcome('loss'); }
          markLeaders();
        }));
        scoresEl.querySelectorAll('[data-fm-score]').forEach(inp => {
          inp.addEventListener('input', () => {
            const raw = inp.value.trim();
            const num = raw === '' ? null : Number(raw);
            const val = (num === null || !isFinite(num)) ? null : num;
            const k = inp.getAttribute('data-fm-score');
            if (k === 'me') state.myScore = val;
            else if (state.playersList[+k]) state.playersList[+k].score = val;
            autoWinner();
          });
        });
        markLeaders();
        renderSheetVoci();
      };
      let scoreTimer = null;
      const scheduleScoreBlock = () => { clearTimeout(scoreTimer); scoreTimer = setTimeout(renderScoreBlock, 450); };

      // ── Una schermata sola: si mettono in ordine i pezzi che ci sono già, la logica resta la loro ──
      const formNode = modal.querySelector('.fm-log-form');
      const resultField = outcomeGroup ? outcomeGroup.closest('.fm-log-field') : null;
      const whoField = q('[data-fm-log-players-label]') ? q('[data-fm-log-players-label]').closest('.fm-log-field') : null;
      if (formNode) formNode.classList.add('fm-log-form--v3', 'fm-log-form--nogame');
      if (formNode && whoField && resultField) {
        formNode.insertBefore(whoField, resultField);
        formNode.insertBefore(moreEl, whoField);
        formNode.insertBefore(factsEl, moreEl);
        formNode.insertBefore(expsEl, whoField);
        [[q('.fm-log-row-2'), 'when'], [q('[data-fm-log-duration-chips]') && q('[data-fm-log-duration-chips]').closest('.fm-log-field'), 'time'], [q('[data-fm-log-where]') && q('[data-fm-log-where]').closest('.fm-log-field'), 'where'], [q('[data-fm-log-extras-field]'), 'other'], [q('[data-fm-log-library-prompt]'), 'other'], [starterEl, 'other']].forEach(x => { if (x[0]) { x[0].setAttribute('data-part', x[1]); moreEl.appendChild(x[0]); } });
        moreEl.insertAdjacentHTML('beforeend', '<label class="fm-more-co" data-part="other"><input type="checkbox" data-fm-coop><span>Si gioca tutti insieme contro il gioco</span></label>' +
          '<div class="fm-log-field fm-edit-only" data-part="other"><span class="fm-log-label-min">Il tuo voto</span><div class="fm-who" data-fm-edit-rating>' + [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(v => '<button type="button" class="fm-who__chip" data-rate="' + v + '" aria-pressed="false">' + v + '</button>').join('') + '</div></div>' +
          '<button type="button" class="fm-more-change" data-part="other" data-fm-change-game>Cambia gioco</button>');
        moreEl.querySelector('[data-fm-edit-rating]').addEventListener('click', (e) => {
          const b = e.target.closest('[data-rate]');
          if (!b) return;
          const v = Number(b.getAttribute('data-rate'));
          state.rating = state.rating === v ? null : v;
          moreEl.querySelectorAll('[data-rate]').forEach(x => x.setAttribute('aria-pressed', String(Number(x.getAttribute('data-rate')) === state.rating)));
        });
        const actionsEl = formNode.querySelector('.fm-log-actions');
        if (actionsEl) actionsEl.insertAdjacentHTML('beforebegin', '<p class="fm-sv__note" data-fm-edit-note hidden>Su BGG questa partita resta com\'era: da qui si corregge solo il tuo diario.</p>');
        if (scoresEl) resultField.appendChild(scoresEl);
        modal.querySelectorAll('.fm-log-label-min').forEach(l => { const t = l.firstChild; if (t && t.nodeType === 3) t.nodeValue = t.nodeValue.replace(/^[^\p{L}]+/u, ''); });
        const lab = q('[data-fm-log-players-label]');
        if (lab) lab.textContent = 'Con chi?';
        const coopLab = coopSub && coopSub.querySelector('.fm-result-coop-sub__label');
        if (coopLab) coopLab.textContent = 'Com\'è finita?';
        if (coopWinGroup) coopWinGroup.querySelectorAll('.fm-result-coop-opt').forEach(b => { b.textContent = b.dataset.coopWin === 'true' ? 'Abbiamo vinto' : 'Ha vinto il gioco'; });
        if (titleBlock) titleBlock.textContent = 'A cosa hai giocato?';
      }
      if (heroSub) {
        heroSub.setAttribute('role', 'button');
        heroSub.setAttribute('tabindex', '0');
        const toggleMore = () => showPart('other');
        heroSub.addEventListener('click', toggleMore);
        heroSub.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleMore(); } });
      }
      ['click', 'input', 'change'].forEach(ev => moreEl.addEventListener(ev, () => setTimeout(updateHero, 0)));
      // Scelta fatta: il valore si legge già nel suo riquadro, il pannello non serve più.
      moreEl.addEventListener('click', (e) => { if (e.target.closest('.fm-duration-chip, .fm-where-btn')) closeMore(); });
      moreEl.addEventListener('change', (e) => { if (e.target.matches('[data-fm-log-date]')) closeMore(); });
      moreEl.addEventListener('change', (e) => { if (e.target.matches('[data-fm-coop]')) { setCoop(e.target.checked); renderScoreBlock(); } });
      moreEl.addEventListener('click', (e) => {
        if (!e.target.closest('[data-fm-change-game]')) return;
        state.product = null; state.bggOnly = null; state.customTitle = ''; state.titleLocked = false;
        if (!state.whoTouched) state.playersList = [];
        closeMore();
        if (gameInput) gameInput.value = '';
        if (formNode) formNode.classList.remove('fm-log-form--preset');
        state.soloFor = null;
        renderPlayersGrid();
        updateSaveBtn();
      });

      renderPlayersGrid();

      // ── SOLITARIO (2026-11-01): tre modi diversi di giocare da soli ──
      // contro il gioco (vinci o perdi), contro l'automa (punti contro punti), contro te stesso (solo il punteggio).
      const modeEl = q('[data-fm-log-mode]');
      const soloEl = q('[data-fm-log-solo]');
      const playersLabelEl = q('[data-fm-log-players-label]');
      const playersFieldEl = playersLabelEl ? playersLabelEl.closest('.fm-log-field') : null;
      const currentGame = () => ({
        bggId: state.bggOnly ? state.bggOnly.bggId : (state.product ? state.product.bgg : null),
        productId: state.product ? state.product.id : null,
        title: state.customTitle
      });
      const soloHint = () => {
        const hint = soloEl && soloEl.querySelector('[data-fm-solo-hint]');
        if (!hint) return;
        const st = this._soloStats(currentGame(), state.soloMode);
        const v = state.myScore;
        let txt = st.best === null ? 'Il primo punteggio diventa il record da battere.' : 'Il tuo record: <b>' + st.best + '</b>' + (st.avg !== null ? ' · media ' + st.avg : '');
        if (typeof v === 'number' && st.best !== null) {
          if (v > st.best) txt = '<b>Nuovo record!</b> Il tuo meglio era ' + st.best;
          else if (v === st.best) txt = 'Hai pareggiato il tuo record, <b>' + st.best + '</b>';
          else txt = 'A <b>' + (st.best - v) + '</b> dal tuo record, ' + st.best;
        }
        hint.innerHTML = txt;
      };
      const soloResultSync = () => {
        if (!soloEl) return;
        const win = state.soloMode === 'game' ? 'coop_win' : 'win';
        const loss = state.soloMode === 'game' ? 'coop_loss' : 'loss';
        soloEl.querySelectorAll('[data-fm-solo-res]').forEach(b => {
          const r = b.getAttribute('data-fm-solo-res');
          b.setAttribute('aria-pressed', String((r === 'win' && state.outcome === win) || (r === 'loss' && state.outcome === loss)));
        });
      };
      const renderSolo = () => {
        renderSheet();
        if (modeEl) modeEl.querySelectorAll('[data-mode]').forEach(b => b.setAttribute('aria-pressed', String((b.dataset.mode === 'solo') === state.solo)));
        syncResultUi();
        if (!soloEl) return;
        soloEl.hidden = !state.solo;
        if (!state.solo) { soloEl.innerHTML = ''; return; }
        const m = state.soloMode;
        const num = (key, label, val) => '<label class="fm-solo__num' + (key === 'me' && m === 'score' ? ' fm-solo__num--big' : '') + '"><span>' + label + '</span><input type="number" inputmode="numeric" step="1" data-fm-solo-score="' + key + '" value="' + (typeof val === 'number' ? val : '') + '" placeholder="—"></label>';
        const res = '<div class="fm-solo__res' + (m === 'automa' ? '' : ' fm-solo__res--3') + '"><button type="button" data-fm-solo-res="win" aria-pressed="false">✓ Ho vinto</button><button type="button" data-fm-solo-res="loss" aria-pressed="false">✕ Ho perso</button>' + (m === 'automa' ? '' : '<button type="button" data-fm-solo-mode="score" aria-pressed="' + (m === 'score') + '">Solo punti</button>') + '</div>';
        const bot = state.playersList.find(p => p && p.isBot);
        let body = '';
        if (m === 'game') body = res + num('me', 'I tuoi punti, se il gioco li conta', state.myScore);
        else if (m === 'automa') body = '<div class="fm-solo__nums">' + num('me', 'Tu', state.myScore) + num('bot', 'Automa', bot ? bot.score : null) + '</div>' + res;
        else body = res + num('me', 'I tuoi punti', state.myScore) + '<p class="fm-solo__hint" data-fm-solo-hint></p>';
        soloEl.innerHTML = body;
        soloResultSync();
        soloHint();
      };
      const setSolo = (on, mode) => {
        const was = state.solo;
        if (on && !was) state.keptPlayers = state.playersList.filter(p => p && !p.isBot);
        state.solo = !!on;
        if (on) {
          state.soloMode = mode || state.soloMode || 'game';
          if (!was) state.outcome = null;
          const bot = state.playersList.find(p => p && p.isBot) || { name: 'Automa', isMe: false, isBot: true, isWin: false, score: null };
          state.playersList = state.soloMode === 'automa' ? [bot] : [];
        } else {
          state.soloMode = null;
          if (was) {
            state.playersList = state.keptPlayers || [];
            state.keptPlayers = null;
            setOutcome(null);
            renderPlayersGrid();
          }
        }
        renderSolo();
      };
      // Con un gioco scelto riparte da come l'hai giocato l'ultima volta. I giochi solo in solitario partono da soli.
      const applySoloDefault = () => {
        const g = currentGame();
        const key = String(g.bggId || g.productId || String(g.title || '').toLowerCase().trim());
        if (!key || key === state.soloFor || state.soloTouched) { state.soloFor = key; return; }
        state.soloFor = key;
        const last = this._soloStats(g, null).lastAny;
        if (last && last.soloMode) setSolo(true, last.soloMode);
        else if (state.product && state.product.pmax === 1) setSolo(true, 'game');
        else if (state.solo) setSolo(false);
      };
      // Di solito si gioca con le stesse persone: si riparte da chi c'era l'ultima volta a questo gioco.
      const applyWhoDefault = () => {
        if (state.whoTouched || state.solo || state.playersList.length) return;
        const g = currentGame(), nk = String(g.title || '').toLowerCase().trim();
        let last = null;
        ((this.profile && this.profile.manualPlays) || []).forEach(m => {
          if (!m || !(g.bggId ? String(m.bggId) === String(g.bggId) : String(m.title || '').toLowerCase().trim() === nk)) return;
          if (!last || String(m.date || '') > String(last.date || '') || (String(m.date || '') === String(last.date || '') && (m.loggedAt || 0) > (last.loggedAt || 0))) last = m;
        });
        if (!last || last.soloMode) return;
        state.playersList = (last.playersList || []).filter(x => x && !x.isMe && (x.name || x.isBot)).map(x => ({ name: x.name || 'Automa', isMe: false, isBot: !!x.isBot, isWin: false, score: null }));
        if (/^coop_/.test(last.outcome || '')) setCoop(true);
        renderPlayersGrid();
      };
      if (modeEl) modeEl.addEventListener('click', (e) => {
        const b = e.target.closest('[data-mode]');
        if (!b) return;
        state.soloTouched = true;
        setSolo(b.dataset.mode === 'solo');
      });
      if (soloEl) {
        soloEl.addEventListener('click', (e) => {
          const t = e.target.closest('[data-fm-solo-mode]');
          if (t) {
            state.soloTouched = true;
            state.outcome = null;
            setSolo(true, state.soloMode === 'score' ? 'game' : 'score');
            return;
          }
          const r = e.target.closest('[data-fm-solo-res]');
          if (r) {
            if (state.soloMode === 'score') { state.soloTouched = true; setSolo(true, 'game'); }
            const pick = state.soloMode === 'game'
              ? (r.getAttribute('data-fm-solo-res') === 'win' ? 'coop_win' : 'coop_loss')
              : r.getAttribute('data-fm-solo-res');
            state.outcome = state.outcome === pick ? null : pick;
            soloResultSync();
          }
        });
        soloEl.addEventListener('input', (e) => {
          const k = e.target.getAttribute('data-fm-solo-score');
          if (!k) return;
          const raw = e.target.value.trim();
          const num = raw === '' ? null : Number(raw);
          const val = (num === null || !isFinite(num)) ? null : num;
          const bot = state.playersList.find(p => p && p.isBot);
          if (k === 'me') state.myScore = val;
          else if (bot) bot.score = val;
          // Contro l'automa i punti bastano a dire chi ha vinto.
          if (state.soloMode === 'automa' && bot && typeof state.myScore === 'number' && typeof bot.score === 'number') {
            state.outcome = state.myScore >= bot.score ? 'win' : 'loss';
            bot.isWin = bot.score > state.myScore;
            soloResultSync();
          }
          soloHint();
        });
      }

      // Alias compat per il vecchio nome usato in saveBtn
      const renderPlayersList = renderPlayersGrid;
      const playersListEl = playersGridEl;

      // ── Library prompt contestuale: appare se gioco NON in ludoteca ──
      const libraryPromptEl = q('[data-fm-log-library-prompt]');
      const isGameInLibrary = (bggId, productId) => {
        const p = this.profile || {};
        // BGG owned
        if (bggId && p.bggCollection && Array.isArray(p.bggCollection.owned)) {
          for (const item of p.bggCollection.owned) {
            const id = (typeof item === 'object') ? item.id : item;
            if (id === bggId) return true;
          }
        }
        // manualOwned
        if (Array.isArray(p.manualOwned)) {
          for (const m of p.manualOwned) {
            if (bggId && m.bggId === bggId) return true;
            if (productId && String(m.productId) === String(productId)) return true;
          }
        }
        // purchasedProducts (Frogames orders)
        if (Array.isArray(p.purchasedProducts)) {
          for (const purch of p.purchasedProducts) {
            if (bggId && purch.bggId === bggId) return true;
            if (productId && String(purch.productId) === String(productId)) return true;
          }
        }
        return false;
      };
      const updateLibraryPrompt = () => {
        if (!libraryPromptEl) return;
        const bggId = state.bggOnly ? state.bggOnly.bggId : (state.product ? state.product.bgg : null);
        const productId = state.product ? state.product.id : null;
        const hasGame = state.product || state.bggOnly || (state.customTitle && state.customTitle.length > 1);
        if (!hasGame) {
          libraryPromptEl.hidden = true;
          return;
        }
        // Se già in ludoteca, nascondi il prompt (no rumore inutile)
        if (isGameInLibrary(bggId, productId)) {
          libraryPromptEl.hidden = true;
        } else {
          libraryPromptEl.hidden = false;
        }
      };

      // ── Slider durata ──
      const durationSlider = q('[data-fm-log-duration-slider]');
      const durationDisplay = q('[data-fm-log-duration-display]');
      const durationUnknownBtn = q('[data-fm-log-duration-unknown]');
      // Mapping slider value (0-48) → minuti: 0 = non scelto, 1-48 = 5min steps fino a 4h.
      // Indici chiave: 6=30m, 12=1h, 24=2h, 36=3h, 48=4h+
      const sliderToMinutes = (val) => {
        const v = parseInt(val, 10);
        if (v <= 0) return null;
        if (v >= 48) return 240; // 4h+
        return v * 5;
      };
      const minutesToLabel = (m) => {
        if (m == null) return '—';
        if (m === 0) return 'Non so';
        if (m >= 240) return '4h+';
        const h = Math.floor(m / 60);
        const min = m % 60;
        if (h === 0) return min + ' min';
        if (min === 0) return h + 'h';
        return h + 'h ' + min + 'min';
      };
      const durationChips = q('[data-fm-log-duration-chips]');
      // Minuti → valore slider (0-48, step 5'). Inverso di sliderToMinutes, cap a 4h+.
      const minutesToSlider = (m) => {
        if (m == null || m <= 0) return 0;
        if (m >= 240) return 48;
        return Math.round(m / 5);
      };
      // Fix barra riempimento: la CSS usa var(--val) ma non veniva mai impostata.
      const setSliderFill = (val) => {
        if (durationSlider) durationSlider.style.setProperty('--val', (val / 48 * 100) + '%');
      };
      // Marca attiva la chip che combacia con i minuti correnti (nessuna se valore "libero").
      const syncDurationChips = () => {
        if (!durationChips) return;
        durationChips.querySelectorAll('.fm-duration-chip').forEach(c => {
          c.classList.toggle('is-active', parseInt(c.dataset.min, 10) === state.minutes);
        });
      };
      const updateDurationDisplay = () => {
        if (!durationDisplay) return;
        const srcLabel = state.minutesSource === 'timer' ? ' · dal timer' : state.minutesSource === 'mine' ? ' · tua media' : state.minutesSource === 'bgg' ? ' · stima BGG' : '';
        const pre = (state.minutesSource === 'mine' || state.minutesSource === 'bgg') ? 'circa ' : '';
        durationDisplay.textContent = state.minutes == null ? '—' : (state.minutes === 0 ? 'Non so' : pre + minutesToLabel(state.minutes) + srcLabel);
      };
      if (durationSlider) {
        durationSlider.addEventListener('input', () => {
          const m = sliderToMinutes(durationSlider.value);
          state.minutes = m;
          state.minutesSource = null;
          setSliderFill(durationSlider.value);
          updateDurationDisplay();
          syncDurationChips();
          if (durationUnknownBtn) durationUnknownBtn.classList.remove('is-active');
        });
      }
      if (durationChips) {
        durationChips.addEventListener('click', (e) => {
          const chip = e.target.closest('.fm-duration-chip');
          if (!chip) return;
          const m = parseInt(chip.dataset.min, 10);
          // Ri-tap sulla chip attiva → deseleziona (torna a "non scelto")
          state.minutes = (state.minutes === m) ? null : m;
          state.minutesSource = null;
          const sv = minutesToSlider(state.minutes);
          if (durationSlider) durationSlider.value = sv;
          setSliderFill(sv);
          updateDurationDisplay();
          syncDurationChips();
          if (durationUnknownBtn) durationUnknownBtn.classList.remove('is-active');
        });
      }
      if (durationUnknownBtn) {
        durationUnknownBtn.addEventListener('click', () => {
          state.minutes = 0;
          state.minutesSource = null;
          durationUnknownBtn.classList.toggle('is-active');
          if (!durationUnknownBtn.classList.contains('is-active')) {
            state.minutes = null;
          }
          if (durationSlider) durationSlider.value = 0;
          setSliderFill(0);
          syncDurationChips();
          updateDurationDisplay();
        });
      }

      // ── Toggle "Dove hai giocato" (tavolo / bga / online) ──
      const whereToggle = q('[data-fm-log-where]');
      const playersLabel = q('[data-fm-log-players-label]');
      const playersHint = q('[data-fm-log-players-hint]');
      const updateWhereHints = () => {
        const live = state.context === 'tavolo';
        if (playersLabel) {
          playersLabel.textContent = live ? 'Con chi?' : 'Contro chi?';
        }
        if (playersHint) {
          playersHint.textContent = live
            ? 'Tap su un avatar per segnarlo vincitore 🏆 — comodo per giochi a punti'
            : 'Online gli avversari non contano come compagni di tavolo — tap per il vincitore 🏆';
        }
        renderRoster();
      };
      if (whereToggle) {
        whereToggle.addEventListener('click', (e) => {
          const btn = e.target.closest('.fm-where-btn');
          if (!btn) return;
          state.context = btn.dataset.where || 'tavolo';
          whereToggle.querySelectorAll('.fm-where-btn').forEach(b => b.classList.toggle('is-active', b === btn));
          updateWhereHints();
        });
      }

      // ── SI GIOCA (2026-11-01): scorciatoie prima di scrivere ──
      const quickEl = q('[data-fm-quick]');
      const quickShelf = q('[data-fm-quick-shelf]');
      const quickAgain = q('[data-fm-quick-again]');
      const quickLabel = q('[data-fm-quick-label]');
      let quickHasItems = false;
      const catalogByBgg = () => {
        const m = new Map();
        const list = (FM.getCatalogProducts ? FM.getCatalogProducts() : null) || this.products || [];
        list.forEach(p => { if (p && p.bgg && !m.has(p.bgg)) m.set(p.bgg, p); });
        return m;
      };
      const coverFor = (bggId, own, cat) => {
        if (own) return own;
        const p = bggId ? cat.get(bggId) : null;
        return p ? p.img : null;
      };
      const MESI = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
      const relTime = (iso) => {
        if (!iso) return '';
        const d = new Date(String(iso).slice(0, 10) + 'T12:00:00');
        if (isNaN(d.getTime())) return '';
        const today = new Date(); today.setHours(12, 0, 0, 0);
        const days = Math.round((today - d) / 86400000);
        if (days <= 0) return 'oggi';
        if (days === 1) return 'ieri';
        if (days < 7) return days + ' giorni fa';
        if (days < 30) { const w = Math.round(days / 7); return w === 1 ? '1 settimana fa' : w + ' settimane fa'; }
        return MESI[d.getMonth()] + (d.getFullYear() !== today.getFullYear() ? ' ' + d.getFullYear() : '');
      };
      const keyOf = (bggId, title) => bggId ? ('b' + bggId) : ('t' + String(title || '').toLowerCase().trim());
      const buildQuickList = () => {
        const prof = this.profile || {};
        const cat = catalogByBgg();
        const out = [];
        const seen = new Set();
        const push = (it) => {
          const k = keyOf(it.bggId, it.title);
          if (!it.title || seen.has(k)) return false;
          seen.add(k);
          out.push(it);
          return out.length >= 9;
        };
        const plays = (prof.manualPlays || []).slice().sort((a, b) =>
          String(b.date || '').localeCompare(String(a.date || '')) || ((b.loggedAt || 0) - (a.loggedAt || 0)));
        for (const p of plays) {
          if (!p) continue;
          if (push({ bggId: p.bggId || null, productId: p.productId || null, title: p.title, img: coverFor(p.bggId, p.img, cat), when: relTime(p.date) })) return out;
        }
        const tp = ((prof.playsActivity && prof.playsActivity.topPlayed) || []).slice()
          .sort((a, b) => String(b.lastPlayed || '').localeCompare(String(a.lastPlayed || '')));
        for (const g of tp) {
          if (!g) continue;
          if (push({ bggId: g.bggId || null, title: g.name, img: coverFor(g.bggId, g.img || g.thumbnail, cat), when: g.lastPlayed ? relTime(g.lastPlayed) : 'da BGG' })) return out;
        }
        const owned = ((prof.bggCollection && prof.bggCollection.owned) || []).concat(prof.manualOwned || []);
        for (const g of owned) {
          if (!g || typeof g !== 'object') continue;
          const bgg = g.id || g.bggId || null;
          if (push({ bggId: bgg, productId: g.productId || null, title: g.name || g.title, img: coverFor(bgg, g.image || g.thumbnail || g.img, cat), when: 'mai giocato' })) return out;
        }
        return out;
      };
      const selectQuickGame = (it) => {
        if (!it) return;
        const prod = it.bggId ? catalogByBgg().get(it.bggId) : null;
        if (prod) {
          state.product = prod; state.bggOnly = null; state.customTitle = prod.t;
        } else if (it.bggId) {
          state.product = null; state.bggOnly = { bggId: it.bggId, name: it.title, img: it.img || null }; state.customTitle = it.title;
        } else {
          state.product = null; state.bggOnly = null; state.customTitle = it.title;
        }
        state.titleLocked = true;
        if (gameInput) gameInput.value = state.customTitle;
        if (suggest) { suggest.hidden = true; }
        updateSaveBtn();
        if (typeof updateExtras === 'function') updateExtras();
      };
      const lastPlay = () => {
        let best = null;
        for (const p of ((this.profile && this.profile.manualPlays) || [])) {
          if (!p || !p.title) continue;
          if (!best || String(p.date || '') > String(best.date || '') ||
              (String(p.date || '') === String(best.date || '') && (p.loggedAt || 0) > (best.loggedAt || 0))) best = p;
        }
        return best;
      };
      const syncQuickVisibility = (hasGame) => {
        if (quickEl) quickEl.hidden = !!hasGame || !quickHasItems;
      };
      const renderQuick = () => {
        if (!quickEl) return;
        const list = buildQuickList();
        const lp = lastPlay();
        quickHasItems = !!(list.length || lp);
        if (quickAgain) {
          if (lp) {
            const cat = catalogByBgg();
            const img = coverFor(lp.bggId, lp.img, cat);
            const names = (lp.playersList || []).filter(x => x && !x.isMe).map(x => x.name).filter(Boolean);
            quickAgain.hidden = false;
            quickAgain.innerHTML = (img ? '<img src="' + escapeHtml(img) + '" alt="">' : '') +
              '<span><b>↻ Come l\'ultima volta</b> · ' + escapeHtml(lp.title) +
              (names.length ? ' con ' + escapeHtml(names.slice(0, 3).join(', ')) + (names.length > 3 ? ' e altri' : '') : '') +
              '<small>' + escapeHtml(relTime(lp.date)) + '</small></span>';
            quickAgain.onclick = () => {
              selectQuickGame({ bggId: lp.bggId || null, productId: lp.productId || null, title: lp.title, img: img });
              state.playersList = (lp.playersList || []).filter(x => x && !x.isMe).map(x => ({
                name: x.name || (x.isBot ? 'Automa' : ''), isMe: false, isBot: !!x.isBot, isWin: false, score: null
              }));
              state.context = lp.context || 'tavolo';
              if (whereToggle) whereToggle.querySelectorAll('.fm-where-btn').forEach(b => b.classList.toggle('is-active', b.dataset.where === state.context));
              updateWhereHints();
              renderPlayersGrid();
            };
          } else {
            quickAgain.hidden = true;
            quickAgain.innerHTML = '';
          }
        }
        if (quickLabel) quickLabel.hidden = !list.length;
        if (quickShelf) {
          quickShelf.innerHTML = list.map((it, i) =>
            '<button type="button" class="fm-quick__g" data-fm-quick-i="' + i + '">' +
              '<span class="fm-quick__cv">' + (it.img
                ? '<img src="' + escapeHtml(it.img) + '" alt="" loading="lazy">'
                : '<span class="fm-quick__noimg">' + escapeHtml(it.title) + '</span>') + '</span>' +
              '<span class="fm-quick__t">' + escapeHtml(it.title) + '</span>' +
              '<span class="fm-quick__w">' + escapeHtml(it.when || '') + '</span>' +
            '</button>').join('');
          quickShelf.querySelectorAll('[data-fm-quick-i]').forEach(b => b.addEventListener('click', () => selectQuickGame(list[+b.getAttribute('data-fm-quick-i')])));
        }
        syncQuickVisibility(state.product || state.bggOnly || (state.customTitle && state.customTitle.trim().length > 1));
      };
      const rewardPanel = q('[data-fm-reward]');
      const formEl = modal.querySelector('.fm-log-form');
      const SAVE_LABEL = saveBtn.textContent;
      const showForm = () => {
        if (rewardPanel) { rewardPanel.hidden = true; rewardPanel.innerHTML = ''; }
        if (formEl) formEl.hidden = false;
      };

      const openModal = () => {
        showForm();
        this._prepareRewardFacts();
        // Data locale: con toISOString tra mezzanotte e le 2 risultava ancora ieri.
        const now0 = new Date();
        const today0 = now0.getFullYear() + '-' + String(now0.getMonth() + 1).padStart(2, '0') + '-' + String(now0.getDate()).padStart(2, '0');
        if (dateInput) dateInput.value = today0;
        state.date = today0;
        modal.hidden = false;
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        renderRoster(); // ricalcola la rubrica (include i compagni delle ultime partite)
        renderQuick();
        // Con lo scaffale visibile niente tastiera subito: copre le copertine sul telefono.
        if (gameInput && (!quickEl || quickEl.hidden)) setTimeout(() => gameInput.focus(), 100);
      };
      const closeModal = () => {
        modal.hidden = true;
        modal.style.display = 'none';
        document.body.style.overflow = '';
        state.product = null;
        state.bggOnly = null;
        state.customTitle = '';
        state.minutes = null;
        state.rating = null;
        state.players = null;
        state.outcome = null;
        state.context = 'tavolo';
        state.playersList = [];
        state.extras = [];
        state.myScore = null;
        state.firstPlayer = null;
        state.minutesSource = null;
        state.solo = false;
        state.soloMode = null;
        state.soloTouched = false;
        state.soloFor = null;
        state.keptPlayers = null;
        state.sheet = null; state.sheetKey = null; state.sheetOpen = false; state.sheetVals = {}; state.sheetExp = {}; state.winWay = null;
        state.coopMode = false; state.whoTouched = false; state.titleLocked = false; state.whoAdding = false; state.whoManaging = false; state.whoRemoved = '';
        state.editId = null;
        closeMore();
        saveBtn.textContent = SAVE_LABEL;
        const editNote = q('[data-fm-edit-note]');
        if (editNote) editNote.hidden = true;
        renderSolo();
        renderRoster();
        if (formEl) { formEl.classList.remove('fm-log-form--preset', 'fm-log-form--picked', 'fm-log-form--editing'); formEl.classList.add('fm-log-form--nogame'); }
        showForm();
        if (gameInput) gameInput.value = '';
        if (suggest) { suggest.innerHTML = ''; suggest.hidden = true; }
        if (durationGroup) durationGroup.querySelectorAll('.fm-chip').forEach(b => b.classList.remove('is-active'));
        if (ratingGroup) ratingGroup.querySelectorAll('.fm-chip').forEach(b => b.classList.remove('is-active'));
        if (playersGroup) playersGroup.querySelectorAll('.fm-chip').forEach(b => b.classList.remove('is-active'));
        if (outcomeGroup) outcomeGroup.querySelectorAll('.fm-result-btn').forEach(b => b.classList.remove('is-active'));
        if (coopSub) coopSub.hidden = true;
        if (coopWinGroup) coopWinGroup.querySelectorAll('.fm-result-coop-opt').forEach(b => b.classList.remove('is-active'));
        if (heroEl) heroEl.hidden = true;
        if (titleBlock) titleBlock.style.display = '';
        if (subtitleBlock) subtitleBlock.style.display = '';
        if (libraryPromptEl) libraryPromptEl.hidden = true;
        if (durationSlider) { durationSlider.value = 0; durationSlider.style.setProperty('--val', '0%'); }
        if (durationUnknownBtn) durationUnknownBtn.classList.remove('is-active');
        if (durationDisplay) durationDisplay.textContent = '—';
        if (durationChips) durationChips.querySelectorAll('.fm-duration-chip').forEach(c => c.classList.remove('is-active'));
        if (whereToggle) whereToggle.querySelectorAll('.fm-where-btn').forEach(b => b.classList.toggle('is-active', b.dataset.where === 'tavolo'));
        updateWhereHints();
        // Reset campo extras
        if (extrasField) extrasField.hidden = true;
        if (extrasSuggested) extrasSuggested.innerHTML = '';
        if (extrasResults) { extrasResults.innerHTML = ''; extrasResults.hidden = true; }
        if (extrasChosen) extrasChosen.innerHTML = '';
        if (extrasSearch) extrasSearch.value = '';
        renderPlayersGrid();
        if (status) { status.hidden = true; status.textContent = ''; }
        saveBtn.disabled = true;
      };

      // Apertura dall'app (assets/frogmatch-app.js): gioco, compagni e durata già compilati.
      this.openLogWith = (o) => {
        o = o || {};
        if (!modal.hidden) closeModal();
        openModal();
        if (o.game) selectQuickGame({ bggId: o.game.bggId || null, productId: o.game.productId || null, title: o.game.title, img: o.game.img || null });
        if (o.date) { state.date = o.date; if (dateInput) dateInput.value = o.date; }
        // Gioco già scelto: prima quello che resta da dire (risultato, chi c'era), poi il resto.
        if (formEl) formEl.classList.toggle('fm-log-form--preset', !!o.game);
        if (Array.isArray(o.players) && o.players.length) {
          state.soloTouched = true;
          state.whoTouched = true;
          setSolo(false);
          state.playersList = o.players.map(n => ({ name: n, isMe: false, isBot: false, isWin: false, score: null }));
        } else if (o.solo) {
          state.soloTouched = true;
          state.whoTouched = true;
          setSolo(true, o.soloMode || state.soloMode || 'game');
        }
        if (o.firstPlayer) state.firstPlayer = o.firstPlayer;
        if (o.minutes) {
          state.minutes = o.minutes;
          state.minutesSource = o.source || null;
          const sv = minutesToSlider(o.minutes);
          if (durationSlider) durationSlider.value = sv;
          setSliderFill(sv);
          updateDurationDisplay();
          syncDurationChips();
        }
        renderPlayersGrid();
        updateSaveBtn();
      };

      // Modifica di una partita salvata: stesso modulo, già riempito. Il gioco non si cambia da qui.
      this.openLogEdit = (m) => {
        if (!modal.hidden) closeModal();
        openModal();
        state.editId = m.id;
        state.whoTouched = true;
        state.soloTouched = true;
        if (formEl) formEl.classList.add('fm-log-form--editing');
        saveBtn.textContent = 'Salva le modifiche';
        selectQuickGame({ bggId: m.bggId || null, productId: m.productId || null, title: m.title, img: m.img || null });
        const d = String(m.date || '').slice(0, 10);
        if (d) { state.date = d; if (dateInput) dateInput.value = d; }
        const est = !(m.minutes > 0) && m.minutesEstimate > 0;
        state.minutes = m.minutes > 0 ? m.minutes : (est ? m.minutesEstimate : null);
        state.minutesSource = est ? (m.durationSource || 'mine') : (m.durationSource || null);
        const sv = minutesToSlider(state.minutes);
        if (durationSlider) durationSlider.value = sv;
        setSliderFill(sv);
        updateDurationDisplay();
        syncDurationChips();
        state.context = (m.context === 'bga' || m.context === 'online') ? m.context : 'tavolo';
        if (whereToggle) whereToggle.querySelectorAll('.fm-where-btn').forEach(b => b.classList.toggle('is-active', b.dataset.where === state.context));
        updateWhereHints();
        state.extras = (m.extras || []).slice();
        renderExtrasChosen();
        state.rating = m.rating || null;
        moreEl.querySelectorAll('[data-rate]').forEach(x => x.setAttribute('aria-pressed', String(Number(x.getAttribute('data-rate')) === state.rating)));
        state.players = m.players || null;
        state.firstPlayer = m.firstPlayer || null;
        const copy = (x) => ({ name: x.name || (x.isBot ? 'Automa' : ''), isMe: false, isBot: !!x.isBot, isWin: !!x.isWin, score: typeof x.score === 'number' ? x.score : null });
        const others = (m.playersList || []).filter(x => x && !x.isMe && (x.name || x.isBot)).map(copy);
        state.myScore = typeof m.myScore === 'number' ? m.myScore : null;
        if (m.soloMode) {
          setSolo(true, m.soloMode);
          if (m.soloMode === 'automa') state.playersList = others.filter(x => x.isBot).slice(0, 1).concat(others.some(x => x.isBot) ? [] : state.playersList);
          state.outcome = m.outcome || null;
          renderSolo();
        } else {
          setSolo(false);
          state.playersList = others;
          if (/^coop_/.test(m.outcome || '')) {
            setCoop(true);
            state.outcome = m.outcome;
            if (coopWinGroup) coopWinGroup.querySelectorAll('.fm-result-coop-opt').forEach(b => b.classList.toggle('is-active', (b.dataset.coopWin === 'true') === (m.outcome === 'coop_win')));
          } else {
            setOutcome(m.outcome === 'win' || m.outcome === 'loss' ? m.outcome : null);
          }
        }
        state.winWay = m.winWay || null;
        state.sheetVals = {};
        const keys = sheetKeys();
        (m.voci || []).forEach(x => { const row = {}; keys.forEach((k, i) => { if (typeof (x.v || [])[i] === 'number') row[k] = x.v[i]; }); state.sheetVals[x.l] = row; });
        state.sheetOpen = !!(m.voci && m.voci.length);
        const editNote = q('[data-fm-edit-note]');
        if (editNote) editNote.hidden = !m.bggPlayId;
        renderPlayersGrid();
        renderSheet();
        updateSaveBtn();
      };

      // Delegato globale: cattura click su qualunque [data-fm-log-play] (FAB, futuri pulsanti)
      this.root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-fm-log-play]');
        if (btn && this.root.contains(btn)) {
          e.preventDefault();
          openModal();
        }
      });
      closes.forEach(b => b.addEventListener('click', closeModal));

      const updateSaveBtn = () => {
        const hasGame = state.product || state.bggOnly || state.customTitle.trim().length > 1;
        // "Salva partita" richiede gioco + data
        saveBtn.disabled = !(hasGame && state.date);
        syncQuickVisibility(hasGame);
        syncSheet();
        if (formEl) {
          formEl.classList.toggle('fm-log-form--nogame', !hasGame);
          formEl.classList.toggle('fm-log-form--picked', !!(state.product || state.bggOnly || state.titleLocked));
        }
        // "Solo in ludoteca" richiede solo gioco (no data necessaria) — legacy, ora rimosso dal modal
        if (onlyAddBtn) onlyAddBtn.disabled = !hasGame;
        // Aggiorna hero card (cover + titolo) ogni volta che lo stato cambia
        if (typeof updateHero === 'function') updateHero();
        // Aggiorna prompt ludoteca contestuale
        if (typeof updateLibraryPrompt === 'function') updateLibraryPrompt();
      };

      if (gameInput) {
        let bggSearchTimer = null;
        let lastQuery = '';
        const VISIBLE_COUNT = 6;
        let allBggResults = [];
        let bggExpanded = false;

        const renderSuggestions = (queryStr) => {
          if (!suggest) return;
          let html = '';
          const visible = bggExpanded ? allBggResults : allBggResults.slice(0, VISIBLE_COUNT);
          html += visible.map(b => {
            const aka = b.aka ? ' <span class="fm-log-suggest__aka">aka ' + escapeHtml(b.aka) + '</span>' : '';
            const imgTag = b.img ?
              '<img src="' + escapeHtml(b.img) + '" alt="" loading="lazy">' :
              '<span class="fm-log-suggest__noimg">🎲</span>';
            return '<li class="fm-log-suggest__item fm-log-suggest__item--bgg" data-source="bgg" data-bgg-id="' + b.bggId + '" data-name="' + escapeHtml(b.name) + '" data-img="' + escapeHtml(b.img || '') + '">' +
              imgTag +
              '<span>' + escapeHtml(b.name) + (b.year ? ' (' + b.year + ')' : '') + aka + '</span></li>';
          }).join('');
          if (!bggExpanded && allBggResults.length > VISIBLE_COUNT) {
            const remaining = allBggResults.length - VISIBLE_COUNT;
            html += '<li class="fm-log-suggest__more" data-fm-more>🔍 Cerca di più (' + remaining + ' altri)</li>';
          }
          if (queryStr && queryStr.length >= 2) {
            html += '<li class="fm-log-suggest__item fm-log-suggest__item--free" data-source="free" data-name="' + escapeHtml(queryStr) + '">' +
              '<span>Non trovi il gioco? Salva con questo titolo: <strong>"' + escapeHtml(queryStr) + '"</strong><span class="fm-log-suggest__badge">A MANO</span></span></li>';
          }
          suggest.innerHTML = html;
          suggest.hidden = html.length === 0;
          const moreBtn = suggest.querySelector('[data-fm-more]');
          if (moreBtn) moreBtn.addEventListener('click', () => { bggExpanded = true; renderSuggestions(queryStr); });
          suggest.querySelectorAll('.fm-log-suggest__item').forEach(li => {
            li.addEventListener('click', () => {
              const src = li.dataset.source;
              if (src === 'bgg') {
                state.product = null;
                state.bggOnly = { bggId: parseInt(li.dataset.bggId, 10), name: li.dataset.name, img: li.dataset.img || null };
                state.customTitle = li.dataset.name;
                gameInput.value = li.dataset.name;
              } else if (src === 'free') {
                state.product = null;
                state.bggOnly = null;
                state.customTitle = li.dataset.name;
                gameInput.value = li.dataset.name;
                state.titleLocked = true;
              }
              suggest.hidden = true;
              updateSaveBtn();
              // Aggiorna campo "Espansioni/set usati" — fetcha espansioni per il game appena scelto
              if (typeof updateExtras === 'function') updateExtras();
            });
          });
        };

        const fetchBggSearch = async (query) => {
          const workerUrl = this.workerUrl || (this.customer && this.customer.workerUrl) || '';
          if (!workerUrl) return [];
          try {
            const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/bgg-search?q=' + encodeURIComponent(query));
            if (!res.ok) return [];
            const data = await res.json();
            return data.results || [];
          } catch (e) { return []; }
        };

        gameInput.addEventListener('input', () => {
          const q = gameInput.value.trim();
          state.customTitle = gameInput.value;
          state.product = null;
          state.bggOnly = null;
          state.titleLocked = false;
          bggExpanded = false;
          updateSaveBtn();
          if (q.length < 2) { allBggResults = []; if (suggest) { suggest.innerHTML = ''; suggest.hidden = true; } return; }
          if (bggSearchTimer) clearTimeout(bggSearchTimer);
          if (q.length < 3) return;
          lastQuery = q;
          if (suggest) {
            suggest.innerHTML = '<li class="fm-log-suggest__loading">🔍 Cerco su BGG...</li>';
            suggest.hidden = false;
          }
          bggSearchTimer = setTimeout(async () => {
            const r = await fetchBggSearch(q);
            if (q !== lastQuery) return;
            allBggResults = r;
            renderSuggestions(q);
          }, 300);
        });
      }

      // ══════════════════════════════════════════════════════════════════
      // ESPANSIONI / SET COMPATIBILI (Feature 2026-05-21)
      // Sezione "🃏 Espansioni / set usati". Permette di taggare espansioni vere
      // (es. Wicked to the Core per Disney Villainous) o set standalone mescolati
      // (es. Marvel Villainous: Infinite Power). Tutti gli extras sono metadata —
      // NON aumentano il count plays, solo il gioco base riceve +1.
      // ══════════════════════════════════════════════════════════════════
      const extrasField = q('[data-fm-log-extras-field]');
      const extrasSuggested = q('[data-fm-log-extras-suggested]');
      const extrasSearch = q('[data-fm-log-extras-search]');
      const extrasResults = q('[data-fm-log-extras-results]');
      const extrasChosen = q('[data-fm-log-extras-chosen]');

      const expansionsCache = {};
      let currentSuggestedList = [];

      // Le espansioni che contano stanno in vista: usate l'ultima volta, tue, vendute da noi. Il resto dietro "Altre".
      const renderExpRow = () => {
        const list = currentSuggestedList, on = new Set(state.extras.map(e => e.bggId));
        const main = list.filter(e => e.why || on.has(e.bggId)).slice(0, 6);
        const shown = new Set(main.map(e => e.bggId));
        const loose = state.extras.filter(e => !list.some(x => x.bggId === e.bggId));
        const rest = list.filter(e => !shown.has(e.bggId)).length;
        if (!main.length && !loose.length && !rest) { expsEl.hidden = true; expsEl.innerHTML = ''; return; }
        expsEl.hidden = false;
        const chip = (id, label, full, pressed) => '<button type="button" class="fm-who__chip" data-fm-exp="' + id + '" aria-pressed="' + pressed + '" title="' + escapeHtml(full) + '">' + (pressed ? '✓ ' : '') + escapeHtml(label) + '</button>';
        expsEl.innerHTML = '<span class="fm-log-label-min">Con quali espansioni?</span><div class="fm-who">' +
          main.map(e => chip(e.bggId, e.label || e.name, e.name, on.has(e.bggId))).join('') +
          loose.map(e => chip(e.bggId, e.name, e.name, true)).join('') +
          (rest ? '<button type="button" class="fm-who__chip fm-who__chip--add" data-fm-exp-more>' + (main.length ? 'Altre ' + rest : 'Scegli tra ' + rest) + '</button>' : '') +
          '</div>';
      };
      expsEl.addEventListener('click', (e) => {
        if (e.target.closest('[data-fm-exp-more]')) { showPart('other'); return; }
        const b = e.target.closest('[data-fm-exp]');
        if (!b) return;
        const id = parseInt(b.getAttribute('data-fm-exp'), 10);
        if (state.extras.some(x => x.bggId === id)) state.extras = state.extras.filter(x => x.bggId !== id);
        else {
          const hit = currentSuggestedList.find(x => x.bggId === id);
          if (hit) state.extras.push({ bggId: id, name: hit.name, type: 'expansion' });
        }
        renderExtrasChosen();
        renderExtrasSuggested(currentSuggestedList);
      });

      const renderExtrasChosen = () => {
        renderExpRow();
        if (!extrasChosen) return;
        // Sotto restano solo quelle trovate con la ricerca: le altre hanno già la loro casella.
        const loose = state.extras.filter(e => !currentSuggestedList.some(x => x.bggId === e.bggId));
        if (loose.length === 0) { extrasChosen.innerHTML = ''; return; }
        extrasChosen.innerHTML = loose.map(e => {
          const type = e.type || 'expansion';
          const isExp = type === 'expansion';
          const icon = isExp ? '🃏' : '🎁';
          const label = isExp ? 'Espansione' : 'Set combinato';
          const typeClass = isExp ? 'fm-log-extras__chip-type--exp' : 'fm-log-extras__chip-type--std';
          return '<span class="fm-log-extras__chip" data-fm-extras-chip-id="' + e.bggId + '">' +
            '<button type="button" class="fm-log-extras__chip-type ' + typeClass + '" data-fm-extras-toggle-type="' + e.bggId + '" title="Tap per cambiare tipo">' +
              icon + ' ' + label +
            '</button>' +
            '<span class="fm-log-extras__chip-name">' + escapeHtml(e.name) + '</span>' +
            '<button type="button" class="fm-log-extras__chip-x" data-fm-extras-remove="' + e.bggId + '" aria-label="Rimuovi">×</button>' +
          '</span>';
        }).join('');
        // Remove button
        extrasChosen.querySelectorAll('[data-fm-extras-remove]').forEach(btn => {
          btn.addEventListener('click', () => {
            const id = parseInt(btn.dataset.fmExtrasRemove, 10);
            state.extras = state.extras.filter(e => e.bggId !== id);
            renderExtrasChosen();
            renderExtrasSuggested(currentSuggestedList);
          });
        });
        // Toggle type (expansion <-> standalone)
        extrasChosen.querySelectorAll('[data-fm-extras-toggle-type]').forEach(btn => {
          btn.addEventListener('click', () => {
            const id = parseInt(btn.dataset.fmExtrasToggleType, 10);
            const entry = state.extras.find(e => e.bggId === id);
            if (!entry) return;
            entry.type = (entry.type === 'standalone') ? 'expansion' : 'standalone';
            renderExtrasChosen();
          });
        });
      };

      const renderExtrasSuggested = (list) => {
        if (!extrasSuggested) return;
        currentSuggestedList = Array.isArray(list) ? list : [];
        renderExpRow();
        if (currentSuggestedList.length === 0) { extrasSuggested.innerHTML = ''; return; }
        const chosenIds = new Set(state.extras.map(e => e.bggId));
        extrasSuggested.innerHTML = '<div class="fm-log-extras__suggested-list">' +
          currentSuggestedList.map(e => {
            const checked = chosenIds.has(e.bggId);
            return '<label class="fm-log-extras__option' + (checked ? ' is-checked' : '') + '">' +
              '<input type="checkbox" data-fm-extras-toggle="' + e.bggId + '" data-fm-extras-name="' + escapeHtml(e.name) + '"' + (checked ? ' checked' : '') + '>' +
              '<span>' + escapeHtml(e.label || e.name) + '</span>' +
            '</label>';
          }).join('') +
          '</div>';
        extrasSuggested.querySelectorAll('[data-fm-extras-toggle]').forEach(cb => {
          cb.addEventListener('change', () => {
            const id = parseInt(cb.dataset.fmExtrasToggle, 10);
            const name = cb.dataset.fmExtrasName;
            if (cb.checked) {
              // Pre-popolata = espansione vera per default (BGG type=boardgameexpansion)
              if (!state.extras.some(e => e.bggId === id)) {
                state.extras.push({ bggId: id, name, type: 'expansion' });
              }
            } else {
              state.extras = state.extras.filter(e => e.bggId !== id);
            }
            renderExtrasChosen();
            renderExtrasSuggested(currentSuggestedList);
          });
        });
      };

      const fetchExpansionsFor = async (bggId) => {
        if (!bggId) return [];
        if (expansionsCache[bggId]) return expansionsCache[bggId];
        const workerUrl = this.workerUrl || (this.customer && this.customer.workerUrl) || '';
        if (!workerUrl) return [];
        try {
          const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/bgg-expansions?id=' + bggId);
          if (!res.ok) return [];
          const data = await res.json();
          const list = data.results || [];
          expansionsCache[bggId] = list;
          return list;
        } catch (e) { return []; }
      };

      const updateExtras = async () => {
        applySoloDefault();
        applyWhoDefault();
        const baseBggId = (state.product && state.product.bgg) || (state.bggOnly && state.bggOnly.bggId) || null;
        if (!baseBggId || !extrasField) {
          if (extrasField) extrasField.hidden = true;
          state.extras = [];
          currentSuggestedList = [];
          if (extrasSuggested) extrasSuggested.innerHTML = '';
          renderExtrasChosen();
          return;
        }
        extrasField.hidden = false;
        state.extras = [];
        currentSuggestedList = [];
        renderExtrasChosen();
        if (extrasSuggested) extrasSuggested.innerHTML = '<div class="fm-log-extras__loading">Cerco espansioni...</div>';
        const list = await fetchExpansionsFor(baseBggId);
        const nowId = (state.product && state.product.bgg) || (state.bggOnly && state.bggOnly.bggId) || null;
        if (nowId !== baseBggId) return; // nel frattempo hai cambiato gioco
        const g = currentGame(), p = this.profile || {};
        const plays = (p.manualPlays || []).filter(m => m && this._playMatchesGame(m, g)).sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')) || ((b.loggedAt || 0) - (a.loggedAt || 0)));
        const used = {}, extra = [];
        plays.forEach(m => (m.extras || []).forEach(e => { if (e && e.bggId && (e.type || 'expansion') === 'expansion') { used[e.bggId] = (used[e.bggId] || 0) + 1; extra.push({ bggId: e.bggId, name: e.name }); } }));
        const owned = {};
        ((p.bggCollection && p.bggCollection.owned) || []).forEach(o => { const i = o && typeof o === 'object' ? o.id : o; if (i) owned[i] = 1; });
        (p.manualOwned || []).concat(p.purchasedProducts || []).forEach(o => { if (o && o.bggId) owned[o.bggId] = 1; });
        const known = new Set(list.map(e => e.bggId)), titles = {};
        (FM.getCatalogProducts() || []).forEach(c => { if (c && c.bgg && c.t && known.has(Number(c.bgg))) titles[c.bgg] = c.t; });
        renderExtrasSuggested(FM.rankExpansions(list, { used, owned, titles, extra, baseTitle: (state.product && state.product.t) || (state.bggOnly && state.bggOnly.name) || '' }));
        renderExtrasChosen();
        // Riparte da come l'hai giocato l'ultima volta: si vede subito e si toglie con un tocco.
        if (!state.editId && !state.extras.length && plays[0] && (plays[0].extras || []).length) {
          state.extras = plays[0].extras.filter(e => e && e.bggId && (e.type || 'expansion') === 'expansion').map(e => ({ bggId: e.bggId, name: e.name, type: 'expansion' }));
          renderExtrasChosen();
          renderExtrasSuggested(currentSuggestedList);
        }
      };

      if (extrasSearch) {
        let searchTimer = null;
        let lastSearchQuery = '';
        extrasSearch.addEventListener('input', () => {
          const sq = extrasSearch.value.trim();
          if (sq.length < 3) {
            if (extrasResults) { extrasResults.innerHTML = ''; extrasResults.hidden = true; }
            return;
          }
          if (searchTimer) clearTimeout(searchTimer);
          if (extrasResults) {
            extrasResults.innerHTML = '<div class="fm-log-extras__result-loading">🔍 Cerco su BGG...</div>';
            extrasResults.hidden = false;
          }
          lastSearchQuery = sq;
          searchTimer = setTimeout(async () => {
            const workerUrl = this.workerUrl || (this.customer && this.customer.workerUrl) || '';
            if (!workerUrl) return;
            try {
              const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/bgg-search?q=' + encodeURIComponent(sq));
              if (!res.ok || sq !== lastSearchQuery) return;
              const data = await res.json();
              const results = (data.results || []).slice(0, 8);
              if (results.length === 0) {
                extrasResults.innerHTML = '<div class="fm-log-extras__result-empty">Nessun risultato</div>';
                return;
              }
              // Ogni risultato ha 2 azioni: "+ Espansione" o "+ Set combinato".
              // L'utente sceglie quale tipo è — espansione vera (richiede gioco base)
              // o set standalone mescolato (gioca da solo, mescolato col base game).
              extrasResults.innerHTML = results.map(r => {
                const safeName = escapeHtml(r.name);
                return '<div class="fm-log-extras__result-row">' +
                  '<span class="fm-log-extras__result-name">' + safeName + (r.year ? ' <span class="fm-log-extras__result-year">(' + r.year + ')</span>' : '') + '</span>' +
                  '<span class="fm-log-extras__result-actions">' +
                    '<button type="button" class="fm-log-extras__result-add fm-log-extras__result-add--exp" data-fm-extras-add-id="' + r.bggId + '" data-fm-extras-add-name="' + safeName + '" data-fm-extras-add-type="expansion" title="Aggiungi come espansione del gioco base">🃏 Espansione</button>' +
                    '<button type="button" class="fm-log-extras__result-add fm-log-extras__result-add--std" data-fm-extras-add-id="' + r.bggId + '" data-fm-extras-add-name="' + safeName + '" data-fm-extras-add-type="standalone" title="Aggiungi come set autonomo mescolato">🎁 Set combinato</button>' +
                  '</span>' +
                '</div>';
              }).join('');
              extrasResults.querySelectorAll('[data-fm-extras-add-id]').forEach(btn => {
                btn.addEventListener('click', () => {
                  const id = parseInt(btn.dataset.fmExtrasAddId, 10);
                  const name = btn.dataset.fmExtrasAddName;
                  const type = btn.dataset.fmExtrasAddType === 'standalone' ? 'standalone' : 'expansion';
                  if (!state.extras.some(e => e.bggId === id)) state.extras.push({ bggId: id, name, type });
                  extrasSearch.value = '';
                  extrasResults.innerHTML = '';
                  extrasResults.hidden = true;
                  renderExtrasChosen();
                  renderExtrasSuggested(currentSuggestedList);
                });
              });
            } catch (e) { /* silenzioso */ }
          }, 350);
        });
      }

      if (dateInput) dateInput.addEventListener('change', () => {
        state.date = dateInput.value;
        updateSaveBtn();
      });

      const bindChipGroup = (group, key, parser) => {
        if (!group) return;
        group.addEventListener('click', (e) => {
          const btn = e.target.closest('button.fm-chip');
          if (!btn || !group.contains(btn)) return;
          group.querySelectorAll('.fm-chip').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const v = btn.dataset.value;
          state[key] = (v === '' || v == null) ? null : parser(v);
        });
      };
      bindChipGroup(durationGroup, 'minutes', v => parseInt(v, 10));
      bindChipGroup(ratingGroup, 'rating', v => parseInt(v, 10));
      bindChipGroup(playersGroup, 'players', v => parseInt(v, 10));

      // Protezione doppio-bind (re-render può attaccare listener più volte → 1 click = N call)
      if (saveBtn.__fmFPLogPlayBound) return;
      saveBtn.__fmFPLogPlayBound = true;
      saveBtn.addEventListener('click', () => {
        // Doppia barriera contro doppio click veloce
        if (saveBtn.disabled) return;
        saveBtn.disabled = true;
        let productId = null, bggId = null, title = state.customTitle, img = null;
        if (state.product) {
          productId = state.product.id;
          bggId = state.product.bgg || null;
          title = state.product.t;
          img = state.product.img || null;
        } else if (state.bggOnly) {
          bggId = state.bggOnly.bggId;
          title = state.bggOnly.name;
          img = state.bggOnly.img || null;
        }

        // Leggi checkbox "Lo possiedo" (modal è fuori dal section root, fallback su document)
        const ownedCheckbox = this.root.querySelector('[data-fm-log-add-owned]') || document.querySelector('[data-fm-log-add-owned]');
        const addToCollection = ownedCheckbox ? ownedCheckbox.checked : false;

        // Snapshot PRIMA del save per detection toast
        const wasNew = this._isFirstTimeForGame({ bggId, productId, title });
        const playsBefore = this._cumPlaysForGame({ bggId, productId, title });

        // Pulisce playersList: rimuove entry vuote (no nome). Default per bot: "Automa".
        const playersListClean = (state.playersList || [])
          .filter(p => p && (p.name && p.name.trim().length > 0 || p.isBot))
          .map(p => ({
            name: (p.name && p.name.trim()) || (p.isBot ? 'Automa' : 'Sfidante'),
            isMe: !!p.isMe,
            isBot: !!p.isBot,
            isWin: !!p.isWin,
            score: (typeof p.score === 'number' && !isNaN(p.score)) ? p.score : null
          }));

        // Outcome normalizzato. Se pending coop senza scelta sub → tratta come unknown.
        let outcomeFinal = state.outcome;
        if (outcomeFinal === 'coop_pending') outcomeFinal = null;

        // Players count: deriva da playersList se popolata, altrimenti dal chip group legacy
        const playersCountFinal = playersListClean.length > 0
          ? playersListClean.length + 1 // +1 per l'utente stesso
          : state.players;

        if (state.editId) {
          const estimate = state.minutesSource === 'mine' || state.minutesSource === 'bgg';
          const edited = FM.editManualPlay(state.editId, {
            date: state.date,
            minutes: estimate ? undefined : (state.minutes || 0),
            rating: state.rating,
            players: state.solo ? 1 : playersCountFinal,
            soloMode: state.solo ? state.soloMode : null,
            outcome: outcomeFinal,
            context: state.context,
            extras: state.extras,
            playersList: pointsCount() ? playersListClean : playersListClean.map(x => Object.assign({}, x, { score: null })),
            myScore: (pointsCount() && typeof state.myScore === 'number' && isFinite(state.myScore)) ? state.myScore : null,
            firstPlayer: state.firstPlayer || null,
            winWay: state.solo ? null : state.winWay,
            // Senza la scheda del gioco le voci non si vedono: restano com'erano.
            voci: state.sheet ? ((state.solo ? null : sheetVociToSave()) || []) : undefined
          });
          if (!edited.ok) {
            if (status) { status.textContent = 'Errore: ' + (edited.error || 'modifica fallita'); status.hidden = false; }
            saveBtn.disabled = false;
            return;
          }
          this.profile = edited.profile;
          closeModal();
          try { this._rerenderAllAfterPlaysChange(); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('frogmatch:play-edited', { detail: { play: edited.play } })); } catch (e) {}
          return;
        }

        const result = FM.logManualPlay({
          productId, bggId, title, img,
          date: state.date,
          // Una stima non è una durata misurata: resta in minutesEstimate e non entra nelle ore giocate.
          minutes: (state.minutesSource === 'mine' || state.minutesSource === 'bgg') ? 0 : (state.minutes || 0),
          minutesEstimate: (state.minutesSource === 'mine' || state.minutesSource === 'bgg') ? state.minutes : null,
          durationSource: state.minutesSource || (state.minutes ? 'hand' : null),
          rating: state.rating,
          players: state.solo ? 1 : playersCountFinal,
          soloMode: state.solo ? state.soloMode : null,
          outcome: outcomeFinal,
          context: state.context, // 'tavolo' | 'bga' | 'online'
          extras: state.extras, // espansioni/set compatibili selezionati nel modal
          // Con una vittoria che chiude la partita i punti non contano: non si salvano nemmeno se scritti prima.
          playersList: playersListClean.length > 0 ? (pointsCount() ? playersListClean : playersListClean.map(x => Object.assign({}, x, { score: null }))) : undefined,
          myScore: (pointsCount() && typeof state.myScore === 'number' && isFinite(state.myScore)) ? state.myScore : null,
          firstPlayer: state.firstPlayer || null,
          winWay: state.solo ? null : state.winWay,
          voci: state.solo ? null : sheetVociToSave(),
          addToCollection
        });
        if (!result.ok) {
          if (status) { status.textContent = 'Errore: ' + (result.error || 'salvataggio fallito'); status.hidden = false; }
          saveBtn.disabled = false; // re-enable per retry
          return;
        }
        this.profile = result.profile;
        if (status) { status.hidden = true; }

        try { document.dispatchEvent(new CustomEvent('frogmatch:play-saved', { detail: { play: result.play } })); } catch (e) {}

        // PREMIO (2026-11-01): resta nel modal e racconta cosa è appena successo.
        // Se qualcosa va storto si torna al vecchio avviso, la partita è comunque salvata.
        let rewardShown = false;
        try {
          rewardShown = this._showPlayReward({
            play: result.play, title, img, bggId, productId, wasNew,
            playsTotal: playsBefore + 1
          }, {
            close: closeModal,
            again: () => { closeModal(); openModal(); }
          });
        } catch (e) {
          console.warn('[FroggerProfile] premio non mostrato:', e);
          rewardShown = false;
        }
        if (rewardShown) {
          if (formEl) formEl.hidden = true;
          try { this._rerenderAllAfterPlaysChange(); } catch (e) {}
          saveBtn.disabled = false;
        } else {
          this._showPlayToast({ title, wasNew, playsTotal: playsBefore + 1 });
          setTimeout(() => {
            closeModal();
            this._rerenderAllAfterPlaysChange();
            saveBtn.disabled = false; // re-enable per la prossima partita
          }, 600);
        }
      });

      // Bind "Solo in ludoteca": aggiunge il gioco a manualOwned senza registrare partita.
      // Per utenti che hanno comprato un gioco e vogliono averlo nella ludoteca, senza
      // dover obbligatoriamente registrare una partita.
      if (onlyAddBtn) {
        onlyAddBtn.addEventListener('click', () => {
          if (onlyAddBtn.disabled) return;
          let productId = null, bggId = null, title = state.customTitle, img = null;
          if (state.product) {
            productId = state.product.id;
            bggId = state.product.bgg || null;
            title = state.product.t;
            img = state.product.img || null;
          } else if (state.bggOnly) {
            bggId = state.bggOnly.bggId;
            title = state.bggOnly.name;
            img = state.bggOnly.img || null;
          }
          const result = FM.addManualOwned({ productId, bggId, title, img });
          if (!result || !result.ok) {
            if (status) { status.textContent = 'Errore: ' + ((result && result.error) || 'aggiunta fallita'); status.hidden = false; }
            return;
          }
          this.profile = FM.loadProfile();
          if (status) {
            status.textContent = '✅ "' + title + '" aggiunto alla tua ludoteca';
            status.hidden = false;
          }
          setTimeout(() => {
            closeModal();
            this._rerenderAllAfterPlaysChange();
          }, 800);
        });
      }

      // Bind modal "Aggiungi alla ludoteca" (separata dal log play)
      this.bindAddOwnedModal();
    }

    /**
     * Re-render TUTTE le sezioni dopo modifica partite/ludoteca.
     * Invalida calPlaysByDate cache così il calendario si ricostruisce con i nuovi dati.
     * Centralizzato per evitare di dimenticare sezioni (bug noto: dopo save partita
     * il calendario non si aggiornava perché chiamavamo solo renderHero/Favorites/DrillDown).
     */
    _rerenderAllAfterPlaysChange() {
      // Invalida cache calendario (forza re-fetch da playsActivity + manualPlays)
      this.calPlaysByDate = null;
      // FIX 2026-05-12: invalida anche cache favoriti modal "La tua ludoteca"
      // così un gioco appena aggiunto via "Aggiungi alla ludoteca" del modal partita
      // appare subito quando apri "Modifica i 4 del cuore".
      this.favBggCachedList = null;
      try { this.renderHero(); } catch (e) {}
      try { this.renderFavorites(); } catch (e) {}
      try { this.renderMoment(); } catch (e) {}
      try { this.renderCalendar(); } catch (e) {}
      try { this.renderChallenges(); } catch (e) {}
      try { this.renderDrillDown(); } catch (e) {}
      // Gems re-rendering è costoso (loop 30 badge): deferred via idle callback per non bloccare UI
      const rerenderGems = () => { try { this.renderGems(); } catch (e) {} };
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(rerenderGems, { timeout: 2000 });
      } else {
        setTimeout(rerenderGems, 100);
      }
    }

    // ────────────────────────────────────────
    // ADD OWNED — modal dedicata "Aggiungi gioco alla ludoteca" senza data partita
    // ────────────────────────────────────────
    bindAddOwnedModal() {
      if (this.root.__fpAddOwnedBound) return;
      this.root.__fpAddOwnedBound = true;

      // Modal è renderizzato fuori dal section (per stacking), serve fallback document
      const q = (sel) => this.root.querySelector(sel) || document.querySelector(sel);
      const qa = (sel) => {
        const local = this.root.querySelectorAll(sel);
        return local.length ? local : document.querySelectorAll(sel);
      };

      const modal = q('[data-fp-add-modal]');
      if (!modal) return;
      const closes = qa('[data-fp-add-close]');
      const gameInput = q('[data-fp-add-game]');
      const suggest = q('[data-fp-add-suggest]');
      const saveBtn = q('[data-fp-add-save]');
      const status = q('[data-fp-add-status]');
      if (!gameInput || !saveBtn) return;

      const state = { product: null, bggOnly: null, customTitle: '' };

      modal.hidden = true;
      modal.style.display = 'none';

      const open = () => {
        modal.hidden = false;
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        setTimeout(() => gameInput.focus(), 100);
      };
      const close = () => {
        modal.hidden = true;
        modal.style.display = 'none';
        document.body.style.overflow = '';
        state.product = null; state.bggOnly = null; state.customTitle = '';
        gameInput.value = '';
        if (suggest) { suggest.innerHTML = ''; suggest.hidden = true; }
        if (status) { status.hidden = true; status.textContent = ''; }
        saveBtn.disabled = true;
      };

      // Delegated listener per pulsante "+ Aggiungi gioco"
      this.root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-fp-add-owned]');
        if (btn && this.root.contains(btn)) {
          e.preventDefault();
          open();
        }
      });
      closes.forEach(b => b.addEventListener('click', close));

      const updateBtn = () => {
        saveBtn.disabled = !(state.product || state.bggOnly || state.customTitle.trim().length > 1);
      };

      let bggSearchTimer = null;
      let lastQuery = '';
      const VISIBLE_COUNT = 6;
      let allBggResults = [];
      let bggExpanded = false;

      const renderSuggestions = (queryStr) => {
        if (!suggest) return;
        let html = '';
        const visible = bggExpanded ? allBggResults : allBggResults.slice(0, VISIBLE_COUNT);
        html += visible.map(b => {
          const aka = b.aka ? ' <span class="fm-log-suggest__aka">aka ' + escapeHtml(b.aka) + '</span>' : '';
          const imgTag = b.img ?
            '<img src="' + escapeHtml(b.img) + '" alt="" loading="lazy">' :
            '<span class="fm-log-suggest__noimg">🎲</span>';
          return '<li class="fm-log-suggest__item fm-log-suggest__item--bgg" data-source="bgg" data-bgg-id="' + b.bggId + '" data-name="' + escapeHtml(b.name) + '" data-img="' + escapeHtml(b.img || '') + '">' +
            imgTag +
            '<span>' + escapeHtml(b.name) + (b.year ? ' (' + b.year + ')' : '') + aka + '</span></li>';
        }).join('');
        if (!bggExpanded && allBggResults.length > VISIBLE_COUNT) {
          const remaining = allBggResults.length - VISIBLE_COUNT;
          html += '<li class="fm-log-suggest__more" data-fp-add-more>🔍 Mostra altri (' + remaining + ')</li>';
        }
        if (queryStr && queryStr.length >= 2) {
          html += '<li class="fm-log-suggest__item fm-log-suggest__item--free" data-source="free" data-name="' + escapeHtml(queryStr) + '">' +
            '<span>Salva con titolo libero: <strong>"' + escapeHtml(queryStr) + '"</strong><span class="fm-log-suggest__badge">A MANO</span></span></li>';
        }
        suggest.innerHTML = html;
        suggest.hidden = html.length === 0;
        const moreBtn = suggest.querySelector('[data-fp-add-more]');
        if (moreBtn) moreBtn.addEventListener('click', () => { bggExpanded = true; renderSuggestions(queryStr); });
        suggest.querySelectorAll('.fm-log-suggest__item').forEach(li => {
          li.addEventListener('click', () => {
            const src = li.dataset.source;
            if (src === 'bgg') {
              state.product = null;
              state.bggOnly = { bggId: parseInt(li.dataset.bggId, 10), name: li.dataset.name, img: li.dataset.img || null };
              state.customTitle = li.dataset.name;
              gameInput.value = li.dataset.name;
            } else if (src === 'free') {
              state.product = null;
              state.bggOnly = null;
              state.customTitle = li.dataset.name;
              gameInput.value = li.dataset.name;
            }
            suggest.hidden = true;
            updateBtn();
          });
        });
      };

      const fetchBggSearch = async (query) => {
        const workerUrl = this.workerUrl || (this.customer && this.customer.workerUrl) || '';
        if (!workerUrl) return [];
        try {
          const res = await fetch(workerUrl.replace(/\/$/, '') + '/api/bgg-search?q=' + encodeURIComponent(query));
          if (!res.ok) return [];
          const data = await res.json();
          return data.results || [];
        } catch (e) { return []; }
      };

      gameInput.addEventListener('input', () => {
        const q = gameInput.value.trim();
        state.customTitle = gameInput.value;
        state.product = null;
        state.bggOnly = null;
        bggExpanded = false;
        updateBtn();
        if (q.length < 2) { allBggResults = []; if (suggest) { suggest.innerHTML = ''; suggest.hidden = true; } return; }
        if (bggSearchTimer) clearTimeout(bggSearchTimer);
        if (q.length < 3) return;
        lastQuery = q;
        if (suggest) {
          suggest.innerHTML = '<li class="fm-log-suggest__loading">🔍 Cerco su BGG...</li>';
          suggest.hidden = false;
        }
        bggSearchTimer = setTimeout(async () => {
          const r = await fetchBggSearch(q);
          if (q !== lastQuery) return;
          allBggResults = r;
          renderSuggestions(q);
        }, 300);
      });

      saveBtn.addEventListener('click', () => {
        if (saveBtn.disabled) return;
        let productId = null, bggId = null, title = state.customTitle, img = null;
        if (state.product) {
          productId = state.product.id;
          bggId = state.product.bgg || null;
          title = state.product.t;
          img = state.product.img || null;
        } else if (state.bggOnly) {
          bggId = state.bggOnly.bggId;
          title = state.bggOnly.name;
          img = state.bggOnly.img || null;
        }
        const result = FM.addManualOwned({ productId, bggId, title, img });
        if (!result.ok) {
          if (status) { status.textContent = result.error || 'Errore'; status.hidden = false; }
          return;
        }
        this.profile = result.profile;
        if (status) { status.textContent = '✓ Aggiunto alla ludoteca'; status.hidden = false; }
        // FIX 2026-05-12: invalida cache favBggCachedList (lista usata dalla modal
        // "Giochi del cuore" → tab "La tua ludoteca"). Senza, l'utente aggiunge
        // un gioco MA non lo vede subito nella selezione preferiti finché non refresh.
        this.favBggCachedList = null;
        setTimeout(() => {
          close();
          this.renderHero();
          this.renderDrillDown();
          // Apri il details ludoteca per mostrare subito il risultato
          const collDrill = this.root.querySelector('[data-fp-drill="collection"]');
          if (collDrill) collDrill.open = true;
        }, 500);
      });
    }

    /** True se questo gioco non ha mai avuto una partita registrata (BGG o manual) */
    _isFirstTimeForGame({ bggId, productId, title }) {
      const act = this.profile.playsActivity;
      const bggMatch = act && act.topPlayed && act.topPlayed.some(g =>
        (bggId && g.bggId === bggId) || (title && g.name === title)
      );
      if (bggMatch) return false;
      const manual = this.profile.manualPlays || [];
      const manualMatch = manual.some(p =>
        (bggId && p.bggId === bggId) ||
        (productId && p.productId === productId) ||
        (title && p.title === title)
      );
      return !manualMatch;
    }

    /** Conteggio cumulativo partite per quel gioco PRIMA del nuovo save */
    _cumPlaysForGame({ bggId, productId, title }) {
      let total = 0;
      const act = this.profile.playsActivity;
      if (act && act.topPlayed) {
        const match = act.topPlayed.find(g =>
          (bggId && g.bggId === bggId) || (title && g.name === title)
        );
        // topPlayed contiene già le partite a mano (mergeManualPlayIntoActivity): sommarle le conterebbe due volte.
        if (match) return match.plays || 0;
      }
      const manual = this.profile.manualPlays || [];
      manual.forEach(p => {
        if ((bggId && p.bggId === bggId) ||
            (productId && p.productId === productId) ||
            (title && p.title === title)) total += 1;
      });
      return total;
    }

    /** Toast emozionale post-save partita */
    // ════════════════════════════════════════════════════════════════════
    // PREMIO DOPO IL SALVATAGGIO (2026-11-01)
    // Subito dopo "Salva partita" il modal mostra cosa è appena successo:
    // risultato, record personale, testa a testa, serie di settimane, giochi
    // diversi, un voto in un tocco, il prossimo gioco e la scheda da condividere.
    // Tutto calcolato dai dati già nel profilo: niente chiamate al server.
    // ════════════════════════════════════════════════════════════════════

    _playMatchesGame(p, { bggId, productId, title }) {
      if (!p) return false;
      if (bggId && p.bggId === bggId) return true;
      if (productId && p.productId && String(p.productId) === String(productId)) return true;
      if (!bggId && title && p.title && String(p.title).toLowerCase().trim() === String(title).toLowerCase().trim()) return true;
      return false;
    }

    /** Il tuo passato da solo su un gioco, in un modo (game/automa/score). `excludeId` toglie la partita appena salvata. */
    _soloStats(game, mode, excludeId) {
      const all = (this.profile.manualPlays || [])
        .filter(p => p && p.id !== excludeId && this._playMatchesGame(p, game))
        .sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')) || ((b.loggedAt || 0) - (a.loggedAt || 0)));
      const same = all.filter(p => p.soloMode && p.soloMode === mode);
      const scores = same.map(p => p.myScore).filter(v => typeof v === 'number');
      const isWin = (p) => p.outcome === 'win' || p.outcome === 'coop_win';
      const decided = same.filter(p => isWin(p) || p.outcome === 'loss' || p.outcome === 'coop_loss');
      let streak = 0;
      if (decided.length) { const w0 = isWin(decided[0]); for (const p of decided) { if (isWin(p) === w0) streak++; else break; } }
      return {
        lastAny: all[0] || null,
        plays: same.length,
        best: scores.length ? Math.max.apply(null, scores) : null,
        avg: scores.length ? Math.round(scores.reduce((a, b) => a + b, 0) / scores.length) : null,
        scored: scores.length,
        wins: decided.filter(isWin).length,
        decided: decided.length,
        streak,
        streakWin: decided.length ? isWin(decided[0]) : false
      };
    }

    _fmtMinutes(m) {
      if (!m) return '';
      if (m < 60) return m + ' minuti';
      const h = Math.floor(m / 60), r = m % 60;
      return h + (h === 1 ? ' ora' : ' ore') + (r ? ' e ' + r + ' min' : '');
    }

    /** Il risultato in una frase, con punteggi quando ci sono tutti. */
    _rewardHeadline(play) {
      const others = (play.playersList || []).filter(p => p && !p.isMe);
      const people = others.filter(p => !p.isBot).map(p => this.companionLabel(p.name)).filter(Boolean);
      const scored = typeof play.myScore === 'number' && others.length > 0 && others.every(p => typeof p.score === 'number');
      const bestOther = scored ? Math.max.apply(null, others.map(p => p.score)) : null;
      const join = (arr) => arr.length <= 1 ? (arr[0] || '') : arr.slice(0, -1).join(', ') + ' e ' + arr[arr.length - 1];
      const oc = play.outcome;
      let big, sub = '', loss = false;
      const pts = typeof play.myScore === 'number' ? play.myScore : null;
      if (play.soloMode === 'score') {
        const st = this._soloStats(play, 'score', play.id);
        if (pts === null) return { big: 'Partita salvata', sub: 'Da solo', loss: false };
        if (st.best === null) return { big: pts + ' punti', sub: 'Ora hai un record da battere', loss: false };
        if (pts > st.best) return { big: 'Nuovo record: ' + pts, sub: 'Il tuo meglio era ' + st.best + ', hai fatto ' + (pts - st.best) + ' in più', loss: false };
        if (pts === st.best) return { big: 'Record pareggiato: ' + pts, sub: 'Ancora un punto e sarebbe stato tuo', loss: false };
        return { big: pts + ' punti', sub: 'A ' + (st.best - pts) + ' dal tuo record, ' + st.best, loss: false };
      }
      if (play.soloMode === 'game') {
        if (oc === 'coop_win') return { big: 'Hai battuto il gioco', sub: pts !== null ? pts + ' punti' : 'Da solo', loss: false };
        if (oc === 'coop_loss') return { big: 'Questa volta ha vinto il gioco', sub: 'La rivincita ti aspetta', loss: true };
        return { big: 'Partita salvata', sub: pts !== null ? pts + ' punti, da solo' : 'Da solo', loss: false };
      }
      if (oc === 'coop_win') { big = 'Avete battuto il gioco'; sub = people.length ? 'Con ' + join(people) : ''; }
      else if (oc === 'coop_loss') { big = 'Questa volta ha vinto il gioco'; loss = true; sub = people.length ? 'Con ' + join(people) + '. La rivincita vi aspetta' : 'La rivincita ti aspetta'; }
      else if (oc === 'win') {
        if (scored && play.myScore === bestOther) { big = 'Pareggio, ' + play.myScore + ' a ' + bestOther; }
        else { big = scored ? 'Hai vinto ' + play.myScore + ' a ' + bestOther : 'Hai vinto'; }
        if (scored && play.myScore > bestOther) {
          const gap = play.myScore - bestOther;
          sub = (people.length ? 'Contro ' + join(people) + ', ' : '') + 'con ' + gap + (gap === 1 ? ' punto' : ' punti') + ' di margine';
        } else if (people.length) sub = 'Contro ' + join(people);
        else if (others.length) sub = 'Contro l\'automa';
      } else if (oc === 'loss') {
        loss = true;
        const winner = scored ? others.find(p => p.score === bestOther) : others.find(p => p.isWin);
        big = scored ? 'Hai perso ' + play.myScore + ' a ' + bestOther : 'Hai perso';
        sub = winner ? 'Ha vinto ' + (winner.isBot ? 'l\'automa' : this.companionLabel(winner.name)) : (people.length ? 'Contro ' + join(people) : '');
      } else {
        big = 'Partita salvata';
        sub = people.length ? 'Con ' + join(people) : '';
      }
      return { big, sub, loss };
    }

    /** I conti dei fatti stanno in Numeri: si carica aprendo la registrazione, così a fine partita è pronto. */
    _loadNumeri() {
      if (window.FrogMatchNumeri) return Promise.resolve(window.FrogMatchNumeri);
      if (this._numeriWait) return this._numeriWait;
      const root = document.querySelector('[data-fp-profile]');
      const js = root && root.getAttribute('data-numeri-js');
      if (!js) return Promise.reject(new Error('numeri assente'));
      this._numeriWait = new Promise((resolve, reject) => {
        let sc = document.querySelector('script[data-nu-js]');
        if (!sc) { sc = document.createElement('script'); sc.src = js; sc.setAttribute('data-nu-js', ''); document.head.appendChild(sc); }
        sc.addEventListener('load', () => resolve(window.FrogMatchNumeri));
        sc.addEventListener('error', () => { this._numeriWait = null; reject(new Error('numeri non caricato')); });
      });
      return this._numeriWait;
    }

    _prepareRewardFacts() {
      const p = this.profile;
      return this._loadNumeri().then(N => N.prepareLog(p).then(() => N)).catch(() => null);
    }

    /** Un fatto solo, il più raro. Se nessuno è all'altezza, lì non compare nulla. */
    _fillRewardFact(panel, play, facts) {
      const box = panel.querySelector('.fm-reward__facts');
      if (!box) return;
      const wait = new Promise(resolve => setTimeout(() => resolve(null), 6000));
      Promise.race([this._prepareRewardFacts(), wait]).then(N => {
        if (!N || panel.hidden || panel.getAttribute('data-fm-reward-play') !== String(play.id)) return;
        const found = N.discoverFacts(FM.loadProfile(), play, { label: (n) => this.companionLabel(n) });
        facts.push.apply(facts, found);
        box.innerHTML = found.map(f =>
          '<div class="fm-reward__fact"><span class="fm-reward__ic fm-reward__ic--' + f.ic + '">' + escapeHtml(f.label) + '</span>' +
          '<div><b>' + escapeHtml(f.title) + '</b>' + (f.sub ? '<small>' + escapeHtml(f.sub) + '</small>' : '') + '</div></div>').join('');
      }).catch(e => console.warn('[FroggerProfile] fatti del premio:', e));
    }

    /** Un gioco in vendita simile a quello appena giocato, che non hai già. */
    _suggestNextGame(ctx) {
      const cat = (FM.getCatalogProducts ? FM.getCatalogProducts() : null) || this.products || [];
      const prof = this.profile || {};
      let played = ctx.bggId ? cat.find(p => p && p.bgg === ctx.bggId)
        : (ctx.productId ? cat.find(p => p && String(p.id) === String(ctx.productId)) : null);
      // Gioco fuori catalogo: meccaniche dalla collezione BGG già arricchita nel profilo.
      if ((!played || !Array.isArray(played.mch) || played.mch.length < 2) && ctx.bggId) {
        const pool = ((prof.bggCollection && prof.bggCollection.owned) || []).concat(prof.manualOwned || []);
        const g = pool.find(x => x && typeof x === 'object' && Number(x.id || x.bggId) === Number(ctx.bggId) && Array.isArray(x.mch) && x.mch.length >= 2);
        if (g) played = { bgg: Number(ctx.bggId), t: ctx.title, mch: g.mch, cat: g.cat || [], w: g.w || null };
      }
      if (!played || !Array.isArray(played.mch) || played.mch.length < 2) return null;
      const have = new Set();
      ((prof.bggCollection && prof.bggCollection.owned) || []).forEach(g => { const id = (g && typeof g === 'object') ? g.id : g; if (id) have.add(Number(id)); });
      (prof.manualOwned || []).forEach(m => { if (m && m.bggId) have.add(Number(m.bggId)); });
      (prof.purchasedProducts || []).forEach(m => { if (m && m.bggId) have.add(Number(m.bggId)); });
      (prof.manualPlays || []).forEach(m => { if (m && m.bggId) have.add(Number(m.bggId)); });
      ((prof.playsActivity && prof.playsActivity.topPlayed) || []).forEach(g => { if (g && g.bggId) have.add(Number(g.bggId)); });
      const EXP = /\b(espansione|expansion|add[-\s]?on|promo pack)\b/i;
      const mset = new Set(played.mch);
      const cset = new Set(played.cat || []);
      const n = (ctx.play && ctx.play.players) || null;
      let best = null, bestScore = 0;
      for (const p of cat) {
        if (!p || !p.av || p.is_exp || EXP.test(p.t || '') || !p.bgg || p.bgg === played.bgg || have.has(Number(p.bgg))) continue;
        const sm = (p.mch || []).filter(m => mset.has(m)).length;
        if (sm < 2) continue;
        const sc = (p.cat || []).filter(c => cset.has(c)).length;
        // Somiglianza in proporzione (Jaccard): un gioco con 15 meccaniche non vince per quantità.
        const union = new Set((p.mch || []).concat(played.mch)).size || 1;
        let score = (sm / union) * 20 + sc + (Number(p.rt) || 0) / 2;
        // Stesso modo di giocare: cooperativo con cooperativo, solitario con solitario.
        const isCoop = (x) => (x.mch || []).indexOf('Cooperative Game') >= 0;
        const isSolo = (x) => (x.mch || []).indexOf('Solo / Solitaire Game') >= 0;
        if (isCoop(played) !== isCoop(p)) score -= 6;
        if (isSolo(played) && !isSolo(p)) score -= 3;
        if (n && p.pmin && p.pmax && (n < p.pmin || n > p.pmax)) score -= 6;
        if (played.w && p.w) score -= Math.abs(played.w - p.w) * 1.5;
        if (score > bestScore) { bestScore = score; best = p; }
      }
      return best ? { product: best, because: played.t } : null;
    }

    _showPlayReward(ctx, actions) {
      const modal = document.querySelector('[data-fm-log-modal]');
      const panel = modal && modal.querySelector('[data-fm-reward]');
      if (!panel) return false;
      const play = ctx.play || {};
      const head = this._rewardHeadline(play);
      const facts = [];
      const next = this._suggestNextGame(ctx);
      // Riga piccola: quando e quanto (il titolo è già nella testata del modal).
      const iso0 = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      const today = iso0(new Date());
      const yest = new Date(); yest.setDate(yest.getDate() - 1);
      const when = !play.date || play.date === today ? 'Oggi' : (play.date === iso0(yest) ? 'Ieri' : new Date(play.date + 'T12:00:00').toLocaleDateString('it-IT', { day: 'numeric', month: 'long' }));
      const small = when + (play.minutes ? ' · ' + this._fmtMinutes(play.minutes) : (play.minutesEstimate ? ' · circa ' + this._fmtMinutes(play.minutesEstimate) : ''));
      const isLogged = !!(this.customer && this.customer.customerId);
      const nextHtml = next ? (
        '<div class="fm-reward__next">' +
          '<a href="' + escapeHtml(next.product.u) + '"><img src="' + escapeHtml(String(next.product.img || '').replace(/([?&])width=\d+/, '$1width=240')) + '" alt="" loading="lazy"></a>' +
          '<div><small>Per chi ama ' + escapeHtml(next.because) + '</small>' +
            '<a href="' + escapeHtml(next.product.u) + '">' + escapeHtml(next.product.t) + '</a>' +
            '<div class="fm-reward__buy">' +
              '<button type="button" class="fm-reward__heart" data-wishlist-btn data-product-id="' + escapeHtml(String(next.product.id)) + '" aria-pressed="false" aria-label="Salva in Wishlist">♥</button>' +
            '</div></div>' +
        '</div>') : '';
      panel.innerHTML =
        '<div class="fm-reward__result' + (head.loss ? ' is-loss' : '') + '"><small>' + escapeHtml(small) + '</small><b>' + escapeHtml(head.big) + '</b>' + (head.sub ? '<span>' + escapeHtml(head.sub) + '</span>' : '') + '</div>' +
        '<div class="fm-reward__facts"></div>' +
        '<div class="fm-reward__vibe"><p>Com\'è stata?</p><div class="fm-reward__vibe-row" role="group" aria-label="Com\'è stata">' +
          '<button type="button" data-fm-vibe="5" aria-pressed="false">😐 Così così</button>' +
          '<button type="button" data-fm-vibe="7" aria-pressed="false">🙂 Bella</button>' +
          '<button type="button" data-fm-vibe="9" aria-pressed="false">🤩 Bellissima</button>' +
        '</div></div>' +
        nextHtml +
        (isLogged ? '' : '<a class="fm-reward__login" href="/account/login?return_url=' + encodeURIComponent(location.pathname + location.hash) + '"><b>Non perdere questa partita</b><span>Accedi e resta con te su ogni telefono.</span></a>') +
        '<div class="fm-reward__actions">' +
          '<button type="button" class="fm-reward__share" data-fm-reward-share>Condividi la scheda</button>' +
          '<button type="button" class="fm-reward__again" data-fm-reward-again>Registra un\'altra partita</button>' +
          '<button type="button" class="fm-reward__done" data-fm-reward-done>Chiudi</button>' +
        '</div>';
      panel.hidden = false;
      panel.setAttribute('data-fm-reward-play', String(play.id));
      this._fillRewardFact(panel, play, facts);
      const inner = panel.closest('.fm-log-modal__inner');
      if (inner) inner.scrollTop = 0;

      // Voto in un tocco: aggiorna il voto della partita appena salvata (scala 1-10).
      panel.querySelectorAll('[data-fm-vibe]').forEach(btn => btn.addEventListener('click', () => {
        panel.querySelectorAll('[data-fm-vibe]').forEach(x => x.setAttribute('aria-pressed', String(x === btn)));
        if (play.id && FM.editManualPlay) {
          const r = FM.editManualPlay(play.id, { rating: parseInt(btn.getAttribute('data-fm-vibe'), 10) });
          if (r && r.ok) this.profile = r.profile;
        }
      }));
      // Carrello rapido (stesso flusso di "Per te").
      const addBtn = panel.querySelector('[data-fm-reward-add]');
      if (addBtn) addBtn.addEventListener('click', async () => {
        if (addBtn.disabled) return;
        const label = addBtn.textContent;
        addBtn.disabled = true; addBtn.textContent = '…';
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(root + 'products/' + encodeURIComponent(addBtn.getAttribute('data-fm-reward-add')) + '.js', { headers: { 'Accept': 'application/json' } });
          if (!res.ok) throw new Error('product ' + res.status);
          const pj = await res.json();
          const variant = (pj.variants || []).find(v => v.available) || (pj.variants || [])[0];
          if (!variant) throw new Error('no variant');
          const add = await fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
          });
          if (!add.ok) throw new Error('cart ' + add.status);
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
          addBtn.textContent = '✓ Nel carrello';
        } catch (e) {
          console.warn('[FroggerProfile] carrello dal premio:', e && e.message);
          addBtn.textContent = 'Riprova';
          setTimeout(() => { addBtn.disabled = false; addBtn.textContent = label; }, 1800);
        }
      });
      try { if (window.FrogWishlist && window.FrogWishlist.refreshButtons) window.FrogWishlist.refreshButtons(); } catch (e) {}
      const shareBtn = panel.querySelector('[data-fm-reward-share]');
      if (shareBtn) shareBtn.addEventListener('click', () => this._shareRewardCard(ctx, head, facts, shareBtn));
      const againBtn = panel.querySelector('[data-fm-reward-again]');
      if (againBtn && actions && actions.again) againBtn.addEventListener('click', actions.again);
      const doneBtn = panel.querySelector('[data-fm-reward-done]');
      if (doneBtn && actions && actions.close) doneBtn.addEventListener('click', actions.close);
      return true;
    }

    /** Scheda 1080×1920 (formato storia) con copertina, risultato e i fatti; poi condividi o scarica. */
    async _shareRewardCard(ctx, head, facts, btn) {
      if (!btn || btn.disabled) return;
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Preparo la scheda…';
      const loadImg = (src) => new Promise((resolve) => { const im = new Image(); im.onload = () => resolve(im); im.onerror = () => resolve(null); im.src = src; });
      try {
        const W = 1080, H = 1920;
        const c = document.createElement('canvas'); c.width = W; c.height = H;
        const g = c.getContext('2d');
        const family = (getComputedStyle(document.body).fontFamily || 'system-ui, sans-serif');
        const font = (w, px) => w + ' ' + px + 'px ' + family;
        const grd = g.createLinearGradient(0, 0, W * 0.4, H);
        grd.addColorStop(0, '#0f3a24'); grd.addColorStop(0.62, '#1d7a43'); grd.addColorStop(1, '#3a9a5c');
        g.fillStyle = grd; g.fillRect(0, 0, W, H);
        const box = (x, y, w, h, r, fill) => { g.fillStyle = fill; g.beginPath(); if (g.roundRect) g.roundRect(x, y, w, h, r); else g.rect(x, y, w, h); g.fill(); };
        const wrap = (text, x, y, maxW, lh, maxLines) => {
          const words = String(text || '').split(/\s+/); let line = '', lines = 0;
          for (let i = 0; i < words.length; i++) {
            const test = line ? line + ' ' + words[i] : words[i];
            if (g.measureText(test).width > maxW && line) {
              lines++;
              if (lines >= maxLines) { g.fillText(line + '…', x, y); return y + lh; }
              g.fillText(line, x, y); y += lh; line = words[i];
            } else line = test;
          }
          if (line) { g.fillText(line, x, y); y += lh; }
          return y;
        };
        g.fillStyle = '#f2b829'; g.font = font(800, 38); g.fillText('FROGMATCH · LA PARTITA', 90, 140);
        box(90, 200, 900, 900, 48, 'rgba(255,255,255,0.94)');
        const coverData = ctx.img ? await this.fetchImageAsDataUrl(ctx.img) : null;
        const cover = coverData ? await loadImg(coverData) : null;
        if (cover && cover.width) {
          const s = Math.min(820 / cover.width, 820 / cover.height);
          const cw = cover.width * s, ch = cover.height * s;
          g.drawImage(cover, 90 + (900 - cw) / 2, 200 + (900 - ch) / 2, cw, ch);
        } else {
          g.fillStyle = '#1d7a43'; g.font = font(800, 72); wrap(ctx.title, 150, 620, 780, 86, 3);
        }
        let y = 1210;
        g.fillStyle = '#ffffff'; g.font = font(700, 54); y = wrap(ctx.title, 90, y, 900, 64, 2);
        g.fillStyle = '#f2b829'; g.font = font(800, 96); y = wrap(head.big, 90, y + 40, 900, 104, 2);
        if (head.sub) { g.fillStyle = 'rgba(255,255,255,0.9)'; g.font = font(500, 42); y = wrap(head.sub, 90, y + 4, 900, 52, 2); }
        y += 36;
        g.font = font(700, 40);
        for (const f of (facts || []).slice(0, 3)) {
          if (y > 1760) break;
          g.fillStyle = '#f2b829'; g.beginPath(); g.arc(106, y - 13, 12, 0, Math.PI * 2); g.fill();
          g.fillStyle = '#ffffff'; y = wrap(f.title, 140, y, 850, 50, 2) + 14;
        }
        g.fillStyle = 'rgba(255,255,255,0.85)'; g.font = font(700, 36); g.fillText('frogames.it', 90, 1840);
        // Logo Frogames in basso a destra (quello della testata del sito).
        try {
          const logoEl = document.querySelector('header img[src*="logo"], .header img[src*="logo"], img[alt*="Frogames" i], img[alt*="FroGames" i]');
          const logoData = logoEl ? await this.fetchImageAsDataUrl(logoEl.currentSrc || logoEl.src) : null;
          const logo = logoData ? await loadImg(logoData) : null;
          if (logo && logo.width) { const lw = 200, lh = logo.height * (lw / logo.width); g.drawImage(logo, W - 90 - lw, 1870 - lh, lw, lh); }
        } catch (e) { /* senza logo va bene lo stesso */ }
        const blob = await new Promise(r => c.toBlob(r, 'image/png'));
        if (!blob) throw new Error('canvas');
        const file = new File([blob], 'frogmatch-partita.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: ctx.title, text: head.big + ' · ' + ctx.title });
        } else {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob); a.download = file.name;
          document.body.appendChild(a); a.click();
          setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
        }
        btn.textContent = '✓ Pronta';
      } catch (e) {
        if (!(e && e.name === 'AbortError')) {
          console.warn('[FroggerProfile] scheda:', e);
          btn.textContent = 'Non riuscita, riprova';
        } else btn.textContent = label;
      } finally {
        setTimeout(() => { btn.disabled = false; btn.textContent = label; }, 1800);
      }
    }

    _showPlayToast({ title, wasNew, playsTotal }) {
      let icon, msg;
      if (wasNew) {
        icon = '📚';
        msg = '<strong>' + escapeHtml(title) + '</strong> è entrato nel tuo scaffale!';
      } else if (playsTotal === 5) {
        icon = '🎲';
        msg = 'Sei diventato fan di <strong>' + escapeHtml(title) + '</strong>! 5 partite alle spalle.';
      } else if (playsTotal === 10) {
        icon = '💎';
        msg = 'Specialista di <strong>' + escapeHtml(title) + '</strong>! 10 partite. Lo conosci dentro e fuori.';
      } else if (playsTotal === 25) {
        icon = '🏆';
        msg = '<strong>25 partite a ' + escapeHtml(title) + '</strong>. Ufficialmente uno dei tuoi.';
      } else if (playsTotal === 50) {
        icon = '🌟';
        msg = '<strong>Cinquanta partite</strong> a ' + escapeHtml(title) + '. Leggenda.';
      } else if (playsTotal === 100) {
        icon = '🐸';
        msg = '<strong>100 partite</strong> a ' + escapeHtml(title) + '. Quasi un\'ossessione bellissima.';
      } else {
        icon = '✓';
        msg = 'Partita registrata · <strong>' + escapeHtml(title) + '</strong> · ' + playsTotal + (playsTotal === 1 ? ' partita' : ' partite');
      }

      // Crea (o riusa) toast container
      let toast = document.querySelector('[data-fp-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'fp-toast';
        toast.setAttribute('data-fp-toast', '');
        document.body.appendChild(toast);
      }
      toast.innerHTML = '<span class="fp-toast__icon">' + icon + '</span><span class="fp-toast__msg">' + msg + '</span>';
      toast.classList.remove('fp-toast--show');
      // Force reflow per riavviare l'animation
      void toast.offsetWidth;
      toast.classList.add('fp-toast--show');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => {
        toast.classList.remove('fp-toast--show');
      }, wasNew ? 4500 : 3500);
    }

    /** Toast con azione "Annulla" (es. per la × che nasconde un compagno). */
    _showUndoToast(msg, onUndo) {
      let toast = document.querySelector('[data-fp-undo-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'fp-toast fp-toast--undo';
        toast.setAttribute('data-fp-undo-toast', '');
        document.body.appendChild(toast);
      }
      toast.innerHTML = '<span class="fp-toast__msg">' + msg + '</span>' +
        '<button type="button" class="fp-toast__undo" data-fp-undo>Annulla</button>';
      toast.classList.remove('fp-toast--show');
      void toast.offsetWidth;
      toast.classList.add('fp-toast--show');
      const hide = () => toast.classList.remove('fp-toast--show');
      clearTimeout(this._undoTimer);
      const undoBtn = toast.querySelector('[data-fp-undo]');
      if (undoBtn) undoBtn.onclick = () => {
        clearTimeout(this._undoTimer);
        hide();
        if (typeof onUndo === 'function') onUndo();
      };
      this._undoTimer = setTimeout(hide, 5000);
    }
  }

  function initProfile() {
    document.querySelectorAll('[data-fp-profile]').forEach(root => {
      if (root.__fpInit) return;
      root.__fpInit = true;
      new ProfileController(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProfile);
  else initProfile();
  document.addEventListener('shopify:section:load', initProfile);

  class PerTeController {
    constructor(root) {
      this.root = root;
      this.quizUrl = root.dataset.quizUrl || '/pages/frogmatch';
      this.profile = FM.loadProfile();

      if (!this.profile) {
        if (FM.scopriAperto()) return;
        const r = root.querySelector('[data-fm-redirect]');
        if (r) r.hidden = false;
        setTimeout(() => { window.location.href = this.quizUrl; }, 200);
        return;
      }

      const content = root.querySelector('[data-fm-content]');
      if (content) content.hidden = false;

      this.products = FM.getCatalogProducts();
      this.currentMood = 'default';

      this.renderHero();
      this.bindMood();
      this.renderGrid();

      // Catalogo completo dal worker (la pagina ne passa solo 250, in ordine alfabetico):
      // quando arriva, la griglia si ricalcola su tutto il catalogo.
      FM.loadFullCatalog().then(full => {
        if (full && full.length > this.products.length) {
          this.products = full;
          this.renderGrid();
        }
      });

      // Carica community data in background; quando arriva, ri-renderizza la grid con communityBoost
      const customer = FM.readCustomerDataFromDOM ? FM.readCustomerDataFromDOM() : null;
      const workerUrl = customer && customer.workerUrl;
      if (workerUrl) {
        FM.loadCommunityData(workerUrl).then(data => {
          if (data) this.renderGrid();
        });
      }
    }

    renderHero() {
      const setText = (sel, v) => {
        const el = this.root.querySelector(sel);
        if (el) el.textContent = v;
      };
      const article = this.root.querySelector('[data-fm-archetype-article]');
      if (article) article.textContent = '';
      setText('[data-fm-archetype-name]', this.profile.archetypeName);
      setText('[data-fm-tagline]', this.profile.archetypeTagline || '');
    }

    bindMood() {
      this.root.querySelectorAll('[data-fm-mood]').forEach(btn => {
        btn.addEventListener('click', () => {
          this.root.querySelectorAll('[data-fm-mood]').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          this.currentMood = btn.dataset.fmMood;
          this.renderGrid();
        });
      });
    }

    renderGrid() {
      const grid = this.root.querySelector('[data-fm-perte-grid]');
      const empty = this.root.querySelector('[data-fm-empty]');
      const count = this.root.querySelector('[data-fm-count]');
      if (!grid) return;

      const mood = MOOD_PRESETS[this.currentMood];
      // Stesse esclusioni della Vetrina: niente espansioni (anche quelle senza gioco_base,
      // riconosciute dal titolo) e niente giochi che hai già nella collezione BGG.
      // Poi prima i giochi acquistabili, in ordine di affinità, e in coda gli esauriti
      // (verificato 01/11: av=false = non vendibile sul negozio).
      const EXP_PATTERN = /\b(espansione|expansion|add[-\s]?on|promo pack)\b/i;
      const ownedRaw = (this.profile.bggCollection && this.profile.bggCollection.owned) || [];
      const owned = new Set(ownedRaw.map(g => Number(g && typeof g === 'object' ? (g.id || g.bggId) : g)).filter(Boolean));
      // Niente neanche i giochi che ha già giocato, comprese le altre edizioni (Regicide → Regicide 2nd Edition).
      const act = this.profile.playsActivity || {};
      const playedSrc = (act.topPlayed || []).concat(this.profile.manualPlays || []);
      const playedIds = new Set(playedSrc.map(g => Number(g && g.bggId)).filter(Boolean));
      const playedNames = Array.from(new Set(playedSrc.map(g => String((g && (g.name || g.title)) || '').toLowerCase().trim()).filter(n => n.length > 3)));
      const isPlayed = p => {
        if (p.bgg && playedIds.has(Number(p.bgg))) return true;
        const t = String(p.t || '').toLowerCase();
        return playedNames.some(n => t === n || t.indexOf(n + ' ') === 0 || t.indexOf(n + ':') === 0);
      };
      const all = FM.rankProducts(this.profile, this.products, mood)
        .filter(p => !p.is_exp && !EXP_PATTERN.test(p.t || '') && !(p.bgg && owned.has(Number(p.bgg))) && !isPlayed(p));
      const ranked = all.filter(p => p.av).concat(all.filter(p => !p.av));
      this.ranked = ranked;
      this.shown = 0;

      grid.innerHTML = '';
      if (ranked.length === 0) {
        if (empty) empty.hidden = false;
        if (count) count.textContent = '';
        this.renderMore();
        return;
      }
      if (empty) empty.hidden = true;
      if (count) count.textContent = ranked.length + ' giochi';
      this.appendCards(48);
      this.bindCart(grid);
    }

    // Una pagina di schede alla volta: con il catalogo intero sono migliaia.
    appendCards(n) {
      const grid = this.root.querySelector('[data-fm-perte-grid]');
      if (!grid || !this.ranked) return;
      const slice = this.ranked.slice(this.shown, this.shown + n);
      const frag = document.createDocumentFragment();
      slice.forEach(p => frag.appendChild(this.card(p)));
      grid.appendChild(frag);
      this.shown += slice.length;
      this.renderMore();
      try { if (window.FrogWishlist && window.FrogWishlist.refreshButtons) window.FrogWishlist.refreshButtons(); } catch (e) {}
    }

    renderMore() {
      let more = this.root.querySelector('[data-fm-perte-more]');
      const left = this.ranked ? this.ranked.length - this.shown : 0;
      if (left <= 0) { if (more) more.hidden = true; return; }
      if (!more) {
        const grid = this.root.querySelector('[data-fm-perte-grid]');
        if (!grid) return;
        more = document.createElement('button');
        more.type = 'button';
        more.className = 'fm-perte__more';
        more.setAttribute('data-fm-perte-more', '');
        more.addEventListener('click', () => this.appendCards(48));
        grid.insertAdjacentElement('afterend', more);
      }
      more.hidden = false;
      more.textContent = 'Mostra altri ' + Math.min(48, left) + ' giochi';
    }

    card(p) {
      const a = document.createElement('a');
      a.className = 'fm-match';
      a.href = p.u;
      const pctHtml = p.matchHideNumber
        ? '<span class="fm-match__pct fm-match__pct--badge" data-tier="' + (p.matchTier || 'low') + '">🌿</span>'
        : '<span class="fm-match__pct" data-tier="' + tier(p.matchPercent) + '">' + p.matchPercent + '%</span>';
      // Copertina come <img> vera: il tema nasconde i div vuoti (div:empty → display:none),
      // e lo sfondo CSS su un div vuoto non si vedeva mai. Più piccola e caricata solo a schermo.
      const src = String(p.img || '').replace(/([?&])width=\d+/, '$1width=400');
      const media = src
        ? '<img class="fm-match__img" src="' + escapeHtml(src) + '" alt="" loading="lazy" decoding="async" width="400" height="400">'
        : '<span class="fm-match__noimg">' + escapeHtml(p.t) + '</span>';
      const price = p.price ? '<span class="fm-match__price">' + escapeHtml(String(p.price)) + ' €</span>' : '';
      const buy = p.av
        ? '<button type="button" class="fm-match__add" data-fm-add="' + escapeHtml(p.h) + '" aria-label="Aggiungi ' + escapeHtml(p.t) + ' al carrello">🛒 Aggiungi</button>'
        : '<span class="fm-match__out">Esaurito</span>';
      // Il cuore solo dentro l'app: la pagina Per te da sola resta con prezzo e Aggiungi.
      const heart = !this.root.classList.contains('fma-perte') ? '' : '<button type="button" class="fm-match__heart" data-wishlist-btn data-product-id="' + escapeHtml(String(p.id)) + '" aria-pressed="false" aria-label="Salva in Wishlist">♥</button>';
      a.innerHTML =
        pctHtml + heart +
        '<div class="fm-match__media">' + media + '</div>' +
        '<div class="fm-match__body"><h3 class="fm-match__title">' + escapeHtml(p.t) + '</h3>' +
        '<div class="fm-match__row">' + price + buy + '</div></div>';
      return a;
    }

    // Carrello rapido, stesso flusso della Vetrina: variante da /products/{h}.js,
    // POST /cart/add.js, poi il drawer del tema (cart:refresh).
    bindCart(grid) {
      if (grid.__fmCartBound) return;
      grid.__fmCartBound = true;
      grid.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-fm-add]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        const label = btn.textContent;
        btn.disabled = true;
        btn.textContent = '…';
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(root + 'products/' + encodeURIComponent(btn.dataset.fmAdd) + '.js', { headers: { 'Accept': 'application/json' } });
          if (!res.ok) throw new Error('product ' + res.status);
          const pj = await res.json();
          const variant = (pj.variants || []).find(v => v.available) || (pj.variants || [])[0];
          if (!variant) throw new Error('no variant');
          const add = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
          });
          if (!add.ok) throw new Error('cart ' + add.status);
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          btn.textContent = '✓ Aggiunto';
        } catch (err) {
          console.warn('[PerTe] carrello:', err.message);
          btn.textContent = 'Riprova';
        } finally {
          setTimeout(() => { btn.disabled = false; btn.textContent = label; }, 1800);
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-fm-perte]').forEach(root => {
      if (root.__fmInit) return;
      root.__fmInit = true;
      new PerTeController(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


/* ────────────────────────────────────────────────
   Controller: Entry choice + routing
   ──────────────────────────────────────────────── */

(function () {
  if (!window.FrogMatch) return;
  const FM = window.FrogMatch;

  function showOnly(target) {
    const map = {
      entry: '[data-fm-entry]',
      structured: '[data-fm-structured-quiz]',
      bgg: '[data-fm-bgg-import]'
    };
    Object.keys(map).forEach(k => {
      document.querySelectorAll(map[k]).forEach(el => {
        el.hidden = (k !== target);
      });
    });
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  function applyHashRoute() {
    const hash = window.location.hash.slice(1);
    if (hash === 'structured' || hash === 'bgg') {
      showOnly(hash);
    } else {
      showOnly('entry');
    }
  }

  function bindEntry(root) {
    const profile = FM.loadProfile();
    if (profile) {
      const existing = root.querySelector('[data-fm-existing-profile]');
      if (existing) existing.hidden = false;
      const archetypeEl = root.querySelector('[data-fm-existing-archetype]');
      if (archetypeEl) archetypeEl.textContent = profile.archetypeName || 'Frogger';
    }

    root.querySelectorAll('[data-fm-entry-choice]').forEach(btn => {
      btn.addEventListener('click', () => {
        const choice = btn.dataset.fmEntryChoice;
        window.location.hash = choice;
        showOnly(choice);
      });
    });

    const redoBtn = root.querySelector('[data-fm-redo]');
    if (redoBtn) {
      redoBtn.addEventListener('click', async () => {
        if (confirm('Vuoi rifare la Carta da capo? Il profilo attuale verrà sostituito.')) {
          FM.clearAll();
          await new Promise(r => setTimeout(r, 800));
          location.reload();
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-fm-entry]').forEach(root => {
      if (root.__fmInit) return;
      root.__fmInit = true;
      bindEntry(root);
    });
    if (document.querySelector('[data-fm-entry]')) {
      applyHashRoute();
      window.addEventListener('hashchange', applyHashRoute);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


/* ────────────────────────────────────────────────
   Controller: Quiz strutturato (multi-step)
   ──────────────────────────────────────────────── */

(function () {
  if (!window.FrogMatch) return;
  const FM = window.FrogMatch;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  const DURATION_MAP = {
    filler: [15, 30],
    short: [30, 60],
    medium: [60, 120],
    long: [120, 240]
  };

  const PLAYER_MAP = { '1': 1, '2': 2, '3': 3, '5': 5 };

  class StructuredQuizController {
    constructor(root) {
      this.root = root;
      this.resultUrl = root.dataset.resultUrl || '/pages/frogmatch-tu';
      this.totalSteps = 6;
      this.currentStep = 1;

      if (!document.querySelector('[data-fm-entry]')) {
        root.hidden = false;
      }

      this.state = {
        typologiesPrimary: [],
        typologiesSecondary: [],
        durationPrimary: null,
        durationSecondary: null,
        players: [],
        weightPrimary: null,
        weightSecondary: null,
        interaction: null,
        alea: null,
        mechanics: [],
        avoidedMechanics: [],
        categories: [],
        engagement: null,
        experience: null,
        age: null,
        motto: null
      };

      this.products = FM.readProductDataFromDOM();
      this.populateOptions();
      this.bindEvents();
      this.updateProgress();
    }

    populateOptions() {
      this.allMechanics = FM.COMMON_MECHANICS.map(m => m.id);
      this.mechExamples = {};
      for (const m of FM.COMMON_MECHANICS) {
        this.mechExamples[m.id] = m.examples;
      }

      const mechAmi = this.root.querySelector('[data-fm-sq-mechanics]');
      const catEl = this.root.querySelector('[data-fm-sq-categories]');

      if (mechAmi) {
        mechAmi.innerHTML = this.renderMechanicsGrouped(this.allMechanics);
      }
      if (catEl) {
        catEl.innerHTML = FM.COMMON_CATEGORIES.map(c =>
          '<button type="button" class="fm-chip" data-value="' + escapeHtml(c) + '">' + escapeHtml(FM.tCat(c)) + '</button>'
        ).join('');
      }
    }

    renderMechanicsGrouped(mechs, selectedSet) {
      const groups = {
        'Costruzione e gestione': ['Engine Building', 'Tableau Building', 'Resource Management', 'Resource To Move', 'Income', 'Loans', 'Stock Holding', 'Investment', 'Tech Trees / Tech Tracks', 'Map Addition', 'Network and Route Building', 'Variable Set-up', 'Modular Board'],
        'Carte': ['Hand Management', 'Open Drafting', 'Closed Drafting', 'Drafting', 'Card Drafting', 'Set Collection', 'Multi-Use Cards', 'Trick-taking', 'Trick Taking', 'Deck, Bag, and Pool Building', 'Deck Construction'],
        'Azioni e lavoratori': ['Worker Placement', 'Worker Placement, Different Worker Types', 'Action Points', 'Action Drafting', 'Simultaneous Action Selection', 'Variable Phase Order'],
        'Movimento e posizione': ['Area Majority / Influence', 'Area Movement', 'Tile Placement', 'Hidden Movement', 'Movement Programming', 'Movement Points', 'Pick-up and Deliver', 'Hexagon Grid', 'Race Game', 'Race'],
        'Conflitto e ruoli': ['Variable Player Powers', 'Combat', 'Critical Hits and Failures', 'Take That', 'Player Elimination', 'Hidden Roles', 'Voting', 'Bribery', 'Bluffing'],
        'Tema e narrazione': ['Cooperative Game', 'Storytelling', 'Adventure', 'Role Playing', 'Campaign / Battle Card Driven', 'Legacy Game', 'Events', 'Action / Event'],
        'Dadi e fortuna': ['Dice Rolling', 'Die Icon Resolution', 'Dice Drafting', 'Push Your Luck'],
        'Asta e negoziazione': ['Auction', 'Auction/Bidding', 'Predictive Bid', 'Negotiation'],
        'Altro': ['Real-Time', 'Deduction', 'Memory', 'Pattern Building', 'Pattern Recognition', 'Acting', 'Singing', 'Solo / Solitaire Game', 'Team-Based Game', 'Action / Dexterity', 'Paper-and-Pencil', 'End Game Bonuses', 'Physical Removal', 'Ladder Climbing']
      };

      const remaining = new Set(mechs);
      const useSelected = selectedSet || new Set();
      let html = '';

      for (const groupName in groups) {
        const groupMechs = groups[groupName].filter(m => remaining.has(m));
        if (groupMechs.length === 0) continue;
        html += '<div class="fm-mech-group"><h3 class="fm-mech-group__title">' + escapeHtml(groupName) + '</h3><div class="fm-mech-group__chips">';
        for (const m of groupMechs) {
          remaining.delete(m);
          html += this.mechChipHtml(m, useSelected.has(m));
        }
        html += '</div></div>';
      }

      const leftover = [...remaining];
      if (leftover.length > 0) {
        html += '<div class="fm-mech-group"><h3 class="fm-mech-group__title">Varie</h3><div class="fm-mech-group__chips">';
        for (const m of leftover) html += this.mechChipHtml(m, useSelected.has(m));
        html += '</div></div>';
      }

      return html;
    }

    mechChipHtml(mech, isActive) {
      const examples = (this.mechExamples && this.mechExamples[mech]) || [];
      const exampleStr = examples.length > 0 ? '<small>' + examples.map(escapeHtml).join(' · ') + '</small>' : '';
      const cls = 'fm-chip fm-chip--card' + (isActive ? ' is-active' : '');
      return '<button type="button" class="' + cls + '" data-value="' + escapeHtml(mech) + '"><strong>' + escapeHtml(FM.tMech(mech)) + '</strong>' + exampleStr + '</button>';
    }

    refreshAvoidedMechanics() {
      const container = this.root.querySelector('[data-fm-sq-avoided-mechanics]');
      if (!container) return;
      const selected = new Set(this.state.mechanics);
      const filtered = (this.allMechanics || []).filter(m => !selected.has(m));
      const activeSet = new Set(this.state.avoidedMechanics);
      container.innerHTML = this.renderMechanicsGrouped(filtered, activeSet);
    }

    bindEvents() {
      this.bindTierMultiChips('[data-fm-sq-typologies-primary]', '[data-fm-sq-typologies-secondary]', 'typologiesPrimary', 'typologiesSecondary', 2, 1);
      this.bindMultiChips('[data-fm-sq-mechanics]', 'mechanics', 5);
      this.bindMultiChips('[data-fm-sq-avoided-mechanics]', 'avoidedMechanics', 3);
      this.bindMultiChips('[data-fm-sq-categories]', 'categories', 3);
      this.bindMultiChips('[data-fm-sq-players]', 'players', 4);

      this.bindTierSingleChips('[data-fm-sq-duration-primary]', '[data-fm-sq-duration-secondary]', 'durationPrimary', 'durationSecondary');
      this.bindTierSingleChips('[data-fm-sq-weight-primary]', '[data-fm-sq-weight-secondary]', 'weightPrimary', 'weightSecondary');
      this.bindSingleChips('[data-fm-sq-interaction]', 'interaction');
      this.bindSingleChips('[data-fm-sq-alea]', 'alea');
      this.bindSingleChips('[data-fm-sq-engagement]', 'engagement');
      this.bindSingleChips('[data-fm-sq-experience]', 'experience');

      const ageInput = this.root.querySelector('[data-fm-sq-age]');
      if (ageInput) ageInput.addEventListener('input', () => {
        this.state.age = ageInput.value ? parseInt(ageInput.value, 10) : null;
      });

      const mottoInput = this.root.querySelector('[data-fm-sq-motto]');
      if (mottoInput) mottoInput.addEventListener('input', () => {
        this.state.motto = mottoInput.value.trim() || null;
      });

      this.root.querySelectorAll('[data-fm-sq-next]').forEach(btn => {
        btn.addEventListener('click', () => this.next());
      });
      const finishBtn = this.root.querySelector('[data-fm-sq-finish]');
      if (finishBtn) finishBtn.addEventListener('click', () => this.finish());
      const backBtn = this.root.querySelector('[data-fm-sq-back]');
      if (backBtn) backBtn.addEventListener('click', () => this.prev());
    }

    bindMultiChips(selector, stateKey, maxPicks) {
      const container = this.root.querySelector(selector);
      if (!container) return;
      const onClick = (btn) => {
        const val = btn.dataset.value;
        const arr = this.state[stateKey];
        const idx = arr.indexOf(val);
        if (idx >= 0) {
          arr.splice(idx, 1);
          btn.classList.remove('is-active');
        } else if (arr.length < maxPicks) {
          arr.push(val);
          btn.classList.add('is-active');
        }
        this.updateNextButton();
      };
      container.addEventListener('click', (e) => {
        const btn = e.target.closest('button.fm-chip');
        if (btn && container.contains(btn)) onClick(btn);
      });
    }

    bindSingleChips(selector, stateKey) {
      const container = this.root.querySelector(selector);
      if (!container) return;
      container.addEventListener('click', (e) => {
        const btn = e.target.closest('button.fm-chip');
        if (!btn || !container.contains(btn)) return;
        container.querySelectorAll('button.fm-chip').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        this.state[stateKey] = btn.dataset.value;
        this.updateNextButton();
      });
    }

    bindTierMultiChips(primarySelector, secondarySelector, primaryKey, secondaryKey, primaryMax, secondaryMax) {
      const primary = this.root.querySelector(primarySelector);
      const secondary = this.root.querySelector(secondarySelector);
      if (!primary || !secondary) return;

      const sync = () => {
        const primarySet = new Set(this.state[primaryKey]);
        const secondarySet = new Set(this.state[secondaryKey]);
        primary.querySelectorAll('button.fm-chip').forEach(b => {
          const v = b.dataset.value;
          b.classList.toggle('is-active', primarySet.has(v));
          b.classList.toggle('is-disabled', secondarySet.has(v));
          b.disabled = secondarySet.has(v);
        });
        secondary.querySelectorAll('button.fm-chip').forEach(b => {
          const v = b.dataset.value;
          b.classList.toggle('is-active', secondarySet.has(v));
          b.classList.toggle('is-disabled', primarySet.has(v));
          b.disabled = primarySet.has(v);
        });
      };

      const handle = (container, stateKey, max) => (e) => {
        const btn = e.target.closest('button.fm-chip');
        if (!btn || !container.contains(btn) || btn.disabled) return;
        const val = btn.dataset.value;
        const arr = this.state[stateKey];
        const idx = arr.indexOf(val);
        if (idx >= 0) {
          arr.splice(idx, 1);
        } else if (arr.length < max) {
          arr.push(val);
        }
        sync();
        this.updateNextButton();
      };

      primary.addEventListener('click', handle(primary, primaryKey, primaryMax));
      secondary.addEventListener('click', handle(secondary, secondaryKey, secondaryMax));
      sync();
    }

    bindTierSingleChips(primarySelector, secondarySelector, primaryKey, secondaryKey) {
      const primary = this.root.querySelector(primarySelector);
      const secondary = this.root.querySelector(secondarySelector);
      if (!primary || !secondary) return;

      const sync = () => {
        const pVal = this.state[primaryKey];
        const sVal = this.state[secondaryKey];
        primary.querySelectorAll('button.fm-chip').forEach(b => {
          const v = b.dataset.value;
          b.classList.toggle('is-active', v === pVal);
          b.classList.toggle('is-disabled', v === sVal);
          b.disabled = v === sVal;
        });
        secondary.querySelectorAll('button.fm-chip').forEach(b => {
          const v = b.dataset.value;
          b.classList.toggle('is-active', v === sVal);
          b.classList.toggle('is-disabled', v === pVal);
          b.disabled = v === pVal;
        });
      };

      primary.addEventListener('click', (e) => {
        const btn = e.target.closest('button.fm-chip');
        if (!btn || !primary.contains(btn) || btn.disabled) return;
        const val = btn.dataset.value;
        this.state[primaryKey] = (this.state[primaryKey] === val) ? null : val;
        sync();
        this.updateNextButton();
      });
      secondary.addEventListener('click', (e) => {
        const btn = e.target.closest('button.fm-chip');
        if (!btn || !secondary.contains(btn) || btn.disabled) return;
        const val = btn.dataset.value;
        this.state[secondaryKey] = (this.state[secondaryKey] === val) ? null : val;
        sync();
        this.updateNextButton();
      });
      sync();
    }

    updateNextButton() {
      const stepEl = this.getStepEl(this.currentStep);
      if (!stepEl) return;
      const nextBtn = stepEl.querySelector('[data-fm-sq-next]');
      const canAdvance = this.canAdvance(this.currentStep);
      if (nextBtn) nextBtn.disabled = !canAdvance;
    }

    canAdvance(step) {
      if (step === 1) return this.state.typologiesPrimary.length > 0;
      if (step === 2) return this.state.durationPrimary != null && this.state.weightPrimary != null;
      if (step === 3) return this.state.mechanics.length > 0;
      if (step === 4) return true;
      if (step === 5) return this.state.categories.length > 0;
      return true;
    }

    getStepEl(n) {
      return this.root.querySelector('[data-fm-sq-step-id="' + n + '"]');
    }

    next() {
      if (!this.canAdvance(this.currentStep)) return;
      if (this.currentStep >= this.totalSteps) return;
      this.goTo(this.currentStep + 1);
    }

    prev() {
      if (this.currentStep <= 1) {
        if (confirm('Tornare alla schermata di scelta?')) {
          window.location.hash = '';
          window.location.reload();
        }
        return;
      }
      this.goTo(this.currentStep - 1);
    }

    goTo(n) {
      const cur = this.getStepEl(this.currentStep);
      const next = this.getStepEl(n);
      if (cur) {
        cur.classList.remove('is-active');
        cur.hidden = true;
      }
      if (next) {
        next.hidden = false;
        next.classList.add('is-active');
      }
      this.currentStep = n;
      this.updateProgress();
      this.updateNextButton();

      if (n === 4) this.refreshAvoidedMechanics();

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    updateProgress() {
      const pct = ((this.currentStep - 1) / (this.totalSteps - 1)) * 100;
      const bar = this.root.querySelector('[data-fm-sq-progress]');
      if (bar) bar.style.width = pct + '%';
      const counter = this.root.querySelector('[data-fm-sq-step]');
      if (counter) counter.textContent = String(this.currentStep);
    }

    finish() {
      const profile = this.buildProfile();
      // Backfill acquisti pregressi del customer (Shopify orders) al primo onboarding manuale.
      try {
        profile.purchasedProducts = FM.backfillPurchasesFromHistory(profile.purchasedProducts || []);
      } catch (e) { /* silenzioso */ }
      FM.saveProfile(profile);
      window.location.href = this.resultUrl;
    }

    buildProfile() {
      const s = this.state;

      const primaryRange = DURATION_MAP[s.durationPrimary] || [60, 120];
      let playtimeTarget = primaryRange.slice();
      let playtimeAcceptable = primaryRange.slice();
      if (s.durationSecondary) {
        const secRange = DURATION_MAP[s.durationSecondary];
        if (secRange) {
          playtimeAcceptable = [
            Math.min(primaryRange[0], secRange[0]),
            Math.max(primaryRange[1], secRange[1])
          ];
        }
      }

      const playerCounts = (s.players && s.players.length > 0) ? s.players.slice() : ['3'];

      const wPrimary = parseFloat(s.weightPrimary) || 3;
      const wSecondary = s.weightSecondary != null ? parseFloat(s.weightSecondary) : null;
      let weightRange;
      if (wSecondary != null) {
        weightRange = [
          Math.max(1, Math.min(wPrimary, wSecondary) - 0.4),
          Math.min(5, Math.max(wPrimary, wSecondary) + 0.4)
        ];
      } else {
        weightRange = [Math.max(1, wPrimary - 0.8), Math.min(5, wPrimary + 0.8)];
      }

      const topTypologies = s.typologiesPrimary.concat(s.typologiesSecondary);

      const profile = {
        version: 2,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        source: 'structured',
        topMechanics: s.mechanics.slice(),
        topCategories: s.categories.slice(),
        topTypologies,
        topTypologiesPrimary: s.typologiesPrimary.slice(),
        topTypologiesSecondary: s.typologiesSecondary.slice(),
        avoidedMechanics: s.avoidedMechanics.slice(),
        avoidedTypologies: [],
        weightTarget: wPrimary,
        weightSecondary: wSecondary,
        weightRange,
        playtimeTarget,
        playtimeAcceptable,
        durationPrimary: s.durationPrimary,
        durationSecondary: s.durationSecondary,
        playerCounts,
        playerCountIdeal: PLAYER_MAP[playerCounts[0]] || 4,
        interactionPreference: s.interaction != null ? parseInt(s.interaction, 10) : null,
        aleaPreference: s.alea != null ? parseInt(s.alea, 10) : null,
        engagementLevel: s.engagement,
        experience: s.experience,
        age: s.age,
        motto: s.motto,
        sample: { loved: 0, passed: 0 }
      };
      profile.archetypeName = FM.archetypeLabel(profile);
      profile.archetypeTagline = FM.archetypeTagline(profile);
      return profile;
    }
  }

  function init() {
    document.querySelectorAll('[data-fm-structured-quiz]').forEach(root => {
      if (root.__fmInit) return;
      root.__fmInit = true;
      new StructuredQuizController(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


/* ────────────────────────────────────────────────
   Controller: BGG Personal Import
   ──────────────────────────────────────────────── */

(function () {
  if (!window.FrogMatch) return;
  const FM = window.FrogMatch;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function normalizeGameName(name) {
    if (!name) return '';
    return String(name)
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s*\([^)]*\)\s*/g, '')
      .replace(/[–—:]/g, ' ')
      .replace(/\b(the|il|lo|la|i|gli|le|un|una|uno|a|an|di|del|della|dei|degli|delle)\b/g, '')
      .replace(/[^a-z0-9]+/g, '')
      .trim();
  }

  class BGGImportController {
    constructor(root) {
      this.root = root;
      this.workerUrl = root.dataset.workerUrl || '';
      this.resultUrl = root.dataset.resultUrl || '/pages/frogmatch-tu';
      this.products = FM.getCatalogProducts();
      FM.loadFullCatalog(); // parte subito: serve all'abbinamento collezione → catalogo

      if (!document.querySelector('[data-fm-entry]')) {
        root.hidden = false;
      }

      this.bggGames = null;
      this.matchedProducts = [];
      this.bindEvents();
      this.prefillUsername();
    }

    prefillUsername() {
      const existing = FM.loadProfile();
      if (existing && existing.bggUsername) {
        const input = this.root.querySelector('[data-fm-bgg-username]');
        if (input) input.value = existing.bggUsername;
      }
    }

    bindEvents() {
      const submit = this.root.querySelector('[data-fm-bgg-submit]');
      if (submit) submit.addEventListener('click', () => this.startImport());

      const input = this.root.querySelector('[data-fm-bgg-username]');
      if (input) input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') this.startImport();
      });

      const back = this.root.querySelector('[data-fm-bgg-back]');
      if (back) back.addEventListener('click', () => this.goBackToEntry());

      const retry = this.root.querySelector('[data-fm-bgg-retry]');
      if (retry) retry.addEventListener('click', () => this.showStep('form'));

      const restart = this.root.querySelector('[data-fm-bgg-restart]');
      if (restart) restart.addEventListener('click', () => this.showStep('form'));

      const build = this.root.querySelector('[data-fm-bgg-build]');
      if (build) build.addEventListener('click', async () => {
        // BUGFIX 2026-05-10: prima il click chiamava buildProfileFromMatches()
        // senza feedback visuale. Se la funzione throw-ava (dataset edge case,
        // bggPlays malformato, archetypeLabel su profilo strano), l'utente
        // vedeva solo "rotella che gira" — esattamente il bug Pierfrancesco.
        // Ora: feedback button + try/catch con showError esplicito.
        if (build.disabled) return;
        const originalText = build.textContent;
        const restoreBtn = () => {
          build.disabled = false;
          build.textContent = originalText;
        };
        build.disabled = true;
        build.textContent = '⚡ Generazione in corso…';
        try {
          await this.buildProfileFromMatches();
          // Se non è ridiretto entro 8s, forziamo redirect manuale
          // (window.location.href dovrebbe essere già stato chiamato dentro)
          setTimeout(() => {
            if (build.disabled) restoreBtn();
          }, 8000);
        } catch (e) {
          console.error('[FrogMatch] buildProfile failed:', e);
          restoreBtn();
          this.showError('Errore generazione profilo: ' + (e.message || 'sconosciuto') + '. Riprova o usa "Compila a mano".');
        }
      });
    }

    showStep(name) {
      this.root.querySelectorAll('[data-fm-bgg-step]').forEach(el => {
        el.hidden = el.dataset.fmBggStep !== name;
      });
    }

    showError(msg) {
      const el = this.root.querySelector('[data-fm-bgg-error-msg]');
      if (el) el.textContent = msg;
      this.showStep('error');
    }

    goBackToEntry() {
      window.location.hash = '';
      window.location.reload();
    }

    async startImport() {
      const input = this.root.querySelector('[data-fm-bgg-username]');
      const username = input ? input.value.trim() : '';
      if (!username) {
        this.showError('Inserisci un username BGG.');
        return;
      }
      if (!/^[a-zA-Z0-9._-]{2,50}$/.test(username)) {
        this.showError('Username non valido (solo lettere, numeri, ., _, -).');
        return;
      }

      this.showStep('loading');
      const loadingMsg = this.root.querySelector('[data-fm-bgg-loading-msg]');

      let attempts = 0;
      while (attempts < 5) {
        try {
          const url = (this.workerUrl ? this.workerUrl.replace(/\/$/, '') : '') + '/api/bgg-collection?username=' + encodeURIComponent(username);
          const res = await fetch(url);
          const data = await res.json();

          if (res.status === 503 && data.retryable) {
            attempts++;
            if (loadingMsg) loadingMsg.textContent = 'BGG sta preparando i dati… (tentativo ' + (attempts + 1) + '/5)';
            await new Promise(r => setTimeout(r, 3500));
            continue;
          }

          if (!res.ok) {
            this.showError(data.error || ('Errore HTTP ' + res.status));
            return;
          }

          if (!data.games || data.games.length === 0) {
            this.showError(data.note || 'Nessun gioco posseduto trovato. Controlla che la collezione BGG sia pubblica e marchi i giochi come "Owned".');
            return;
          }

          this.bggGames = data.games;
          this.bggUsername = username;
          // Fetch plays in parallelo (non bloccante: se fallisce, profilo viene generato senza plays)
          this.fetchBggPlays(username).catch(e => console.warn('[FrogMatch] plays fetch failed:', e));
          await this.processCollection();
          return;
        } catch (err) {
          this.showError('Errore di rete: ' + err.message);
          return;
        }
      }

      this.showError('BGG non risponde dopo 5 tentativi. Riprova fra qualche minuto.');
    }

    async fetchBggPlays(username) {
      // selfAliases: passa il firstName del customer per il check self-companion lato worker
      let selfAliasParam = '';
      try {
        const customer = (FM.readCustomerDataFromDOM && FM.readCustomerDataFromDOM()) || {};
        if (customer.firstName) {
          selfAliasParam = '&selfAliases=' + encodeURIComponent(customer.firstName);
        }
      } catch (e) {}
      const url = (this.workerUrl ? this.workerUrl.replace(/\/$/, '') : '') + '/api/bgg-plays?username=' + encodeURIComponent(username) + selfAliasParam;
      try {
        const res = await fetch(url);
        if (!res.ok) {
          this.bggPlays = null;
          return;
        }
        const data = await res.json();
        this.bggPlays = data;
      } catch (e) {
        this.bggPlays = null;
      }
    }

    async processCollection() {
      // Abbina la collezione BGG a TUTTO il catalogo, non ai 250 prodotti della pagina.
      try {
        const full = await FM.loadFullCatalog();
        if (full && full.length > this.products.length) this.products = full;
      } catch (e) {}
      const productByBgg = {};
      const productByName = {};
      for (const p of this.products) {
        if (p.bgg && p.bgg > 0) productByBgg[p.bgg] = p;
        if (p.t) {
          const norm = normalizeGameName(p.t);
          if (norm && !productByName[norm]) productByName[norm] = p;
        }
      }

      const matches = [];
      const unmatched = [];
      for (const g of this.bggGames) {
        let p = productByBgg[g.id];
        let matchType = p ? 'bgg_id' : null;
        if (!p && g.name) {
          const norm = normalizeGameName(g.name);
          if (norm && productByName[norm]) {
            p = productByName[norm];
            matchType = 'name';
          }
        }
        if (p) {
          matches.push(Object.assign({}, p, {
            userRating: g.userRating,
            owned: !!g.owned,
            prevowned: !!g.prevowned,
            wishlist: !!g.wishlist,
            bggName: g.name,
            inCatalog: true,
            matchType
          }));
        } else {
          unmatched.push(g);
        }
      }

      const idsToFetch = new Set();
      for (const g of unmatched) idsToFetch.add(g.id);
      for (const m of matches) {
        if (m.bgg && m.bgg > 0) idsToFetch.add(m.bgg);
      }

      if (idsToFetch.size > 0) {
        const loadingMsg = this.root.querySelector('[data-fm-bgg-loading-msg]');
        if (loadingMsg) loadingMsg.textContent = 'Recupero metadata BGG su ' + idsToFetch.size + ' giochi…';

        // Chunking parallelo: BGG XML può tagliare risposte oltre ~50 IDs.
        // Spezziamo in chunk da 40 e li lanciamo in parallelo (max 3 in volo).
        const CHUNK = 20;
        const allIds = [...idsToFetch];
        const chunks = [];
        for (let i = 0; i < allIds.length; i += CHUNK) {
          chunks.push(allIds.slice(i, i + CHUNK));
        }

        const detailById = {};
        const fetchChunk = async (chunkIds) => {
          try {
            const url = (this.workerUrl ? this.workerUrl.replace(/\/$/, '') : '') + '/api/bgg-batch?ids=' + chunkIds.join(',');
            const res = await fetch(url);
            if (!res.ok) return;
            const data = await res.json();
            for (const d of (data.games || [])) detailById[d.id] = d;
          } catch (e) {
            console.warn('[FrogMatch] BGG batch chunk failed:', e);
          }
        };

        // Lancio sequenziale a gruppi di 3 (semaforo soft)
        for (let i = 0; i < chunks.length; i += 3) {
          await Promise.all(chunks.slice(i, i + 3).map(fetchChunk));
          if (loadingMsg) {
            const done = Math.min(allIds.length, (i + 3) * CHUNK);
            loadingMsg.textContent = 'Metadata BGG: ' + done + ' / ' + allIds.length + '…';
          }
        }

        // Apply ai matches (per recuperare designers)
        for (const m of matches) {
          if (m.bgg && detailById[m.bgg]) {
            m.des = detailById[m.bgg].des || [];
          }
        }

        // Apply agli unmatched (popola mch/cat/etc dove possibile)
        for (const g of unmatched) {
          const d = detailById[g.id];
          if (d) {
            g.t = d.name || g.name;
            g.img = d.img;
            g.mch = d.mch || [];
            g.cat = d.cat || [];
            g.des = d.des || [];
            g.w = d.w;
            g.tmin = d.tmin;
            g.tmax = d.tmax;
            g.pmin = d.pmin;
            g.pmax = d.pmax;
            g.rt = d.rt;
            g.rk = d.rk || 0; // BGG rank (per badge "Trovatore di Nicchie")
            // Deriva flag f da BGG categories/mechanics (prima erano sempre false → tipologie sbagliate)
            const catLow = (d.cat || []).map(c => c.toLowerCase());
            const mchLow = (d.mch || []).map(m => m.toLowerCase());
            g.f = {
              coop: catLow.some(c => /cooperative/.test(c)) || mchLow.some(m => /cooperative game/.test(m)),
              party: catLow.some(c => /party/.test(c)),
              solo: mchLow.some(m => /solo|solitaire/.test(m)) || (d.pmin === 1 && d.pmax === 1),
              t2p: false,
              team: catLow.some(c => /team/.test(c)) || mchLow.some(m => /team-based/.test(m))
            };
            g.inCatalog = false;
            g.id = -g.id;
          }
        }
      }

      this.matchedProducts = matches;
      // Accetta sia giochi con mch (ideali per derivazione tipologie),
      // sia giochi senza mch ma con segnale di gusto (rating/owned/wishlist):
      // bastano per generare reactions love/pass e quindi un profilo basico.
      this.unmatchedGames = unmatched.filter(g => {
        const hasMch = g.mch && g.mch.length > 0;
        const hasSignal = g.userRating != null || g.owned || g.prevowned || g.wishlist;
        return hasMch || hasSignal;
      });
      this.renderResult(matches, this.unmatchedGames, this.bggGames.length);
    }

    deriveReaction(p) {
      // Owned (own=1) sempre love: ce l'hai sullo scaffale OGGI
      if (p.owned) return 'love';
      // Prevowned (own=0, prevowned=1): l'avevi e l'hai venduto. È ambiguo:
      //   - rating ≥7: lo amavi, l'hai venduto per spazio o nuove edizioni → love
      //   - rating ≤5: l'hai provato e non ti piaceva → pass
      //   - rating 6 / no rating: scartato dopo averlo provato → debole 'pass'
      //     (il segnale di averlo venduto SENZA rated alto significa che non ti
      //     ha conquistato; meglio pass che unknown per non gonfiare l'archetipo
      //     con tipologie che hai provato e abbandonato)
      if (p.prevowned) {
        if (p.userRating != null && p.userRating >= 7) return 'love';
        if (p.userRating != null && p.userRating <= 5) return 'pass';
        return 'pass';
      }
      // Né owned né prevowned: solo rating o wishlist
      if (p.userRating != null) {
        if (p.userRating >= 7) return 'love';
        if (p.userRating <= 4) return 'pass';
        return 'unknown';
      }
      if (p.wishlist) return 'love';
      return 'unknown';
    }

    renderResult(matches, unmatched, totalBgg) {
      const matchedEl = this.root.querySelector('[data-fm-bgg-matched]');
      const totalsEl = this.root.querySelector('[data-fm-bgg-totals]');
      const listEl = this.root.querySelector('[data-fm-bgg-matches]');
      const note = this.root.querySelector('[data-fm-bgg-unmatched-note]');
      const buildBtn = this.root.querySelector('[data-fm-bgg-build]');

      const all = [...matches, ...unmatched];
      // "Utilizzabili" = mch popolato OPPURE hai dato un segnale di gusto (rating/owned/wishlist).
      // Il primo dà tipologie precise, il secondo basta per reactions love/pass.
      const usable = all.filter(g => {
        const hasMch = g.mch && g.mch.length > 0;
        const hasSignal = g.userRating != null || g.owned || g.prevowned || g.wishlist;
        return hasMch || hasSignal;
      });

      if (matchedEl) matchedEl.textContent = String(usable.length);
      if (totalsEl) totalsEl.textContent = ' (su ' + totalBgg + ' giochi della tua collezione BGG)';

      if (listEl) {
        if (usable.length === 0) {
          listEl.innerHTML = '<li class="fm-bgg__no-match">⚠️ Su BGG non risultano giochi <strong>posseduti</strong> né <strong>valutati</strong>. Per generare il profilo serve almeno: marcare un gioco come "Owned" su BGG, oppure dargli un voto. Aggiorna la tua collezione e riprova, oppure usa l\'opzione "Compila a mano".</li>';
        } else {
          usable.sort((a, b) => {
            const sa = (a.owned ? 200 : 0) + (a.userRating || 0);
            const sb = (b.owned ? 200 : 0) + (b.userRating || 0);
            return sb - sa;
          });
          const top = usable.slice(0, 30);
          listEl.innerHTML = top.map(p => {
            let badge = '';
            if (p.owned) badge = '<span class="fm-bgg__match-status fm-bgg__match-status--owned">Posseduto</span>';
            else if (p.prevowned) badge = '<span class="fm-bgg__match-status">Ex posseduto</span>';
            else if (p.wishlist) badge = '<span class="fm-bgg__match-status fm-bgg__match-status--wish">Wishlist</span>';
            else if (p.userRating != null) badge = '<span class="fm-bgg__match-status">Valutato</span>';
            const ratingStr = p.userRating ? '<span class="fm-bgg__match-rating">' + p.userRating.toFixed(1) + '</span>' : '';
            // Fallback robusti: per i giochi BGG-only senza metadata (batch fetch timeout/fail),
            // p.t è undefined ma p.name (dalla BGG collection raw) è valorizzato.
            // BUGFIX 2026-05-10: validazione stringa contro "undefined" letterale +
            // empty string + whitespace-only. Cliente Pierfrancesco vedeva 60 card
            // con title "undefined" perché p.name arrivava come stringa "undefined"
            // (parser BGG XML fallback su valori mancanti). Falsy check da solo non basta.
            const nameOk = (s) => s != null && typeof s === 'string' && s !== 'undefined' && s.trim().length > 0;
            const title = (nameOk(p.t) ? p.t : null)
              || (nameOk(p.bggName) ? p.bggName : null)
              || (nameOk(p.name) ? p.name : null)
              || ('Gioco BGG ' + (Math.abs(p.id || 0) || p.bggId || ''));
            const imgSrc = p.img || p.thumbnail || p.image || '';
            const imgTag = imgSrc
              ? '<img class="fm-bgg__match-img" src="' + escapeHtml(imgSrc) + '" alt="" loading="lazy">'
              : '<span class="fm-bgg__match-img fm-bgg__match-img--placeholder" aria-hidden="true">🎲</span>';
            return '<li class="fm-bgg__match">' + imgTag + '<div class="fm-bgg__match-meta"><span class="fm-bgg__match-title">' + escapeHtml(title) + '</span>' + badge + '</div>' + ratingStr + '</li>';
          }).join('');
          if (usable.length > 30) {
            listEl.innerHTML += '<li class="fm-bgg__more">+ altri ' + (usable.length - 30) + '</li>';
          }
        }
      }

      if (note) note.hidden = true;

      if (buildBtn) buildBtn.disabled = usable.length === 0;

      this.showStep('result');
    }

    async buildProfileFromMatches() {
      // Se i plays sono ancora in caricamento, dai loro fino a 4s per arrivare
      if (this.bggUsername && this.bggPlays === undefined) {
        await Promise.race([
          this.fetchBggPlays(this.bggUsername),
          new Promise(r => setTimeout(r, 4000))
        ]);
      }

      // Allineato a renderResult: accetta giochi con mch O con rating/owned/wishlist.
      // Senza mch il gioco contribuisce solo come "love/pass" (collezione + voti),
      // ma il profilo si genera comunque (deriveProfileFromSwipes gestisce mch vuoto).
      const all = [
        ...this.matchedProducts,
        ...((this.unmatchedGames || []).filter(g => {
          const hasMch = g.mch && g.mch.length > 0;
          const hasSignal = g.userRating != null || g.owned || g.prevowned || g.wishlist;
          return hasMch || hasSignal;
        }))
      ];
      if (all.length === 0) {
        this.showError('Su BGG non risultano giochi posseduti né valutati. Marca almeno un gioco come "Owned" o dagli un voto, poi riprova.');
        return;
      }

      const existingProfile = FM.loadProfile();
      // Backfill acquisti pregressi da customer.orders (server-side Liquid).
      // Unisce gli acquisti già nel profilo (da sync) con quelli storici Shopify.
      const existingPurchases = FM.backfillPurchasesFromHistory(
        (existingProfile && existingProfile.purchasedProducts) || []
      );

      const bggImportShopifyIds = new Set(
        this.matchedProducts.map(p => String(p.id))
      );
      const bggImportBggIds = new Set(
        all.map(g => g.bggId || g.bgg).filter(Boolean).map(id => String(id))
      );

      let purchasesAdded = 0;
      for (const purchase of existingPurchases) {
        const purchaseShopifyId = String(purchase.productId);
        if (bggImportShopifyIds.has(purchaseShopifyId)) continue;
        if (purchase.bggId && bggImportBggIds.has(String(purchase.bggId))) continue;
        const cataloged = this.products.find(p => String(p.id) === purchaseShopifyId);
        if (cataloged && cataloged.mch && cataloged.mch.length > 0) {
          all.push(Object.assign({}, cataloged, {
            owned: true,
            _fromPurchase: true,
            bggName: purchase.title
          }));
          purchasesAdded++;
        }
      }

      // Lookup minuti/partite giocati per gioco (da BGG plays raw)
      const minutesByBgg = {};
      const playsByBgg = {};
      const recentPlaysByBgg = {}; // partite ultimi 365 giorni → recency (fix 2026-06)
      if (this.bggPlays && Array.isArray(this.bggPlays.topPlayed)) {
        for (const tp of this.bggPlays.topPlayed) {
          if (!tp.bggId) continue;
          minutesByBgg[tp.bggId] = tp.minutes || 0;
          playsByBgg[tp.bggId] = tp.plays || 0;
          recentPlaysByBgg[tp.bggId] = tp.plays365d || 0;
        }
      }

      const fakeSwipes = all.map(p => ({
        productId: p.id,
        reaction: this.deriveReaction(p),
        product: p,
        userRating: p.userRating,
        // Ore al tavolo per pesare l'archetipo: 1h Twilight Imperium pesa di più di 10x Trio (30 min)
        // perché 8h > 5h totali. Si applica solo a giochi con plays loggate.
        minutesPlayed: p.bgg ? (minutesByBgg[p.bgg] || 0) : 0,
        playsCount: p.bgg ? (playsByBgg[p.bgg] || 0) : 0,
        recentPlaysCount: p.bgg ? (recentPlaysByBgg[p.bgg] || 0) : 0
      })).filter(s => s.reaction !== 'unknown');

      if (fakeSwipes.length === 0) {
        this.showError('Nessun gioco BGG ha un segnale di gusto utilizzabile. Marca almeno un gioco come "Owned" o dagli un voto su BGG, poi riprova.');
        return;
      }

      const derived = FM.deriveProfileFromSwipes(fakeSwipes);

      const loved = fakeSwipes.filter(s => s.reaction === 'love').length;
      const passed = fakeSwipes.filter(s => s.reaction === 'pass').length;

      const playsActivity = this.bggPlays && this.bggPlays.totalPlays != null ? {
        fetchedAt: this.bggPlays.fetchedAt || Date.now(),
        fromDate: this.bggPlays.fromDate,
        toDate: this.bggPlays.toDate,
        totalPlays: this.bggPlays.totalPlays,
        totalMinutes: this.bggPlays.totalMinutes,
        last30DaysPlays: this.bggPlays.last30DaysPlays,
        last30DaysMinutes: this.bggPlays.last30DaysMinutes,
        last90DaysMinutes: this.bggPlays.last90DaysMinutes,
        mostRecentPlay: this.bggPlays.mostRecentPlay,
        uniqueGames: this.bggPlays.uniqueGames,
        // Count veri per periodo (worker v8+) — NON limitati a top 30
        uniqueGames30d: this.bggPlays.uniqueGames30d,
        uniqueGames90d: this.bggPlays.uniqueGames90d,
        uniqueGames180d: this.bggPlays.uniqueGames180d,
        uniqueGames365d: this.bggPlays.uniqueGames365d,
        totalPlays30d: this.bggPlays.totalPlays30d,
        totalPlays90d: this.bggPlays.totalPlays90d,
        totalPlays180d: this.bggPlays.totalPlays180d,
        totalPlays365d: this.bggPlays.totalPlays365d,
        activityStatus: this.bggPlays.activityStatus,
        companions: (this.bggPlays.companions || []).slice(0, 12),
        badgeStats: this.bggPlays.badgeStats || null,
        topPlayed: (this.bggPlays.topPlayed || []).slice(0, 30),
        playsByDate: this.bggPlays.playsByDate || null,
        // Flag continuation backlog: per chi ha >1000 partite il client farà
        // fetch incrementali in background per importare il resto.
        archivedTotal: this.bggPlays.archivedTotal || 0,
        bggTotalDeclared: this.bggPlays.bggTotalDeclared || null,
        hasMoreToImport: !!this.bggPlays.hasMoreToImport,
        nextPageToFetch: this.bggPlays.nextPageToFetch || null
      } : null;

      // Opt-in community: leggi checkbox dalla UI (default checked)
      const optinCheckbox = this.root.querySelector('[data-fm-optin-share-plays]');
      const shareCommunityPlays = optinCheckbox ? optinCheckbox.checked : true;

      // Costruisci bggCollection (array di {id,name,thumbnail} per achievement + ludoteca UI)
      let bggCollectionData = null;
      if (this.bggGames && Array.isArray(this.bggGames)) {
        const owned = [], prevowned = [], wishlist = [];
        for (const g of this.bggGames) {
          if (!g.id) continue;
          const lite = { id: g.id, name: g.name, thumbnail: g.thumbnail || g.image || '' };
          if (g.owned) owned.push(lite);
          else if (g.prevowned) prevowned.push(lite);
          if (g.wishlist) wishlist.push(lite);
        }
        bggCollectionData = { owned, prevowned, wishlist, fetchedAt: Date.now() };
      }

      const profile = Object.assign({
        version: 2,
        createdAt: (existingProfile && existingProfile.createdAt) || Date.now(),
        updatedAt: Date.now(),
        source: 'bgg',
        bggUsername: (this.root.querySelector('[data-fm-bgg-username]') || {}).value || null,
        bggOwnedCount: this.bggGames ? this.bggGames.length : 0,
        bggCollection: bggCollectionData,
        bggMatchedCount: this.matchedProducts.length,
        bggExternalCount: this.unmatchedGames ? this.unmatchedGames.length : 0,
        bggLovedCount: loved,
        bggPassedCount: passed,
        purchasedProducts: existingPurchases,
        purchaseUpdateCount: (existingProfile && existingProfile.purchaseUpdateCount) || 0,
        lastPurchaseUpdate: existingProfile && existingProfile.lastPurchaseUpdate,
        purchasesPreservedOnReimport: purchasesAdded,
        playsActivity,
        shareCommunityPlays,
        shareCommunityPlaysSetAt: Date.now()
      }, derived);

      // Try/catch defensivo: se l'archetipo throw-a (mai successo finora ma
      // dati edge case di profili strani potrebbero), salviamo comunque il
      // profilo con archetypeName fallback e procediamo. Meglio profilo
      // generico che build bloccato.
      try {
        profile.archetypeName = FM.archetypeLabel(profile);
        profile.archetypeTagline = FM.archetypeTagline(profile);
      } catch (e) {
        console.warn('[FrogMatch] archetype compute failed, fallback:', e);
        profile.archetypeName = profile.archetypeName || 'Frogger';
        profile.archetypeTagline = profile.archetypeTagline || 'Profilo unico';
      }

      FM.saveProfile(profile);
      window.location.href = this.resultUrl;
    }
  }

  function init() {
    document.querySelectorAll('[data-fm-bgg-import]').forEach(root => {
      if (root.__fmInit) return;
      root.__fmInit = true;
      new BGGImportController(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
